msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-09 12:00-0500\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: es\n"
"Project-Id-Version: oranje-web\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"

#. placeholder {0}: lastSent.byName
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid " · por {0}"
msgstr " · por {0}"

#. placeholder {0}: entry.lunchDeductionMinutes
#: src/features/timesheet/components/AttendanceView.tsx
msgid "-{0} min lonche"
msgstr "-{0} min lonche"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "; los Supervisores, los Managers de Área y los Managers Generales adicionales se dan de alta aquí. El correo, el hotel y el rol no se editan: cambiar cualquiera es dar de baja y dar de alta."
msgstr "; los Supervisores, los Managers de Área y los Managers Generales adicionales se dan de alta aquí. El correo, el hotel y el rol no se editan: cambiar cualquiera es dar de baja y dar de alta."

#: src/features/worker/pages/PunchPage.tsx
msgid "¡Listo!"
msgstr "¡Listo!"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "¿A quiénes?"
msgstr "¿A quiénes?"

#. placeholder {0}: String(latestVersion)
#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "¿Actualizar las tarifas con la v{0}?"
msgstr "¿Actualizar las tarifas con la v{0}?"

#. placeholder {0}: eligible.length
#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "¿Aprobar {0} semanas de un golpe?"
msgstr "¿Aprobar {0} semanas de un golpe?"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "¿Aprobar la semana?"
msgstr "¿Aprobar la semana?"

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "¿Cancelar «{0}»?"
msgstr "¿Cancelar «{0}»?"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "¿Cancelar el envío a firma?"
msgstr "¿Cancelar el envío a firma?"

#: src/features/worker/pages/PunchPage.tsx
msgid "¿Cómo funciona el ponche?"
msgstr "¿Cómo funciona el ponche?"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "¿Cómo funciona la importación?"
msgstr "¿Cómo funciona la importación?"

#: src/features/accounting/pages/AccountingPendingPages.tsx
#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/audits/pages/AuditsPage.tsx
#: src/features/contracts/pages/ContractListPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "¿Cómo funciona?"
msgstr "¿Cómo funciona?"

#: src/features/observability/components/CohortsView.tsx
msgid "¿Cómo se calcula?"
msgstr "¿Cómo se calcula?"

#: src/features/worker/pages/Phase2Page.tsx
msgid "¿Cómo te trasladas?"
msgstr "¿Cómo te trasladas?"

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "¿Creamos la propuesta ahora?"
msgstr "¿Creamos la propuesta ahora?"

#: src/features/messaging/components/ContactActions.tsx
msgid "¿Dar de baja a {name}?"
msgstr "¿Dar de baja a {name}?"

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "¿Eliminar {hotelName}?"
msgstr "¿Eliminar {hotelName}?"

#: src/features/messaging/components/ContactActions.tsx
msgid "¿Eliminar a {name}?"
msgstr "¿Eliminar a {name}?"

#. placeholder {0}: tag.name
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "¿Eliminar la etiqueta «{0}»?"
msgstr "¿Eliminar la etiqueta «{0}»?"

#: src/features/dashboard/components/InviteHotelAccountCard.tsx
msgid "¿Entró un Supervisor o un gerente nuevo?"
msgstr "¿Entró un Supervisor o un gerente nuevo?"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "¿Enviamos la propuesta?"
msgstr "¿Enviamos la propuesta?"

#. placeholder {0}: campaign.name
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "¿Enviar «{0}»?"
msgstr "¿Enviar «{0}»?"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "¿Enviar la semana a revisión?"
msgstr "¿Enviar la semana a revisión?"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "¿Enviar y aprobar la semana?"
msgstr "¿Enviar y aprobar la semana?"

#: src/features/auth/pages/LoginPage.tsx
msgid "¿Eres colaborador? <0>Entra por aquí</0>"
msgstr "¿Eres colaborador? <0>Entra por aquí</0>"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "¿La olvidaste?"
msgstr "¿La olvidaste?"

#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
msgid "¿Liberar a {workerName}?"
msgstr "¿Liberar a {workerName}?"

#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
msgid "¿Liberar este lugar?"
msgstr "¿Liberar este lugar?"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "¿Marcamos la propuesta como enviada?"
msgstr "¿Marcamos la propuesta como enviada?"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "¿Marcar el contrato como enviado?"
msgstr "¿Marcar el contrato como enviado?"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "¿Necesitas regresarlo? El semáforo no retrocede: se sale por una rama y se reactiva hacia Azul claro. Desde <0>Rojo</0> reactivan el BD o el BDC; desde <1>Café</1> y <2>Negro</2>, solo el BDC."
msgstr "¿Necesitas regresarlo? El semáforo no retrocede: se sale por una rama y se reactiva hacia Azul claro. Desde <0>Rojo</0> reactivan el BD o el BDC; desde <1>Café</1> y <2>Negro</2>, solo el BDC."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "¿No sabes cómo armarlo?"
msgstr "¿No sabes cómo armarlo?"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "¿Por qué se elimina? El motivo queda en el journal."
msgstr "¿Por qué se elimina? El motivo queda en el journal."

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "¿Por qué se rechaza?"
msgstr "¿Por qué se rechaza?"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "¿Por qué se rechaza? (ilegible, incorrecto…)"
msgstr "¿Por qué se rechaza? (ilegible, incorrecto…)"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "¿Primera vez aquí?"
msgstr "¿Primera vez aquí?"

#: src/features/worker/pages/Phase3Page.tsx
msgid "¿Qué es de ti?"
msgstr "¿Qué es de ti?"

#: src/features/observability/components/CohortSection.tsx
msgid "¿Qué pasó con los que ingresaron?"
msgstr "¿Qué pasó con los que ingresaron?"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "¿Quién lo pagó?"
msgstr "¿Quién lo pagó?"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "¿Quitar el acceso?"
msgstr "¿Quitar el acceso?"

#. placeholder {0}: removing.label
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "¿Quitar la deducción de {0}?"
msgstr "¿Quitar la deducción de {0}?"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "¿Quitar la función?"
msgstr "¿Quitar la función?"

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "¿Registrar el pago de {workerName}?"
msgstr "¿Registrar el pago de {workerName}?"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "¿Seguro? Toca «Sí, descartar borrador» para confirmar."
msgstr "¿Seguro? Toca «Sí, descartar borrador» para confirmar."

#: src/features/auth/pages/LoginPage.tsx
msgid "¿Sin acceso? Pídele el alta al Administrador de tu departamento."
msgstr "¿Sin acceso? Pídele el alta al Administrador de tu departamento."

#: src/mobile/AppLoginPage.tsx
msgid "¿Sin acceso? Si eres colaborador, tu Reclutadora te da de alta. Si trabajas en un hotel, pide el alta a tu Manager."
msgstr "¿Sin acceso? Si eres colaborador, tu Reclutadora te da de alta. Si trabajas en un hotel, pide el alta a tu Manager."

#: src/features/auth/pages/LoginPage.tsx
msgid "¿Sin acceso? Tu Reclutadora te da de alta y te llega un correo para crear tu contraseña."
msgstr "¿Sin acceso? Tu Reclutadora te da de alta y te llega un correo para crear tu contraseña."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "¿Sincronizar colaboradores con Mensajería?"
msgstr "¿Sincronizar colaboradores con Mensajería?"

#: src/features/auth/pages/LoginPage.tsx
msgid "¿Trabajas en Oranje o en un hotel? <0>Entra por aquí</0>"
msgstr "¿Trabajas en Oranje o en un hotel? <0>Entra por aquí</0>"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid ".xlsx, .csv, .txt o .pdf · hasta 5 MB y 500 hoteles"
msgstr ".xlsx, .csv, .txt o .pdf · hasta 5 MB y 500 hoteles"

#. placeholder {0}: aggregate.people
#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "· {0} pers."
msgstr "· {0} pers."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "· ajuste a la tarifa de la posición"
msgstr "· ajuste a la tarifa de la posición"

#. placeholder {0}: lastSent.version
#. placeholder {1}: lastSent.sentAt ? formatDate(lastSent.sentAt) : '—'
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "· el hotel tiene la v{0} (enviada {1})"
msgstr "· el hotel tiene la v{0} (enviada {1})"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "· fuera de geocerca"
msgstr "· fuera de geocerca"

#. placeholder {0}: row.payConcept.name
#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "· gasto: {0}"
msgstr "· gasto: {0}"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "· marca manual"
msgstr "· marca manual"

#. placeholder {0}: i18n._(active.label)
#: src/features/messaging/pages/MessagingPage.tsx
msgid "«{0}» de Mensajería todavía se está construyendo."
msgstr "«{0}» de Mensajería todavía se está construyendo."

#. placeholder {0}: template.name
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "«{0}» quedó desactivada."
msgstr "«{0}» quedó desactivada."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "«{0}» quedó en pausa."
msgstr "«{0}» quedó en pausa."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "«{0}» quedó programada."
msgstr "«{0}» quedó programada."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "«{0}» se canceló."
msgstr "«{0}» se canceló."

#. placeholder {0}: pending.item.name
#: src/features/admin/pages/CatalogsPage.tsx
msgid "«{0}» se elimina de verdad — no se archiva. Si algo del sistema lo está usando, el propio sistema lo va a impedir y te lo dirá aquí."
msgstr "«{0}» se elimina de verdad — no se archiva. Si algo del sistema lo está usando, el propio sistema lo va a impedir y te lo dirá aquí."

#. placeholder {0}: item.label
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "«{0}» se elimina de verdad. Si alguna inspección ya lo contestó, el sistema lo va a impedir y te lo dice aquí."
msgstr "«{0}» se elimina de verdad. Si alguna inspección ya lo contestó, el sistema lo va a impedir y te lo dice aquí."

#. placeholder {0}: campaign.name
#. placeholder {1}: result.queued
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "«{0}» se está enviando a {1} contactos."
msgstr "«{0}» se está enviando a {1} contactos."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "«{0}» se está enviando."
msgstr "«{0}» se está enviando."

#. placeholder {0}: check?.name ?? input.name
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "«{0}» se mandó a Meta: queda en revisión."
msgstr "«{0}» se mandó a Meta: queda en revisión."

#. placeholder {0}: template.name
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "«{0}» se reactivó."
msgstr "«{0}» se reactivó."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "«{0}» se reanudó."
msgstr "«{0}» se reanudó."

#. placeholder {0}: input.name
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "«{0}» se reenvió a Meta: queda en revisión."
msgstr "«{0}» se reenvió a Meta: queda en revisión."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "«{0}» volvió a borrador."
msgstr "«{0}» volvió a borrador."

#: src/shared/components/ModulePlaceholder.tsx
msgid "«{title}» ya tiene su lugar en el menú. Lo estamos construyendo y va a estar listo muy pronto."
msgstr "«{title}» ya tiene su lugar en el menú. Lo estamos construyendo y va a estar listo muy pronto."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "«Aprobada y enviada a Oranje» es del hotel, no tuya"
msgstr "«Aprobada y enviada a Oranje» es del hotel, no tuya"

#: src/features/observability/components/CohortsView.tsx
msgid "«Ingresó» = su primera semana con ponches en todo su historial. «Trabajó» una semana = ponchó al menos una vez esa semana; no dice cuántos días. Lo que pasó con quien ya no trabaja sale de su estado actual en el Semáforo del Colaborador."
msgstr "«Ingresó» = su primera semana con ponches en todo su historial. «Trabajó» una semana = ponchó al menos una vez esa semana; no dice cuántos días. Lo que pasó con quien ya no trabaja sale de su estado actual en el Semáforo del Colaborador."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "«Pago estimado» es un cálculo en vivo, no lo que ya se le pagó: parte las 40 h semanales por requisición y paga el resto al multiplicador de horas extra del hotel. Sin contrato ni tarifa interna que resolver, no se inventa un número — queda en «—»."
msgstr "«Pago estimado» es un cálculo en vivo, no lo que ya se le pagó: parte las 40 h semanales por requisición y paga el resto al multiplicador de horas extra del hotel. Sin contrato ni tarifa interna que resolver, no se inventa un número — queda en «—»."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "«Pago estimado» es un cálculo en vivo, no lo que ya se le pagó: parte las 40 h semanales por requisición y paga el resto al multiplicador de horas extra del hotel. Sin contrato ni tarifa interna que resolver, no se inventa un número — queda en «—». Lo que corrijas aquí es lo que paga la corrida real, no solo esta pantalla."
msgstr "«Pago estimado» es un cálculo en vivo, no lo que ya se le pagó: parte las 40 h semanales por requisición y paga el resto al multiplicador de horas extra del hotel. Sin contrato ni tarifa interna que resolver, no se inventa un número — queda en «—». Lo que corrijas aquí es lo que paga la corrida real, no solo esta pantalla."

#. placeholder {0}: String(PROSPECT_TEXT_MAX.needDescription)
#: src/features/onboarding/import/mapImportRows.ts
msgid "«Qué necesita» pasa de {0} caracteres"
msgstr "«Qué necesita» pasa de {0} caracteres"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "«Regresar» un prospecto es salir por una rama y reactivarlo. La reentrada es siempre hacia Azul claro, el único punto de retorno: se retoma el contacto, no la propuesta vieja."
msgstr "«Regresar» un prospecto es salir por una rama y reactivarlo. La reentrada es siempre hacia Azul claro, el único punto de retorno: se retoma el contacto, no la propuesta vieja."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "«Stand-by» es una pausa temporal y la compartes con el Manager de Área. «Reportar» abre una incidencia que revisa Inspección. «Ver perfil» te lleva a su expediente."
msgstr "«Stand-by» es una pausa temporal y la compartes con el Manager de Área. «Reportar» abre una incidencia que revisa Inspección. «Ver perfil» te lleva a su expediente."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "«Ver bitácora» te dice quién la movió y cuándo. El resto de los botones cambia según dónde esté: cubrirla o eliminarla con motivo."
msgstr "«Ver bitácora» te dice quién la movió y cuándo. El resto de los botones cambia según dónde esté: cubrirla o eliminarla con motivo."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
msgid "(devuelta)"
msgstr "(devuelta)"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "(en curso)"
msgstr "(en curso)"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "(listo)"
msgstr "(listo)"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "(pendiente)"
msgstr "(pendiente)"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "(sin nombre)"
msgstr "(sin nombre)"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "[Apellido]"
msgstr "[Apellido]"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "[Nombre]"
msgstr "[Nombre]"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "[Teléfono]"
msgstr "[Teléfono]"

#. placeholder {0}: reasons.length
#: src/features/admin/pages/CatalogsPage.tsx
msgid "{0, plural, =0 {sin motivos} one {# motivo} other {# motivos}}"
msgstr "{0, plural, =0 {sin motivos} one {# motivo} other {# motivos}}"

#. placeholder {0}: positions.length
#: src/features/admin/pages/CatalogsPage.tsx
msgid "{0, plural, =0 {sin posiciones} one {# posición} other {# posiciones}}"
msgstr "{0, plural, =0 {sin posiciones} one {# posición} other {# posiciones}}"

#. placeholder {0}: group.openCount
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "{0, plural, one {# abierta} other {# abiertas}}"
msgstr "{0, plural, one {# abierta} other {# abiertas}}"

#. placeholder {0}: member.openProspects
#: src/features/team/pages/TeamPage.tsx
msgid "{0, plural, one {# abierto} other {# abiertos}}"
msgstr "{0, plural, one {# abierto} other {# abiertos}}"

#. placeholder {0}: adjustments.length
#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "{0, plural, one {# ajuste sin incluir} other {# ajustes sin incluir}}"
msgstr "{0, plural, one {# ajuste sin incluir} other {# ajustes sin incluir}}"

#. placeholder {0}: selected.age
#: src/features/recruitment/components/PoolRoster.tsx
msgid "{0, plural, one {# año} other {# años}}"
msgstr "{0, plural, one {# año} other {# años}}"

#. placeholder {0}: pool.total
#: src/features/recruitment/pages/PoolPage.tsx
msgid "{0, plural, one {# coincide} other {# coinciden}}"
msgstr "{0, plural, one {# coincide} other {# coinciden}}"

#. placeholder {0}: manager.activeWorkers
#: src/features/team/pages/HotelTeamPage.tsx
msgid "{0, plural, one {# colaborador activo} other {# colaboradores activos}}"
msgstr "{0, plural, one {# colaborador activo} other {# colaboradores activos}}"

#. placeholder {0}: selected.people.length
#. placeholder {0}: selection.people.length
#: src/features/schedule/pages/SchedulePage.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "{0, plural, one {# colaborador} other {# colaboradores}}"
msgstr "{0, plural, one {# colaborador} other {# colaboradores}}"

#. placeholder {0}: topPerformer.conversions
#: src/features/dashboard/components/ActivityCards.tsx
msgid "{0, plural, one {# conversión} other {# conversiones}}"
msgstr "{0, plural, one {# conversión} other {# conversiones}}"

#. placeholder {0}: selection.total
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "{0, plural, one {# día elegido} other {# días elegidos}}"
msgstr "{0, plural, one {# día elegido} other {# días elegidos}}"

#. placeholder {0}: candidates.length
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "{0, plural, one {# hotel con propuesta} other {# hoteles con propuesta}} · cada una se edita desde la ficha del hotel"
msgstr "{0, plural, one {# hotel con propuesta} other {# hoteles con propuesta}} · cada una se edita desde la ficha del hotel"

#. placeholder {0}: result.created
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0, plural, one {# hotel importado al Pipeline, en Gris.} other {# hoteles importados al Pipeline, en Gris.}}"
msgstr "{0, plural, one {# hotel importado al Pipeline, en Gris.} other {# hoteles importados al Pipeline, en Gris.}}"

#. placeholder {0}: counts.ready
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0, plural, one {# lista} other {# listas}}"
msgstr "{0, plural, one {# lista} other {# listas}}"

#. placeholder {0}: managers.length
#. placeholder {1}: supervisors.length
#: src/features/team/pages/HotelTeamPage.tsx
msgid "{0, plural, one {# Manager de Área} other {# Managers de Área}} y {1, plural, one {# Supervisor} other {# Supervisores}}"
msgstr "{0, plural, one {# Manager de Área} other {# Managers de Área}} y {1, plural, one {# Supervisor} other {# Supervisores}}"

#. placeholder {0}: result.failed
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0, plural, one {# no se importó.} other {# no se importaron.}}"
msgstr "{0, plural, one {# no se importó.} other {# no se importaron.}}"

#. placeholder {0}: contract.positionCount
#: src/features/clients/components/ClientCardGrid.tsx
msgid "{0, plural, one {# posición} other {# posiciones}}"
msgstr "{0, plural, one {# posición} other {# posiciones}}"

#. placeholder {0}: candidates.length
#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "{0, plural, one {# prospecto en Rosa esperando aprobación} other {# prospectos en Rosa esperando aprobación}}"
msgstr "{0, plural, one {# prospecto en Rosa esperando aprobación} other {# prospectos en Rosa esperando aprobación}}"

#. placeholder {0}: owner.openProspects
#: src/features/territory/components/TerritoryOwnerPicker.tsx
msgid "{0, plural, one {# prospecto} other {# prospectos}}"
msgstr "{0, plural, one {# prospecto} other {# prospectos}}"

#. placeholder {0}: version.rates.length
#. placeholder {1}: formatMoney(cheapest)
#: src/features/onboarding/lib/summarizeRates.ts
msgid "{0, plural, one {# puesto} other {# puestos}} · desde {1} el bill"
msgstr "{0, plural, one {# puesto} other {# puestos}} · desde {1} el bill"

#. placeholder {0}: member.requisitionsThisMonth ?? 0
#: src/features/team/pages/HotelTeamPage.tsx
msgid "{0, plural, one {# requisición este mes} other {# requisiciones este mes}}"
msgstr "{0, plural, one {# requisición este mes} other {# requisiciones este mes}}"

#. placeholder {0}: hotelItems.length
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "{0, plural, one {# requisición} other {# requisiciones}}"
msgstr "{0, plural, one {# requisición} other {# requisiciones}}"

#. placeholder {0}: candidate.pendingRequirements
#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "{0, plural, one {# requisito pendiente} other {# requisitos pendientes}}"
msgstr "{0, plural, one {# requisito pendiente} other {# requisitos pendientes}}"

#. placeholder {0}: board.totalFreeSlots
#. placeholder {1}: board.totalRequisitions
#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "{0, plural, one {# slot libre} other {# slots libres}} en {1, plural, one {# requisición autorizada} other {# requisiciones autorizadas}}"
msgstr "{0, plural, one {# slot libre} other {# slots libres}} en {1, plural, one {# requisición autorizada} other {# requisiciones autorizadas}}"

#. placeholder {0}: group.freeSlots
#. placeholder {1}: group.requisitions
#: src/features/recruitment/pages/SelfPickHotelPage.tsx
msgid "{0, plural, one {# slot libre} other {# slots libres}} en {1, plural, one {# requisición} other {# requisiciones}}"
msgstr "{0, plural, one {# slot libre} other {# slots libres}} en {1, plural, one {# requisición} other {# requisiciones}}"

#. placeholder {0}: manager.supervisorsInCharge ?? 0
#: src/features/team/pages/HotelTeamPage.tsx
msgid "{0, plural, one {# supervisor a cargo} other {# supervisores a cargo}}"
msgstr "{0, plural, one {# supervisor a cargo} other {# supervisores a cargo}}"

#. placeholder {0}: group.urgentCount
#. placeholder {0}: group.urgentRows
#: src/features/recruitment/pages/SelfPickHotelPage.tsx
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "{0, plural, one {# urgente} other {# urgentes}}"
msgstr "{0, plural, one {# urgente} other {# urgentes}}"

#. placeholder {0}: owner.zoneCount
#: src/features/territory/components/TerritoryOwnerPicker.tsx
msgid "{0, plural, one {# zona} other {# zonas}}"
msgstr "{0, plural, one {# zona} other {# zonas}}"

#. placeholder {0}: fields.length
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "{0, plural, one {Agregar contacto} other {Agregar # contactos}}"
msgstr "{0, plural, one {Agregar contacto} other {Agregar # contactos}}"

#. placeholder {0}: values.drafts.length
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "{0, plural, one {Contacto agregado} other {# contactos agregados}}"
msgstr "{0, plural, one {Contacto agregado} other {# contactos agregados}}"

#. placeholder {0}: importable.length
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0, plural, one {Elegir el único hotel que se puede importar} other {Elegir los # hoteles que se pueden importar}}"
msgstr "{0, plural, one {Elegir el único hotel que se puede importar} other {Elegir los # hoteles que se pueden importar}}"

#. placeholder {0}: session.zones.length
#: src/features/audits/pages/AuditsPage.tsx
msgid "{0, plural, one {Inspeccionas los hoteles de tu zona:} other {Inspeccionas los hoteles de tus zonas:}}"
msgstr "{0, plural, one {Inspeccionas los hoteles de tu zona:} other {Inspeccionas los hoteles de tus zonas:}}"

#. placeholder {0}: session.zones.length
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "{0, plural, one {Solo ves los hoteles de tu zona:} other {Solo ves los hoteles de tus zonas:}}"
msgstr "{0, plural, one {Solo ves los hoteles de tu zona:} other {Solo ves los hoteles de tus zonas:}}"

#. placeholder {0}: formatTimeIn(shift.startsAt, shift.hotelTimeZone)
#. placeholder {1}: formatTimeIn(shift.endsAt, shift.hotelTimeZone)
#: src/features/worker/pages/HomePage.tsx
msgid "{0} – {1}"
msgstr "{0} – {1}"

#. placeholder {0}: block.start
#. placeholder {1}: block.end
#. placeholder {2}: block.people.length
#: src/features/schedule/components/ScheduleTimelineGrid.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "{0} – {1} · {2} en el turno"
msgstr "{0} – {1} · {2} en el turno"

#. placeholder {0}: role.name
#: src/features/admin/components/UserFormDialog.tsx
msgid "{0} — próximamente"
msgstr "{0} — próximamente"

#. placeholder {0}: scoped.hotelName
#. placeholder {1}: scoped.requisitionNumber
#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "{0} · {1}"
msgstr "{0} · {1}"

#. placeholder {0}: target.worker.fullName
#. placeholder {1}: formatMoney(Number(target.amount))
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "{0} · {1} — el motivo queda registrado y Reclutamiento lo ve."
msgstr "{0} · {1} — el motivo queda registrado y Reclutamiento lo ve."

#. placeholder {0}: detail.hotelName
#. placeholder {1}: detail.department
#. placeholder {2}: detail.createdByName
#. placeholder {3}: formatDateTime(detail.createdAt)
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "{0} · {1} · creada por {2} el {3}"
msgstr "{0} · {1} · creada por {2} el {3}"

#. placeholder {0}: board.requisitionNumber
#. placeholder {1}: board.hotelName
#. placeholder {2}: board.lineNumber
#. placeholder {3}: board.positionName
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "{0} · {1} · renglón {2} · {3}"
msgstr "{0} · {1} · renglón {2} · {3}"

#. placeholder {0}: member.fullName
#. placeholder {1}: String(member.openProspects)
#. placeholder {2}: formatPercent(member.conversionRate)
#: src/features/dashboard/components/ActivityCards.tsx
msgid "{0} · {1} abiertos · {2}"
msgstr "{0} · {1} abiertos · {2}"

#. placeholder {0}: formatDate(worker.birthDate)
#. placeholder {1}: worker.age
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "{0} · {1} años"
msgstr "{0} · {1} años"

#. placeholder {0}: contract.hotelName
#. placeholder {1}: formatDate(contract.signedAt)
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "{0} · activado el {1}"
msgstr "{0} · activado el {1}"

#. placeholder {0}: contract.hotelName
#. placeholder {1}: contract.signedByName
#. placeholder {2}: formatDate(contract.signedAt)
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "{0} · activado por {1} el {2}"
msgstr "{0} · activado por {1} el {2}"

#. placeholder {0}: hotel.zone
#. placeholder {1}: workspace.owner.name
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "{0} · BD: {1}"
msgstr "{0} · BD: {1}"

#. placeholder {0}: version.rates[0]?.positionName ?? ''
#. placeholder {1}: formatMoney(cheapest)
#: src/features/onboarding/lib/summarizeRates.ts
msgid "{0} · bill {1}"
msgstr "{0} · bill {1}"

#. placeholder {0}: contract.hotelName
#. placeholder {1}: formatDate(contract.createdAt)
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "{0} · borrador creado el {1}"
msgstr "{0} · borrador creado el {1}"

#. placeholder {0}: row.startTime
#. placeholder {1}: row.quantity
#: src/features/schedule/pages/SchedulePage.tsx
msgid "{0} · demanda {1}"
msgstr "{0} · demanda {1}"

#. placeholder {0}: shift.position
#. placeholder {1}: formatTimeIn(shift.startsAt, shift.hotelTimeZone)
#: src/features/worker/pages/PunchPage.tsx
msgid "{0} · desde {1}"
msgstr "{0} · desde {1}"

#. placeholder {0}: entry.requisitionNumber ?? t`Sin folio`
#: src/features/timesheet/components/TimesheetGrid.tsx
msgid "{0} · días de esta requisición"
msgstr "{0} · días de esta requisición"

#. placeholder {0}: contract.hotelName
#. placeholder {1}: formatDate(contract.sentAt)
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "{0} · enviado el {1}"
msgstr "{0} · enviado el {1}"

#. placeholder {0}: contract.hotelName
#. placeholder {1}: contract.sentByName
#. placeholder {2}: formatDate(contract.sentAt)
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "{0} · enviado por {1} el {2}"
msgstr "{0} · enviado por {1} el {2}"

#. placeholder {0}: hotel.zone
#. placeholder {1}: hotel.geofenceMeters
#. placeholder {2}: hotel.timeZone
#: src/features/territory/components/HotelMapCard.tsx
msgid "{0} · geocerca {1} m · {2}"
msgstr "{0} · geocerca {1} m · {2}"

#. placeholder {0}: timeline.hotelName
#. placeholder {1}: formatWeekRange(selectedWeek, addDaysIso(selectedWeek, 6))
#: src/features/schedule/pages/SchedulePage.tsx
msgid "{0} · Semana {1}"
msgstr "{0} · Semana {1}"

#. placeholder {0}: shift.position
#. placeholder {1}: formatTimeIn(shift.startsAt, shift.hotelTimeZone)
#. placeholder {2}: formatTimeIn(shift.endsAt, shift.hotelTimeZone)
#: src/features/worker/pages/PunchPage.tsx
msgid "{0} · turno {1} – {2}"
msgstr "{0} · turno {1} – {2}"

#. placeholder {0}: worker.catalogPosition
#. placeholder {1}: worker.zoneName
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "{0} · Zona {1}"
msgstr "{0} · Zona {1}"

#. placeholder {0}: owner.roleLabel
#. placeholder {1}: scope.periodLabel
#: src/features/dashboard/components/SalesDashboard.tsx
msgid "{0} · zonas {zones} · {1}"
msgstr "{0} · zonas {zones} · {1}"

#. placeholder {0}: entry.fromStatus ? ONBOARDING_STATUS_LABEL[entry.fromStatus] : '—'
#. placeholder {1}: ONBOARDING_STATUS_LABEL[entry.toStatus]
#: src/features/onboarding/components/StatusTimeline.tsx
msgid "{0} → {1}"
msgstr "{0} → {1}"

#. placeholder {0}: String(Math.round(months / 12))
#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "{0} a"
msgstr "{0} a"

#. placeholder {0}: metrics.openCount
#. placeholder {1}: metrics.urgentCount
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "{0} abiertas · {1} urgentes"
msgstr "{0} abiertas · {1} urgentes"

#. placeholder {0}: formatNumber(totals.accepted)
#: src/features/messaging/components/MessagingReportsList.tsx
msgid "{0} aceptados por Meta"
msgstr "{0} aceptados por Meta"

#. placeholder {0}: member.fullName
#. placeholder {1}: target.label
#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "{0} ahora reporta a {1}."
msgstr "{0} ahora reporta a {1}."

#. placeholder {0}: row.personal.age
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "{0} años"
msgstr "{0} años"

#. placeholder {0}: formatHours(row.totalHours + weekLunchMinutes / 60)
#: src/features/timesheet/components/AttendanceView.tsx
msgid "{0} antes del lonche (-{weekLunchMinutes} min)"
msgstr "{0} antes del lonche (-{weekLunchMinutes} min)"

#. placeholder {0}: formatNumber(totals.optOuts)
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "{0} bajas"
msgstr "{0} bajas"

#. placeholder {0}: formatNumber(totals.optOuts)
#: src/features/messaging/components/MessagingReportsList.tsx
msgid "{0} bajas después del envío"
msgstr "{0} bajas después del envío"

#. placeholder {0}: block.people.length
#. placeholder {0}: rows.length
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/schedule/components/ScheduleTimelineGrid.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "{0} colaboradores"
msgstr "{0} colaboradores"

#. placeholder {0}: counts.errors
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0} con error"
msgstr "{0} con error"

#. placeholder {0}: matches.length
#: src/features/accounting/components/ConsolidationPayStatus.tsx
msgid "{0} Consolidados esta semana"
msgstr "{0} Consolidados esta semana"

#. placeholder {0}: selected.length
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "{0} contactos elegidos"
msgstr "{0} contactos elegidos"

#. placeholder {0}: imported.created + imported.updated
#. placeholder {1}: imported.created
#. placeholder {2}: imported.updated
#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "{0} contactos importados: {1} nuevos y {2} actualizados."
msgstr "{0} contactos importados: {1} nuevos y {2} actualizados."

#. placeholder {0}: member.quarterConversions
#: src/features/team/pages/TeamPage.tsx
msgid "{0} conv."
msgstr "{0} conv."

#. placeholder {0}: prospect.daysWithoutAttempt
#: src/features/dashboard/components/StaleProspectList.tsx
msgid "{0} d sin intento"
msgstr "{0} d sin intento"

#. placeholder {0}: String(row.filledSlots)
#. placeholder {0}: at1.part
#. placeholder {0}: at12.part
#. placeholder {1}: String(row.totalSlots)
#. placeholder {1}: at1.whole
#. placeholder {1}: at12.whole
#: src/features/observability/components/CohortSection.tsx
#: src/features/observability/components/CohortsView.tsx
#: src/features/observability/components/KpiCard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "{0} de {1}"
msgstr "{0} de {1}"

#. placeholder {0}: String(withMailbox)
#. placeholder {1}: String(rows.length)
#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "{0} de {1} con buzón"
msgstr "{0} de {1} con buzón"

#. placeholder {0}: detail.active
#: src/features/observability/components/CohortSection.tsx
msgid "{0} de {size}"
msgstr "{0} de {size}"

#. placeholder {0}: item.count
#: src/features/observability/components/CohortSection.tsx
msgid "{0} de {total}"
msgstr "{0} de {total}"

#. placeholder {0}: formatHours(row.totalHours)
#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "{0} de la meta"
msgstr "{0} de la meta"

#. placeholder {0}: formatPercent(rates.delivery)
#. placeholder {0}: formatPercent(rates.failure)
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "{0} de los destinatarios"
msgstr "{0} de los destinatarios"

#. placeholder {0}: formatPercent(rates.read)
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "{0} de los entregados"
msgstr "{0} de los entregados"

#. placeholder {0}: toRevoke.person.fullName
#. placeholder {1}: roleLabelOf(toRevoke.role.code).title
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "{0} deja de poder trabajar como {1}. Si está trabajando con esa función ahora, vuelve a la de su alta en su siguiente acción."
msgstr "{0} deja de poder trabajar como {1}. Si está trabajando con esa función ahora, vuelve a la de su alta en su siguiente acción."

#. placeholder {0}: toRevoke.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "{0} deja de ver «{title}». Si solo quieres pausarlo, apágalo con el interruptor: así no hay que volver a darlo."
msgstr "{0} deja de ver «{title}». Si solo quieres pausarlo, apágalo con el interruptor: así no hay que volver a darlo."

#. placeholder {0}: selected.fullName
#: src/features/recruitment/components/PoolRoster.tsx
msgid "{0} deja de verse en el Pool"
msgstr "{0} deja de verse en el Pool"

#. placeholder {0}: String(portfolio.total)
#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "{0} en cartera"
msgstr "{0} en cartera"

#. placeholder {0}: pool.total
#: src/features/recruitment/pages/PoolPage.tsx
msgid "{0} en el pool"
msgstr "{0} en el pool"

#. placeholder {0}: preview.blacklistedCount
#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "{0} en lista negra: se importan desactivados y no reciben mensajes."
msgstr "{0} en lista negra: se importan desactivados y no reciben mensajes."

#. placeholder {0}: data.meta.total
#. placeholder {0}: data.pagination.total
#. placeholder {0}: tags.length
#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "{0} en total"
msgstr "{0} en total"

#. placeholder {0}: campaign.deliveredCount
#. placeholder {1}: campaign.readCount
#. placeholder {2}: campaign.failedCount
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "{0} entregados · {1} leídos · {2} fallidos"
msgstr "{0} entregados · {1} leídos · {2} fallidos"

#. placeholder {0}: result.sent
#. placeholder {1}: result.created
#. placeholder {2}: result.updated
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "{0} enviados a Mensajería: {1} nuevos y {2} actualizados."
msgstr "{0} enviados a Mensajería: {1} nuevos y {2} actualizados."

#. placeholder {0}: contract.number
#: src/features/onboarding/components/ContractStepCard.tsx
msgid "{0} está con el hotel, esperando su firma."
msgstr "{0} está con el hotel, esperando su firma."

#. placeholder {0}: contract.number
#: src/features/onboarding/components/ContractStepCard.tsx
msgid "{0} está en Borrador: termínalo y envíalo desde el contrato."
msgstr "{0} está en Borrador: termínalo y envíalo desde el contrato."

#. placeholder {0}: String(spot.hotels.length)
#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "{0} hoteles aquí"
msgstr "{0} hoteles aquí"

#. placeholder {0}: String(Math.round(months))
#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "{0} m"
msgstr "{0} m"

#. placeholder {0}: String(months)
#: src/features/contracts/utils/validity.ts
msgid "{0} meses restantes"
msgstr "{0} meses restantes"

#. placeholder {0}: record.created
#. placeholder {1}: record.updated
#. placeholder {2}: record.skipped
#: src/features/messaging/components/ContactImportsDialog.tsx
msgid "{0} nuevos · {1} actualizados · {2} omitidos"
msgstr "{0} nuevos · {1} actualizados · {2} omitidos"

#. placeholder {0}: counts.incomplete
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{0} para completar"
msgstr "{0} para completar"

#. placeholder {0}: String(activeCount)
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "{0} personas con acceso"
msgstr "{0} personas con acceso"

#. placeholder {0}: String(rates.length)
#: src/features/contracts/components/ContractChecklist.tsx
msgid "{0} posiciones cotizadas: cada una con su pay rate y su bill rate."
msgstr "{0} posiciones cotizadas: cada una con su pay rate y su bill rate."

#. placeholder {0}: board?.openCount ?? 0
#. placeholder {1}: board?.zoneCount ?? 0
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "{0} prospectos abiertos · {1} zonas"
msgstr "{0} prospectos abiertos · {1} zonas"

#. placeholder {0}: String(contract.rates.length)
#. placeholder {1}: formatMoney(cheapest)
#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "{0} puestos · desde {1}"
msgstr "{0} puestos · desde {1}"

#. placeholder {0}: result.blacklisted ?? 0
#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "{0} quedaron desactivados por estar en lista negra."
msgstr "{0} quedaron desactivados por estar en lista negra."

#. placeholder {0}: contacts.length
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "{0} registrados · {pendingLabel}"
msgstr "{0} registrados · {pendingLabel}"

#. placeholder {0}: report.exits.total
#. placeholder {1}: report.exits.red
#. placeholder {2}: report.exits.brown
#. placeholder {3}: report.exits.black
#. placeholder {4}: IS_DEV_UI ? ' (RR-V-07)' : ''
#: src/features/reports/pages/ReportsPage.tsx
msgid "{0} salidas · Rojo {1} · Café {2} · Negro {3} — reactivables a Azul claro{4}"
msgstr "{0} salidas · Rojo {1} · Café {2} · Negro {3} — reactivables a Azul claro{4}"

#. placeholder {0}: member.staleCount
#: src/features/team/pages/TeamPage.tsx
msgid "{0} sin actividad"
msgstr "{0} sin actividad"

#. placeholder {0}: String(quiet)
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "{0} sin altas ni asignaciones en 7 días o más."
msgstr "{0} sin altas ni asignaciones en 7 días o más."

#. placeholder {0}: String(fields.length)
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "{0} sin guardar"
msgstr "{0} sin guardar"

#. placeholder {0}: selection.withoutRequisition
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "{0} sin requisición"
msgstr "{0} sin requisición"

#. placeholder {0}: result.synced
#. placeholder {1}: result.created
#. placeholder {2}: result.updated
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "{0} sincronizadas: {1} nuevas y {2} actualizadas."
msgstr "{0} sincronizadas: {1} nuevas y {2} actualizadas."

#. placeholder {0}: metrics.freeSlots
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "{0} slots libres"
msgstr "{0} slots libres"

#. placeholder {0}: filters.hotelName
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "{0} tiene semanas atrasadas sin aprobar:"
msgstr "{0} tiene semanas atrasadas sin aprobar:"

#. placeholder {0}: template.variableCount
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "{0} variables"
msgstr "{0} variables"

#. placeholder {0}: actedHotelName || fallbackProspect
#: src/features/conversion/pages/ConversionPage.tsx
msgid "{0} volvió a renegociación"
msgstr "{0} volvió a renegociación"

#. placeholder {0}: grant.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "{0} vuelve a tener «{title}»"
msgstr "{0} vuelve a tener «{title}»"

#. placeholder {0}: actedHotelName || fallbackHotel
#: src/features/conversion/pages/ConversionPage.tsx
msgid "{0} ya es cliente activo"
msgstr "{0} ya es cliente activo"

#. placeholder {0}: currentPrimary.name
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "{0} ya es el principal; si marcas este, lo reemplaza"
msgstr "{0} ya es el principal; si marcas este, lo reemplaza"

#. placeholder {0}: contract.number
#: src/features/onboarding/components/ContractStepCard.tsx
msgid "{0} ya está vigente. Lo que sigue es convertir el hotel en cliente: pasarlo a Naranja."
msgstr "{0} ya está vigente. Lo que sigue es convertir el hotel en cliente: pasarlo a Naranja."

#. placeholder {0}: target.fullName
#. placeholder {1}: roleLabelOf(role.code).title
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "{0} ya no trabaja como {1}"
msgstr "{0} ya no trabaja como {1}"

#. placeholder {0}: grant.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "{0} ya no ve «{title}» hasta que lo prendas"
msgstr "{0} ya no ve «{title}» hasta que lo prendas"

#. placeholder {0}: person.fullName
#. placeholder {1}: roleLabelOf(roleCode).title
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "{0} ya puede trabajar como {1}"
msgstr "{0} ya puede trabajar como {1}"

#. placeholder {0}: person.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "{0} ya tiene «{title}»"
msgstr "{0} ya tiene «{title}»"

#. placeholder {0}: weekRangeOf(item.week)
#. placeholder {1}: item.size
#: src/features/observability/components/CohortTimeline.tsx
msgid "{0}: {1} ingresos"
msgstr "{0}: {1} ingresos"

#. placeholder {0}: missingLaterFields.join(', ')
#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "{0}: eso lo completa el colaborador desde su app."
msgstr "{0}: eso lo completa el colaborador desde su app."

#. placeholder {0}: contract.hotelName
#: src/features/contracts/components/ContractPdfButton.tsx
msgid "{0}. Se firma fuera del sistema: el documento sale sin firmas."
msgstr "{0}. Se firma fuera del sistema: el documento sale sin firmas."

#. placeholder {0}: requisition.filledSlots
#. placeholder {1}: requisition.totalSlots
#: src/features/dashboard/components/RequisitionMiniList.tsx
msgid "{0}/{1} cubiertos"
msgstr "{0}/{1} cubiertos"

#. placeholder {0}: input.body.text.length
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "{0}/1024 · Las variables se agregan con el botón de abajo y no pueden ir al inicio ni al final."
msgstr "{0}/1024 · Las variables se agregan con el botón de abajo y no pueden ir al inicio ni al final."

#. placeholder {0}: contract.multipliers.overtime.bill.toFixed(2)
#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "{0}× lo facturado"
msgstr "{0}× lo facturado"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "{anomalies, plural, one {# día con anomalía} other {# días con anomalía}} por revisar: resuélvelos antes de enviar la semana"
msgstr "{anomalies, plural, one {# día con anomalía} other {# días con anomalía}} por revisar: resuélvelos antes de enviar la semana"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "{answeredCount} de {totalCount} contestados"
msgstr "{answeredCount} de {totalCount} contestados"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "{assignedName} asignado al slot"
msgstr "{assignedName} asignado al slot"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "{averageDays} d"
msgstr "{averageDays} d"

#: src/features/observability/components/CohortSection.tsx
msgid "{backMonday} de {size}"
msgstr "{backMonday} de {size}"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "{days, plural, one {Última actividad hace # día} other {Última actividad hace # días}}"
msgstr "{days, plural, one {Última actividad hace # día} other {Última actividad hace # días}}"

#: src/shared/lib/formatters.ts
msgid "{days} d en estado"
msgstr "{days} d en estado"

#: src/features/observability/components/KpiCard.tsx
#: src/shared/lib/formatters.ts
msgid "{days} días"
msgstr "{days} días"

#: src/features/accounting/components/ConsolidationPayStatus.tsx
msgid "{daysLate, plural, one {# día de atraso} other {# días de atraso}}"
msgstr "{daysLate, plural, one {# día de atraso} other {# días de atraso}}"

#: src/features/requisitions/components/RequisitionCardList.tsx
msgid "{department} · {positions, plural, one {# posición} other {# posiciones}}"
msgstr "{department} · {positions, plural, one {# posición} other {# posiciones}}"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "{failing, plural, one {# con problema} other {# con problemas}}"
msgstr "{failing, plural, one {# con problema} other {# con problemas}}"

#: src/features/requisitions/components/CoverageBar.tsx
msgid "{filled} de {total} posiciones · {label}"
msgstr "{filled} de {total} posiciones · {label}"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
#: src/features/recruitment/components/SelfPickPositionCard.tsx
msgid "{freeSlots, plural, one {# slot libre} other {# slots libres}}"
msgstr "{freeSlots, plural, one {# slot libre} other {# slots libres}}"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "{freeSlots} de {totalFreeSlots} coinciden con los filtros"
msgstr "{freeSlots} de {totalFreeSlots} coinciden con los filtros"

#: src/features/messaging/components/Pager.tsx
msgid "{from}–{to} de {total}"
msgstr "{from}–{to} de {total}"

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "{fullName} deja de aparecer en el Pool y en toda búsqueda. Si tiene correo corporativo, también se elimina su buzón."
msgstr "{fullName} deja de aparecer en el Pool y en toda búsqueda. Si tiene correo corporativo, también se elimina su buzón."

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "{fullName} queda activo y le llega su invitación"
msgstr "{fullName} queda activo y le llega su invitación"

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "{fullName} queda sin aprobar; se avisó a quien la propuso"
msgstr "{fullName} queda sin aprobar; se avisó a quien la propuso"

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "{fullName} se eliminó del Pool"
msgstr "{fullName} se eliminó del Pool"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "{hidden, plural, one {# más: búscala en el Pool de Colaboradores} other {# más: búscalas en el Pool de Colaboradores}}"
msgstr "{hidden, plural, one {# más: búscala en el Pool de Colaboradores} other {# más: búscalas en el Pool de Colaboradores}}"

#. placeholder {0}: ONBOARDING_STATUS_LABEL[currentStatus]
#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "{hotelName} · desde {0}. Solo ves los pasos que tu rol puede dar."
msgstr "{hotelName} · desde {0}. Solo ves los pasos que tu rol puede dar."

#. placeholder {0}: version.version
#: src/features/onboarding/components/ContractPreviewDialog.tsx
msgid "{hotelName} · Propuesta v{0}. Las tarifas se toman de esta versión."
msgstr "{hotelName} · Propuesta v{0}. Las tarifas se toman de esta versión."

#: src/features/onboarding/components/ContractUnlockedDialog.tsx
msgid "{hotelName} pasó a Amarillo: el contrato nace con las tarifas que ya se cotizaron en la propuesta — las revisas, ajustas lo que se haya negociado y lo guardas en Borrador."
msgstr "{hotelName} pasó a Amarillo: el contrato nace con las tarifas que ya se cotizaron en la propuesta — las revisas, ajustas lo que se haya negociado y lo guardas en Borrador."

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "{hotelName} ya está en Verde: puedes armar y enviar su propuesta aquí mismo, o hacerlo después desde su ficha."
msgstr "{hotelName} ya está en Verde: puedes armar y enviar su propuesta aquí mismo, o hacerlo después desde su ficha."

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "{hotelName}: {freeSlots, plural, one {ver su # slot libre} other {ver sus # slots libres}}"
msgstr "{hotelName}: {freeSlots, plural, one {ver su # slot libre} other {ver sus # slots libres}}"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "{hotelName}: {total, plural, one {ver su # requisición} other {ver sus # requisiciones}}"
msgstr "{hotelName}: {total, plural, one {ver su # requisición} other {ver sus # requisiciones}}"

#. placeholder {0}: members.length - leadCount
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "{leadCount, plural, one {# Líder} other {# Líderes}} y {0, plural, one {# Reclutadora} other {# Reclutadoras}}"
msgstr "{leadCount, plural, one {# Líder} other {# Líderes}} y {0, plural, one {# Reclutadora} other {# Reclutadoras}}"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "{memberCount, plural, one {# BD te reporta} other {# BDs te reportan}} · {totalOpen} prospectos abiertos y {totalConversions, plural, one {# conversión} other {# conversiones}} entre todos."
msgstr "{memberCount, plural, one {# BD te reporta} other {# BDs te reportan}} · {totalOpen} prospectos abiertos y {totalConversions, plural, one {# conversión} other {# conversiones}} entre todos."

#: src/shared/components/RefreshControl.tsx
msgid "{minutos, plural, one {Actualizado hace # minuto} other {Actualizado hace # minutos}}"
msgstr "{minutos, plural, one {Actualizado hace # minuto} other {Actualizado hace # minutos}}"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "{missing, plural, one {# hueco} other {# huecos}}"
msgstr "{missing, plural, one {# hueco} other {# huecos}}"

#: src/features/messaging/components/ContactActions.tsx
msgid "{name} quedó dado de baja."
msgstr "{name} quedó dado de baja."

#: src/features/messaging/components/ContactActions.tsx
msgid "{name} se eliminó."
msgstr "{name} se eliminó."

#: src/features/requisitions/components/RequisitionCardList.tsx
msgid "{number} · {department} · {positions, plural, one {# posición} other {# posiciones}}"
msgstr "{number} · {department} · {positions, plural, one {# posición} other {# posiciones}}"

#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "{okCount} se aprobaron; {failCount} no — algo cambió mientras tanto. Revísalas una por una."
msgstr "{okCount} se aprobaron; {failCount} no — algo cambió mientras tanto. Revísalas una por una."

#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "{okCount} semanas aprobadas"
msgstr "{okCount} semanas aprobadas"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "{openCount, plural, one {# abierta} other {# abiertas}}"
msgstr "{openCount, plural, one {# abierta} other {# abiertas}}"

#: src/shared/components/CardPagination.tsx
msgid "{page} de {totalPages}"
msgstr "{page} de {totalPages}"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "{pending, plural, one {# pendiente} other {# pendientes}}"
msgstr "{pending, plural, one {# pendiente} other {# pendientes}}"

#: src/features/messaging/components/WorkersSyncNotice.tsx
msgid "{pending} colaboradores nuevos sin sincronizar"
msgstr "{pending} colaboradores nuevos sin sincronizar"

#: src/features/recruitment/pages/PoolPage.tsx
msgid "{pendingDocsCount} por verificar"
msgstr "{pendingDocsCount} por verificar"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "{pendingValidation} en Blanco, por validar"
msgstr "{pendingValidation} en Blanco, por validar"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "{positionCount, plural, one {# posición} other {# posiciones}} · {totalSlots, plural, one {# slot} other {# slots}}"
msgstr "{positionCount, plural, one {# posición} other {# posiciones}} · {totalSlots, plural, one {# slot} other {# slots}}"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "{positions, plural, one {# posición} other {# posiciones}}"
msgstr "{positions, plural, one {# posición} other {# posiciones}}"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "{previousLifted, plural, one {# levantado} other {# levantados}}"
msgstr "{previousLifted, plural, one {# levantado} other {# levantados}}"

#: src/features/worker/pages/HomePage.tsx
msgid "{punched} de 4"
msgstr "{punched} de 4"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "{quantity, plural, one {# slot libre} other {# slots libres}}"
msgstr "{quantity, plural, one {# slot libre} other {# slots libres}}"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "{reason}: revisa la fecha de nacimiento."
msgstr "{reason}: revisa la fecha de nacimiento."

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "{requisitions, plural, one {# requisición} other {# requisiciones}}"
msgstr "{requisitions, plural, one {# requisición} other {# requisiciones}}"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "{selectedCount, plural, one {Importar # hotel} other {Importar # hoteles}}"
msgstr "{selectedCount, plural, one {Importar # hotel} other {Importar # hoteles}}"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "{sentCount} de {totalRecipients} enviados"
msgstr "{sentCount} de {totalRecipients} enviados"

#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "{slotCount} · {occupiedCount} asignadas"
msgstr "{slotCount} · {occupiedCount} asignadas"

#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "{slotCount} · {occupiedCount} ocupados"
msgstr "{slotCount} · {occupiedCount} ocupados"

#. placeholder {0}: position.startTime
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "{slots, plural, one {# slot} other {# slots}} · desde {startDate} · {0}"
msgstr "{slots, plural, one {# slot} other {# slots}} · desde {startDate} · {0}"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "{staleCount} sin actividad 7+ días"
msgstr "{staleCount} sin actividad 7+ días"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "{statusLabel} es un estado final: el ciclo ya no cambia de estado"
msgstr "{statusLabel} es un estado final: el ciclo ya no cambia de estado"

#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "{title}. Abrir en Mi Territorio"
msgstr "{title}. Abrir en Mi Territorio"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "{total, plural, one {# requisición} other {# requisiciones}}"
msgstr "{total, plural, one {# requisición} other {# requisiciones}}"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "{total} colaboradores sin teléfono válido"
msgstr "{total} colaboradores sin teléfono válido"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "{totalConversions, plural, one {# hotel convertido} other {# hoteles convertidos}} por tu equipo · tasa {teamRateLabel}"
msgstr "{totalConversions, plural, one {# hotel convertido} other {# hoteles convertidos}} por tu equipo · tasa {teamRateLabel}"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "{typedLength} caracteres. Lista para guardar."
msgstr "{typedLength} caracteres. Lista para guardar."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "{unmarked, plural, one {# día sin marca ni estado} other {# días sin marca ni estado}}: marca Descanso, OFF… en cada uno antes de enviar la semana"
msgstr "{unmarked, plural, one {# día sin marca ni estado} other {# días sin marca ni estado}}: marca Descanso, OFF… en cada uno antes de enviar la semana"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "{unresolvedCount, plural, one {# hoja sin tarifa, no incluida} other {# hojas sin tarifa, no incluidas}}"
msgstr "{unresolvedCount, plural, one {# hoja sin tarifa, no incluida} other {# hojas sin tarifa, no incluidas}}"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "{urgentCount, plural, one {# urgente} other {# urgentes}}"
msgstr "{urgentCount, plural, one {# urgente} other {# urgentes}}"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "{urgentRows, plural, one {# urgente} other {# urgentes}}"
msgstr "{urgentRows, plural, one {# urgente} other {# urgentes}}"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "{value} m"
msgstr "{value} m"

#: src/features/personnel/components/StandByDialog.tsx
msgid "{workerName} quedó en Stand-by"
msgstr "{workerName} quedó en Stand-by"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "{workerName} quedó reportado"
msgstr "{workerName} quedó reportado"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "{years} a"
msgstr "{years} a"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "% acumulado de destinatarios desde el inicio del envío."
msgstr "% acumulado de destinatarios desde el inicio del envío."

#: src/features/messaging/components/ReportCharts.tsx
msgid "% de destinatarios"
msgstr "% de destinatarios"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "← Volver a iniciar sesión"
msgstr "← Volver a iniciar sesión"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "+ Agregar posición"
msgstr "+ Agregar posición"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "+ Enlace"
msgstr "+ Enlace"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "+ Llamar"
msgstr "+ Llamar"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "+ Nueva etiqueta"
msgstr "+ Nueva etiqueta"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "+ Nueva plantilla"
msgstr "+ Nueva plantilla"

#: src/features/messaging/components/ContactActions.tsx
msgid "+ Nuevo contacto"
msgstr "+ Nuevo contacto"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "+ Respuesta rápida"
msgstr "+ Respuesta rápida"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "+{hidden} más"
msgstr "+{hidden} más"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "<0>Casos escalados.</0> Los que te escalan Líderes e Inspectores llegarán con la pantalla de <1>Incidencias</1>."
msgstr "<0>Casos escalados.</0> Los que te escalan Líderes e Inspectores llegarán con la pantalla de <1>Incidencias</1>."

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "<0>El contrato {activeContractNumber} queda vencido.</0> Solo puede haber uno vigente por hotel."
msgstr "<0>El contrato {activeContractNumber} queda vencido.</0> Solo puede haber uno vigente por hotel."

#. placeholder {0}: IS_DEV_UI ? ' (RR-15)' : ''
#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "<0>Gana el primero que confirma{0}.</0> Al tomar un slot se bloquea solo ese slot, no la requisición completa: otra Reclutadora puede seguir tomando los demás de la misma posición."
msgstr "<0>Gana el primero que confirma{0}.</0> Al tomar un slot se bloquea solo ese slot, no la requisición completa: otra Reclutadora puede seguir tomando los demás de la misma posición."

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "<0>Indicador de Calidad.</0> Lo mide QA, que todavía no tiene su módulo."
msgstr "<0>Indicador de Calidad.</0> Lo mide QA, que todavía no tiene su módulo."

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "<0>Tarifas y términos quedan bloqueados.</0> Si hace falta corregir algo, se desbloquea con un motivo."
msgstr "<0>Tarifas y términos quedan bloqueados.</0> Si hace falta corregir algo, se desbloquea con un motivo."

#. placeholder {0}: rate.payRate.toFixed(2)
#. placeholder {1}: rate.billRate.toFixed(2)
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "${0} pay · ${1} bill"
msgstr "${0} pay · ${1} bill"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "1 · La plantilla"
msgstr "1 · La plantilla"

#: src/features/messaging/components/WorkersSyncNotice.tsx
msgid "1 colaborador nuevo sin sincronizar"
msgstr "1 colaborador nuevo sin sincronizar"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "1 colaborador sin teléfono válido"
msgstr "1 colaborador sin teléfono válido"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "1 contacto elegido"
msgstr "1 contacto elegido"

#: src/features/contracts/utils/validity.ts
msgid "1 mes restante"
msgstr "1 mes restante"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "1 persona con acceso"
msgstr "1 persona con acceso"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "1 posición cotizada, con su pay rate y su bill rate."
msgstr "1 posición cotizada, con su pay rate y su bill rate."

#. placeholder {0}: formatMoney(cheapest)
#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "1 puesto · {0} el bill"
msgstr "1 puesto · {0} el bill"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "1 sin guardar"
msgstr "1 sin guardar"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "1 variable"
msgstr "1 variable"

#: src/shared/constants/workerEnums.ts
msgid "1–2 años"
msgstr "1–2 años"

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "100 = todos sus días salieron bien en esa medida"
msgstr "100 = todos sus días salieron bien en esa medida"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "2 · Arrastra el archivo o elígelo"
msgstr "2 · Arrastra el archivo o elígelo"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "2 camaristas y 1 houseman"
msgstr "2 camaristas y 1 houseman"

#: src/shared/constants/workerEnums.ts
msgid "3–5 años"
msgstr "3–5 años"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "a bill rate"
msgstr "a bill rate"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "A bill rate, no a lo que pagamos"
msgstr "A bill rate, no a lo que pagamos"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "A este correo le llega el contrato para firmar."
msgstr "A este correo le llega el contrato para firmar."

#: src/features/messaging/components/CampaignsTour.tsx
msgid "A estos colaboradores no les llega nada hasta que corrijas su teléfono en su expediente y vuelvas a sincronizar."
msgstr "A estos colaboradores no les llega nada hasta que corrijas su teléfono en su expediente y vuelvas a sincronizar."

#: src/features/worker/pages/Phase3Page.tsx
msgid "A quién llamamos y qué debemos saber"
msgstr "A quién llamamos y qué debemos saber"

#: src/features/messaging/pages/MessagingPage.tsx
msgid "A quién se le escribe"
msgstr "A quién se le escribe"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "A quien tenga al menos una de las etiquetas elegidas."
msgstr "A quien tenga al menos una de las etiquetas elegidas."

#: src/shared/constants/workerEnums.ts
msgid "A+"
msgstr "A+"

#: src/shared/constants/workerEnums.ts
msgid "A−"
msgstr "A−"

#: src/shared/constants/workerEnums.ts
msgid "AB+"
msgstr "AB+"

#: src/shared/constants/workerEnums.ts
msgid "AB−"
msgstr "AB−"

#: src/shared/constants/timesheetStatus.ts
msgid "Abierta"
msgstr "Abierta"

#: src/features/admin/components/AccountDeletionsSection.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Abiertas"
msgstr "Abiertas"

#: src/features/dashboard/components/StatusFunnel.tsx
msgid "abiertos"
msgstr "abiertos"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Abiertos"
msgstr "Abiertos"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Abre la hoja lista para descargar como PDF"
msgstr "Abre la hoja lista para descargar como PDF"

#: src/features/contracts/components/ContractSignatureCard.tsx
#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Abriendo DocuSign…"
msgstr "Abriendo DocuSign…"

#: src/features/worker/components/CameraCapture.tsx
msgid "Abriendo la cámara…"
msgstr "Abriendo la cámara…"

#: src/app/RequireSession.tsx
msgid "Abriendo tu sesión…"
msgstr "Abriendo tu sesión…"

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Abriendo…"
msgstr "Abriendo…"

#: src/features/contracts/components/ContractTable.tsx
msgid "Abrir"
msgstr "Abrir"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Abrir el original en pestaña nueva ↗"
msgstr "Abrir el original en pestaña nueva ↗"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Abrir en el editor"
msgstr "Abrir en el editor"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "Abrir expediente"
msgstr "Abrir expediente"

#: src/features/clients/components/ClientSpotlightCard.tsx
#: src/features/territory/components/HotelMapCard.tsx
msgid "Abrir ficha del hotel"
msgstr "Abrir ficha del hotel"

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "Abrir la requisición"
msgstr "Abrir la requisición"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Abrir la semana de este día en la vista Días"
msgstr "Abrir la semana de este día en la vista Días"

#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Abrir propuesta"
msgstr "Abrir propuesta"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Abrir su correo"
msgstr "Abrir su correo"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Abrir versión nueva"
msgstr "Abrir versión nueva"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Acceso"
msgstr "Acceso"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Acceso creado"
msgstr "Acceso creado"

#. placeholder {0}: grant.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Acceso de {0}"
msgstr "Acceso de {0}"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Acceso en Firebase"
msgstr "Acceso en Firebase"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Acceso y contraseñas"
msgstr "Acceso y contraseñas"

#: src/features/admin/pages/FeatureAccessPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Accesos especiales"
msgstr "Accesos especiales"

#: src/features/observability/lib/cohorts.ts
#: src/shared/constants/workerStatus.ts
msgid "Accidentado"
msgstr "Accidentado"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Accidente abierto"
msgstr "Accidente abierto"

#: src/features/observability/lib/cohorts.ts
msgid "Accidente laboral"
msgstr "Accidente laboral"

#: src/layouts/Sidebar.tsx
msgid "Accidentes"
msgstr "Accidentes"

#: src/features/observability/tabs/InspectionTab.tsx
msgid "Accidentes levantados a tiempo, inspecciones programadas y visitas a hoteles todavía no se pueden medir: el Manager de QA no lee accidentes y el sistema no guarda inspecciones programadas ni visitas."
msgstr "Accidentes levantados a tiempo, inspecciones programadas y visitas a hoteles todavía no se pueden medir: el Manager de QA no lee accidentes y el sistema no guarda inspecciones programadas ni visitas."

#: src/features/observability/lib/inspectionKpis.ts
msgid "Accidentes que todavía no se cierran, de todos los hoteles."
msgstr "Accidentes que todavía no se cierran, de todos los hoteles."

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/contracts/components/ContractTable.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Acciones"
msgstr "Acciones"

#. placeholder {0}: slot.assigneeName ?? ''
#. placeholder {0}: slot.workerName ?? ''
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Acciones de {0}"
msgstr "Acciones de {0}"

#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Aceptados por Meta"
msgstr "Aceptados por Meta"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Aceptando…"
msgstr "Aceptando…"

#: src/features/onboarding/components/HotelLocationMap.tsx
msgid "Acercar"
msgstr "Acercar"

#: src/features/worker/components/useFaceGuide.ts
msgid "Acércate un poco"
msgstr "Acércate un poco"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Activa"
msgstr "Activa"

#: src/features/onboarding/components/HotelDataCard.tsx
msgid "Activado como cliente"
msgstr "Activado como cliente"

#: src/features/contracts/components/ActivateContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Activando…"
msgstr "Activando…"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Activar contrato"
msgstr "Activar contrato"

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Activar el contrato"
msgstr "Activar el contrato"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Activar es del BDC"
msgstr "Activar es del BDC"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Activar, expirar o cancelar un contrato es del BDC."
msgstr "Activar, expirar o cancelar un contrato es del BDC."

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Actividad"
msgstr "Actividad"

#: src/features/observability/components/PeopleView.tsx
msgid "Actividad en el periodo"
msgstr "Actividad en el periodo"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/worker/pages/PermissionsPage.tsx
#: src/shared/constants/contractStatus.ts
msgid "Activo"
msgstr "Activo"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Activo — puede entrar al sistema"
msgstr "Activo — puede entrar al sistema"

#: src/features/admin/components/userListParts.tsx
msgid "Activos"
msgstr "Activos"

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Actualiza el estado"
msgstr "Actualiza el estado"

#: src/features/messaging/components/tours.ts
msgid "Actualiza sin recargar"
msgstr "Actualiza sin recargar"

#: src/shared/components/RefreshControl.tsx
msgid "Actualizado hace un momento"
msgstr "Actualizado hace un momento"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Actualizados"
msgstr "Actualizados"

#: src/features/contracts/components/ProposalSyncNotice.tsx
#: src/features/messaging/components/RefreshButton.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/shared/components/RefreshControl.tsx
msgid "Actualizando…"
msgstr "Actualizando…"

#: src/features/messaging/components/RefreshButton.tsx
#: src/shared/components/RefreshControl.tsx
msgid "Actualizar"
msgstr "Actualizar"

#: src/shared/components/RefreshControl.tsx
msgid "Actualizar {label}"
msgstr "Actualizar {label}"

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Actualizar con la v{latestVersion}"
msgstr "Actualizar con la v{latestVersion}"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Actualizar estado"
msgstr "Actualizar estado"

#: src/shared/constants/roles.ts
msgid "Administrador"
msgstr "Administrador"

#: src/shared/constants/roles.ts
msgid "Agente de Customer Service"
msgstr "Agente de Customer Service"

#: src/features/onboarding/types/hotelContactsForm.schema.ts
msgid "Agrega al menos un contacto"
msgstr "Agrega al menos un contacto"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Agrega al menos un puesto con su tarifa"
msgstr "Agrega al menos un puesto con su tarifa"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Agrega al menos un puesto con su tarifa: el cuadro es lo que el hotel acepta."
msgstr "Agrega al menos un puesto con su tarifa: el cuadro es lo que el hotel acepta."

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Agrega al menos una posición"
msgstr "Agrega al menos una posición"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Agrega la tarifa al contrato del hotel y pulsa «Recalcular»: esta factura las va a incluir."
msgstr "Agrega la tarifa al contrato del hotel y pulsa «Recalcular»: esta factura las va a incluir."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Agrega la tarifa en el contrato del hotel, o la tarifa interna del colaborador, y vuelve a cerrar la semana: lo que ya se cerró no se duplica."
msgstr "Agrega la tarifa en el contrato del hotel, o la tarifa interna del colaborador, y vuelve a cerrar la semana: lo que ya se cerró no se duplica."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Agregando…"
msgstr "Agregando…"

#. placeholder {0}: i18n._(editor.noun)
#. placeholder {0}: i18n._(tab.noun)
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Agregar {0}"
msgstr "Agregar {0}"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Agregar a Blacklist"
msgstr "Agregar a Blacklist"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Agregar contacto"
msgstr "Agregar contacto"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Agregar cuenta del hotel"
msgstr "Agregar cuenta del hotel"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Agregar deducción"
msgstr "Agregar deducción"

#. placeholder {0}: consolidation.worker.fullName
#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Agregar deducción a {0}"
msgstr "Agregar deducción a {0}"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Agregar la entrada que falta"
msgstr "Agregar la entrada que falta"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Agregar la salida que falta"
msgstr "Agregar la salida que falta"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Agregar marca manual"
msgstr "Agregar marca manual"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Agregar motivo"
msgstr "Agregar motivo"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Agregar otra posición"
msgstr "Agregar otra posición"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Agregar otro"
msgstr "Agregar otro"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Agregar otro contacto"
msgstr "Agregar otro contacto"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Agregar posición"
msgstr "Agregar posición"

#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Agregar puesto"
msgstr "Agregar puesto"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Agregar reactivo"
msgstr "Agregar reactivo"

#: src/features/schedule/components/AddShiftDialog.tsx
#: src/features/schedule/pages/SchedulePage.tsx
msgid "Agregar turno"
msgstr "Agregar turno"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Agregar un gasto extra (p. ej. Uber)"
msgstr "Agregar un gasto extra (p. ej. Uber)"

#: src/features/admin/pages/UsersPage.tsx
msgid "Agregar usuario"
msgstr "Agregar usuario"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Agregar variable"
msgstr "Agregar variable"

#: src/features/observability/components/CohortsView.tsx
msgid "Agrupar por"
msgstr "Agrupar por"

#: src/features/observability/components/KpiCard.tsx
#: src/layouts/RoleSwitcher.tsx
msgid "Ahora"
msgstr "Ahora"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ahora sigue Reclutamiento"
msgstr "Ahora sigue Reclutamiento"

#. placeholder {0}: roleLabelOf(roleCode).title
#: src/layouts/RoleSwitcher.tsx
msgid "Ahora trabajas como {0}"
msgstr "Ahora trabajas como {0}"

#. placeholder {0}: row.workerName
#: src/features/timesheet/components/AttendanceView.tsx
msgid "Ahora viendo a {0}"
msgstr "Ahora viendo a {0}"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "ajusta la tarifa de su posición"
msgstr "ajusta la tarifa de su posición"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Ajusta lo que ya se cotizó en la propuesta para esta posición."
msgstr "Ajusta lo que ya se cotizó en la propuesta para esta posición."

#: src/shared/hooks/useResizableSplit.ts
msgid "Ajustar ancho del formulario"
msgstr "Ajustar ancho del formulario"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Ajustar la tarifa de esta posición"
msgstr "Ajustar la tarifa de esta posición"

#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "Ajuste a la tarifa de la posición"
msgstr "Ajuste a la tarifa de la posición"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Ajuste aprobado"
msgstr "Ajuste aprobado"

#. placeholder {0}: formatMoney(Number(rateRequested))
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Ajuste de {0} pedido: pendiente de aprobación."
msgstr "Ajuste de {0} pedido: pendiente de aprobación."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Ajuste de tarifa"
msgstr "Ajuste de tarifa"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Ajuste de tarifa pedido: queda pendiente de que lo apruebe el Manager de QA"
msgstr "Ajuste de tarifa pedido: queda pendiente de que lo apruebe el Manager de QA"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Ajuste rechazado"
msgstr "Ajuste rechazado"

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Ajustes a incluir"
msgstr "Ajustes a incluir"

#: src/features/admin/pages/MailSettingsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Ajustes del correo"
msgstr "Ajustes del correo"

#. placeholder {0}: formatMoney(Number(payPreview.deductionAmount))
#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Ajustes incluidos -{0}"
msgstr "Ajustes incluidos -{0}"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/layouts/Sidebar.tsx
msgid "Ajustes pendientes"
msgstr "Ajustes pendientes"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Al 100% (Azul claro)"
msgstr "Al 100% (Azul claro)"

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Al activarlo, este hotel <0>empieza a cobrar</0>: desde la fecha de vigencia, la nómina de su gente y la factura del hotel se calculan con estas tarifas."
msgstr "Al activarlo, este hotel <0>empieza a cobrar</0>: desde la fecha de vigencia, la nómina de su gente y la factura del hotel se calculan con estas tarifas."

#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "Al convertirlo"
msgstr "Al convertirlo"

#. placeholder {0}: atCost.map((rate) => rate.positionName).join(', ')
#: src/features/contracts/components/ContractChecklist.tsx
msgid "Al costo, sin margen para Oranje: {0}. Es válido; si no era la intención, corrígelo con «Editar tarifas»."
msgstr "Al costo, sin margen para Oranje: {0}. Es válido; si no era la intención, corrígelo con «Editar tarifas»."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Al crear la cuenta, la persona recibe un correo de invitación y establece su contraseña."
msgstr "Al crear la cuenta, la persona recibe un correo de invitación y establece su contraseña."

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Al eliminar tu cuenta, tu acceso a Oranje se cierra de inmediato en la app y en el web. La eliminación se completa en 14 días."
msgstr "Al eliminar tu cuenta, tu acceso a Oranje se cierra de inmediato en la app y en el web. La eliminación se completa en 14 días."

#. placeholder {0}: currentPrimary.name
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "al guardar, {0} deja de serlo"
msgstr "al guardar, {0} deja de serlo"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Al hotel le llega el PDF para imprimirlo y firmarlo"
msgstr "Al hotel le llega el PDF para imprimirlo y firmarlo"

#. placeholder {0}: i18n._(effect.lead)
#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Al incluirlo, <0>{0}</0>: entra en la próxima corrida de pago de esta semana, la que corres desde el Consolidado."
msgstr "Al incluirlo, <0>{0}</0>: entra en la próxima corrida de pago de esta semana, la que corres desde el Consolidado."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Al levantarlo, el colaborador vuelve a <0>Blanco</0> — no a disponible: reingresa por la validación de la Reclutadora."
msgstr "Al levantarlo, el colaborador vuelve a <0>Blanco</0> — no a disponible: reingresa por la validación de la Reclutadora."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Al levantarlo, la persona reingresa por la validación de la Reclutadora, como si empezara."
msgstr "Al levantarlo, la persona reingresa por la validación de la Reclutadora, como si empezara."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Al marcar a otro como principal, el anterior deja de serlo en el mismo guardado."
msgstr "Al marcar a otro como principal, el anterior deja de serlo en el mismo guardado."

#: src/features/worker/pages/HomePage.tsx
msgid "Al ponchar se abre la cámara"
msgstr "Al ponchar se abre la cámara"

#: src/features/worker/pages/PunchPage.tsx
msgid "Al tocar el botón se abre la cámara. La foto confirma que eres tú; no se comparte con el hotel."
msgstr "Al tocar el botón se abre la cámara. La foto confirma que eres tú; no se comparte con el hotel."

#: src/features/onboarding/components/HotelLocationMap.tsx
msgid "Alejar"
msgstr "Alejar"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Alergias o condiciones médicas"
msgstr "Alergias o condiciones médicas"

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Algo en el sistema todavía depende de esta cuenta. Repórtalo para revisarlo."
msgstr "Algo en el sistema todavía depende de esta cuenta. Repórtalo para revisarlo."

#: src/app/RouteErrorPage.tsx
msgid "Algo salió mal al abrir esta pantalla. Vuelve a cargarla para intentarlo de nuevo."
msgstr "Algo salió mal al abrir esta pantalla. Vuelve a cargarla para intentarlo de nuevo."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Alguien más borró un reactivo de esta lista: recarga para ver el orden real."
msgstr "Alguien más borró un reactivo de esta lista: recarga para ver el orden real."

#. placeholder {0}: String(slotElegido)
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Alguien tomó el lugar {0} mientras llenabas esto. Se asignará el siguiente libre."
msgstr "Alguien tomó el lugar {0} mientras llenabas esto. Se asignará el siguiente libre."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Alta de personal del sistema"
msgstr "Alta de personal del sistema"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Alta de una cuenta del hotel"
msgstr "Alta de una cuenta del hotel"

#. placeholder {0}: formatDayMonth(worker.createdAt)
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Alta del {0}"
msgstr "Alta del {0}"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Alta en Oranje"
msgstr "Alta en Oranje"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Altas · 30 d"
msgstr "Altas · 30 d"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Altas · 30 días"
msgstr "Altas · 30 días"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Altas (30 días)"
msgstr "Altas (30 días)"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Altas de tu equipo todavía en Blanco"
msgstr "Altas de tu equipo todavía en Blanco"

#: src/shared/components/ApprovalTimelinessPanel.tsx
#: src/shared/constants/onboardingStatus.ts
msgid "Amarillo"
msgstr "Amarillo"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Amarillo · desviación"
msgstr "Amarillo · desviación"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/audits/components/AuditHistoryList.tsx
msgid "Ambiente y Recursos"
msgstr "Ambiente y Recursos"

#: src/features/admin/pages/UsersPage.tsx
msgid "Ámbito"
msgstr "Ámbito"

#: src/shared/constants/workerEnums.ts
msgid "Amistad"
msgstr "Amistad"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Análisis con historia; el pulso de hoy vive en el Dashboard"
msgstr "Análisis con historia; el pulso de hoy vive en el Dashboard"

#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Ancho de columna"
msgstr "Ancho de columna"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Anomalía sin resolver"
msgstr "Anomalía sin resolver"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/ContactImportsDialog.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/components/Pager.tsx
#: src/features/messaging/components/Tour.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/shared/components/CardPagination.tsx
msgid "Anterior"
msgstr "Anterior"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Antes de activar:"
msgstr "Antes de activar:"

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Antes de actualizar:"
msgstr "Antes de actualizar:"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "antes de deducciones"
msgstr "antes de deducciones"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Antes de enviar o activar:"
msgstr "Antes de enviar o activar:"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Antes de enviar:"
msgstr "Antes de enviar:"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Antes de guardar o enviar:"
msgstr "Antes de guardar o enviar:"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Antes de guardar:"
msgstr "Antes de guardar:"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Antes de pagar, se revisa"
msgstr "Antes de pagar, se revisa"

#. placeholder {0}: failing.map((check) => check.title.toLowerCase()).join(' · ')
#: src/features/contracts/components/ContractNextStep.tsx
msgid "Antes hay que resolver: {0}."
msgstr "Antes hay que resolver: {0}."

#: src/features/observability/lib/hotelKpis.ts
msgid "Anticipación"
msgstr "Anticipación"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Apagado"
msgstr "Apagado"

#: src/features/observability/tabs/SalesTab.tsx
msgid "Aparece quien tiene prospectos o registró intentos. Quien no tiene cartera ni actividad no se puede listar desde aquí. Las conversiones se le cuentan al dueño del prospecto."
msgstr "Aparece quien tiene prospectos o registró intentos. Quien no tiene cartera ni actividad no se puede listar desde aquí. Las conversiones se le cuentan al dueño del prospecto."

#: src/features/messaging/components/ContactActions.tsx
msgid "Apellido"
msgstr "Apellido"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Apellido del contacto"
msgstr "Apellido del contacto"

#: src/features/observability/pages/ObservabilityPage.tsx
msgid "Aprobación de ponches"
msgstr "Aprobación de ponches"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Aprobación oportuna de ponches"
msgstr "Aprobación oportuna de ponches"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/shared/constants/timesheetStatus.ts
msgid "Aprobada"
msgstr "Aprobada"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Aprobada y enviada a Oranje"
msgstr "Aprobada y enviada a Oranje"

#: src/features/accounting/types/settlement.constants.ts
msgid "Aprobada, sin enviar"
msgstr "Aprobada, sin enviar"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Aprobada. Falta registrar el envío al hotel."
msgstr "Aprobada. Falta registrar el envío al hotel."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Aprobado no es lo mismo que incluido: aquí ves qué haría cada uno a la próxima corrida y decides, uno por uno, antes de que pese en algo."
msgstr "Aprobado no es lo mismo que incluido: aquí ves qué haría cada uno a la próxima corrida y decides, uno por uno, antes de que pese en algo."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Aprobado por"
msgstr "Aprobado por"

#. placeholder {0}: row.approvedBy?.fullName ?? '—'
#. placeholder {1}: row.approvedAt && <> · {formatDateTime(row.approvedAt)}</>
#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Aprobado por {0}{1}"
msgstr "Aprobado por {0}{1}"

#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "Aprobados por el Manager de QA, sin decidir si pesan en esta nómina. Inclúyelos uno por uno."
msgstr "Aprobados por el Manager de QA, sin decidir si pesan en esta nómina. Inclúyelos uno por uno."

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Aprobados recientemente"
msgstr "Aprobados recientemente"

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/conversion/pages/ConversionPage.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/features/timesheet/components/BulkApproveButton.tsx
#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Aprobando…"
msgstr "Aprobando…"

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Aprobar"
msgstr "Aprobar"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Aprobar conversión"
msgstr "Aprobar conversión"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Aprobar factura"
msgstr "Aprobar factura"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Aprobar la conversión Rosa → Naranja —o devolverla a Café— es del BDC. Cuando la apruebe, el hotel queda como cliente activo y puede generar requisiciones."
msgstr "Aprobar la conversión Rosa → Naranja —o devolverla a Café— es del BDC. Cuando la apruebe, el hotel queda como cliente activo y puede generar requisiciones."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Aprobar semana"
msgstr "Aprobar semana"

#. placeholder {0}: eligible.length
#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "Aprobar todas ({0})"
msgstr "Aprobar todas ({0})"

#: src/features/observability/components/KpiCard.tsx
msgid "Aproximado"
msgstr "Aproximado"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Aprueban la semana:"
msgstr "Aprueban la semana:"

#: src/features/worker/components/QrScanner.tsx
msgid "Apunta al código impreso en el acceso del hotel. La app también toma tu ubicación."
msgstr "Apunta al código impreso en el acceso del hotel. La app también toma tu ubicación."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Aquí nace la cuenta de cada persona del equipo Oranje: quién es, qué rol tiene y a quién reporta."
msgstr "Aquí nace la cuenta de cada persona del equipo Oranje: quién es, qué rol tiene y a quién reporta."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Aquí no se captura contraseña: al crear, la persona recibe un correo de invitación y establece la suya. Hasta que entre por primera vez, la cuenta aparece como «Invitación enviada»."
msgstr "Aquí no se captura contraseña: al crear, la persona recibe un correo de invitación y establece la suya. Hasta que entre por primera vez, la cuenta aparece como «Invitación enviada»."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Aquí se piden las posiciones que no tienen departamento, las de otras industrias. Las ves completas en la pestaña «Posiciones». General no se renombra ni se elimina."
msgstr "Aquí se piden las posiciones que no tienen departamento, las de otras industrias. Las ves completas en la pestaña «Posiciones». General no se renombra ni se elimina."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "aquí termina el ciclo"
msgstr "aquí termina el ciclo"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Aquí ves lo básico de quien tienes asignado: sus datos de contacto y dónde trabaja. El semáforo, los documentos y el historial completo los lleva Reclutamiento."
msgstr "Aquí ves lo básico de quien tienes asignado: sus datos de contacto y dónde trabaja. El semáforo, los documentos y el historial completo los lleva Reclutamiento."

#: src/features/worker/pages/HomePage.tsx
msgid "Aquí ves tu estado, ponchas tus turnos y recibes los avisos de Reclutamiento y del hotel."
msgstr "Aquí ves tu estado, ponchas tus turnos y recibes los avisos de Reclutamiento y del hotel."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Aquí vive el acuerdo con cada hotel cliente: lo que se le cobra por hora y lo que se le paga a su gente. Antes de esto, el hotel todavía se estaba convenciendo — eso pasa en Propuestas."
msgstr "Aquí vive el acuerdo con cada hotel cliente: lo que se le cobra por hora y lo que se le paga a su gente. Antes de esto, el hotel todavía se estaba convenciendo — eso pasa en Propuestas."

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Archivando…"
msgstr "Archivando…"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Archivar ciclo"
msgstr "Archivar ciclo"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Archivar el ciclo"
msgstr "Archivar el ciclo"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Archivar no es marcar Rojo o Negro: esos estados se pueden reactivar. Esto cierra el ciclo para siempre."
msgstr "Archivar no es marcar Rojo o Negro: esos estados se pueden reactivar. Esto cierra el ciclo para siempre."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Archivo"
msgstr "Archivo"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Archivo del documento"
msgstr "Archivo del documento"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Archivo del SSN o ITIN"
msgstr "Archivo del SSN o ITIN"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Archivo para el vault"
msgstr "Archivo para el vault"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Archivo subido al vault"
msgstr "Archivo subido al vault"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Archivos sueltos de este hotel. Se ven igual desde Contrato y desde Propuesta."
msgstr "Archivos sueltos de este hotel. Se ven igual desde Contrato y desde Propuesta."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Arizona — Phoenix (sin horario de verano)"
msgstr "Arizona — Phoenix (sin horario de verano)"

#: src/shared/constants/onboardingStatus.ts
msgid "Armar y enviar propuesta"
msgstr "Armar y enviar propuesta"

#: src/features/observability/lib/people.ts
msgid "Arrancan en el periodo"
msgstr "Arrancan en el periodo"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Arrastra el mapa para dejar el pin en la entrada por donde llegan los colaboradores."
msgstr "Arrastra el mapa para dejar el pin en la entrada por donde llegan los colaboradores."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Arrastra la cinta o usa ‹ › para moverte entre semanas, como en el Timesheet del hotel. Cada día es de una persona y una requisición."
msgstr "Arrastra la cinta o usa ‹ › para moverte entre semanas, como en el Timesheet del hotel. Cada día es de una persona y una requisición."

#: src/features/onboarding/components/HotelLocationMap.tsx
msgid "Arrastra para ajustar la ubicación exacta"
msgstr "Arrastra para ajustar la ubicación exacta"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Arrastra para cambiar el orden"
msgstr "Arrastra para cambiar el orden"

#. placeholder {0}: String(index + 1)
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Arrastra para cambiar el orden del renglón {0}"
msgstr "Arrastra para cambiar el orden del renglón {0}"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Así quedó en Borrador, antes de validar y autorizar."
msgstr "Así quedó en Borrador, antes de validar y autorizar."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Así se leería"
msgstr "Así se leería"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Así se ve en WhatsApp"
msgstr "Así se ve en WhatsApp"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Así se verá"
msgstr "Así se verá"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Así se verá:"
msgstr "Así se verá:"

#: src/features/messaging/components/tours.ts
msgid "Así va la mensajería"
msgstr "Así va la mensajería"

#: src/shared/constants/workerStatus.ts
msgid "Asig. temporal"
msgstr "Asig. temporal"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Asignación de slot"
msgstr "Asignación de slot"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Asignaciones · 30 d"
msgstr "Asignaciones · 30 d"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Asignaciones · 30 días"
msgstr "Asignaciones · 30 días"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Asignaciones (30 días)"
msgstr "Asignaciones (30 días)"

#: src/features/worker/pages/HomePage.tsx
msgid "Asignaciones, cambios de turno y recordatorios llegan a Avisos. Revísalos cada día."
msgstr "Asignaciones, cambios de turno y recordatorios llegan a Avisos. Revísalos cada día."

#. placeholder {0}: formatDayMonthTime(slot.assignedAt)
#: src/features/requisitions/components/SlotList.tsx
msgid "Asignado {0}"
msgstr "Asignado {0}"

#. placeholder {0}: selected.assignment.hotelName
#. placeholder {1}: selected.assignment.requisitionNumber
#: src/features/recruitment/components/PoolRoster.tsx
msgid "Asignado en {0} · {1}"
msgstr "Asignado en {0} · {1}"

#: src/features/observability/lib/cohorts.ts
msgid "Asignado, pero sin ponches recientes"
msgstr "Asignado, pero sin ponches recientes"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Asignamos a {total, plural, one {la persona que pediste} other {las # personas que pediste}}."
msgstr "Asignamos a {total, plural, one {la persona que pediste} other {las # personas que pediste}}."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Asignando…"
msgstr "Asignando…"

#: src/features/requisitions/components/SlotList.tsx
msgid "Asignar al siguiente slot libre"
msgstr "Asignar al siguiente slot libre"

#. placeholder {0}: String(objetivo ?? board.nextFreeOrdinal)
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Asignar al slot {0}"
msgstr "Asignar al slot {0}"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Asignar colaborador"
msgstr "Asignar colaborador"

#: src/features/team/components/AssignTerritoryDialog.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "Asignar territorio"
msgstr "Asignar territorio"

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Asistencia"
msgstr "Asistencia"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/shared/components/GuidedTour.tsx
msgid "Atrás"
msgstr "Atrás"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Aún no hay cambios de estado."
msgstr "Aún no hay cambios de estado."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Aún no hay clientes activos"
msgstr "Aún no hay clientes activos"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Aún no hay nadie dado de alta con el rol al que reporta. Da de alta primero a esa persona."
msgstr "Aún no hay nadie dado de alta con el rol al que reporta. Da de alta primero a esa persona."

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Aún no hay propuestas"
msgstr "Aún no hay propuestas"

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Aún no hay prospectos abiertos"
msgstr "Aún no hay prospectos abiertos"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Aún no hay QR generado."
msgstr "Aún no hay QR generado."

#: src/features/requisitions/components/RequisitionCardList.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Aún no hay requisiciones"
msgstr "Aún no hay requisiciones"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Aún no te validan"
msgstr "Aún no te validan"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Aún no tienes asignación"
msgstr "Aún no tienes asignación"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Aún no tienes colaboradores asignados"
msgstr "Aún no tienes colaboradores asignados"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "aún sin calcular"
msgstr "aún sin calcular"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Aún sin cotizar ningún puesto"
msgstr "Aún sin cotizar ningún puesto"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "aún sin pin"
msgstr "aún sin pin"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Autenticación"
msgstr "Autenticación"

#: src/features/observability/lib/cohorts.ts
msgid "Automático"
msgstr "Automático"

#: src/features/requisitions/api/requisitionsApi.ts
#: src/features/requisitions/components/RequisitionTable.tsx
#: src/shared/constants/requisitionStatus.ts
msgid "Autorizada"
msgstr "Autorizada"

#. placeholder {0}: formatDayMonthTime(item.authorizedAt)
#: src/features/requisitions/components/RequisitionCardList.tsx
msgid "Autorizada {0}"
msgstr "Autorizada {0}"

#: src/shared/components/UrgencyChip.tsx
msgid "Autorizada {since, plural, one {hace # día} other {hace # días}}"
msgstr "Autorizada {since, plural, one {hace # día} other {hace # días}}"

#: src/shared/components/UrgencyChip.tsx
msgid "Autorizada hoy"
msgstr "Autorizada hoy"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Autorizadas hace más de 24 h y nadie las ha tomado; la más vieja primero"
msgstr "Autorizadas hace más de 24 h y nadie las ha tomado; la más vieja primero"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Autorizadas hace más de 24 h, sin tomar"
msgstr "Autorizadas hace más de 24 h, sin tomar"

#: src/features/dashboard/components/HotelDashboard.tsx
#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Autorizadas y en proceso"
msgstr "Autorizadas y en proceso"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Autorizadas, sin tomar (Self-Pick)"
msgstr "Autorizadas, sin tomar (Self-Pick)"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/types/settlement.constants.ts
#: src/features/observability/lib/inspectionKpis.ts
msgid "Autorizado"
msgstr "Autorizado"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Autorizar pago"
msgstr "Autorizar pago"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Avance"
msgstr "Avance"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Avance del envío"
msgstr "Avance del envío"

#. placeholder {0}: step.movedBy
#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "avanza el {0}"
msgstr "avanza el {0}"

#: src/shared/constants/catalogs.ts
msgid "Avanzado"
msgstr "Avanzado"

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Avisamos a la persona y a quien quede como su Líder. Sus requisiciones y colaboradores no cambian."
msgstr "Avisamos a la persona y a quien quede como su Líder. Sus requisiciones y colaboradores no cambian."

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Avisaremos al Administrador para que tu hotel tenga otro responsable."
msgstr "Avisaremos al Administrador para que tu hotel tenga otro responsable."

#: src/features/worker/components/MobileShell.tsx
#: src/features/worker/pages/NotificationsPage.tsx
msgid "Avisos"
msgstr "Avisos"

#: src/features/worker/components/MobileShell.tsx
msgid "Avisos · {unread}"
msgstr "Avisos · {unread}"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Avisos de trabajo: turnos, pagos, documentos. Llega también a EE. UU."
msgstr "Avisos de trabajo: turnos, pagos, documentos. Llega también a EE. UU."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "ayer"
msgstr "ayer"

#: src/shared/constants/onboardingStatus.ts
msgid "Azul claro"
msgstr "Azul claro"

#: src/shared/constants/workerEnums.ts
msgid "B+"
msgstr "B+"

#: src/shared/constants/workerEnums.ts
msgid "B−"
msgstr "B−"

#: src/features/personnel/components/StandByDialog.tsx
msgid "Bajó el ritmo de ocupación esta semana…"
msgstr "Bajó el ritmo de ocupación esta semana…"

#: src/shared/constants/catalogs.ts
msgid "Básico"
msgstr "Básico"

#: src/features/reports/pages/ReportsPage.tsx
msgid "BD"
msgstr "BD"

#. placeholder {0}: member.zoneNames.length > 0 ? t`Zonas ${formatList(member.zoneNames)}` : t`sin territorio asignado todavía`
#: src/features/team/pages/TeamPage.tsx
msgid "BD · {0}"
msgstr "BD · {0}"

#: src/features/team/pages/TeamPage.tsx
msgid "BDs a cargo"
msgstr "BDs a cargo"

#: src/features/worker/pages/HomePage.tsx
msgid "Bienvenido a Oranje"
msgstr "Bienvenido a Oranje"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Bienvenido al alta de personal"
msgstr "Bienvenido al alta de personal"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Bill rate"
msgstr "Bill rate"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Bill rate por hora"
msgstr "Bill rate por hora"

#: src/features/onboarding/components/ContactAttemptLog.tsx
msgid "Bitácora de intentos de contacto"
msgstr "Bitácora de intentos de contacto"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Bitácora de la requisición"
msgstr "Bitácora de la requisición"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "BLACK · Blacklist"
msgstr "BLACK · Blacklist"

#: src/features/observability/lib/cohorts.ts
#: src/features/observability/lib/workerKpis.ts
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/layouts/Sidebar.tsx
#: src/shared/constants/workerStatus.ts
msgid "Blacklist"
msgstr "Blacklist"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Bloqueado"
msgstr "Bloqueado"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Bloqueando…"
msgstr "Bloqueando…"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Bloquear"
msgstr "Bloquear"

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
#: src/features/recruitment/pages/SelfPickPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Bolsa · Self-Pick"
msgstr "Bolsa · Self-Pick"

#: src/features/accounting/types/settlement.constants.ts
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/observability/lib/inspectionKpis.ts
#: src/features/onboarding/components/ProposalVersionHistory.tsx
#: src/shared/constants/contractStatus.ts
msgid "Borrador"
msgstr "Borrador"

#: src/features/onboarding/components/ProposalVersionList.tsx
msgid "Borrador · sin enviar"
msgstr "Borrador · sin enviar"

#. placeholder {0}: campaign.name
#. placeholder {1}: campaign.totalRecipients
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Borrador «{0}» creado: le llegaría a {1} contactos."
msgstr "Borrador «{0}» creado: le llegaría a {1} contactos."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Borrador → la Contadora lo valida contra los Timesheets aprobados → el Manager de Contabilidad autoriza (segunda firma) → se registra el pago."
msgstr "Borrador → la Contadora lo valida contra los Timesheets aprobados → el Manager de Contabilidad autoriza (segunda firma) → se registra el pago."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Borrador cancelado"
msgstr "Borrador cancelado"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Borrador cancelado: nunca rigió"
msgstr "Borrador cancelado: nunca rigió"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Borrador descartado"
msgstr "Borrador descartado"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Borrador guardado"
msgstr "Borrador guardado"

#. placeholder {0}: formatDateTime(restoredDraftAt)
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Borrador recuperado (guardado el {0})."
msgstr "Borrador recuperado (guardado el {0})."

#. placeholder {0}: formatDateTime(restoredDraftAt)
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Borrador recuperado (guardado el {0}). El hotel ya quedó registrado: al crear se completa lo que faltó."
msgstr "Borrador recuperado (guardado el {0}). El hotel ya quedó registrado: al crear se completa lo que faltó."

#: src/features/onboarding/pages/ProposalListPage.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Borrador sin enviar"
msgstr "Borrador sin enviar"

#. placeholder {0}: last.version
#. placeholder {0}: prospect.latestProposalVersion
#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/utils/resolveActivityLabel.ts
msgid "Borrador v{0}"
msgstr "Borrador v{0}"

#. placeholder {0}: draft.version
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Borrador v{0} · en elaboración"
msgstr "Borrador v{0} · en elaboración"

#. placeholder {0}: String(version)
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Borrador v{0} abierto"
msgstr "Borrador v{0} abierto"

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "Borrador v1 abierto"
msgstr "Borrador v1 abierto"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Borrador, sin enviar"
msgstr "Borrador, sin enviar"

#. placeholder {0}: doc.displayName
#. placeholder {0}: documentTypeLabel(doc.documentType)
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Borrar {0}"
msgstr "Borrar {0}"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Borrar el documento"
msgstr "Borrar el documento"

#: src/features/onboarding/components/PlacesSearchField.tsx
msgid "Borrar la búsqueda"
msgstr "Borrar la búsqueda"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Botones"
msgstr "Botones"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Botones (opcional)"
msgstr "Botones (opcional)"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Bruto"
msgstr "Bruto"

#. placeholder {0}: formatMoney(totalGross)
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Bruto {0}"
msgstr "Bruto {0}"

#: src/features/messaging/components/tours.ts
msgid "Busca a quien sea"
msgstr "Busca a quien sea"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Busca el hotel en Google"
msgstr "Busca el hotel en Google"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Busca el hotel o marca el punto en el mapa"
msgstr "Busca el hotel o marca el punto en el mapa"

#: src/shared/components/PhoneInput.tsx
msgid "Busca el país"
msgstr "Busca el país"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Busca por folio o por hotel, o filtra por estado. «Quitar filtros» te devuelve el tablero completo."
msgstr "Busca por folio o por hotel, o filtra por estado. «Quitar filtros» te devuelve el tablero completo."

#: src/features/messaging/components/tours.ts
msgid "Busca una etiqueta"
msgstr "Busca una etiqueta"

#: src/features/onboarding/components/PlacesSearchField.tsx
msgid "Buscador no disponible: marca la ubicación directo en el mapa"
msgstr "Buscador no disponible: marca la ubicación directo en el mapa"

#: src/shared/components/SearchField.tsx
msgid "Buscando"
msgstr "Buscando"

#. placeholder {0}: term.trim()
#: src/layouts/GlobalSearch.tsx
msgid "Buscando «{0}»…"
msgstr "Buscando «{0}»…"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Buscando los cambios disponibles…"
msgstr "Buscando los cambios disponibles…"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Buscando…"
msgstr "Buscando…"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Buscar"
msgstr "Buscar"

#: src/features/team/pages/TeamPage.tsx
msgid "Buscar BD"
msgstr "Buscar BD"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Buscar colaborador"
msgstr "Buscar colaborador"

#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Buscar colaboradores"
msgstr "Buscar colaboradores"

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Buscar contactos"
msgstr "Buscar contactos"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Buscar contrato"
msgstr "Buscar contrato"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Buscar cuenta del hotel"
msgstr "Buscar cuenta del hotel"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Buscar destinatarios"
msgstr "Buscar destinatarios"

#. placeholder {0}: tab ? i18n._(tab.label) : ''
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Buscar en {0}"
msgstr "Buscar en {0}"

#: src/features/team/pages/HotelTeamPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Buscar en tu equipo"
msgstr "Buscar en tu equipo"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Buscar en tu plantel"
msgstr "Buscar en tu plantel"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Buscar etiqueta…"
msgstr "Buscar etiqueta…"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Buscar etiquetas"
msgstr "Buscar etiquetas"

#: src/features/clients/components/ClientFilters.tsx
#: src/features/contracts/components/MissingContractsNotice.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Buscar hotel"
msgstr "Buscar hotel"

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Buscar hotel en la cola"
msgstr "Buscar hotel en la cola"

#: src/features/territory/pages/TerritoryPage.tsx
msgid "Buscar hotel en mi territorio"
msgstr "Buscar hotel en mi territorio"

#: src/layouts/GlobalSearch.tsx
#: src/layouts/Header.tsx
msgid "Buscar hoteles, requisiciones o colaboradores"
msgstr "Buscar hoteles, requisiciones o colaboradores"

#: src/layouts/Header.tsx
msgid "Buscar hoteles, requisiciones, colaboradores…"
msgstr "Buscar hoteles, requisiciones, colaboradores…"

#: src/features/onboarding/components/PlacesSearchField.tsx
msgid "Buscar la ubicación del hotel"
msgstr "Buscar la ubicación del hotel"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Buscar persona con funciones adicionales"
msgstr "Buscar persona con funciones adicionales"

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Buscar por nombre, teléfono o email…"
msgstr "Buscar por nombre, teléfono o email…"

#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/components/SyncWorkersButton.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Buscar por nombre…"
msgstr "Buscar por nombre…"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Buscar reactivo"
msgstr "Buscar reactivo"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Buscar requisición"
msgstr "Buscar requisición"

#: src/features/admin/pages/UsersPage.tsx
msgid "Buscar usuario"
msgstr "Buscar usuario"

#: src/shared/constants/roles.ts
msgid "Business Developer"
msgstr "Business Developer"

#: src/shared/constants/roles.ts
msgid "Business Developer Coordinator"
msgstr "Business Developer Coordinator"

#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "búsqueda «{searchTerm}»"
msgstr "búsqueda «{searchTerm}»"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Buzón"
msgstr "Buzón"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Buzón creado"
msgstr "Buzón creado"

#. placeholder {0}: credential.email
#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Buzón creado: {0}"
msgstr "Buzón creado: {0}"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Buzón de correo"
msgstr "Buzón de correo"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Buzón eliminado"
msgstr "Buzón eliminado"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Buzón sin crear"
msgstr "Buzón sin crear"

#. placeholder {0}: hotel.name
#. placeholder {1}: weekRangeOf(hotel.firstWeek)
#: src/features/observability/components/CohortsView.tsx
msgid "Cada barra es una semana y su número, cuántas personas empezaron a ponchar en {0} esa semana (desde {1}). Toca una barra o usa las flechas para moverte; lo sombreado son las 12 semanas que se comparan abajo."
msgstr "Cada barra es una semana y su número, cuántas personas empezaron a ponchar en {0} esa semana (desde {1}). Toca una barra o usa las flechas para moverte; lo sombreado son las 12 semanas que se comparan abajo."

#: src/features/observability/components/CohortsView.tsx
msgid "Cada barra es una semana y su número, cuántas personas empezaron a trabajar esa semana. Toca una barra o usa las flechas para moverte; lo sombreado son las 12 semanas que se comparan abajo."
msgstr "Cada barra es una semana y su número, cuántas personas empezaron a trabajar esa semana. Toca una barra o usa las flechas para moverte; lo sombreado son las 12 semanas que se comparan abajo."

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Cada borrador tiene su botón Enviar, con confirmación. Ahí sí sale por WhatsApp a todos sus destinatarios."
msgstr "Cada borrador tiene su botón Enviar, con confirmación. Ahí sí sale por WhatsApp a todos sus destinatarios."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Cada cambio de estado, con quién lo hizo y cuándo"
msgstr "Cada cambio de estado, con quién lo hizo y cuándo"

#: src/features/onboarding/components/StatusTimeline.tsx
msgid "Cada cambio de estado, con quién lo hizo y por qué"
msgstr "Cada cambio de estado, con quién lo hizo y por qué"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Cada cuenta pertenece a un solo hotel. El primer Manager General nace en la Conversión"
msgstr "Cada cuenta pertenece a un solo hotel. El primer Manager General nace en la Conversión"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Cada deducción dice de qué tipo es y, si hace falta, de dónde sale, para que la Contadora pueda cotejarla."
msgstr "Cada deducción dice de qué tipo es y, si hace falta, de dónde sale, para que la Contadora pueda cotejarla."

#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Cada envío congela una versión. Renegociar es abrir una nueva, que arranca con las tarifas de la anterior."
msgstr "Cada envío congela una versión. Renegociar es abrir una nueva, que arranca con las tarifas de la anterior."

#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Cada envío queda como una versión; ninguna se borra."
msgstr "Cada envío queda como una versión; ninguna se borra."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Cada estado avanza solo hacia el siguiente; el semáforo nunca retrocede."
msgstr "Cada estado avanza solo hacia el siguiente; el semáforo nunca retrocede."

#: src/features/messaging/components/tours.ts
msgid "Cada etiqueta dice cuántos contactos tiene; desde aquí ves a quiénes o la eliminas."
msgstr "Cada etiqueta dice cuántos contactos tiene; desde aquí ves a quiénes o la eliminas."

#: src/features/messaging/components/ContactImportsDialog.tsx
msgid "Cada Excel importado, con la lista que le puso a sus contactos. Reimportar nunca borra datos."
msgstr "Cada Excel importado, con la lista que le puso a sus contactos. Reimportar nunca borra datos."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Cada fila es un hotel y una semana con hojas pendientes, con el Manager de Área responsable de ese departamento."
msgstr "Cada fila es un hotel y una semana con hojas pendientes, con el Manager de Área responsable de ese departamento."

#: src/features/observability/components/CohortsView.tsx
msgid "Cada fila son quienes ingresaron esa semana; cada columna, qué parte trabajó k semanas después. La columna en curso todavía puede subir."
msgstr "Cada fila son quienes ingresaron esa semana; cada columna, qué parte trabajó k semanas después. La columna en curso todavía puede subir."

#: src/features/observability/components/CohortsView.tsx
msgid "Cada fila son quienes ingresaron ese mes; cada columna, qué parte trabajó k meses después. El mes en curso todavía puede subir."
msgstr "Cada fila son quienes ingresaron ese mes; cada columna, qué parte trabajó k meses después. El mes en curso todavía puede subir."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Cada inspección queda con su calificación y su fecha. Si te equivocaste en un reactivo, desde aquí la corriges: no se borra, se corrige."
msgstr "Cada inspección queda con su calificación y su fecha. Si te equivocaste en un reactivo, desde aquí la corriges: no se borra, se corrige."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Cada intento cuenta la historia"
msgstr "Cada intento cuenta la historia"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Cada línea se compara contra el Timesheet aprobado: horas, rate y descuentos."
msgstr "Cada línea se compara contra el Timesheet aprobado: horas, rate y descuentos."

#: src/features/requisitions/components/SlotList.tsx
msgid "Cada lugar es una persona que pediste. Aquí ves quién llega a cada uno."
msgstr "Cada lugar es una persona que pediste. Aquí ves quién llega a cada uno."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Cada persona trae su estado del Semáforo. Búscala por nombre y tócala para ver su detalle del día."
msgstr "Cada persona trae su estado del Semáforo. Búscala por nombre y tócala para ver su detalle del día."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Cada posición con fecha y hora"
msgstr "Cada posición con fecha y hora"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Cada puesto con sus lugares. Donde dice «Sin asignar» puedes tocar para llenarlo, y si ya está ocupado te lleva al perfil de quien lo cubre."
msgstr "Cada puesto con sus lugares. Donde dice «Sin asignar» puedes tocar para llenarlo, y si ya está ocupado te lleva al perfil de quien lo cubre."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Cada quien recibe el suyo."
msgstr "Cada quien recibe el suyo."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Cada reactivo pesa lo suyo"
msgstr "Cada reactivo pesa lo suyo"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Cada renglón es un puesto que el hotel pidió: cuántas personas, desde cuándo y con qué modalidad. Cada persona pedida es un <0>slot</0>, y los slots se llenan en orden. <1>Cobertura</1> dice cuántos ya tienen a alguien; <2>Urgencia</2>, cuánto falta para que empiece."
msgstr "Cada renglón es un puesto que el hotel pidió: cuántas personas, desde cuándo y con qué modalidad. Cada persona pedida es un <0>slot</0>, y los slots se llenan en orden. <1>Cobertura</1> dice cuántos ya tienen a alguien; <2>Urgencia</2>, cuánto falta para que empiece."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Cada renglón es un puesto que pediste: cuántas personas, desde cuándo y con qué modalidad. <0>Cobertura</0> dice a cuántas ya les asignamos a alguien; <1>Urgencia</1>, cuánto falta para que empiecen."
msgstr "Cada renglón es un puesto que pediste: cuántas personas, desde cuándo y con qué modalidad. <0>Cobertura</0> dice a cuántas ya les asignamos a alguien; <1>Urgencia</1>, cuánto falta para que empiecen."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Cada semana, el pago al colaborador y el cobro al hotel se calculan con estas tarifas y estos recargos. Si el contrato no está activo, ese hotel no puede facturar."
msgstr "Cada semana, el pago al colaborador y el cobro al hotel se calculan con estas tarifas y estos recargos. Si el contrato no está activo, ese hotel no puede facturar."

#: src/features/requisitions/components/SlotList.tsx
msgid "Cada slot es un lugar por cubrir. Un slot libre se puede borrar; uno ocupado no."
msgstr "Cada slot es un lugar por cubrir. Un slot libre se puede borrar; uno ocupado no."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Cada tarjeta trae su urgencia y cuánto lleva cubierto. Toca el color y te dice desde cuándo corre y cuándo empieza el puesto."
msgstr "Cada tarjeta trae su urgencia y cuánto lleva cubierto. Toca el color y te dice desde cuándo corre y cuándo empieza el puesto."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Cada unidad de Cantidad es un lugar por cubrir"
msgstr "Cada unidad de Cantidad es un lugar por cubrir"

#: src/shared/constants/onboardingStatus.ts
msgid "Cafe"
msgstr "Cafe"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Café"
msgstr "Café"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Calendario de pago y aprobación"
msgstr "Calendario de pago y aprobación"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Calidad"
msgstr "Calidad"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Calificación preliminar"
msgstr "Calificación preliminar"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Calle, ciudad y estado"
msgstr "Calle, ciudad y estado"

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Cámara"
msgstr "Cámara"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "Cambia el estado o la búsqueda, o quítalos con «Quitar filtros» para ver todas las de este hotel."
msgstr "Cambia el estado o la búsqueda, o quítalos con «Quitar filtros» para ver todas las de este hotel."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Cambia el estado o la búsqueda, o quítalos con «Quitar filtros» para volver a ver el tablero completo."
msgstr "Cambia el estado o la búsqueda, o quítalos con «Quitar filtros» para volver a ver el tablero completo."

#: src/features/contracts/components/ContractRowList.tsx
msgid "Cambia el estado, la zona o la búsqueda. Un hotel gana su contrato al cerrar la negociación."
msgstr "Cambia el estado, la zona o la búsqueda. Un hotel gana su contrato al cerrar la negociación."

#: src/shared/components/MascotaPeek.tsx
msgid "Cambia el idioma desde tu tarjeta de perfil, abajo del menú."
msgstr "Cambia el idioma desde tu tarjeta de perfil, abajo del menú."

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Cambia ese filtro o quítalo con «Quitar filtros» para volver a ver el tablero completo."
msgstr "Cambia ese filtro o quítalo con «Quitar filtros» para volver a ver el tablero completo."

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Cambia la búsqueda o límpiala para volver a ver todos los prospectos en Rosa."
msgstr "Cambia la búsqueda o límpiala para volver a ver todos los prospectos en Rosa."

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Cambia tu contraseña"
msgstr "Cambia tu contraseña"

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Cambia tu contraseña para seguir"
msgstr "Cambia tu contraseña para seguir"

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
msgid "Cambia un filtro, o quítalos con «Quitar filtros» para ver todos los slots libres de este hotel."
msgstr "Cambia un filtro, o quítalos con «Quitar filtros» para ver todos los slots libres de este hotel."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Cambiando…"
msgstr "Cambiando…"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/worker/components/PhotoUploader.tsx
msgid "Cambiar"
msgstr "Cambiar"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Cambiar archivo"
msgstr "Cambiar archivo"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/worker/components/AccessDeadlineBanner.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Cambiar contraseña"
msgstr "Cambiar contraseña"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Cambiar de Líder"
msgstr "Cambiar de Líder"

#. placeholder {0}: member.fullName
#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Cambiar de Líder a {0}"
msgstr "Cambiar de Líder a {0}"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Cambiar de persona es dar de baja este usuario y dar de alta al nuevo."
msgstr "Cambiar de persona es dar de baja este usuario y dar de alta al nuevo."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/onboarding/pages/ProspectDetailPage.tsx
#: src/features/recruitment/components/ChangeStateDialog.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Cambiar estado"
msgstr "Cambiar estado"

#: src/features/admin/components/PaymentLimitsSection.tsx
#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Cambiar esto es del Administrador."
msgstr "Cambiar esto es del Administrador."

#: src/features/worker/components/PhotoUploader.tsx
msgid "Cambiar foto"
msgstr "Cambiar foto"

#: src/layouts/RoleSwitcher.tsx
msgid "Cambiar función"
msgstr "Cambiar función"

#: src/layouts/RoleSwitcher.tsx
msgid "Cambiar función. Ahora trabajas como {activeTitle}"
msgstr "Cambiar función. Ahora trabajas como {activeTitle}"

#: src/features/worker/components/PhotoUploader.tsx
msgid "Cambiar mi foto"
msgstr "Cambiar mi foto"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Campaña"
msgstr "Campaña"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/pages/MessagingPage.tsx
msgid "Campañas"
msgstr "Campañas"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Campañas del periodo"
msgstr "Campañas del periodo"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Campañas enviadas"
msgstr "Campañas enviadas"

#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Campañas recientes"
msgstr "Campañas recientes"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Canal y resultado, de la lista"
msgstr "Canal y resultado, de la lista"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Cancelada"
msgstr "Cancelada"

#. placeholder {0}: formatInstantDate(row.cancelledAt)
#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Cancelada el {0}"
msgstr "Cancelada el {0}"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Canceladas"
msgstr "Canceladas"

#: src/shared/constants/contractStatus.ts
msgid "Cancelado"
msgstr "Cancelado"

#: src/features/contracts/components/ContractSignatureCard.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cancelando…"
msgstr "Cancelando…"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/components/PayConsolidationButton.tsx
#: src/features/accounting/components/PayOverrideDialog.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/admin/components/RoleGrantsSection.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/admin/pages/FeatureAccessPage.tsx
#: src/features/audits/components/AuditFormDialog.tsx
#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/components/ProposalSyncNotice.tsx
#: src/features/contracts/components/SignAndSendDialog.tsx
#: src/features/contracts/components/UnlockContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/ImportContactsDialog.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/features/onboarding/components/ArchiveCycleDialog.tsx
#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
#: src/features/onboarding/components/DeleteHotelAction.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/HotelPunchQrCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/components/RegisterAttemptDialog.tsx
#: src/features/onboarding/import/ImportProspectsDialog.tsx
#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
#: src/features/recruitment/components/ChangeStateDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/DeleteWorkerDialog.tsx
#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/requisitions/components/SlotList.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
#: src/features/schedule/components/AddShiftDialog.tsx
#: src/features/team/components/AssignTerritoryDialog.tsx
#: src/features/team/components/MoveRecruiterDialog.tsx
#: src/features/timesheet/components/BulkApproveButton.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/WeekActionBar.tsx
#: src/features/worker/components/CameraCapture.tsx
#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
#: src/shared/components/SendDocumentModal.tsx
msgid "Cancelar"
msgstr "Cancelar"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cancelar borrador"
msgstr "Cancelar borrador"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Cancelar campaña"
msgstr "Cancelar campaña"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Cancelar edición"
msgstr "Cancelar edición"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cancelar edición de datos del documento"
msgstr "Cancelar edición de datos del documento"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Cancelar edición de multiplicadores"
msgstr "Cancelar edición de multiplicadores"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cancelar edición de vigencia"
msgstr "Cancelar edición de vigencia"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Cancelar envío"
msgstr "Cancelar envío"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Cancelar la solicitud"
msgstr "Cancelar la solicitud"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Cancelar solicitud"
msgstr "Cancelar solicitud"

#: src/features/observability/lib/people.ts
msgid "Candidatos dados de alta"
msgstr "Candidatos dados de alta"

#. placeholder {0}: position.quantity
#: src/features/requisitions/components/SlotList.tsx
msgid "Cant. {0}"
msgstr "Cant. {0}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Cantidad"
msgstr "Cantidad"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Cantidad {ordinal}"
msgstr "Cantidad {ordinal}"

#: src/features/observability/lib/inspectionKpis.ts
msgid "Capturado en sitio"
msgstr "Capturado en sitio"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Capturar una marca que el ponche no registró, con motivo"
msgstr "Capturar una marca que el ponche no registró, con motivo"

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "cargado, en verificación"
msgstr "cargado, en verificación"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Cargado, sin verificar"
msgstr "Cargado, sin verificar"

#: src/features/worker/components/WorkerSkeleton.tsx
msgid "Cargando"
msgstr "Cargando"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Cargando archivos…"
msgstr "Cargando archivos…"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Cargando bitácora…"
msgstr "Cargando bitácora…"

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Cargando la cola…"
msgstr "Cargando la cola…"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Cargando los pasos disponibles…"
msgstr "Cargando los pasos disponibles…"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Cargando motivos…"
msgstr "Cargando motivos…"

#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Cargando propuestas…"
msgstr "Cargando propuestas…"

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Cargando prospectos…"
msgstr "Cargando prospectos…"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Cargando quién firma…"
msgstr "Cargando quién firma…"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Cargando requisiciones…"
msgstr "Cargando requisiciones…"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Cargando…"
msgstr "Cargando…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Catálogo"
msgstr "Catálogo"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Catálogo actualizado"
msgstr "Catálogo actualizado"

#: src/features/admin/pages/CatalogsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Catálogos"
msgstr "Catálogos"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Categoría"
msgstr "Categoría"

#: src/features/worker/components/useFaceGuide.ts
msgid "Centra tu cara en el óvalo"
msgstr "Centra tu cara en el óvalo"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Central — Chicago, Houston, Dallas"
msgstr "Central — Chicago, Houston, Dallas"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Centro de México — CDMX, Guadalajara, Monterrey"
msgstr "Centro de México — CDMX, Guadalajara, Monterrey"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Cerrada"
msgstr "Cerrada"

#: src/features/observability/lib/inspectionKpis.ts
msgid "Cerrado"
msgstr "Cerrado"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Cerrando…"
msgstr "Cerrando…"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/clients/pages/ClientPortfolioPage.tsx
#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/ContactImportsDialog.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
#: src/features/onboarding/components/ContractPreviewDialog.tsx
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/requisitions/components/RequisitionJournalDialog.tsx
#: src/features/timesheet/components/DayStatusTour.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/shared/components/GuidedTour.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Cerrar"
msgstr "Cerrar"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Cerrar edición de cláusulas"
msgstr "Cerrar edición de cláusulas"

#: src/features/worker/components/QrScanner.tsx
msgid "Cerrar el lector"
msgstr "Cerrar el lector"

#: src/features/territory/components/HotelMapCard.tsx
msgid "Cerrar la ficha del hotel"
msgstr "Cerrar la ficha del hotel"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Cerrar lista de contratos"
msgstr "Cerrar lista de contratos"

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Cerrar lista de propuestas"
msgstr "Cerrar lista de propuestas"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Cerrar semana"
msgstr "Cerrar semana"

#: src/features/worker/components/MobileShell.tsx
#: src/layouts/Sidebar.tsx
#: src/mobile/UnsupportedRolePage.tsx
msgid "Cerrar sesión"
msgstr "Cerrar sesión"

#. placeholder {0}: formatDate(prospect.cycleStartedAt)
#. placeholder {1}: prospect.daysInStatus
#. placeholder {2}: prospect.owner.name
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Ciclo abierto desde {0} · {1} días en {statusLabel} · Dueño: {2}"
msgstr "Ciclo abierto desde {0} · {1} días en {statusLabel} · Dueño: {2}"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Ciclo archivado"
msgstr "Ciclo archivado"

#: src/features/observability/lib/salesKpis.ts
msgid "Ciclo de onboarding"
msgstr "Ciclo de onboarding"

#: src/features/team/pages/TeamPage.tsx
msgid "Ciclos abiertos por estado"
msgstr "Ciclos abiertos por estado"

#: src/features/observability/lib/salesKpis.ts
msgid "Ciclos cerrados en Rechazo sobre los ciclos que terminaron en el periodo."
msgstr "Ciclos cerrados en Rechazo sobre los ciclos que terminaron en el periodo."

#. placeholder {0}: formatDayMonth(closingDateOf(mondayOf(day)))
#. placeholder {0}: formatDayMonth(closingDateOf(selectedWeek))
#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Cierra el {0}"
msgstr "Cierra el {0}"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Cierra el ciclo definitivamente y libera al hotel"
msgstr "Cierra el ciclo definitivamente y libera al hotel"

#: src/shared/constants/contactAttempt.ts
msgid "Cita agendada"
msgstr "Cita agendada"

#: src/features/observability/lib/people.ts
msgid "Citas"
msgstr "Citas"

#: src/features/observability/lib/salesKpis.ts
msgid "Citas agendadas"
msgstr "Citas agendadas"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ciudad y estado"
msgstr "Ciudad y estado"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cláusulas del documento"
msgstr "Cláusulas del documento"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Cláusulas guardadas"
msgstr "Cláusulas guardadas"

#: src/features/contracts/components/clauses/ClausesEditor.tsx
msgid "Clic en una variable para insertarla donde dejaste el cursor"
msgstr "Clic en una variable para insertarla donde dejaste el cursor"

#: src/features/territory/components/TerritoryMapLegend.tsx
msgid "Cliente"
msgstr "Cliente"

#: src/features/onboarding/components/HotelGlobeCard.tsx
#: src/shared/constants/onboardingStatus.ts
msgid "Cliente activo"
msgstr "Cliente activo"

#: src/features/clients/components/ClientFilters.tsx
msgid "Cliente desde"
msgstr "Cliente desde"

#. placeholder {0}: formatDate(client.activatedAt)
#. placeholder {0}: formatDayMonth(hotel.clientSince)
#: src/features/clients/components/ClientSpotlightCard.tsx
#: src/features/territory/components/TerritoryHotelCard.tsx
msgid "Cliente desde {0}"
msgstr "Cliente desde {0}"

#: src/shared/constants/onboardingStatus.ts
msgid "Cliente pausado o inactivo"
msgstr "Cliente pausado o inactivo"

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "clientes"
msgstr "clientes"

#: src/features/clients/pages/ClientPortfolioPage.tsx
#: src/features/dashboard/components/ActivityCards.tsx
msgid "Clientes activos"
msgstr "Clientes activos"

#: src/layouts/Sidebar.tsx
msgid "Clientes Activos"
msgstr "Clientes Activos"

#: src/features/observability/lib/salesKpis.ts
msgid "Clientes sin requisitar"
msgstr "Clientes sin requisitar"

#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Cobertura"
msgstr "Cobertura"

#. placeholder {0}: board.coverage.name
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Cobertura · {0}"
msgstr "Cobertura · {0}"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Cobertura parcial"
msgstr "Cobertura parcial"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Cobertura por hotel"
msgstr "Cobertura por hotel"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Cobro registrado"
msgstr "Cobro registrado"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Cola del Self-Pick"
msgstr "Cola del Self-Pick"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/auth/pages/LoginPage.tsx
#: src/features/observability/components/CohortSection.tsx
#: src/features/observability/pages/ObservabilityPage.tsx
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/timesheet/components/TimesheetGrid.tsx
#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
#: src/shared/constants/roles.ts
msgid "Colaborador"
msgstr "Colaborador"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "colaborador × requisición"
msgstr "colaborador × requisición"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Colaborador actualizado"
msgstr "Colaborador actualizado"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Colaborador asignado al slot"
msgstr "Colaborador asignado al slot"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Colaborador creado — {created}"
msgstr "Colaborador creado — {created}"

#: src/features/admin/pages/UsersPage.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/layouts/GlobalSearch.tsx
msgid "Colaboradores"
msgstr "Colaboradores"

#: src/features/observability/lib/workerKpis.ts
msgid "Colaboradores con el perfil completo sobre todo el Pool."
msgstr "Colaboradores con el perfil completo sobre todo el Pool."

#: src/features/recruitment/pages/PoolPage.tsx
msgid "Colaboradores con su estado en el Semáforo; los Disponibles se pueden asignar a una requisición"
msgstr "Colaboradores con su estado en el Semáforo; los Disponibles se pueden asignar a una requisición"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Colaboradores dados de alta en el periodo."
msgstr "Colaboradores dados de alta en el periodo."

#: src/features/observability/lib/workerKpis.ts
msgid "Colaboradores en Blacklist sobre todo el Pool."
msgstr "Colaboradores en Blacklist sobre todo el Pool."

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Colaboradores en el Pool"
msgstr "Colaboradores en el Pool"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Colaboradores evaluados"
msgstr "Colaboradores evaluados"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Colaboradores puestos en un hotel"
msgstr "Colaboradores puestos en un hotel"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Colaboradores que dio de alta"
msgstr "Colaboradores que dio de alta"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Colaboradores sin teléfono válido"
msgstr "Colaboradores sin teléfono válido"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Color"
msgstr "Color"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Columnas del archivo y cómo llenarlas"
msgstr "Columnas del archivo y cómo llenarlas"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Columnas: Nombre y Teléfono (obligatorias), Apellido, Email y Etiquetas. Excel, CSV o PDF con texto, hasta 5 MB."
msgstr "Columnas: Nombre y Teléfono (obligatorias), Apellido, Email y Etiquetas. Excel, CSV o PDF con texto, hasta 5 MB."

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Comenzar el alta"
msgstr "Comenzar el alta"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Comenzar el contrato"
msgstr "Comenzar el contrato"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Comenzar la requisición"
msgstr "Comenzar la requisición"

#: src/features/accounting/types/settlement.constants.ts
#: src/features/contracts/components/MultiplierTable.tsx
msgid "Comida"
msgstr "Comida"

#: src/features/observability/lib/workerKpis.ts
msgid "Comida de más de {LONG_LUNCH_MIN} min"
msgstr "Comida de más de {LONG_LUNCH_MIN} min"

#: src/features/observability/lib/workerKpis.ts
msgid "Comida de menos de {SHORT_LUNCH_MIN} min"
msgstr "Comida de menos de {SHORT_LUNCH_MIN} min"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "como cliente"
msgstr "como cliente"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Cómo combinar las etiquetas"
msgstr "Cómo combinar las etiquetas"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Cómo funciona"
msgstr "Cómo funciona"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Cómo funciona Contratos"
msgstr "Cómo funciona Contratos"

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Cómo funciona el Consolidado Semanal"
msgstr "Cómo funciona el Consolidado Semanal"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Cómo funciona el semáforo"
msgstr "Cómo funciona el semáforo"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Cómo funciona el Timesheet de todos los hoteles"
msgstr "Cómo funciona el Timesheet de todos los hoteles"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Cómo funciona este Timesheet para Contabilidad"
msgstr "Cómo funciona este Timesheet para Contabilidad"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Cómo funciona Factura al Hotel"
msgstr "Cómo funciona Factura al Hotel"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Cómo funciona Inspecciones"
msgstr "Cómo funciona Inspecciones"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Cómo funciona Semanas sin aprobar"
msgstr "Cómo funciona Semanas sin aprobar"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Cómo funcionan las Deducciones"
msgstr "Cómo funcionan las Deducciones"

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Cómo funcionan los ajustes a incluir"
msgstr "Cómo funcionan los ajustes a incluir"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Cómo funcionan los Catálogos"
msgstr "Cómo funcionan los Catálogos"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Cómo les fue a las campañas: entregados, leídos y por qué no llegaron."
msgstr "Cómo les fue a las campañas: entregados, leídos y por qué no llegaron."

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Cómo les fue a los envíos"
msgstr "Cómo les fue a los envíos"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Como Líder, también recluta y asigna: sus números son los suyos, no los de su grupo. Las Reclutadoras de su grupo aparecen debajo de ella en la lista."
msgstr "Como Líder, también recluta y asigna: sus números son los suyos, no los de su grupo. Las Reclutadoras de su grupo aparecen debajo de ella en la lista."

#: src/features/worker/pages/HomePage.tsx
msgid "cómo llegas al trabajo"
msgstr "cómo llegas al trabajo"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Cómo llegas al trabajo"
msgstr "Cómo llegas al trabajo"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Como lo conoce el hotel. Si lo llenó Google, puedes corregirlo."
msgstr "Como lo conoce el hotel. Si lo llenó Google, puedes corregirlo."

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Cómo poncha tu gente"
msgstr "Cómo poncha tu gente"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Cómo ponchan aquí"
msgstr "Cómo ponchan aquí"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Cómo terminó cada mensaje."
msgstr "Cómo terminó cada mensaje."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Cómo va esta requisición"
msgstr "Cómo va esta requisición"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Cómo va tu demanda"
msgstr "Cómo va tu demanda"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "completa al menos una posición con su pago y su factura"
msgstr "completa al menos una posición con su pago y su factura"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Completa el expediente o confirma validarlo a medias"
msgstr "Completa el expediente o confirma validarlo a medias"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Completa el gasto: concepto, quién lo pagó, monto y motivo."
msgstr "Completa el gasto: concepto, quién lo pagó, monto y motivo."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Completa la tarifa acordada y su motivo."
msgstr "Completa la tarifa acordada y su motivo."

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Completa tus datos"
msgstr "Completa tus datos"

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Completa tus datos para seguir"
msgstr "Completa tus datos para seguir"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Completada"
msgstr "Completada"

#. placeholder {0}: formatInstantDate(row.completedAt)
#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Completada el {0}"
msgstr "Completada el {0}"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Completadas"
msgstr "Completadas"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Completado"
msgstr "Completado"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Completar"
msgstr "Completar"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Completar ahora"
msgstr "Completar ahora"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Completar datos"
msgstr "Completar datos"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Completar la eliminación"
msgstr "Completar la eliminación"

#: src/features/worker/components/AccessDeadlineBanner.tsx
#: src/features/worker/pages/HomePage.tsx
msgid "Completar mis datos"
msgstr "Completar mis datos"

#: src/features/recruitment/components/PoolTable.tsx
msgid "completo"
msgstr "completo"

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Comprobando…"
msgstr "Comprobando…"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Comprobante de domicilio"
msgstr "Comprobante de domicilio"

#: src/features/messaging/components/tours.ts
msgid "Con Actualizar traes las cifras y el avance de las campañas al momento."
msgstr "Con Actualizar traes las cifras y el avance de las campañas al momento."

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Con Actualizar ves cómo va cada envío (enviados, entregados, leídos) sin recargar la página."
msgstr "Con Actualizar ves cómo va cada envío (enviados, entregados, leídos) sin recargar la página."

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "con contrato vigente"
msgstr "con contrato vigente"

#: src/shared/components/MascotaPeek.tsx
msgid "Con Ctrl/⌘ K abres la búsqueda desde cualquier pantalla."
msgstr "Con Ctrl/⌘ K abres la búsqueda desde cualquier pantalla."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Con cualquiera de ellas"
msgstr "Con cualquiera de ellas"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Con entrada registrada"
msgstr "Con entrada registrada"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Con error"
msgstr "Con error"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Con este correo entra a la app y revisa su buzón. Las contraseñas las genera el sistema y quedan en su expediente: dáselas en persona, no por correo."
msgstr "Con este correo entra a la app y revisa su buzón. Las contraseñas las genera el sistema y quedan en su expediente: dáselas en persona, no por correo."

#. placeholder {0}: worker.fullName
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Con esto {0} entra a su app de ponche y a su correo. Dáselas en mano, no por correo."
msgstr "Con esto {0} entra a su app de ponche y a su correo. Dáselas en mano, no por correo."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Con estos datos y el SSN/ITIN de Documentos el perfil queda completo; la foto no cuenta"
msgstr "Con estos datos y el SSN/ITIN de Documentos el perfil queda completo; la foto no cuenta"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "con la tarifa y el multiplicador vigentes"
msgstr "con la tarifa y el multiplicador vigentes"

#: src/features/messaging/components/ContactActions.tsx
msgid "Con lada de país (+52…) o elige el país al lado."
msgstr "Con lada de país (+52…) o elige el país al lado."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Con las etiquetas se eligen los destinatarios de una campaña."
msgstr "Con las etiquetas se eligen los destinatarios de una campaña."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Con las etiquetas se eligen los destinatarios de una campaña. Las marcadas con «Sincronización» las pone «Sincronizar colaboradores» y no se pueden eliminar."
msgstr "Con las etiquetas se eligen los destinatarios de una campaña. Las marcadas con «Sincronización» las pone «Sincronizar colaboradores» y no se pueden eliminar."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Con los títulos listos, un ejemplo y una hoja de instrucciones con las zonas y los valores válidos."
msgstr "Con los títulos listos, un ejemplo y una hoja de instrucciones con las zonas y los valores válidos."

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Con lugares todavía sin llenar"
msgstr "Con lugares todavía sin llenar"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Con problema"
msgstr "Con problema"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Con su cobertura. Toca una para abrirla y ver puesto por puesto quién la está cubriendo."
msgstr "Con su cobertura. Toca una para abrirla y ver puesto por puesto quién la está cubriendo."

#: src/features/messaging/components/tours.ts
msgid "Con su nombre, teléfono y etiquetas."
msgstr "Con su nombre, teléfono y etiquetas."

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "con timesheet esta semana"
msgstr "con timesheet esta semana"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Con todas"
msgstr "Con todas"

#: src/features/worker/pages/PunchPage.tsx
msgid "con tu foto"
msgstr "con tu foto"

#: src/features/messaging/components/tours.ts
msgid "Con Ver detalle ves cómo llega por WhatsApp. Las rechazadas se corrigen y se reenvían."
msgstr "Con Ver detalle ves cómo llega por WhatsApp. Las rechazadas se corrigen y se reenvían."

#: src/features/messaging/components/tours.ts
msgid "Con Ver reporte ves a quién le llegó, quién no y por qué."
msgstr "Con Ver reporte ves a quién le llegó, quién no y por qué."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Concepto"
msgstr "Concepto"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "concepto de pago"
msgstr "concepto de pago"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Concepto del gasto"
msgstr "Concepto del gasto"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Conceptos de pago"
msgstr "Conceptos de pago"

#: src/features/worker/pages/PunchPage.tsx
msgid "Confirmando que estás en el hotel"
msgstr "Confirmando que estás en el hotel"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Confirmar"
msgstr "Confirmar"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Confirmar cambio"
msgstr "Confirmar cambio"

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Confirmar rechazo"
msgstr "Confirmar rechazo"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Confirmar regreso"
msgstr "Confirmar regreso"

#. placeholder {0}: doc.displayName
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Confirmar: borrar {0}"
msgstr "Confirmar: borrar {0}"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Confirmar: el anterior deja de servir"
msgstr "Confirmar: el anterior deja de servir"

#: src/shared/components/MascotaPeek.tsx
msgid "Consejo"
msgstr "Consejo"

#: src/features/onboarding/components/ContactAttemptLog.tsx
msgid "Conservar"
msgstr "Conservar"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Consolidado"
msgstr "Consolidado"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Consolidado marcado como revisado"
msgstr "Consolidado marcado como revisado"

#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Consolidado Semanal"
msgstr "Consolidado Semanal"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Consta quién firmó por el hotel"
msgstr "Consta quién firmó por el hotel"

#: src/features/observability/pages/ObservabilityPage.tsx
msgid "Contabilidad"
msgstr "Contabilidad"

#: src/features/team/pages/TeamPage.tsx
msgid "contactado hoy"
msgstr "contactado hoy"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Contacto actualizado"
msgstr "Contacto actualizado"

#: src/features/messaging/components/ContactActions.tsx
msgid "Contacto actualizado."
msgstr "Contacto actualizado."

#: src/features/messaging/components/ContactActions.tsx
msgid "Contacto creado."
msgstr "Contacto creado."

#: src/features/personnel/components/ContactQr.tsx
msgid "Contacto de {name} en QR"
msgstr "Contacto de {name} en QR"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase3Page.tsx
msgid "Contacto de emergencia"
msgstr "Contacto de emergencia"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Contacto del hotel"
msgstr "Contacto del hotel"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Contacto desactivado"
msgstr "Contacto desactivado"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Contacto eliminado"
msgstr "Contacto eliminado"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Contacto nuevo"
msgstr "Contacto nuevo"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Contacto nuevo · {hotelName}"
msgstr "Contacto nuevo · {hotelName}"

#: src/features/conversion/api/conversionApi.ts
msgid "Contacto principal registrado"
msgstr "Contacto principal registrado"

#: src/shared/constants/onboardingStatus.ts
msgid "Contacto y datos"
msgstr "Contacto y datos"

#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/pages/MessagingPage.tsx
msgid "Contactos"
msgstr "Contactos"

#. placeholder {0}: tag.name
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Contactos con «{0}»"
msgstr "Contactos con «{0}»"

#: src/features/onboarding/components/HotelContactList.tsx
msgid "Contactos del hotel"
msgstr "Contactos del hotel"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Contactos elegidos"
msgstr "Contactos elegidos"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Contactos específicos"
msgstr "Contactos específicos"

#: src/shared/constants/roles.ts
msgid "Contadora"
msgstr "Contadora"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Contesta todos los reactivos para poder guardar"
msgstr "Contesta todos los reactivos para poder guardar"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Contexto que le sirva a quien abra el siguiente ciclo…"
msgstr "Contexto que le sirva a quien abra el siguiente ciclo…"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Continúa al día siguiente"
msgstr "Continúa al día siguiente"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/shared/components/OnboardingIntro.tsx
msgid "Continuar"
msgstr "Continuar"

#: src/features/onboarding/components/ProspectPhotoCard.tsx
msgid "Continuar borrador →"
msgstr "Continuar borrador →"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Contraer cláusulas del documento"
msgstr "Contraer cláusulas del documento"

#: src/features/contracts/components/MissingContractsNotice.tsx
msgid "Contraer hoteles listos para su contrato"
msgstr "Contraer hoteles listos para su contrato"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Contraer texto de la propuesta"
msgstr "Contraer texto de la propuesta"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/auth/pages/LoginPage.tsx
#: src/features/worker/components/MobileShell.tsx
#: src/features/worker/pages/PasswordPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Contraseña"
msgstr "Contraseña"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Contraseña cambiada"
msgstr "Contraseña cambiada"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Contraseña cambiada. Dásela en mano."
msgstr "Contraseña cambiada. Dásela en mano."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Contraseña copiada"
msgstr "Contraseña copiada"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Contraseña de la app (y del web)"
msgstr "Contraseña de la app (y del web)"

#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Contraseña de la app de ponche"
msgstr "Contraseña de la app de ponche"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Contraseña del buzón"
msgstr "Contraseña del buzón"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Contraseña del correo"
msgstr "Contraseña del correo"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Contraseña nueva"
msgstr "Contraseña nueva"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Contraseña temporal"
msgstr "Contraseña temporal"

#: src/features/clients/components/ClientFilters.tsx
msgid "Contrato"
msgstr "Contrato"

#. placeholder {0}: contract.number
#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Contrato {0}"
msgstr "Contrato {0}"

#. placeholder {0}: contract?.number ?? ''
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Contrato {0} activado"
msgstr "Contrato {0} activado"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Contrato bloqueado"
msgstr "Contrato bloqueado"

#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Contrato cambió"
msgstr "Contrato cambió"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Contrato creado — en Borrador"
msgstr "Contrato creado — en Borrador"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
msgid "Contrato enviado"
msgstr "Contrato enviado"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Contrato enviado al hotel"
msgstr "Contrato enviado al hotel"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Contrato expirado: dejó de regir"
msgstr "Contrato expirado: dejó de regir"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Contrato marcado como enviado: quedó bloqueado"
msgstr "Contrato marcado como enviado: quedó bloqueado"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Contrato marcado como expirado"
msgstr "Contrato marcado como expirado"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Contrato vigente: no hay nada pendiente"
msgstr "Contrato vigente: no hay nada pendiente"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/contracts/pages/ContractListPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Contratos"
msgstr "Contratos"

#: src/shared/constants/catalogs.ts
msgid "Conversacional"
msgstr "Conversacional"

#: src/features/conversion/pages/ConversionQueuePage.tsx
#: src/features/observability/lib/salesKpis.ts
#: src/layouts/Sidebar.tsx
msgid "Conversión"
msgstr "Conversión"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Conversión a cliente activo"
msgstr "Conversión a cliente activo"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Conversión aprobada"
msgstr "Conversión aprobada"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Conversión por BD"
msgstr "Conversión por BD"

#: src/features/dashboard/components/ActivityCards.tsx
#: src/features/observability/lib/people.ts
msgid "Conversiones"
msgstr "Conversiones"

#: src/features/team/pages/TeamPage.tsx
msgid "Conversiones (trim.)"
msgstr "Conversiones (trim.)"

#: src/features/team/pages/TeamPage.tsx
msgid "Conversiones del trimestre"
msgstr "Conversiones del trimestre"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Convertidos"
msgstr "Convertidos"

#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "Convertir en cliente"
msgstr "Convertir en cliente"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Convertir es del BDC"
msgstr "Convertir es del BDC"

#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "Convirtiendo…"
msgstr "Convirtiendo…"

#: src/shared/constants/workerEnums.ts
msgid "Cónyuge"
msgstr "Cónyuge"

#: src/shared/constants/roles.ts
msgid "Coordinador de Inspección"
msgstr "Coordinador de Inspección"

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/shared/components/CredentialField.tsx
msgid "Copiar"
msgstr "Copiar"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Copiar contraseña"
msgstr "Copiar contraseña"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Copiar contraseña de la app"
msgstr "Copiar contraseña de la app"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Copiar contraseña del correo"
msgstr "Copiar contraseña del correo"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Copiar correo"
msgstr "Copiar correo"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Copiar el teléfono"
msgstr "Copiar el teléfono"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Copiar usuario"
msgstr "Copiar usuario"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Corre el corte de todos los hoteles con horas aprobadas esa semana. Es idempotente: repetirlo no duplica nada de lo que ya quedó en un Consolidado."
msgstr "Corre el corte de todos los hoteles con horas aprobadas esa semana. Es idempotente: repetirlo no duplica nada de lo que ya quedó en un Consolidado."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Corrección eliminada — vuelve a lo calculado"
msgstr "Corrección eliminada — vuelve a lo calculado"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Corrección guardada"
msgstr "Corrección guardada"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Correcto"
msgstr "Correcto"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Corregido"
msgstr "Corregido"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
#: src/features/audits/components/AuditHistoryList.tsx
msgid "Corregir"
msgstr "Corregir"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Corregir esta marca"
msgstr "Corregir esta marca"

#: src/features/onboarding/components/ContactAttemptLog.tsx
msgid "Corregir este intento"
msgstr "Corregir este intento"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Corregir horas extra"
msgstr "Corregir horas extra"

#. placeholder {0}: row.workerName
#: src/features/timesheet/components/AttendanceView.tsx
msgid "Corregir horas extra de {0}"
msgstr "Corregir horas extra de {0}"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Corregir intento de contacto"
msgstr "Corregir intento de contacto"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Corregir la entrada"
msgstr "Corregir la entrada"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Corregir la salida"
msgstr "Corregir la salida"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Corregir marca"
msgstr "Corregir marca"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Corregir mis datos"
msgstr "Corregir mis datos"

#. placeholder {0}: target.workerName
#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Corregir pago de {0}"
msgstr "Corregir pago de {0}"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Corregir tarifa"
msgstr "Corregir tarifa"

#: src/features/contracts/components/RateTable.tsx
msgid "Corregir una tarifa"
msgstr "Corregir una tarifa"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Corregir y reenviar"
msgstr "Corregir y reenviar"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Corregir y reenviar a Meta"
msgstr "Corregir y reenviar a Meta"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/auth/pages/LoginPage.tsx
#: src/features/observability/lib/people.ts
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/worker/pages/ProfilePage.tsx
#: src/mobile/AppLoginPage.tsx
#: src/shared/constants/contactAttempt.ts
msgid "Correo"
msgstr "Correo"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Correo copiado"
msgstr "Correo copiado"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Correo corporativo"
msgstr "Correo corporativo"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Correo de acceso"
msgstr "Correo de acceso"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Correo de horas (sábado)"
msgstr "Correo de horas (sábado)"

#: src/shared/lib/contractClauses.ts
msgid "Correo de la empresa"
msgstr "Correo de la empresa"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Correo de Oranje en el documento"
msgstr "Correo de Oranje en el documento"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Correo de quien envía"
msgstr "Correo de quien envía"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Correo de quien firma por el hotel"
msgstr "Correo de quien firma por el hotel"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Correo del contacto no válido: no se guarda"
msgstr "Correo del contacto no válido: no se guarda"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Correo del hotel"
msgstr "Correo del hotel"

#: src/shared/lib/contractClauses.ts
msgid "Correo del proveedor"
msgstr "Correo del proveedor"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Correo para avisarte (opcional)"
msgstr "Correo para avisarte (opcional)"

#: src/features/observability/lib/people.ts
msgid "Correos"
msgstr "Correos"

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Correos corporativos"
msgstr "Correos corporativos"

#: src/features/audits/components/EnvironmentAuditDialog.tsx
msgid "Corrige lo que haga falta de {hotelName}: se guarda con PATCH, sobre la misma inspección."
msgstr "Corrige lo que haga falta de {hotelName}: se guarda con PATCH, sobre la misma inspección."

#: src/features/audits/components/PersonalPresentationAuditDialog.tsx
msgid "Corrige lo que haga falta: se guarda con PATCH, sobre la misma inspección."
msgstr "Corrige lo que haga falta: se guarda con PATCH, sobre la misma inspección."

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Corrige los teléfonos"
msgstr "Corrige los teléfonos"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Corte de pago (miércoles)"
msgstr "Corte de pago (miércoles)"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Cotiza al menos un puesto para descargar"
msgstr "Cotiza al menos un puesto para descargar"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "cPanel rechazó la operación."
msgstr "cPanel rechazó la operación."

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Crea la campaña"
msgstr "Crea la campaña"

#: src/features/messaging/components/tours.ts
msgid "Crea una etiqueta"
msgstr "Crea una etiqueta"

#: src/features/messaging/components/tours.ts
msgid "Crea una plantilla"
msgstr "Crea una plantilla"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/requisitions/api/requisitionsApi.ts
#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Creada"
msgstr "Creada"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Creado"
msgstr "Creado"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Créalo desde <0>Correos corporativos</0>."
msgstr "Créalo desde <0>Correos corporativos</0>."

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/conversion/components/RequirementRow.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Creando…"
msgstr "Creando…"

#: src/features/messaging/components/ContactActions.tsx
msgid "Crear"
msgstr "Crear"

#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Crear acceso"
msgstr "Crear acceso"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Crear borrador"
msgstr "Crear borrador"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Crear buzón"
msgstr "Crear buzón"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/PoolPage.tsx
msgid "Crear colaborador"
msgstr "Crear colaborador"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Crear cuenta"
msgstr "Crear cuenta"

#: src/features/conversion/api/conversionApi.ts
msgid "Crear cuenta del hotel"
msgstr "Crear cuenta del hotel"

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "Crear el contrato"
msgstr "Crear el contrato"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Crear etiqueta"
msgstr "Crear etiqueta"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Crear lista con estos"
msgstr "Crear lista con estos"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Crear o versionar la propuesta es del BD dueño del hotel."
msgstr "Crear o versionar la propuesta es del BD dueño del hotel."

#: src/features/onboarding/components/ProspectPhotoCard.tsx
msgid "Crear propuesta →"
msgstr "Crear propuesta →"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Crear propuesta v1"
msgstr "Crear propuesta v1"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Crear prospecto"
msgstr "Crear prospecto"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Crear requisición"
msgstr "Crear requisición"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Crear usuario"
msgstr "Crear usuario"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Crear y gestionar buzones corporativos es una acción del sistema, reservada al Administrador."
msgstr "Crear y gestionar buzones corporativos es una acción del sistema, reservada al Administrador."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Crédito"
msgstr "Crédito"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Crédito aplicado"
msgstr "Crédito aplicado"

#: src/features/observability/lib/people.ts
msgid "Creó la requisición"
msgstr "Creó la requisición"

#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
msgid "cualquiera"
msgstr "cualquiera"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Cuando el hotel liquida, Contabilidad marca la factura como pagada — el sistema no cobra solo."
msgstr "Cuando el hotel liquida, Contabilidad marca la factura como pagada — el sistema no cobra solo."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Cuando el ponche normal no pudo"
msgstr "Cuando el ponche normal no pudo"

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Cuando el Schedule programe a alguien en este hotel, aparecerá aquí para inspeccionarlo."
msgstr "Cuando el Schedule programe a alguien en este hotel, aparecerá aquí para inspeccionarlo."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Cuando el Schedule programe turnos de tus requisiciones, aparecerán aquí con su estado y sus marcas del día."
msgstr "Cuando el Schedule programe turnos de tus requisiciones, aparecerán aquí con su estado y sus marcas del día."

#: src/features/observability/components/CohortsView.tsx
msgid "Cuando empezó a ponchar"
msgstr "Cuando empezó a ponchar"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Cuando esté firmado por las dos partes, actívalo con «Activar contrato»."
msgstr "Cuando esté firmado por las dos partes, actívalo con «Activar contrato»."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Cuando la Reclutadora valida el alta, pasa a Verde fuerte y entra al Pool de Colaboradores."
msgstr "Cuando la Reclutadora valida el alta, pasa a Verde fuerte y entra al Pool de Colaboradores."

#: src/features/worker/lib/noShiftMessage.ts
msgid "Cuando la Reclutadora valide tus datos quedarás Disponible para asignación. Con tu primera requisición, tu turno aparece aquí."
msgstr "Cuando la Reclutadora valide tus datos quedarás Disponible para asignación. Con tu primera requisición, tu turno aparece aquí."

#: src/features/worker/lib/noShiftMessage.ts
msgid "Cuando Reclutamiento te asigne a una requisición, tu turno del día aparece aquí y podrás ponchar."
msgstr "Cuando Reclutamiento te asigne a una requisición, tu turno del día aparece aquí y podrás ponchar."

#: src/shared/components/MascotaPeek.tsx
msgid "Cuando salga una versión nueva te avisamos con un mensaje: recarga y listo."
msgstr "Cuando salga una versión nueva te avisamos con un mensaje: recarga y listo."

#: src/features/audits/components/AuditHistoryList.tsx
msgid "Cuando se guarde la primera de Presentación Personal o de Ambiente y Recursos, aparecerá aquí."
msgstr "Cuando se guarde la primera de Presentación Personal o de Ambiente y Recursos, aparecerá aquí."

#: src/features/requisitions/components/RequisitionCardList.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Cuando un hotel pida personal, su requisición aparecerá aquí con su semáforo."
msgstr "Cuando un hotel pida personal, su requisición aparecerá aquí con su semáforo."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Cuando una semana cierre con horas sin aprobar, aparecerá aquí con el Manager de Área que debe aprobarla."
msgstr "Cuando una semana cierre con horas sin aprobar, aparecerá aquí con el Manager de Área que debe aprobarla."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Cuando valides el alta, pasa a Verde fuerte y queda disponible para asignarse a un hotel."
msgstr "Cuando valides el alta, pasa a Verde fuerte y queda disponible para asignarse a un hotel."

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Cuántas requisiciones tienes trabajándose, cuántas ya se cubrieron y cuántas semanas de horas siguen sin aprobar — esas últimas no se pagan hasta que alguien las apruebe."
msgstr "Cuántas requisiciones tienes trabajándose, cuántas ya se cubrieron y cuántas semanas de horas siguen sin aprobar — esas últimas no se pagan hasta que alguien las apruebe."

#: src/features/messaging/components/tours.ts
msgid "Cuántos contactos, plantillas y campañas hay en la plataforma de mensajería."
msgstr "Cuántos contactos, plantillas y campañas hay en la plataforma de mensajería."

#: src/features/messaging/components/tours.ts
msgid "Cuántos se enviaron, entregaron y leyeron, y qué conviene revisar."
msgstr "Cuántos se enviaron, entregaron y leyeron, y qué conviene revisar."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Cuántos ya marcaron entrada hoy, cuántos están en pausa y cuántos protegidos por un accidente."
msgstr "Cuántos ya marcaron entrada hoy, cuántos están en pausa y cuántos protegidos por un accidente."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Cuatro letras y dos números. Ejemplo: kmrt48"
msgstr "Cuatro letras y dos números. Ejemplo: kmrt48"

#: src/features/worker/pages/PunchPage.tsx
msgid "Cuatro marcas al día"
msgstr "Cuatro marcas al día"

#: src/features/requisitions/utils/coverage.ts
msgid "cubierta"
msgstr "cubierta"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Cubierta"
msgstr "Cubierta"

#: src/shared/constants/requisitionStatus.ts
msgid "Cubierta parcialmente"
msgstr "Cubierta parcialmente"

#: src/shared/constants/requisitionStatus.ts
msgid "Cubierta totalmente"
msgstr "Cubierta totalmente"

#: src/features/dashboard/components/HotelDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Cubiertas"
msgstr "Cubiertas"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Cubiertas parcialmente"
msgstr "Cubiertas parcialmente"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Cubiertas totalmente"
msgstr "Cubiertas totalmente"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "cubierto"
msgstr "cubierto"

#: src/features/recruitment/components/SelfPickPositionCard.tsx
msgid "Cubierto"
msgstr "Cubierto"

#: src/shared/constants/workerStatus.ts
msgid "Cubriendo una asignación temporal, completa o parcial."
msgstr "Cubriendo una asignación temporal, completa o parcial."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Cubrimos {covered} de {total, plural, one {# lugar} other {# lugares}}. Si todavía necesitas personal, crea una requisición nueva."
msgstr "Cubrimos {covered} de {total, plural, one {# lugar} other {# lugares}}. Si todavía necesitas personal, crea una requisición nueva."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Cubrir slots en Self-Pick"
msgstr "Cubrir slots en Self-Pick"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Cuenta activada"
msgstr "Cuenta activada"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Cuenta actualizada"
msgstr "Cuenta actualizada"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Cuenta creada"
msgstr "Cuenta creada"

#. placeholder {0}: values.email
#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Cuenta creada — invitación enviada a {0}"
msgstr "Cuenta creada — invitación enviada a {0}"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Cuenta dada de baja"
msgstr "Cuenta dada de baja"

#: src/features/worker/components/MobileShell.tsx
msgid "Cuenta de {shortName}"
msgstr "Cuenta de {shortName}"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Cuenta del hotel creada"
msgstr "Cuenta del hotel creada"

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Cuentas por aprobar"
msgstr "Cuentas por aprobar"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Cumple"
msgstr "Cumple"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Cumple las reglas de Meta."
msgstr "Cumple las reglas de Meta."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Cumple, No o N/A por reactivo. El score es un promedio ponderado — N/A no cuenta ni pesa, y el peso lo define el Administrador."
msgstr "Cumple, No o N/A por reactivo. El score es un promedio ponderado — N/A no cuenta ni pesa, y el peso lo define el Administrador."

#: src/shared/constants/workerStatus.ts
msgid "Cumplió una semana: colabora fijo en el hotel."
msgstr "Cumplió una semana: colabora fijo en el hotel."

#: src/shared/constants/roles.ts
msgid "Customer Service Manager"
msgstr "Customer Service Manager"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "D"
msgstr "D"

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Da de alta el primero con «Nuevo prospecto»: el ciclo arranca en Gris."
msgstr "Da de alta el primero con «Nuevo prospecto»: el ciclo arranca en Gris."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Da de alta varios hoteles a la vez desde un Excel, CSV, TXT o PDF. Solo las personas de esta lista ven el botón «Importar hoteles» en el Pipeline."
msgstr "Da de alta varios hoteles a la vez desde un Excel, CSV, TXT o PDF. Solo las personas de esta lista ven el botón «Importar hoteles» en el Pipeline."

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Dado de baja"
msgstr "Dado de baja"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Dados de alta, todavía en Blanco"
msgstr "Dados de alta, todavía en Blanco"

#: src/features/dashboard/components/InviteHotelAccountCard.tsx
msgid "Dale su acceso al sistema desde aquí: es para quien trabaja en tu hotel con cuenta propia, no para los colaboradores que te asigna Oranje. Si es gerente, Oranje lo confirma antes de que pueda entrar."
msgstr "Dale su acceso al sistema desde aquí: es para quien trabaja en tu hotel con cuenta propia, no para los colaboradores que te asigna Oranje. Si es gerente, Oranje lo confirma antes de que pueda entrar."

#: src/features/admin/pages/FeatureAccessPage.tsx
#: src/features/dashboard/components/InviteHotelAccountCard.tsx
#: src/features/worker/pages/PermissionsPage.tsx
msgid "Dar acceso"
msgstr "Dar acceso"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Dar de alta el hotel abre su ciclo comercial en Gris. Un hotel solo puede tener un ciclo abierto a la vez."
msgstr "Dar de alta el hotel abre su ciclo comercial en Gris. Un hotel solo puede tener un ciclo abierto a la vez."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/messaging/components/ContactActions.tsx
msgid "Dar de baja"
msgstr "Dar de baja"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Dar de baja no borra nada: la persona deja de entrar y su historial queda."
msgstr "Dar de baja no borra nada: la persona deja de entrar y su historial queda."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Dar función"
msgstr "Dar función"

#. placeholder {0}: worker?.fullName ?? ''
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Dáselas en mano a {0}. Las vuelves a ver en su expediente, con «Acceso y contraseñas»."
msgstr "Dáselas en mano a {0}. Las vuelves a ver en su expediente, con «Acceso y contraseñas»."

#: src/layouts/Sidebar.tsx
msgid "Dashboard"
msgstr "Dashboard"

#: src/features/observability/pages/ObservabilityPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Dashboard de QA"
msgstr "Dashboard de QA"

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Datos"
msgstr "Datos"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Datos básicos"
msgstr "Datos básicos"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Datos contables"
msgstr "Datos contables"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Datos de emergencia guardados"
msgstr "Datos de emergencia guardados"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Datos del colaborador"
msgstr "Datos del colaborador"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Datos del documento"
msgstr "Datos del documento"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Datos del documento guardados"
msgstr "Datos del documento guardados"

#: src/features/onboarding/components/HotelDataCard.tsx
msgid "Datos del hotel"
msgstr "Datos del hotel"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Datos personales"
msgstr "Datos personales"

#. placeholder {0}: weekRangeOf(bandFrom)
#. placeholder {1}: weekRangeOf(bandTo)
#: src/features/observability/components/CohortSection.tsx
msgid "De {0} a {1}"
msgstr "De {0} a {1}"

#: src/features/team/pages/TeamPage.tsx
msgid "de abrir el ciclo a convertir"
msgstr "de abrir el ciclo a convertir"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "De aquí salen la nómina y la factura"
msgstr "De aquí salen la nómina y la factura"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "De baja — ya no puede entrar"
msgstr "De baja — ya no puede entrar"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "de contrato"
msgstr "de contrato"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "De dónde sale, p. ej. «Dos camisas de uniforme.»"
msgstr "De dónde sale, p. ej. «Dos camisas de uniforme.»"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "De Gris a Naranja"
msgstr "De Gris a Naranja"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "De los destinatarios a los que leyeron."
msgstr "De los destinatarios a los que leyeron."

#: src/features/territory/components/TerritoryOwnerPicker.tsx
msgid "De quién es el territorio"
msgstr "De quién es el territorio"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "de todos los hoteles, esta semana"
msgstr "de todos los hoteles, esta semana"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "De un golpe: cuántas tienes abiertas, cuántas van a medias y cuántas empiezan en menos de 3 días."
msgstr "De un golpe: cuántas tienes abiertas, cuántas van a medias y cuántas empiezan en menos de 3 días."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "De Verde no se sale sin la Propuesta Personalizada enviada."
msgstr "De Verde no se sale sin la Propuesta Personalizada enviada."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Decisiones de Oranje"
msgstr "Decisiones de Oranje"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Decisiones de Oranje sobre su perfil"
msgstr "Decisiones de Oranje sobre su perfil"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Deducción agregada: {typeLabel}"
msgstr "Deducción agregada: {typeLabel}"

#. placeholder {0}: target.label
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Deducción quitada: {0}"
msgstr "Deducción quitada: {0}"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Deducciones"
msgstr "Deducciones"

#. placeholder {0}: formatMoney(totalDeductions)
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Deducciones {0}"
msgstr "Deducciones {0}"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Deduce comida"
msgstr "Deduce comida"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Define cuántos, desde cuándo y en qué horario. Cada unidad de cantidad es un lugar que Reclutamiento va a cubrir."
msgstr "Define cuántos, desde cuándo y en qué horario. Cada unidad de cantidad es un lugar que Reclutamiento va a cubrir."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Definir contraseña"
msgstr "Definir contraseña"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Del periodo"
msgstr "Del periodo"

#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "del Timesheet"
msgstr "del Timesheet"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Demanda"
msgstr "Demanda"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Demanda de la semana"
msgstr "Demanda de la semana"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Demanda y cobertura de la semana"
msgstr "Demanda y cobertura de la semana"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Demasiados intentos seguidos. Espera un minuto e inténtalo de nuevo."
msgstr "Demasiados intentos seguidos. Espera un minuto e inténtalo de nuevo."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "departamento"
msgstr "departamento"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Departamento"
msgstr "Departamento"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Departamento de hotel"
msgstr "Departamento de hotel"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Departamento de la posición"
msgstr "Departamento de la posición"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Departamento del hotel"
msgstr "Departamento del hotel"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Departamento o posición, p. ej. Steward…"
msgstr "Departamento o posición, p. ej. Steward…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Departamentos y posiciones"
msgstr "Departamentos y posiciones"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Departamentos, posiciones, modalidades e inglés viven aquí — de acá beben las requisiciones y las altas."
msgstr "Departamentos, posiciones, modalidades e inglés viven aquí — de acá beben las requisiciones y las altas."

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Desactivada"
msgstr "Desactivada"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Desactivada en la plataforma: no se puede usar en campañas."
msgstr "Desactivada en la plataforma: no se puede usar en campañas."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Desactivar"
msgstr "Desactivar"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Desactivar contacto"
msgstr "Desactivar contacto"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Desbloqueado"
msgstr "Desbloqueado"

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "Desbloqueando…"
msgstr "Desbloqueando…"

#: src/features/contracts/components/UnlockContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Desbloquear"
msgstr "Desbloquear"

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "Desbloquear contrato"
msgstr "Desbloquear contrato"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "desbloquearlo es del BDC."
msgstr "desbloquearlo es del BDC."

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Descanso"
msgstr "Descanso"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Descárgala como PDF y pégala en el acceso."
msgstr "Descárgala como PDF y pégala en el acceso."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Descargar"
msgstr "Descargar"

#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Descargar CSV"
msgstr "Descargar CSV"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Descargar Excel"
msgstr "Descargar Excel"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Descargar firmado"
msgstr "Descargar firmado"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Descargar para firmar en papel"
msgstr "Descargar para firmar en papel"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Descargar PDF"
msgstr "Descargar PDF"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Descargar plantilla"
msgstr "Descargar plantilla"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Descargar QR"
msgstr "Descargar QR"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Descargar Word"
msgstr "Descargar Word"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Descartando…"
msgstr "Descartando…"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Descartar borrador"
msgstr "Descartar borrador"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Descartar cambios"
msgstr "Descartar cambios"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "descontado"
msgstr "descontado"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Descripción"
msgstr "Descripción"

#: src/shared/components/SettlementEffectBadge.tsx
msgid "Descuento: se le resta"
msgstr "Descuento: se le resta"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Descuentos con nombre"
msgstr "Descuentos con nombre"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Desde"
msgstr "Desde"

#. placeholder {0}: formatTimeIn(shift.startsAt, shift.hotelTimeZone)
#: src/features/worker/pages/HomePage.tsx
msgid "Desde {0}"
msgstr "Desde {0}"

#. placeholder {0}: ONBOARDING_STATUS_LABEL[currentStatus]
#. placeholder {1}: i18n._(STATUS_MOVER[currentStatus])
#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Desde {0} tu rol no mueve el prospecto: {1}"
msgstr "Desde {0} tu rol no mueve el prospecto: {1}"

#. placeholder {0}: i18n._(WORKER_STATUS_MOVER[currentStatus])
#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Desde {currentLabel} tu rol no mueve al colaborador: {0}"
msgstr "Desde {currentLabel} tu rol no mueve al colaborador: {0}"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Desde aquí el semáforo solo permite ir a: {targets}."
msgstr "Desde aquí el semáforo solo permite ir a: {targets}."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Desde aquí inspeccionas"
msgstr "Desde aquí inspeccionas"

#. placeholder {0}: formatDate(value.from)
#: src/shared/components/DateRangeField.tsx
msgid "Desde el {0}"
msgstr "Desde el {0}"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Desde el inicio"
msgstr "Desde el inicio"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Desde el principio"
msgstr "Desde el principio"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "desde Naranja, por el BDC"
msgstr "desde Naranja, por el BDC"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Desde un Excel, CSV, TXT o PDF con una tabla de hoteles."
msgstr "Desde un Excel, CSV, TXT o PDF con una tabla de hoteles."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "desde Verde (BD o BDC) o desde Rosa (BDC)"
msgstr "desde Verde (BD o BDC) o desde Rosa (BDC)"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "desde Verde, por el BD"
msgstr "desde Verde, por el BD"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Desempeño"
msgstr "Desempeño"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Desempeño del equipo"
msgstr "Desempeño del equipo"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Deshabilitada"
msgstr "Deshabilitada"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Desprogramar"
msgstr "Desprogramar"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Después"
msgstr "Después"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "Después de esto la versión queda congelada: no se vuelve a editar. Para cualquier cambio, aunque sea pequeño, se abre una versión nueva."
msgstr "Después de esto la versión queda congelada: no se vuelve a editar. Para cualquier cambio, aunque sea pequeño, se abre una versión nueva."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Después de revisar, ya no cambian"
msgstr "Después de revisar, ya no cambian"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Después se la pones a los contactos al editarlos o al importar un Excel."
msgstr "Después se la pones a los contactos al editarlos o al importar un Excel."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Después: nadie más aprueba. El contrato queda vigente y el hotel puede pedir personal con estas tarifas."
msgstr "Después: nadie más aprueba. El contrato queda vigente y el hotel puede pedir personal con estas tarifas."

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Destinatarios"
msgstr "Destinatarios"

#. placeholder {0}: campaign.name
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Destinatarios de «{0}»"
msgstr "Destinatarios de «{0}»"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Detalle de Requisición"
msgstr "Detalle de Requisición"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Detalle del día"
msgstr "Detalle del día"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Devolver a Café"
msgstr "Devolver a Café"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Devolviendo…"
msgstr "Devolviendo…"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Devuelto a Café"
msgstr "Devuelto a Café"

#: src/features/messaging/components/ReportCharts.tsx
#: src/features/schedule/components/AddShiftDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Día"
msgstr "Día"

#: src/shared/constants/workerStatus.ts
msgid "Día 1-2"
msgstr "Día 1-2"

#: src/shared/constants/workerStatus.ts
msgid "Día 3+"
msgstr "Día 3+"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Día de la marca"
msgstr "Día de la marca"

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Día del turno"
msgstr "Día del turno"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Día festivo"
msgstr "Día festivo"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Día no reconocido: «{weekText}»"
msgstr "Día no reconocido: «{weekText}»"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Día revisado"
msgstr "Día revisado"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Días"
msgstr "Días"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Días de atraso"
msgstr "Días de atraso"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Días de atraso (prom.)"
msgstr "Días de atraso (prom.)"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Días de una misma requisición"
msgstr "Días de una misma requisición"

#: src/features/observability/lib/hotelKpis.ts
msgid "Días entre que se crea la requisición y su primer día de trabajo, de las creadas en el periodo."
msgstr "Días entre que se crea la requisición y su primer día de trabajo, de las creadas en el periodo."

#: src/features/reports/pages/ReportsPage.tsx
msgid "Días prom."
msgstr "Días prom."

#: src/features/team/pages/TeamPage.tsx
msgid "Días prom. a Naranja"
msgstr "Días prom. a Naranja"

#: src/features/team/pages/TeamPage.tsx
msgid "Días promedio a Naranja"
msgstr "Días promedio a Naranja"

#: src/features/reports/pages/ReportsPage.tsx
msgid "días promedio en cada estado · dónde se atora el pipeline"
msgstr "días promedio en cada estado · dónde se atora el pipeline"

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "Días sin anomalía"
msgstr "Días sin anomalía"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Días sin ponches"
msgstr "Días sin ponches"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Dices qué puesto necesitas, cuántas personas y desde cuándo. Nace autorizada: a Reclutamiento le llega en cuanto la guardas."
msgstr "Dices qué puesto necesitas, cuántas personas y desde cuándo. Nace autorizada: a Reclutamiento le llega en cuanto la guardas."

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Dinos a quién va dirigida la propuesta"
msgstr "Dinos a quién va dirigida la propuesta"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Dinos el nombre de la propiedad en el documento"
msgstr "Dinos el nombre de la propiedad en el documento"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Dinos la ciudad y el estado del hotel"
msgstr "Dinos la ciudad y el estado del hotel"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Dinos la fecha de preparación del documento"
msgstr "Dinos la fecha de preparación del documento"

#: src/features/observability/lib/people.ts
msgid "Dio de alta al candidato"
msgstr "Dio de alta al candidato"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Dirección"
msgstr "Dirección"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Dirección de la propiedad"
msgstr "Dirección de la propiedad"

#: src/shared/lib/contractClauses.ts
msgid "Dirección del hotel"
msgstr "Dirección del hotel"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Directo contigo"
msgstr "Directo contigo"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Dirigida a"
msgstr "Dirigida a"

#: src/shared/constants/workerStatus.ts
msgid "Disp. voluntario"
msgstr "Disp. voluntario"

#: src/features/worker/pages/HomePage.tsx
msgid "Disponibilidad"
msgstr "Disponibilidad"

#: src/shared/constants/workerStatus.ts
msgid "Disponible"
msgstr "Disponible"

#: src/shared/constants/workerStatus.ts
msgid "Disponible para que Reclutamiento lo asigne."
msgstr "Disponible para que Reclutamiento lo asigne."

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Disponibles"
msgstr "Disponibles"

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Doble firma, en orden"
msgstr "Doble firma, en orden"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolTable.tsx
msgid "Documento"
msgstr "Documento"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documento agregado"
msgstr "Documento agregado"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documento borrado"
msgstr "Documento borrado"

#: src/features/conversion/api/conversionApi.ts
msgid "Documento de T&C negociado"
msgstr "Documento de T&C negociado"

#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "documento pendiente"
msgstr "documento pendiente"

#: src/features/recruitment/components/PoolRoster.tsx
msgid "Documento pendiente de verificar"
msgstr "Documento pendiente de verificar"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documento rechazado"
msgstr "Documento rechazado"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Documento recibido. Si te equivocaste de archivo, súbelo de nuevo y reemplaza el anterior."
msgstr "Documento recibido. Si te equivocaste de archivo, súbelo de nuevo y reemplaza el anterior."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documento subido"
msgstr "Documento subido"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documento verificado"
msgstr "Documento verificado"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Documentos"
msgstr "Documentos"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "DocuSign anula el documento y el hotel ya no podrá firmarlo. El contrato vuelve a ser editable."
msgstr "DocuSign anula el documento y el hotel ya no podrá firmarlo. El contrato vuelve a ser editable."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "DocuSign no aceptó el envío. Revisa el correo del hotel e inténtalo de nuevo."
msgstr "DocuSign no aceptó el envío. Revisa el correo del hotel e inténtalo de nuevo."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "DocuSign no aceptó las credenciales de Oranje. Avísale al Administrador."
msgstr "DocuSign no aceptó las credenciales de Oranje. Avísale al Administrador."

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Dom"
msgstr "Dom"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Domicilio"
msgstr "Domicilio"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Dos caminos: el ambiente del hotel se contesta de una, y la de personal te deja elegir a quién — arriba salen primero los que llevan más tiempo sin inspeccionarse."
msgstr "Dos caminos: el ambiente del hotel se contesta de una, y la de personal te deja elegir a quién — arriba salen primero los que llevan más tiempo sin inspeccionarse."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Dos inspecciones, un mismo registro"
msgstr "Dos inspecciones, un mismo registro"

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Dueño"
msgstr "Dueño"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Dueño del prospecto"
msgstr "Dueño del prospecto"

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Dueño: yo"
msgstr "Dueño: yo"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Duplicar"
msgstr "Duplicar"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/components/PoolTable.tsx
msgid "Edad"
msgstr "Edad"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/messaging/components/ContactActions.tsx
#: src/features/onboarding/components/HotelContactList.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Editar"
msgstr "Editar"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Editar cláusulas"
msgstr "Editar cláusulas"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Editar colaborador"
msgstr "Editar colaborador"

#: src/features/messaging/components/ContactActions.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Editar contacto"
msgstr "Editar contacto"

#. placeholder {0}: editingContact.name
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Editar contacto · {0}"
msgstr "Editar contacto · {0}"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Editar cuenta del hotel"
msgstr "Editar cuenta del hotel"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Editar datos del documento"
msgstr "Editar datos del documento"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Editar datos del hotel"
msgstr "Editar datos del hotel"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Editar expediente"
msgstr "Editar expediente"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Editar mis datos"
msgstr "Editar mis datos"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Editar multiplicadores"
msgstr "Editar multiplicadores"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Editar personal del sistema"
msgstr "Editar personal del sistema"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Editar prospecto"
msgstr "Editar prospecto"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Editar reactivo"
msgstr "Editar reactivo"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Editar tarifas"
msgstr "Editar tarifas"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Editar usuario"
msgstr "Editar usuario"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Editar vigencia"
msgstr "Editar vigencia"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Ej: Campaña Navidad 2026"
msgstr "Ej: Campaña Navidad 2026"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ej. 10/19/2026"
msgstr "Ej. 10/19/2026"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ej. Atlanta, GA"
msgstr "Ej. Atlanta, GA"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ej. Irene Garcia/Business Development Coordinator"
msgstr "Ej. Irene Garcia/Business Development Coordinator"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ej. Marriott International"
msgstr "Ej. Marriott International"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Ejecutivo"
msgstr "Ejecutivo"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Ejemplo de cada variable"
msgstr "Ejemplo de cada variable"

#. placeholder {0}: index + 1
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Ejemplo de la variable {0}"
msgstr "Ejemplo de la variable {0}"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Ejemplos para Meta"
msgstr "Ejemplos para Meta"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El \"Dear [nombre],\" de la carta — ya viene del contacto principal del hotel, cámbialo si va dirigida a alguien más"
msgstr "El \"Dear [nombre],\" de la carta — ya viene del contacto principal del hotel, cámbialo si va dirigida a alguien más"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El \"Prepared [DATE]\" del machote — se prellena con hoy, cámbiala si el documento debe llevar otra fecha"
msgstr "El \"Prepared [DATE]\" del machote — se prellena con hoy, cámbiala si el documento debe llevar otra fecha"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El \"Printed Name / Title\" del lado ORANJE PEOPLE en la firma del documento"
msgstr "El \"Printed Name / Title\" del lado ORANJE PEOPLE en la firma del documento"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El [PROPERTY NAME] del machote — ya viene del hotel, cámbialo si el documento debe usar otro nombre"
msgstr "El [PROPERTY NAME] del machote — ya viene del hotel, cámbialo si el documento debe usar otro nombre"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "El acceso no está configurado en este ambiente. Avisa al Administrador."
msgstr "El acceso no está configurado en este ambiente. Avisa al Administrador."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "el Administrador"
msgstr "el Administrador"

#: src/features/admin/components/UserFormDialog.tsx
msgid "El Administrador no reporta a nadie."
msgstr "El Administrador no reporta a nadie."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "El ajuste de tarifa o el gasto de una eventual, ya aprobado por el Manager de QA. Mientras no lo incluyas, no pesa en la nómina."
msgstr "El ajuste de tarifa o el gasto de una eventual, ya aprobado por el Manager de QA. Mientras no lo incluyas, no pesa en la nómina."

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "El ajuste de tarifa o el gasto extra (p. ej. Uber) de una asignación eventual. Mientras esté aquí, no pesa en ningún pago."
msgstr "El ajuste de tarifa o el gasto extra (p. ej. Uber) de una asignación eventual. Mientras esté aquí, no pesa en ningún pago."

#: src/features/recruitment/pages/PoolPage.tsx
msgid "El alta es de Reclutamiento: la Reclutadora captura la Fase 1 en la entrevista."
msgstr "El alta es de Reclutamiento: la Reclutadora captura la Fase 1 en la entrevista."

#: src/features/admin/pages/UsersPage.tsx
msgid "El alta, la edición y la baja del personal interno de Oranje las hace el Administrador; tu rol no tiene este módulo."
msgstr "El alta, la edición y la baja del personal interno de Oranje las hace el Administrador; tu rol no tiene este módulo."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "El archivo está vacío."
msgstr "El archivo está vacío."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "El archivo pasa de 15 MB: comprímelo o escanéalo con menos resolución."
msgstr "El archivo pasa de 15 MB: comprímelo o escanéalo con menos resolución."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "El archivo pasa de 5 MB."
msgstr "El archivo pasa de 5 MB."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "El archivo pasa de 5 MB. Divídelo en varios."
msgstr "El archivo pasa de 5 MB. Divídelo en varios."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "el BD"
msgstr "el BD"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "el BDC"
msgstr "el BDC"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "El bill rate debe ser mayor que cero"
msgstr "El bill rate debe ser mayor que cero"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "El bill rate es mayor que el pay rate en todas las posiciones: la diferencia es el margen de Oranje."
msgstr "El bill rate es mayor que el pay rate en todas las posiciones: la diferencia es el margen de Oranje."

#. placeholder {0}: badMargin.map((rate) => rate.positionName).join(', ')
#: src/features/contracts/components/ContractChecklist.tsx
msgid "El bill rate no puede quedar por debajo del pay rate: corrige {0} con «Editar tarifas»."
msgstr "El bill rate no puede quedar por debajo del pay rate: corrige {0} con «Editar tarifas»."

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "El bill rate no puede quedar por debajo del pay rate: se pierde en cada hora."
msgstr "El bill rate no puede quedar por debajo del pay rate: se pierde en cada hora."

#: src/shared/components/MascotaPeek.tsx
msgid "El botón del menú (☰) en el encabezado esconde el panel y te da más espacio."
msgstr "El botón del menú (☰) en el encabezado esconde el panel y te da más espacio."

#: src/features/onboarding/components/PlacesSearchField.tsx
msgid "El buscador no está disponible"
msgstr "El buscador no está disponible"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "El buzón de correo quedó con la misma contraseña."
msgstr "El buzón de correo quedó con la misma contraseña."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "El buzón de correo quedó listo, con su propia contraseña."
msgstr "El buzón de correo quedó listo, con su propia contraseña."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "El buzón real detrás del correo @oranjepeople.com de cada colaborador"
msgstr "El buzón real detrás del correo @oranjepeople.com de cada colaborador"

#: src/features/conversion/api/conversionApi.ts
msgid "El cambio queda en el historial del prospecto"
msgstr "El cambio queda en el historial del prospecto"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "El camino a cliente"
msgstr "El camino a cliente"

#: src/features/dashboard/components/PipelineFlowCard.tsx
msgid "El camino principal del ciclo; los desvíos abajo"
msgstr "El camino principal del ciclo; los desvíos abajo"

#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "El catálogo no tiene puestos todavía. Pídele al Administrador que los agregue en Catálogos · Departamentos y posiciones; sin ellos no se puede cotizar."
msgstr "El catálogo no tiene puestos todavía. Pídele al Administrador que los agregue en Catálogos · Departamentos y posiciones; sin ellos no se puede cotizar."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El ciclo"
msgstr "El ciclo"

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "El ciclo abre con un contacto: escribe su nombre"
msgstr "El ciclo abre con un contacto: escribe su nombre"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El ciclo comercial"
msgstr "El ciclo comercial"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "El ciclo comercial de este hotel está cerrado: ya no se cotiza."
msgstr "El ciclo comercial de este hotel está cerrado: ya no se cotiza."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "El ciclo comercial del hotel: de prospecto a cliente."
msgstr "El ciclo comercial del hotel: de prospecto a cliente."

#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "El ciclo comercial se cierra aquí: de Naranja no se regresa. Si más adelante el hotel se pausa, se le marca como inactivo, pero el ciclo no vuelve a abrirse."
msgstr "El ciclo comercial se cierra aquí: de Naranja no se regresa. Si más adelante el hotel se pausa, se le marca como inactivo, pero el ciclo no vuelve a abrirse."

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "El ciclo de {hotelName} se cierra definitivamente y el hotel queda libre para un ciclo nuevo."
msgstr "El ciclo de {hotelName} se cierra definitivamente y el hotel queda libre para un ciclo nuevo."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "El ciclo sigue vivo en Café: se retoma desde el Pipeline cuando el hotel se desbloquee."
msgstr "El ciclo sigue vivo en Café: se retoma desde el Pipeline cuando el hotel se desbloquee."

#: src/features/observability/lib/cohorts.ts
msgid "El colaborador"
msgstr "El colaborador"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "El colaborador completa la Fase 2 (transporte y SSN/ITIN) y la Fase 3 (contacto de emergencia y salud) desde su app; si lo validas a medias, tiene 1 día para completarlo."
msgstr "El colaborador completa la Fase 2 (transporte y SSN/ITIN) y la Fase 3 (contacto de emergencia y salud) desde su app; si lo validas a medias, tiene 1 día para completarlo."

#: src/features/timesheet/api/timesheetApi.ts
msgid "El colaborador no tiene asignación en esta requisición"
msgstr "El colaborador no tiene asignación en esta requisición"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "El colaborador pasa a Rojo: es una incidencia, no una pausa — Inspección la revisa y decide si vuelve o queda fuera."
msgstr "El colaborador pasa a Rojo: es una incidencia, no una pausa — Inspección la revisa y decide si vuelve o queda fuera."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "El colaborador pidió que Oranje lo cubriera: se le resta de su próxima nómina."
msgstr "El colaborador pidió que Oranje lo cubriera: se le resta de su próxima nómina."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "El colaborador ya no tiene asignación en esta requisición."
msgstr "El colaborador ya no tiene asignación en esta requisición."

#: src/features/worker/pages/HomePage.tsx
msgid "El color de arriba dice en qué punto estás: desde el alta hasta asignado. Lo mueve Oranje; tú solo enciendes tu disponibilidad."
msgstr "El color de arriba dice en qué punto estás: desde el alta hasta asignado. Lo mueve Oranje; tú solo enciendes tu disponibilidad."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "El color te dice la prisa"
msgstr "El color te dice la prisa"

#: src/features/onboarding/import/mapImportRows.ts
msgid "El contacto no tiene teléfono ni correo válidos: agrégalo después"
msgstr "El contacto no tiene teléfono ni correo válidos: agrégalo después"

#. placeholder {0}: principalContact.name
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "El contacto Principal ({0}) no tiene correo registrado."
msgstr "El contacto Principal ({0}) no tiene correo registrado."

#. placeholder {0}: principalContact.name
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "El contacto Principal ({0}) no tiene correo registrado. Agrégalo en Contactos del hotel, o escríbelo aquí."
msgstr "El contacto Principal ({0}) no tiene correo registrado. Agrégalo en Contactos del hotel, o escríbelo aquí."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "El contrato del hotel no tiene tarifa para este puesto: pídele a Ventas que la agregue."
msgstr "El contrato del hotel no tiene tarifa para este puesto: pídele a Ventas que la agregue."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "El contrato nace en Borrador, se afina y se activa. Solo puede haber uno vigente a la vez: para renovar, se crea el siguiente y se marca el viejo como vencido. Nunca se borra ninguno."
msgstr "El contrato nace en Borrador, se afina y se activa. Solo puede haber uno vigente a la vez: para renovar, se crea el siguiente y se marca el viejo como vencido. Nunca se borra ninguno."

#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "El contrato no tiene tarifa de facturación para esta posición: no se calcula lo que se le cobraría al hotel."
msgstr "El contrato no tiene tarifa de facturación para esta posición: no se calcula lo que se le cobraría al hotel."

#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "El contrato se editó DESPUÉS de que esta semana ya se aprobó: lo que ves aquí es el cálculo nuevo, no el que se aprobó."
msgstr "El contrato se editó DESPUÉS de que esta semana ya se aprobó: lo que ves aquí es el cálculo nuevo, no el que se aprobó."

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "El contrato ya está en Borrador"
msgstr "El contrato ya está en Borrador"

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "El contrato ya está vigente"
msgstr "El contrato ya está vigente"

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "El contrato ya se envió al hotel"
msgstr "El contrato ya se envió al hotel"

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "El contrato ya tenía las tarifas de la última propuesta."
msgstr "El contrato ya tenía las tarifas de la última propuesta."

#. placeholder {0}: String(latestVersion)
#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "El contrato ya tiene las tarifas de la v{0}"
msgstr "El contrato ya tiene las tarifas de la v{0}"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "El correo de quien envía es obligatorio"
msgstr "El correo de quien envía es obligatorio"

#. placeholder {0}: info.message ?? ''
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "El correo no aceptó el cambio: {0}."
msgstr "El correo no aceptó el cambio: {0}."

#: src/features/admin/pages/UsersPage.tsx
msgid "El correo no se edita: es con el que la persona entra. Para cambiar de persona, da de baja y da de alta. La cuenta queda enlazada la primera vez que entra. Las cuentas de los hoteles tienen su propia pestaña: «Personal de hoteles»."
msgstr "El correo no se edita: es con el que la persona entra. Para cambiar de persona, da de baja y da de alta. La cuenta queda enlazada la primera vez que entra. Las cuentas de los hoteles tienen su propia pestaña: «Personal de hoteles»."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "El correo o la contraseña no coinciden. Revísalos e inténtalo de nuevo."
msgstr "El correo o la contraseña no coinciden. Revísalos e inténtalo de nuevo."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "El correo saldrá por Firebase hasta que lo regreses"
msgstr "El correo saldrá por Firebase hasta que lo regreses"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "El correo tiene su propia contraseña: el servidor de correo pide una más fuerte que la de la app."
msgstr "El correo tiene su propia contraseña: el servidor de correo pide una más fuerte que la de la app."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "El correo vuelve a salir por el servidor de Oranje"
msgstr "El correo vuelve a salir por el servidor de Oranje"

#. placeholder {0}: ONBOARDING_STATUS_LABEL[report.bottleneck.status]
#. placeholder {1}: String(report.bottleneck.averageDays)
#: src/features/reports/pages/ReportsPage.tsx
msgid "El cuello está en {0}: {1} d promedio antes de salir"
msgstr "El cuello está en {0}: {1} d promedio antes de salir"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "el departamento"
msgstr "el departamento"

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "El desempeño se calcula con turnos y marcas reales: cuando acumule días trabajados, aquí aparece su radar."
msgstr "El desempeño se calcula con turnos y marcas reales: cuando acumule días trabajados, aquí aparece su radar."

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "El día completo, marca por marca"
msgstr "El día completo, marca por marca"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "El día tiene una anomalía sin resolver: la revisa el Supervisor del hotel."
msgstr "El día tiene una anomalía sin resolver: la revisa el Supervisor del hotel."

#. placeholder {0}: IS_DEV_UI && <code className="text-xs text-ink-4"> · has_anomaly = true</code>
#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "El día tiene una anomalía sin resolver{0}: revisa las marcas y explica la resolución en la nota."
msgstr "El día tiene una anomalía sin resolver{0}: revisa las marcas y explica la resolución en la nota."

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "El Documento de T&C ya se negocia. El BDC aprueba la conversión desde <0>Conversión</0> y el hotel pasa a Naranja, listo para pedir personal."
msgstr "El Documento de T&C ya se negocia. El BDC aprueba la conversión desde <0>Conversión</0> y el hotel pasa a Naranja, listo para pedir personal."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El documento quedará sin nombre ni puesto en la firma de ORANJE PEOPLE. Escríbelo aquí si hace falta."
msgstr "El documento quedará sin nombre ni puesto en la firma de ORANJE PEOPLE. Escríbelo aquí si hace falta."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El edificio"
msgstr "El edificio"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/reports/pages/ReportsPage.tsx
msgid "El envío recurrente llega pronto"
msgstr "El envío recurrente llega pronto"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "El envío se rechazó. Corrige lo necesario y vuelve a «Firmar con DocuSign»."
msgstr "El envío se rechazó. Corrige lo necesario y vuelve a «Firmar con DocuSign»."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "El estado del colaborador y la verificación de sus documentos los lleva la Reclutadora o el Líder de Grupo. Aquí consultas su expediente y su historial."
msgstr "El estado del colaborador y la verificación de sus documentos los lleva la Reclutadora o el Líder de Grupo. Aquí consultas su expediente y su historial."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "El expediente se completa por fases"
msgstr "El expediente se completa por fases"

#: src/features/recruitment/components/SelfPickFilterBar.tsx
msgid "El filtro por zona estará disponible próximamente"
msgstr "El filtro por zona estará disponible próximamente"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "El firmante aún no está registrado: se captura en la ficha del hotel."
msgstr "El firmante aún no está registrado: se captura en la ficha del hotel."

#: src/features/dashboard/components/PipelineFlowCard.tsx
msgid "El flujo del semáforo"
msgstr "El flujo del semáforo"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El folio se asigna al guardar y Reclutamiento la ve en ese momento: la urgencia corre desde ahí."
msgstr "El folio se asigna al guardar y Reclutamiento la ve en ese momento: la urgencia corre desde ahí."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El folio se asigna automáticamente al guardar"
msgstr "El folio se asigna automáticamente al guardar"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "El Gris protege"
msgstr "El Gris protege"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "El historial queda"
msgstr "El historial queda"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "el hotel"
msgstr "el hotel"

#: src/features/conversion/pages/ConversionPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El hotel"
msgstr "El hotel"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "El hotel cambió de firmante"
msgstr "El hotel cambió de firmante"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "El hotel imprime el código en el acceso; la app lo escanea junto con la ubicación."
msgstr "El hotel imprime el código en el acceso; la app lo escanea junto con la ubicación."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El hotel imprime un código en el acceso y la app lo escanea, con la ubicación."
msgstr "El hotel imprime un código en el acceso y la app lo escanea, con la ubicación."

#: src/features/observability/lib/cohorts.ts
msgid "El hotel lo mandó a descansar (Stand-by)"
msgstr "El hotel lo mandó a descansar (Stand-by)"

#: src/shared/constants/workerStatus.ts
msgid "El hotel lo mandó a descansar (vacaciones, temporada baja)."
msgstr "El hotel lo mandó a descansar (vacaciones, temporada baja)."

#: src/shared/constants/workerStatus.ts
msgid "El hotel lo reportó. El Inspector está revisando el caso."
msgstr "El hotel lo reportó. El Inspector está revisando el caso."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "El hotel no paga el lonche: se resta media hora con 6.5 h o más."
msgstr "El hotel no paga el lonche: se resta media hora con 6.5 h o más."

#: src/features/contracts/components/MultiplierTable.tsx
msgid "El hotel no puede pagar menos recargo de festivo que el colaborador."
msgstr "El hotel no puede pagar menos recargo de festivo que el colaborador."

#: src/features/contracts/components/MultiplierTable.tsx
msgid "El hotel no puede pagar menos recargo de overtime que el colaborador."
msgstr "El hotel no puede pagar menos recargo de overtime que el colaborador."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "El hotel no tiene contrato vigente con tarifa para esas posiciones."
msgstr "El hotel no tiene contrato vigente con tarifa para esas posiciones."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El hotel no tiene ninguna posición de este departamento en su contrato vigente — por eso el selector de abajo no muestra nada. Agrégala al contrato antes de pedir personal aquí."
msgstr "El hotel no tiene ninguna posición de este departamento en su contrato vigente — por eso el selector de abajo no muestra nada. Agrégala al contrato antes de pedir personal aquí."

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "El hotel no tiene QR generado todavía: regenéralo desde su ficha."
msgstr "El hotel no tiene QR generado todavía: regenéralo desde su ficha."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "El hotel no tiene un contacto Principal registrado."
msgstr "El hotel no tiene un contacto Principal registrado."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "El hotel no tiene un contacto Principal registrado. Agrégalo en Contactos del hotel, o escríbelo aquí."
msgstr "El hotel no tiene un contacto Principal registrado. Agrégalo en Contactos del hotel, o escríbelo aquí."

#: src/features/timesheet/components/HotelPaysLunchToggle.tsx
msgid "El hotel paga el lonche (horas completas)"
msgstr "El hotel paga el lonche (horas completas)"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "El hotel paga el lonche: las horas quedan completas."
msgstr "El hotel paga el lonche: las horas quedan completas."

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "El hotel pidió corregir la dirección de la propiedad"
msgstr "El hotel pidió corregir la dirección de la propiedad"

#: src/features/conversion/api/conversionApi.ts
msgid "El hotel queda activado como cliente desde hoy"
msgstr "El hotel queda activado como cliente desde hoy"

#: src/features/worker/lib/noShiftMessage.ts
msgid "El hotel te mandó a descansar. Cuando te reactive, tus turnos vuelven a aparecer aquí."
msgstr "El hotel te mandó a descansar. Cuando te reactive, tus turnos vuelven a aparecer aquí."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "El hotel ya aprobó esta semana"
msgstr "El hotel ya aprobó esta semana"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "El hotel ya dijo que sí"
msgstr "El hotel ya dijo que sí"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "El hotel ya no podrá editar estos días: ni marca manual ni corregir una marca. Si algo cambia después de enviarla, contacta a Oranje."
msgstr "El hotel ya no podrá editar estos días: ni marca manual ni corregir una marca. Si algo cambia después de enviarla, contacta a Oranje."

#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "El hotel ya no podrá editar estos días: ni marca manual ni corregir una marca. Si algo cambia después, contacta a Oranje."
msgstr "El hotel ya no podrá editar estos días: ni marca manual ni corregir una marca. Si algo cambia después, contacta a Oranje."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "El hotel ya no tiene un contrato vigente: no se le puede asignar personal hasta que Ventas lo active."
msgstr "El hotel ya no tiene un contrato vigente: no se le puede asignar personal hasta que Ventas lo active."

#: src/features/conversion/api/conversionApi.ts
msgid "El hotel ya puede generar requisiciones"
msgstr "El hotel ya puede generar requisiciones"

#. placeholder {0}: String(lastSent.version)
#: src/features/onboarding/components/ContractStepCard.tsx
msgid "El hotel ya tiene la propuesta v{0}. El contrato nace con esas mismas tarifas: las revisas, ajustas lo que se haya negociado y lo guardas en Borrador."
msgstr "El hotel ya tiene la propuesta v{0}. El contrato nace con esas mismas tarifas: las revisas, ajustas lo que se haya negociado y lo guardas en Borrador."

#. placeholder {0}: IS_DEV_UI && ( <code className="text-ink-4"> · pendiente 13 del ADR (duración del turno)</code> )
#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "El Indicador de Cumplimiento del Timesheet lo calcula el sistema comparando el Contrato con el Timesheet, sin intervención humana. Las horas contractuales por colaborador <0>todavía no están disponibles</0>: hasta que lo estén, esas columnas muestran una raya en vez de un dato inventado{0}. Un Colaborador en Gris (accidente) tampoco se evalúa: queda fuera de la medición semanal."
msgstr "El Indicador de Cumplimiento del Timesheet lo calcula el sistema comparando el Contrato con el Timesheet, sin intervención humana. Las horas contractuales por colaborador <0>todavía no están disponibles</0>: hasta que lo estén, esas columnas muestran una raya en vez de un dato inventado{0}. Un Colaborador en Gris (accidente) tampoco se evalúa: queda fuera de la medición semanal."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El Inspector se asigna solo por la zona del hotel"
msgstr "El Inspector se asigna solo por la zona del hotel"

#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
msgid "El lugar queda <0>disponible otra vez</0>, pero el puesto no se cubre solo: busca un reemplazo antes de que el hotel se quede sin alguien ahí."
msgstr "El lugar queda <0>disponible otra vez</0>, pero el puesto no se cubre solo: busca un reemplazo antes de que el hotel se quede sin alguien ahí."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "El machote compartido, o lo que ya se editó para este contrato"
msgstr "El machote compartido, o lo que ya se editó para este contrato"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "El machote de venta, o lo que ya se editó para este ciclo"
msgstr "El machote de venta, o lo que ya se editó para este ciclo"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "El Manager de Área aprueba hasta esta hora."
msgstr "El Manager de Área aprueba hasta esta hora."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Manager de Área autoriza y aprueba lo de su departamento; no lo de los demás."
msgstr "El Manager de Área autoriza y aprueba lo de su departamento; no lo de los demás."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Manager de Área reporta al Manager General."
msgstr "El Manager de Área reporta al Manager General."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "El Manager de Contabilidad la aprueba y la envía; la Contadora y el Manager pueden ver el borrador desde que nace."
msgstr "El Manager de Contabilidad la aprueba y la envía; la Contadora y el Manager pueden ver el borrador desde que nace."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Manager General no lleva departamento: cubre todo el hotel."
msgstr "El Manager General no lleva departamento: cubre todo el hotel."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Manager General no reporta a nadie."
msgstr "El Manager General no reporta a nadie."

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "El Manager General ve todos los departamentos"
msgstr "El Manager General ve todos los departamentos"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "El mismo Timesheet del hotel, de todos a la vez"
msgstr "El mismo Timesheet del hotel, de todos a la vez"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "El motivo queda en el historial del prospecto."
msgstr "El motivo queda en el historial del prospecto."

#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
msgid "El motivo queda en su historia"
msgstr "El motivo queda en su historia"

#: src/features/observability/components/CohortSection.tsx
msgid "El motivo y quién lo originó se leen de las primeras {MAX_HISTORIES} personas que ya no trabajan. Elige una sola semana para verlo de todas."
msgstr "El motivo y quién lo originó se leen de las primeras {MAX_HISTORIES} personas que ya no trabajan. Elige una sola semana para verlo de todas."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "El multiplicador de horas extra no se corrige aquí — sigue siendo el del hotel. El monto se recalcula solo, con lo que escribas."
msgstr "El multiplicador de horas extra no se corrige aquí — sigue siendo el del hotel. El monto se recalcula solo, con lo que escribas."

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "El neto de cada colaborador antes de pagarle: sale del Consolidado con rate interno, deducciones y overtime autorizado."
msgstr "El neto de cada colaborador antes de pagarle: sale del Consolidado con rate interno, deducciones y overtime autorizado."

#. placeholder {0}: money(netAfter)
#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "El neto queda en <0>{0}</0>."
msgstr "El neto queda en <0>{0}</0>."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "el nivel de inglés"
msgstr "el nivel de inglés"

#. placeholder {0}: String(PROSPECT_TEXT_MAX.contactFullName)
#: src/features/onboarding/import/mapImportRows.ts
msgid "El nombre del contacto pasa de {0} caracteres"
msgstr "El nombre del contacto pasa de {0} caracteres"

#: src/features/onboarding/types/hotelContactsForm.schema.ts
msgid "El nombre es obligatorio"
msgstr "El nombre es obligatorio"

#. placeholder {0}: String(PROSPECT_TEXT_MAX.hotelName)
#: src/features/onboarding/import/mapImportRows.ts
msgid "El nombre pasa de {0} caracteres"
msgstr "El nombre pasa de {0} caracteres"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "El orden dentro de su categoría se define arrastrando la fila en la lista, después de guardar."
msgstr "El orden dentro de su categoría se define arrastrando la fila en la lista, después de guardar."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "El pago en bloque aún no está disponible"
msgstr "El pago en bloque aún no está disponible"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "El pago estimado es en vivo"
msgstr "El pago estimado es en vivo"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "El pago lo hace Contabilidad cuando la semana está aprobada"
msgstr "El pago lo hace Contabilidad cuando la semana está aprobada"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "El pay rate debe ser mayor que cero"
msgstr "El pay rate debe ser mayor que cero"

#: src/shared/components/SendDocumentModal.tsx
msgid "El PDF del documento se adjunta solo. Queda registrado en el historial de correos."
msgstr "El PDF del documento se adjunta solo. Queda registrado en el historial de correos."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "El PDF tiene más de 50 páginas: no parece una lista de hoteles."
msgstr "El PDF tiene más de 50 páginas: no parece una lista de hoteles."

#: src/features/admin/pages/UsersPage.tsx
msgid "El personal interno de Oranje: quién es, qué rol tiene y si ya entró."
msgstr "El personal interno de Oranje: quién es, qué rol tiene y si ya entró."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El pin exacto y la geocerca validarán los ponches cuando sea cliente: arrástralo a la entrada real del personal."
msgstr "El pin exacto y la geocerca validarán los ponches cuando sea cliente: arrástralo a la entrada real del personal."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El pin se arrastra a propósito."
msgstr "El pin se arrastra a propósito."

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "el Pipeline"
msgstr "el Pipeline"

#: src/features/recruitment/pages/PoolPage.tsx
msgid "el Pool de Colaboradores"
msgstr "el Pool de Colaboradores"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "El Pre-Payroll se arma desde el Consolidado Semanal y las deducciones. Cuando esos datos se conecten a esta pantalla, aparecerán aquí."
msgstr "El Pre-Payroll se arma desde el Consolidado Semanal y las deducciones. Cuando esos datos se conecten a esta pantalla, aparecerán aquí."

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "el primer contacto"
msgstr "el primer contacto"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El primer Manager General de cada hotel nace en la Conversión; aquí se dan de alta los Supervisores, los Managers de Área y los Managers Generales adicionales."
msgstr "El primer Manager General de cada hotel nace en la Conversión; aquí se dan de alta los Supervisores, los Managers de Área y los Managers Generales adicionales."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "El prospecto"
msgstr "El prospecto"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "El QR anterior deja de servir al instante: hay que cambiar la hoja del acceso"
msgstr "El QR anterior deja de servir al instante: hay que cambiar la hoja del acceso"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "El QR de otro hotel no te corresponde."
msgstr "El QR de otro hotel no te corresponde."

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "El QR lo descarga y regenera el BD, el BDC o el personal del hotel."
msgstr "El QR lo descarga y regenera el BD, el BDC o el personal del hotel."

#. placeholder {0}: String(GEOFENCE_MAX_M)
#: src/features/onboarding/types/prospectForm.schema.ts
msgid "El radio máximo es de {0} m"
msgstr "El radio máximo es de {0} m"

#. placeholder {0}: String(GEOFENCE_MIN_M)
#: src/features/onboarding/types/prospectForm.schema.ts
msgid "El radio mínimo es de {0} m"
msgstr "El radio mínimo es de {0} m"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "El registro de auditoría de lo que se hizo con la cuenta se conserva por seguridad."
msgstr "El registro de auditoría de lo que se hizo con la cuenta se conserva por seguridad."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El renglón {line} apunta a un valor que ya no existe en el catálogo."
msgstr "El renglón {line} apunta a un valor que ya no existe en el catálogo."

#. placeholder {0}: i18n._(fieldLabel)
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "El renglón {line} elige un valor que ya no existe en el catálogo ({0}): vuelve a elegirlo."
msgstr "El renglón {line} elige un valor que ya no existe en el catálogo ({0}): vuelve a elegirlo."

#: src/features/recruitment/api/selfPickApi.ts
msgid "El renglón no existe"
msgstr "El renglón no existe"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "El reporte aparece cuando se envía."
msgstr "El reporte aparece cuando se envía."

#: src/features/messaging/components/tours.ts
msgid "El reporte de cada campaña"
msgstr "El reporte de cada campaña"

#: src/features/messaging/components/tours.ts
msgid "El resumen"
msgstr "El resumen"

#: src/features/admin/components/UserFormDialog.tsx
msgid "El rol que elijas decide qué módulos verá la persona al entrar. Las cuentas de los hoteles se dan de alta en su propia pestaña."
msgstr "El rol que elijas decide qué módulos verá la persona al entrar. Las cuentas de los hoteles se dan de alta en su propia pestaña."

#: src/features/schedule/pages/SchedulePage.tsx
msgid "el Schedule"
msgstr "el Schedule"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El semáforo lo acompaña del primer contacto hasta cliente activo — cada paso queda en su historia."
msgstr "El semáforo lo acompaña del primer contacto hasta cliente activo — cada paso queda en su historia."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "El semáforo lo mueve Reclutamiento"
msgstr "El semáforo lo mueve Reclutamiento"

#: src/features/conversion/api/conversionApi.ts
msgid "El semáforo pasa a Naranja"
msgstr "El semáforo pasa a Naranja"

#: src/features/admin/components/UserFormDialog.tsx
msgid "El servicio de acceso no respondió y el usuario no se creó. Inténtalo de nuevo en un momento."
msgstr "El servicio de acceso no respondió y el usuario no se creó. Inténtalo de nuevo en un momento."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El servidor no aceptó este dato: revísalo."
msgstr "El servidor no aceptó este dato: revísalo."

#. placeholder {0}: steps.join(', ')
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "El servidor no aceptó un dato del paso {0}: está marcado en rojo. Corrígelo y vuelve a crear el prospecto."
msgstr "El servidor no aceptó un dato del paso {0}: está marcado en rojo. Corrígelo y vuelve a crear el prospecto."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "el Sistema"
msgstr "el Sistema"

#: src/shared/constants/workerStatus.ts
msgid "el sistema lo libera al terminar la asignación; el hotel puede mandarlo a Stand-by y el propio colaborador ponerse Disponible voluntario."
msgstr "el sistema lo libera al terminar la asignación; el hotel puede mandarlo a Stand-by y el propio colaborador ponerse Disponible voluntario."

#. placeholder {0}: IS_DEV_UI ? ' (D-27)' : ''
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "El Stand-by (Rosa) lo compartes con el Manager de Área. Un colaborador en Gris (accidente) está protegido: no se manda a Stand-by, no se veta y sus faltas no cuentan{0}."
msgstr "El Stand-by (Rosa) lo compartes con el Manager de Área. Un colaborador en Gris (accidente) está protegido: no se manda a Stand-by, no se veta y sus faltas no cuentan{0}."

#: src/features/personnel/components/StandByDialog.tsx
msgid "El Stand-by manda al colaborador a Rosa: sigue siendo tuyo, pero no recibe turnos nuevos hasta reactivarlo."
msgstr "El Stand-by manda al colaborador a Rosa: sigue siendo tuyo, pero no recibe turnos nuevos hasta reactivarlo."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Supervisor reporta a un Manager de Área de su departamento o al Manager General."
msgstr "El Supervisor reporta a un Manager de Área de su departamento o al Manager General."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "El Supervisor revisa el timesheet de su departamento; no verá ni podrá pedir personal de los demás."
msgstr "El Supervisor revisa el timesheet de su departamento; no verá ni podrá pedir personal de los demás."

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "El Supervisor revisa; la aprobación de horas es del Manager de Área o del Manager General."
msgstr "El Supervisor revisa; la aprobación de horas es del Manager de Área o del Manager General."

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "El Supervisor ya la envió; ya no se puede editar. Falta que un Manager la apruebe."
msgstr "El Supervisor ya la envió; ya no se puede editar. Falta que un Manager la apruebe."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "El Supervisor, el Manager de Área o el Manager General las abren desde su zona. Aquí ves las que llegan, su urgencia y cómo va la cobertura."
msgstr "El Supervisor, el Manager de Área o el Manager General las abren desde su zona. Aquí ves las que llegan, su urgencia y cómo va la cobertura."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "el tablero de Requisiciones"
msgstr "el tablero de Requisiciones"

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "El teléfono de quien envía es obligatorio"
msgstr "El teléfono de quien envía es obligatorio"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "El territorio lo reparte el BDC"
msgstr "El territorio lo reparte el BDC"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "El total nuevo quedaría por debajo de las notas de crédito: revísalas antes de recalcular."
msgstr "El total nuevo quedaría por debajo de las notas de crédito: revísalas antes de recalcular."

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "El trabajo de tu equipo y la cobertura de requisiciones, para descargar"
msgstr "El trabajo de tu equipo y la cobertura de requisiciones, para descargar"

#: src/features/admin/components/UserFormDialog.tsx
msgid "El usuario quedó guardado, pero el correo de invitación no salió: reenvíala desde su ficha."
msgstr "El usuario quedó guardado, pero el correo de invitación no salió: reenvíala desde su ficha."

#: src/features/admin/components/UserFormDialog.tsx
msgid "El usuario se guardó, pero sus zonas no: ábrelo de nuevo para reintentar."
msgstr "El usuario se guardó, pero sus zonas no: ábrelo de nuevo para reintentar."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "El veto lo puede quitar únicamente el Administrador; si no eres tú, el sistema va a rechazar la acción."
msgstr "El veto lo puede quitar únicamente el Administrador; si no eres tú, el sistema va a rechazar la acción."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "El veto no se borra: queda en el historial como levantado, con tu motivo"
msgstr "El veto no se borra: queda en el historial como levantado, con tu motivo"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "El veto queda vigente desde ahora; el historial de la persona nunca se borra"
msgstr "El veto queda vigente desde ahora; el historial de la persona nunca se borra"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "El veto siempre carga su porqué y su respaldo — sin evidencia no hay veto."
msgstr "El veto siempre carga su porqué y su respaldo — sin evidencia no hay veto."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Elaborar la propuesta es del BD o del BDC"
msgstr "Elaborar la propuesta es del BD o del BDC"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Elegir el archivo"
msgstr "Elegir el archivo"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Elegir el hotel"
msgstr "Elegir el hotel"

#: src/features/admin/components/RoleGrantsSection.tsx
#: src/features/admin/pages/FeatureAccessPage.tsx
#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Elige a la persona"
msgstr "Elige a la persona"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Elige a la persona…"
msgstr "Elige a la persona…"

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Elige a quién"
msgstr "Elige a quién"

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Elige a quién (todos, por etiquetas o uno por uno) y la plantilla. Para un Excel, primero impórtalo en Contactos. Se guarda como borrador: todavía no se envía nada."
msgstr "Elige a quién (todos, por etiquetas o uno por uno) y la plantilla. Para un Excel, primero impórtalo en Contactos. Se guarda como borrador: todavía no se envía nada."

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Elige a quién inspeccionar. El tiempo sin inspeccionar te dice por dónde empezar."
msgstr "Elige a quién inspeccionar. El tiempo sin inspeccionar te dice por dónde empezar."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Elige a quién se inspecciona antes de guardar."
msgstr "Elige a quién se inspecciona antes de guardar."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Elige a un colaborador Disponible…"
msgstr "Elige a un colaborador Disponible…"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Elige a un colaborador para asignar"
msgstr "Elige a un colaborador para asignar"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Elige a un colaborador."
msgstr "Elige a un colaborador."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Elige al dueño"
msgstr "Elige al dueño"

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Elige al dueño del prospecto"
msgstr "Elige al dueño del prospecto"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Elige al menos un contacto."
msgstr "Elige al menos un contacto."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Elige al menos una etiqueta."
msgstr "Elige al menos una etiqueta."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Elige el concepto…"
msgstr "Elige el concepto…"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Elige el departamento"
msgstr "Elige el departamento"

#: src/shared/components/DateField.tsx
msgid "Elige el día"
msgstr "Elige el día"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "elige el hotel"
msgstr "elige el hotel"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Elige el hotel"
msgstr "Elige el hotel"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Elige el hotel y ves en qué va su propuesta: seguirla, abrir una nueva versión o crear la primera."
msgstr "Elige el hotel y ves en qué va su propuesta: seguirla, abrir una nueva versión o crear la primera."

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Elige el hotel ya registrado"
msgstr "Elige el hotel ya registrado"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Elige el hotel…"
msgstr "Elige el hotel…"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
msgid "Elige el motivo…"
msgstr "Elige el motivo…"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Elige el nuevo estado"
msgstr "Elige el nuevo estado"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Elige el parentesco"
msgstr "Elige el parentesco"

#: src/features/messaging/components/tours.ts
msgid "Elige el periodo"
msgstr "Elige el periodo"

#: src/features/onboarding/components/JobTitleSelect.tsx
#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Elige el puesto"
msgstr "Elige el puesto"

#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Elige el puesto…"
msgstr "Elige el puesto…"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Elige el resultado del intento"
msgstr "Elige el resultado del intento"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Elige el resultado…"
msgstr "Elige el resultado…"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Elige el rol"
msgstr "Elige el rol"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Elige el semáforo"
msgstr "Elige el semáforo"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Elige el tipo de intento"
msgstr "Elige el tipo de intento"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Elige el tipo de sangre"
msgstr "Elige el tipo de sangre"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Elige la función"
msgstr "Elige la función"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Elige la industria"
msgstr "Elige la industria"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Elige la modalidad"
msgstr "Elige la modalidad"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Elige la posición"
msgstr "Elige la posición"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Elige la posición…"
msgstr "Elige la posición…"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/types/prospectForm.schema.ts
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Elige la zona"
msgstr "Elige la zona"

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Elige la zona horaria"
msgstr "Elige la zona horaria"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Elige la zona…"
msgstr "Elige la zona…"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Elige primero el hotel y el rol: los jefes posibles salen de ahí."
msgstr "Elige primero el hotel y el rol: los jefes posibles salen de ahí."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Elige quién ocupa el siguiente slot libre"
msgstr "Elige quién ocupa el siguiente slot libre"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Elige tu tipo…"
msgstr "Elige tu tipo…"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Elige tu transporte para continuar"
msgstr "Elige tu transporte para continuar"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Elige tu transporte…"
msgstr "Elige tu transporte…"

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Elige un bloque para ver a sus colaboradores y revisar sus días."
msgstr "Elige un bloque para ver a sus colaboradores y revisar sus días."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Elige un hotel de la lista para ver su propuesta."
msgstr "Elige un hotel de la lista para ver su propuesta."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Elige un hotel para ajustar si paga el lonche"
msgstr "Elige un hotel para ajustar si paga el lonche"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Elige un hotel para cerrar su semana"
msgstr "Elige un hotel para cerrar su semana"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Elige un hotel…"
msgstr "Elige un hotel…"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Elige un motivo…"
msgstr "Elige un motivo…"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Elige un resultado para armar la lista."
msgstr "Elige un resultado para armar la lista."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Elige un rol"
msgstr "Elige un rol"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Elige un turno para ver a sus colaboradores."
msgstr "Elige un turno para ver a sus colaboradores."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Elige una fecha y hora al menos un minuto en el futuro."
msgstr "Elige una fecha y hora al menos un minuto en el futuro."

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Elige una Líder o «Directo contigo»"
msgstr "Elige una Líder o «Directo contigo»"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Elige una plantilla aprobada"
msgstr "Elige una plantilla aprobada"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Elige una plantilla."
msgstr "Elige una plantilla."

#: src/features/worker/pages/PasswordPage.tsx
msgid "Elige una que solo tú sepas; la temporal que te dieron deja de servir."
msgstr "Elige una que solo tú sepas; la temporal que te dieron deja de servir."

#: src/features/observability/components/CohortSection.tsx
msgid "Elige una semana para verlo."
msgstr "Elige una semana para verlo."

#: src/features/admin/pages/UsersPage.tsx
msgid "Eliminaciones"
msgstr "Eliminaciones"

#: src/shared/constants/requisitionStatus.ts
msgid "Eliminada"
msgstr "Eliminada"

#: src/features/account/pages/DeleteAccountPage.tsx
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/onboarding/components/DeleteHotelAction.tsx
#: src/features/recruitment/components/DeleteWorkerDialog.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Eliminando…"
msgstr "Eliminando…"

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/recruitment/components/PoolRoster.tsx
msgid "Eliminar"
msgstr "Eliminar"

#. placeholder {0}: department.name
#. placeholder {0}: i18n._(pending.noun)
#. placeholder {0}: item.label
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Eliminar {0}"
msgstr "Eliminar {0}"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Eliminar buzón"
msgstr "Eliminar buzón"

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "Eliminar colaborador"
msgstr "Eliminar colaborador"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Eliminar contacto"
msgstr "Eliminar contacto"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Eliminar departamento"
msgstr "Eliminar departamento"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Eliminar es de verdad"
msgstr "Eliminar es de verdad"

#: src/features/onboarding/components/ContactAttemptLog.tsx
msgid "Eliminar este intento"
msgstr "Eliminar este intento"

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Eliminar hotel"
msgstr "Eliminar hotel"

#: src/features/account/pages/DeleteAccountPage.tsx
#: src/features/worker/components/MobileShell.tsx
#: src/features/worker/pages/ProfilePage.tsx
#: src/layouts/Sidebar.tsx
msgid "Eliminar mi cuenta"
msgstr "Eliminar mi cuenta"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Eliminar motivo"
msgstr "Eliminar motivo"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Eliminar posición"
msgstr "Eliminar posición"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Eliminar reactivo"
msgstr "Eliminar reactivo"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Eliminar requisición"
msgstr "Eliminar requisición"

#: src/features/messaging/components/ContactActions.tsx
msgid "Email"
msgstr "Email"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Embudo de entrega"
msgstr "Embudo de entrega"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Emergencia"
msgstr "Emergencia"

#: src/features/accounting/types/settlement.constants.ts
msgid "Emitida"
msgstr "Emitida"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Emitida al hotel. Falta registrar el cobro."
msgstr "Emitida al hotel. Falta registrar el cobro."

#: src/features/worker/pages/HomePage.tsx
msgid "Empezar"
msgstr "Empezar"

#. placeholder {0}: formatDate(startDate)
#. placeholder {1}: -ahead
#: src/shared/components/UrgencyChip.tsx
msgid "Empezó el {0} · {1, plural, one {hace # día} other {hace # días}}"
msgstr "Empezó el {0} · {1, plural, one {hace # día} other {hace # días}}"

#. placeholder {0}: formatDate(startDate)
#: src/shared/components/UrgencyChip.tsx
msgid "Empieza el {0} · {ahead, plural, one {en # día} other {en # días}}"
msgstr "Empieza el {0} · {ahead, plural, one {en # día} other {en # días}}"

#: src/shared/constants/requisitionStatus.ts
msgid "empieza en 3 a 5 días"
msgstr "empieza en 3 a 5 días"

#: src/shared/constants/requisitionStatus.ts
msgid "empieza en más de 5 días"
msgstr "empieza en más de 5 días"

#: src/shared/constants/requisitionStatus.ts
msgid "empieza en menos de 3 días"
msgstr "empieza en menos de 3 días"

#. placeholder {0}: formatDate(startDate)
#: src/shared/components/UrgencyChip.tsx
msgid "Empieza hoy, {0}"
msgstr "Empieza hoy, {0}"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "empiezan en menos de 3 días"
msgstr "empiezan en menos de 3 días"

#. placeholder {0}: String(days)
#: src/features/contracts/components/ContractFilters.tsx
msgid "en {0} días"
msgstr "en {0} días"

#. placeholder {0}: metrics.openHotels
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "en {0} hoteles"
msgstr "en {0} hoteles"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "en 7 días"
msgstr "en 7 días"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "En accidente"
msgstr "En accidente"

#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "En Blacklist"
msgstr "En Blacklist"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/messaging/components/ReportParts.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "En cola"
msgstr "En cola"

#: src/features/territory/components/TerritoryMapLegend.tsx
msgid "En contacto"
msgstr "En contacto"

#: src/shared/constants/workerStatus.ts
msgid "En descanso de un hotel y se ofreció disponible para una asignación temporal."
msgstr "En descanso de un hotel y se ofreció disponible para una asignación temporal."

#. placeholder {0}: formatDate(selected.createdAt)
#. placeholder {0}: formatDate(worker.createdAt)
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "En el Pool desde el {0}"
msgstr "En el Pool desde el {0}"

#: src/shared/constants/requisitionStatus.ts
msgid "En elaboración"
msgstr "En elaboración"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "En ese hotel aún no hay un Manager de Área de ese departamento ni un Manager General activos."
msgstr "En ese hotel aún no hay un Manager de Área de ese departamento ni un Manager General activos."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "En ese hotel aún no hay un Manager General activo."
msgstr "En ese hotel aún no hay un Manager General activo."

#: src/features/worker/pages/PunchPage.tsx
msgid "En este hotel Entrada y Salida se registran escaneando el QR del acceso."
msgstr "En este hotel Entrada y Salida se registran escaneando el QR del acceso."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "En este idioma le llega la invitación y abre la app la primera vez. Después lo cambia desde su cuenta."
msgstr "En este idioma le llega la invitación y abre la app la primera vez. Después lo cambia desde su cuenta."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "En firma: falta que firme el hotel. Mientras tanto el contrato no se edita."
msgstr "En firma: falta que firme el hotel. Mientras tanto el contrato no se edita."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "En firma: falta que firme Oranje. Mientras tanto el contrato no se edita."
msgstr "En firma: falta que firme Oranje. Mientras tanto el contrato no se edita."

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "En la geocerca"
msgstr "En la geocerca"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "En la plataforma"
msgstr "En la plataforma"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "en los últimos {days} días"
msgstr "en los últimos {days} días"

#: src/features/observability/components/KpiCard.tsx
msgid "En meta"
msgstr "En meta"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/shared/constants/requisitionStatus.ts
msgid "En proceso"
msgstr "En proceso"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "En revisión"
msgstr "En revisión"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "En Stand-by"
msgstr "En Stand-by"

#: src/features/messaging/components/ReportCharts.tsx
msgid "En total"
msgstr "En total"

#: src/shared/components/MascotaPeek.tsx
msgid "En una vista de detalle, la flecha ← te regresa a donde estabas."
msgstr "En una vista de detalle, la flecha ← te regresa a donde estabas."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Encabezado (opcional)"
msgstr "Encabezado (opcional)"

#: src/features/worker/pages/HomePage.tsx
msgid "Enciende Amarillo cuando quieras que te consideren para más turnos."
msgstr "Enciende Amarillo cuando quieras que te consideren para más turnos."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Enlace"
msgstr "Enlace"

#: src/features/account/pages/DeleteAccountPage.tsx
#: src/features/accounting/pages/AccountingPendingPages.tsx
#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/messaging/components/Tour.tsx
#: src/features/timesheet/components/DayStatusTour.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Entendido"
msgstr "Entendido"

#. placeholder {0}: i18n._(branch.enteredFrom)
#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "entra {0}"
msgstr "entra {0}"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Entra a cada una para ver el detalle, los motivos y los destinatarios."
msgstr "Entra a cada una para ver el detalle, los motivos y los destinatarios."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Entra a Oranje"
msgstr "Entra a Oranje"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Entra al Pool hoy. Lo suyo tiene 1 día para completarlo desde su app; si no lo hace, su acceso se bloquea hasta que lo complete. Lo de Fase 1 no le bloquea nada: eso queda en tus manos."
msgstr "Entra al Pool hoy. Lo suyo tiene 1 día para completarlo desde su app; si no lo hace, su acceso se bloquea hasta que lo complete. Lo de Fase 1 no le bloquea nada: eso queda en tus manos."

#: src/features/schedule/components/AddShiftDialog.tsx
#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/worker/api/punchApi.ts
#: src/features/worker/pages/PunchPage.tsx
msgid "Entrada"
msgstr "Entrada"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Entrada – Salida"
msgstr "Entrada – Salida"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Entrada de hoy"
msgstr "Entrada de hoy"

#: src/features/worker/pages/PunchPage.tsx
msgid "Entrada y Salida llevan tu foto"
msgstr "Entrada y Salida llevan tu foto"

#: src/features/worker/pages/PunchPage.tsx
msgid "Entrada y Salida necesitan tu foto: tómala y vuelve a intentar."
msgstr "Entrada y Salida necesitan tu foto: tómala y vuelve a intentar."

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Entrada, lunch y salida con su geocerca y sus dos relojes. Un día sin salida no puede irse a revisión."
msgstr "Entrada, lunch y salida con su geocerca y sus dos relojes. Un día sin salida no puede irse a revisión."

#: src/features/worker/pages/PunchPage.tsx
msgid "Entrada, salida al lunch, regreso y salida. El botón siempre sabe cuál toca: solo tócalo cuando llegue el momento."
msgstr "Entrada, salida al lunch, regreso y salida. El botón siempre sabe cuál toca: solo tócalo cuando llegue el momento."

#: src/features/observability/lib/workerKpis.ts
msgid "Entradas a la hora o antes, de las que tenían un turno programado."
msgstr "Entradas a la hora o antes, de las que tenían un turno programado."

#. placeholder {0}: role.title
#: src/mobile/UnsupportedRolePage.tsx
msgid "Entraste como {0}. Tu trabajo en Oranje está en el web, desde la computadora."
msgstr "Entraste como {0}. Tu trabajo en Oranje está en el web, desde la computadora."

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/components/ReportParts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Entregados"
msgstr "Entregados"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Entregados sin leer"
msgstr "Entregados sin leer"

#. placeholder {0}: timeOf(row.clockInAt, timeZone)
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Entró {0}"
msgstr "Entró {0}"

#: src/features/onboarding/components/ProposalVersionHistory.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Enviada"
msgstr "Enviada"

#. placeholder {0}: formatDate(candidate.latestSentAt)
#. placeholder {0}: formatDate(version.sentAt)
#: src/features/onboarding/components/ProposalVersionHistory.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Enviada {0}"
msgstr "Enviada {0}"

#. placeholder {0}: formatDate(selected.sentAt)
#. placeholder {0}: formatDate(version.sentAt)
#. placeholder {1}: selected.byName
#. placeholder {1}: version.byName
#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Enviada {0} · {1}"
msgstr "Enviada {0} · {1}"

#. placeholder {0}: formatDate(version.sentAt)
#. placeholder {1}: version.byName
#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Enviada {0} por {1}"
msgstr "Enviada {0} por {1}"

#: src/shared/constants/timesheetStatus.ts
msgid "Enviada a aprobación"
msgstr "Enviada a aprobación"

#: src/features/admin/pages/MailSettingsPage.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Enviado"
msgstr "Enviado"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Enviado, en revisión"
msgstr "Enviado, en revisión"

#: src/features/messaging/components/ReportParts.tsx
msgid "Enviados sin confirmar"
msgstr "Enviados sin confirmar"

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Envíala desde aquí"
msgstr "Envíala desde aquí"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Enviando"
msgstr "Enviando"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Enviando y aprobando…"
msgstr "Enviando y aprobando…"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
#: src/features/timesheet/components/WeekActionBar.tsx
#: src/shared/components/SendDocumentModal.tsx
msgid "Enviando…"
msgstr "Enviando…"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Enviar"
msgstr "Enviar"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Enviar a {total} contactos"
msgstr "Enviar a {total} contactos"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Enviar a revisión"
msgstr "Enviar a revisión"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Enviar contrato"
msgstr "Enviar contrato"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Enviar contrato por correo"
msgstr "Enviar contrato por correo"

#: src/shared/components/SendDocumentModal.tsx
msgid "Enviar correo"
msgstr "Enviar correo"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Enviar enlace"
msgstr "Enviar enlace"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Enviar invitación por correo"
msgstr "Enviar invitación por correo"

#: src/features/onboarding/components/ContractPreviewDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Enviar por correo"
msgstr "Enviar por correo"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Enviar por correo para firmar en papel"
msgstr "Enviar por correo para firmar en papel"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Enviar propuesta"
msgstr "Enviar propuesta"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Enviar propuesta por correo"
msgstr "Enviar propuesta por correo"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Enviar y aprobar"
msgstr "Enviar y aprobar"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Envío cancelado: el contrato se puede editar otra vez"
msgstr "Envío cancelado: el contrato se puede editar otra vez"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Envío de emergencia (jueves)"
msgstr "Envío de emergencia (jueves)"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Envío registrado"
msgstr "Envío registrado"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/pages/MessagingPage.tsx
msgid "Envíos masivos por WhatsApp"
msgstr "Envíos masivos por WhatsApp"

#: src/features/onboarding/components/JobTitleSelect.tsx
msgid "Equipo Oranje"
msgstr "Equipo Oranje"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Eres el único Administrador activo: nombra a otro antes de eliminar tu cuenta."
msgstr "Eres el único Administrador activo: nombra a otro antes de eliminar tu cuenta."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Es el contacto principal"
msgstr "Es el contacto principal"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "es el principal de este hotel"
msgstr "es el principal de este hotel"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Es el punto que usa el ponche para medir la distancia. Arrástralo a la entrada real del hotel para tener mejor precisión: unos metros de más rechazan ponches legítimos."
msgstr "Es el punto que usa el ponche para medir la distancia. Arrástralo a la entrada real del hotel para tener mejor precisión: unos metros de más rechazan ponches legítimos."

#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Es la contraseña con la que entras a esta app. La de tu correo corporativo se cambia desde el correo."
msgstr "Es la contraseña con la que entras a esta app. La de tu correo corporativo se cambia desde el correo."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Es menor de edad"
msgstr "Es menor de edad"

#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
msgid "Es obligatorio decir por qué: el motivo acompaña la transición en el historial del colaborador."
msgstr "Es obligatorio decir por qué: el motivo acompaña la transición en el historial del colaborador."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Es su contraseña de uso: puede cambiarla cuando quiera con «¿Olvidaste tu contraseña?». No se envía por correo."
msgstr "Es su contraseña de uso: puede cambiarla cuando quiera con «¿Olvidaste tu contraseña?». No se envía por correo."

#. placeholder {0}: formatDate(access.dueAt)
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Es temporal y se le venció el {0}: su app solo le deja cambiarla."
msgstr "Es temporal y se le venció el {0}: su app solo le deja cambiarla."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Es temporal: el colaborador la cambia desde su app en los próximos 30 días. La verás una sola vez: dásela en persona, no por correo."
msgstr "Es temporal: el colaborador la cambia desde su app en los próximos 30 días. La verás una sola vez: dásela en persona, no por correo."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Es temporal: tiene 30 días para cambiarla desde su app; si no, su acceso se bloquea hasta que lo haga."
msgstr "Es temporal: tiene 30 días para cambiarla desde su app; si no, su acceso se bloquea hasta que lo haga."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Es temporal: tiene 30 días para cambiarla desde su app."
msgstr "Es temporal: tiene 30 días para cambiarla desde su app."

#. placeholder {0}: formatDate(access.dueAt)
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Es temporal: tiene hasta el {0} para cambiarla desde su app."
msgstr "Es temporal: tiene hasta el {0} para cambiarla desde su app."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Es un borrador en elaboración: los valores pueden cambiar hasta que el BD o el BDC la envíen. Cuando la envíen, aquí verás la versión final."
msgstr "Es un borrador en elaboración: los valores pueden cambiar hasta que el BD o el BDC la envíen. Cuando la envíen, aquí verás la versión final."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Es un Excel antiguo (.xls): ábrelo y guárdalo como .xlsx."
msgstr "Es un Excel antiguo (.xls): ábrelo y guárdalo como .xlsx."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Esa asignación es de otro hotel."
msgstr "Esa asignación es de otro hotel."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Esa cuenta ya no existe en ese hotel. Recarga la página."
msgstr "Esa cuenta ya no existe en ese hotel. Recarga la página."

#: src/features/worker/pages/PunchPage.tsx
msgid "Esa foto no se pudo procesar: toma otra desde la cámara."
msgstr "Esa foto no se pudo procesar: toma otra desde la cámara."

#. placeholder {0}: formatDayMonth(workDate)
#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Esa marca ya quedó registrada el {0}."
msgstr "Esa marca ya quedó registrada el {0}."

#: src/features/worker/pages/PunchPage.tsx
msgid "Esa marca ya quedó registrada hoy."
msgstr "Esa marca ya quedó registrada hoy."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Esa persona ya no tiene una asignación activa aquí."
msgstr "Esa persona ya no tiene una asignación activa aquí."

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Esa Reclutadora ya no está en tu equipo. Recarga la página para ver tu equipo actual."
msgstr "Esa Reclutadora ya no está en tu equipo. Recarga la página para ver tu equipo actual."

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Esa versión de la propuesta no existe. Vuelve a Propuestas y elige otra."
msgstr "Esa versión de la propuesta no existe. Vuelve a Propuestas y elige otra."

#: src/features/worker/components/QrScanner.tsx
msgid "Escanea el QR del acceso"
msgstr "Escanea el QR del acceso"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Escanéalo con la cámara de tu celular al llegar y al salir: te lleva directo a ponchar. También toma tu ubicación."
msgstr "Escanéalo con la cámara de tu celular al llegar y al salir: te lleva directo a ponchar. También toma tu ubicación."

#: src/features/personnel/components/ContactQr.tsx
msgid "Escanéalo con tu celular para llamarle o guardar su contacto"
msgstr "Escanéalo con tu celular para llamarle o guardar su contacto"

#: src/features/worker/pages/PunchPage.tsx
msgid "escaneando el QR del acceso"
msgstr "escaneando el QR del acceso"

#: src/layouts/GlobalSearch.tsx
msgid "Escribe al menos 2 letras. Navega con ↑ ↓ y abre con Enter."
msgstr "Escribe al menos 2 letras. Navega con ↑ ↓ y abre con Enter."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Escribe al menos 4 caracteres para poder guardar."
msgstr "Escribe al menos 4 caracteres para poder guardar."

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Escribe al menos un teléfono o un correo del contacto"
msgstr "Escribe al menos un teléfono o un correo del contacto"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Escribe el motivo (al menos 4 letras) para poder eliminarla"
msgstr "Escribe el motivo (al menos 4 letras) para poder eliminarla"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Escribe el motivo: queda en el journal."
msgstr "Escribe el motivo: queda en el journal."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Escribe el nombre completo"
msgstr "Escribe el nombre completo"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Escribe el nombre de la etiqueta."
msgstr "Escribe el nombre de la etiqueta."

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Escribe el nombre del hotel"
msgstr "Escribe el nombre del hotel"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Escribe el teléfono con su código de país: +1 para EE. UU., +52 para México."
msgstr "Escribe el teléfono con su código de país: +1 para EE. UU., +52 para México."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Escribe el texto de cada variable fija."
msgstr "Escribe el texto de cada variable fija."

#: src/features/onboarding/import/mapImportRows.ts
msgid "Escribe Sí o No en horas extra, no «{overtimeText}»"
msgstr "Escribe Sí o No en horas extra, no «{overtimeText}»"

#: src/features/auth/types/login.schema.ts
#: src/mobile/AppLoginPage.tsx
msgid "Escribe tu contraseña"
msgstr "Escribe tu contraseña"

#: src/features/auth/types/login.schema.ts
#: src/mobile/AppLoginPage.tsx
msgid "Escribe tu correo"
msgstr "Escribe tu correo"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Escribe tu correo y te mandamos el enlace."
msgstr "Escribe tu correo y te mandamos el enlace."

#: src/features/onboarding/types/hotelContactsForm.schema.ts
#: src/shared/components/SendDocumentModal.tsx
msgid "Escribe un correo válido"
msgstr "Escribe un correo válido"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Escribe un correo válido o déjalo vacío."
msgstr "Escribe un correo válido o déjalo vacío."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Escribe un correo válido, como ana@hotel.com"
msgstr "Escribe un correo válido, como ana@hotel.com"

#: src/features/auth/types/login.schema.ts
#: src/mobile/AppLoginPage.tsx
msgid "Escribe un correo válido, como ana@oranje.mx"
msgstr "Escribe un correo válido, como ana@oranje.mx"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Escribe un correo válido, como ana@oranjepeople.com"
msgstr "Escribe un correo válido, como ana@oranjepeople.com"

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Escribe un correo válido, como marta@hotel.mx"
msgstr "Escribe un correo válido, como marta@hotel.mx"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Escribir una contraseña"
msgstr "Escribir una contraseña"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Escribirla yo"
msgstr "Escribirla yo"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Ese archivo no se pudo leer: sube una foto clara o un PDF."
msgstr "Ese archivo no se pudo leer: sube una foto clara o un PDF."

#: src/features/worker/pages/PunchPage.tsx
msgid "Ese código no es el QR vigente del hotel: busca la hoja actual, o pídele al Supervisor un ponche manual."
msgstr "Ese código no es el QR vigente del hotel: busca la hoja actual, o pídele al Supervisor un ponche manual."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Ese colaborador ya no tiene asignación activa en este hotel."
msgstr "Ese colaborador ya no tiene asignación activa en este hotel."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Ese colaborador ya tiene una asignación activa."
msgstr "Ese colaborador ya tiene una asignación activa."

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Ese correo no es válido"
msgstr "Ese correo no es válido"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Ese correo ya está dado de alta en Oranje."
msgstr "Ese correo ya está dado de alta en Oranje."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Ese correo ya está en uso: prueba otro."
msgstr "Ese correo ya está en uso: prueba otro."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ese correo ya tiene cuenta de acceso. Da el alta sin contraseña (invitación) o que la persona use «¿Olvidaste tu contraseña?»."
msgstr "Ese correo ya tiene cuenta de acceso. Da el alta sin contraseña (invitación) o que la persona use «¿Olvidaste tu contraseña?»."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Ese documento ya está verificado: no se puede borrar, deja rastro de quién lo revisó."
msgstr "Ese documento ya está verificado: no se puede borrar, deja rastro de quién lo revisó."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Ese documento ya estaba verificado: no se puede rechazar."
msgstr "Ese documento ya estaba verificado: no se puede rechazar."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Ese documento ya estaba verificado."
msgstr "Ese documento ya estaba verificado."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ese formato no se pudo abrir: usa una foto JPG, PNG o WebP."
msgstr "Ese formato no se pudo abrir: usa una foto JPG, PNG o WebP."

#: src/features/worker/components/PhotoUploader.tsx
msgid "Ese formato no se pudo leer: usa JPG, PNG o WebP."
msgstr "Ese formato no se pudo leer: usa JPG, PNG o WebP."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Ese formato no se puede procesar (los HEIC del iPhone no entran): usa JPG, PNG o WebP."
msgstr "Ese formato no se puede procesar (los HEIC del iPhone no entran): usa JPG, PNG o WebP."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Ese formato no se puede procesar (los HEIC del iPhone no entran): usa JPG, PNG, WebP o PDF."
msgstr "Ese formato no se puede procesar (los HEIC del iPhone no entran): usa JPG, PNG, WebP o PDF."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Ese hotel no está en ninguna de tus zonas."
msgstr "Ese hotel no está en ninguna de tus zonas."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Ese hotel ya no existe. Recarga la página y vuelve a elegirlo."
msgstr "Ese hotel ya no existe. Recarga la página y vuelve a elegirlo."

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Ese motivo ya no está disponible: elige otro de la lista."
msgstr "Ese motivo ya no está disponible: elige otro de la lista."

#: src/features/worker/pages/Phase3Page.tsx
msgid "Ese número de emergencia no es válido para el país elegido. Revisa los dígitos o cambia el país."
msgstr "Ese número de emergencia no es válido para el país elegido. Revisa los dígitos o cambia el país."

#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/types/hotelContactsForm.schema.ts
#: src/features/onboarding/types/prospectForm.schema.ts
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Ese número no es válido para el país elegido. Revisa los dígitos o cambia el país."
msgstr "Ese número no es válido para el país elegido. Revisa los dígitos o cambia el país."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Ese paso existe, pero lo ejecuta {rolesLabel}: pídeselo — tu rol no lo tiene asignado."
msgstr "Ese paso existe, pero lo ejecuta {rolesLabel}: pídeselo — tu rol no lo tiene asignado."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Ese paso no existe en el Semáforo: elige otro estado."
msgstr "Ese paso no existe en el Semáforo: elige otro estado."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ese rol no se da de alta aquí: las cuentas de los hoteles van en «Personal de hoteles»."
msgstr "Ese rol no se da de alta aquí: las cuentas de los hoteles van en «Personal de hoteles»."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ese rol ya no existe. Recarga la página y vuelve a elegirlo."
msgstr "Ese rol ya no existe. Recarga la página y vuelve a elegirlo."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ese semáforo no existe."
msgstr "Ese semáforo no existe."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Ese tipo de archivo no se puede importar. Usa .xlsx, .csv, .txt o .pdf."
msgstr "Ese tipo de archivo no se puede importar. Usa .xlsx, .csv, .txt o .pdf."

#: src/features/worker/pages/PunchPage.tsx
msgid "Ese turno no es tuyo. Recarga la pantalla e inténtalo de nuevo."
msgstr "Ese turno no es tuyo. Recarga la pantalla e inténtalo de nuevo."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "esperando al Manager"
msgstr "esperando al Manager"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Esperando aprobación"
msgstr "Esperando aprobación"

#: src/mobile/UnsupportedRolePage.tsx
msgid "Esta app es para colaboradores y hoteles"
msgstr "Esta app es para colaboradores y hoteles"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Esta asignación paga esto en vez de la tarifa del contrato, desde ahora."
msgstr "Esta asignación paga esto en vez de la tarifa del contrato, desde ahora."

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Está bloqueado: desbloquéalo primero."
msgstr "Está bloqueado: desbloquéalo primero."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Esta campaña todavía no sale"
msgstr "Esta campaña todavía no sale"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Está dada de baja: el acceso no cuenta."
msgstr "Está dada de baja: el acceso no cuenta."

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "Está en firma: primero cancela el envío."
msgstr "Está en firma: primero cancela el envío."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Está en firma: se activa sola cuando firme el hotel"
msgstr "Está en firma: se activa sola cuando firme el hotel"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Está en Gris por un accidente laboral: no se puede vetar hasta que su caso se resuelva."
msgstr "Está en Gris por un accidente laboral: no se puede vetar hasta que su caso se resuelva."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Está en uso: hay requisiciones, posiciones o colaboradores colgando de esta fila. Elimina o reasigna eso primero."
msgstr "Está en uso: hay requisiciones, posiciones o colaboradores colgando de esta fila. Elimina o reasigna eso primero."

#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Esta es la versión que tiene el hotel"
msgstr "Esta es la versión que tiene el hotel"

#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Esta es la versión que tiene el hotel: la última que se le envió."
msgstr "Esta es la versión que tiene el hotel: la última que se le envió."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Esta factura ya se aprobó y no se recalcula: agrega la tarifa al contrato para las siguientes y cobra estas horas aparte."
msgstr "Esta factura ya se aprobó y no se recalcula: agrega la tarifa al contrato para las siguientes y cobra estas horas aparte."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Esta inspección no es de tu hotel."
msgstr "Esta inspección no es de tu hotel."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Está llenando"
msgstr "Está llenando"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Esta pantalla dice a quién avisar"
msgstr "Esta pantalla dice a quién avisar"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Esta pantalla existe para que el módulo tenga su lugar; sus reglas siguen en el vault."
msgstr "Esta pantalla existe para que el módulo tenga su lugar; sus reglas siguen en el vault."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Esta plantilla no tiene variables: le llega igual a todos."
msgstr "Esta plantilla no tiene variables: le llega igual a todos."

#: src/shared/components/UrgencyChip.tsx
msgid "Esta posición ya está cubierta: no importa cuánto falte para que inicie."
msgstr "Esta posición ya está cubierta: no importa cuánto falte para que inicie."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Esta requisición la elimina quien la creó, el Manager de Área de su departamento, el Manager General o el Inspector de su zona."
msgstr "Esta requisición la elimina quien la creó, el Manager de Área de su departamento, el Manager General o el Inspector de su zona."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Esta requisición no es tuya: solo puedes eliminar las que tú creaste."
msgstr "Esta requisición no es tuya: solo puedes eliminar las que tú creaste."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Esta requisición se eliminó"
msgstr "Esta requisición se eliminó"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Esta requisición tiene posiciones de otro departamento: la elimina el Manager General."
msgstr "Esta requisición tiene posiciones de otro departamento: la elimina el Manager General."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Esta requisición ya cerró: el slot no vuelve a abrirse."
msgstr "Esta requisición ya cerró: el slot no vuelve a abrirse."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Esta requisición ya estaba eliminada."
msgstr "Esta requisición ya estaba eliminada."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Esta requisición ya no está autorizada o en proceso: no se puede unir."
msgstr "Esta requisición ya no está autorizada o en proceso: no se puede unir."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Esta requisición ya no está en proceso: revisa su estado antes de asignar."
msgstr "Esta requisición ya no está en proceso: revisa su estado antes de asignar."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "esta semana"
msgstr "esta semana"

#: src/features/observability/lib/period.ts
msgid "Esta semana"
msgstr "Esta semana"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Esta semana es de otro departamento: no te toca aprobarla."
msgstr "Esta semana es de otro departamento: no te toca aprobarla."

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Esta semana no hay jornadas con horas. La vista Días también enseña ausencias y pendientes."
msgstr "Esta semana no hay jornadas con horas. La vista Días también enseña ausencias y pendientes."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Esta semana ya está cerrada."
msgstr "Esta semana ya está cerrada."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Esta semana ya se envió a aprobación: no admite más cambios."
msgstr "Esta semana ya se envió a aprobación: no admite más cambios."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Esta transición exige un motivo: elígelo de la lista."
msgstr "Esta transición exige un motivo: elígelo de la lista."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Esta versión ya se envió: lo enviado no se descarta."
msgstr "Esta versión ya se envió: lo enviado no se descarta."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Esta versión ya se envió: lo enviado no se edita — abre una versión nueva."
msgstr "Esta versión ya se envió: lo enviado no se edita — abre una versión nueva."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "estado"
msgstr "estado"

#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/contracts/components/ContractFilters.tsx
#: src/features/contracts/components/ContractTable.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingFilters.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Estado"
msgstr "Estado"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "estado actual"
msgstr "estado actual"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Estado actual"
msgstr "Estado actual"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Estado actual: {currentLabel}. Puedes pasarlo a cualquier estado y regresarlo al anterior; Blacklist va por su propio flujo y Asignación temporal se pone sola al asignar."
msgstr "Estado actual: {currentLabel}. Puedes pasarlo a cualquier estado y regresarlo al anterior; Blacklist va por su propio flujo y Asignación temporal se pone sola al asignar."

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Estado actual: {currentLabel}. Solo puedes elegir los cambios permitidos para tu rol."
msgstr "Estado actual: {currentLabel}. Solo puedes elegir los cambios permitidos para tu rol."

#. placeholder {0}: ONBOARDING_STATUS_LABEL[selectedStatus]
#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Estado cambiado a {0}"
msgstr "Estado cambiado a {0}"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Estado cambiado a {label}"
msgstr "Estado cambiado a {label}"

#. placeholder {0}: template.name
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Estado de «{0}» actualizado con Meta."
msgstr "Estado de «{0}» actualizado con Meta."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Estado de la semana"
msgstr "Estado de la semana"

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "Estado de la semana."
msgstr "Estado de la semana."

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Estado de la solicitud"
msgstr "Estado de la solicitud"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Estado inicial"
msgstr "Estado inicial"

#. placeholder {0}: WORKER_STATUS_LABEL[status]
#: src/features/worker/pages/HomePage.tsx
msgid "Estado: {0}"
msgstr "Estado: {0}"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Estado: {statusLabel}"
msgstr "Estado: {statusLabel}"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Estamos trabajando en tu requisición"
msgstr "Estamos trabajando en tu requisición"

#: src/features/observability/lib/people.ts
msgid "Estancados"
msgstr "Estancados"

#: src/features/worker/pages/HomePage.tsx
msgid "Estás <0>disponible por voluntad propia</0>: Reclutamiento puede asignarte en cuanto haya una requisición."
msgstr "Estás <0>disponible por voluntad propia</0>: Reclutamiento puede asignarte en cuanto haya una requisición."

#: src/features/worker/lib/noShiftMessage.ts
msgid "Estás en incapacidad"
msgstr "Estás en incapacidad"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Estás en la semana actual"
msgstr "Estás en la semana actual"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Estás en Stand-by"
msgstr "Estás en Stand-by"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Estas filas no se importan:"
msgstr "Estas filas no se importan:"

#: src/features/worker/pages/PunchPage.tsx
msgid "Estás fuera del hotel: la marca no se guarda. Pídele al Supervisor un ponche manual."
msgstr "Estás fuera del hotel: la marca no se guarda. Pídele al Supervisor un ponche manual."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Estas horas del periodo no se cobraron porque el contrato no tiene tarifa para su puesto:"
msgstr "Estas horas del periodo no se cobraron porque el contrato no tiene tarifa para su puesto:"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Estas horas no entraron porque no tienen tarifa:"
msgstr "Estas horas no entraron porque no tienen tarifa:"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Este — Atlanta, Miami, Nueva York"
msgstr "Este — Atlanta, Miami, Nueva York"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Este ambiente no está conectado a la plataforma de mensajería"
msgstr "Este ambiente no está conectado a la plataforma de mensajería"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Este ambiente no manda correo propio"
msgstr "Este ambiente no manda correo propio"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Este borrador lo activa el BDC cuando la verificación de «Qué sigue» esté en verde: al activarlo, el contrato pasa a regir la nómina y la factura del hotel."
msgstr "Este borrador lo activa el BDC cuando la verificación de «Qué sigue» esté en verde: al activarlo, el contrato pasa a regir la nómina y la factura del hotel."

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Este cambio necesita un motivo"
msgstr "Este cambio necesita un motivo"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Este catálogo está vacío. Agrega su primera fila con el botón de arriba."
msgstr "Este catálogo está vacío. Agrega su primera fila con el botón de arriba."

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Este ciclo ya estaba cerrado."
msgstr "Este ciclo ya estaba cerrado."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Este colaborador no tiene un correo @oranjepeople.com asignado todavía."
msgstr "Este colaborador no tiene un correo @oranjepeople.com asignado todavía."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Este colaborador todavía no tiene acceso. Créalo primero."
msgstr "Este colaborador todavía no tiene acceso. Créalo primero."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Este colaborador ya tiene acceso."
msgstr "Este colaborador ya tiene acceso."

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Este consolidado ya tiene una deducción de {typeLabel}. Agrégala solo si corresponde otra."
msgstr "Este consolidado ya tiene una deducción de {typeLabel}. Agrégala solo si corresponde otra."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Este contacto aparece en la bitácora de intentos, así que no se puede borrar. Desactívalo y dejará de mostrarse."
msgstr "Este contacto aparece en la bitácora de intentos, así que no se puede borrar. Desactívalo y dejará de mostrarse."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Este contrato no existe o fue borrado. Vuelve a la lista y elige otro."
msgstr "Este contrato no existe o fue borrado. Vuelve a la lista y elige otro."

#: src/features/contracts/components/RateTable.tsx
msgid "Este contrato no trae ninguna posición cotizada."
msgstr "Este contrato no trae ninguna posición cotizada."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Este contrato se canceló en borrador: nunca rigió y no admite cambios."
msgstr "Este contrato se canceló en borrador: nunca rigió y no admite cambios."

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Este contrato tiene las tarifas de la propuesta v{currentVersion}, pero la última enviada es la v{latestVersion}."
msgstr "Este contrato tiene las tarifas de la propuesta v{currentVersion}, pero la última enviada es la v{latestVersion}."

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Este contrato ya está cerrado: las tarifas quedaron congeladas."
msgstr "Este contrato ya está cerrado: las tarifas quedaron congeladas."

#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Este contrato ya está cerrado: no admite más cambios."
msgstr "Este contrato ya está cerrado: no admite más cambios."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Este contrato ya está en firma."
msgstr "Este contrato ya está en firma."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Este contrato ya estaba marcado como enviado."
msgstr "Este contrato ya estaba marcado como enviado."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Este contrato ya expiró: dejó de regir y no admite cambios. Para renovar, se crea uno nuevo para el hotel."
msgstr "Este contrato ya expiró: dejó de regir y no admite cambios. Para renovar, se crea uno nuevo para el hotel."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Este cuadro es el que firma el hotel: al crear el Documento de T&C se copia tal cual, sin volver a capturarlo."
msgstr "Este cuadro es el que firma el hotel: al crear el Documento de T&C se copia tal cual, sin volver a capturarlo."

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Este día no tiene jornadas con horas. El punto naranja marca los días que sí."
msgstr "Este día no tiene jornadas con horas. El punto naranja marca los días que sí."

#: src/features/contracts/components/clauses/ClausesEditWarningDialog.tsx
msgid "Este es el <0>texto de venta</0> de esta propuesta: lo que cambies aquí queda solo para este ciclo, sin afectar al Contrato ni a otras propuestas."
msgstr "Este es el <0>texto de venta</0> de esta propuesta: lo que cambies aquí queda solo para este ciclo, sin afectar al Contrato ni a otras propuestas."

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Este hotel no tiene colaboradores asignados"
msgstr "Este hotel no tiene colaboradores asignados"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "este hotel no tiene principal todavía"
msgstr "este hotel no tiene principal todavía"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Este hotel no tiene propuesta o el enlace ya no sirve. Vuelve al Pipeline y ábrela desde su ficha."
msgstr "Este hotel no tiene propuesta o el enlace ya no sirve. Vuelve al Pipeline y ábrela desde su ficha."

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "Este hotel no tiene requisiciones en tu tablero"
msgstr "Este hotel no tiene requisiciones en tu tablero"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Este hotel no tiene requisiciones todavía."
msgstr "Este hotel no tiene requisiciones todavía."

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "Este hotel no tiene schedule ese día"
msgstr "Este hotel no tiene schedule ese día"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Este hotel no tiene sus datos contables capturados (cierre de semana y pago de horas extra): complétalos en su ficha antes de crear el contrato."
msgstr "Este hotel no tiene sus datos contables capturados (cierre de semana y pago de horas extra): complétalos en su ficha antes de crear el contrato."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Este hotel no tiene un BDC que firme por Oranje"
msgstr "Este hotel no tiene un BDC que firme por Oranje"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Este hotel no tiene un contrato vigente con tarifas: no se puede pedir personal todavía."
msgstr "Este hotel no tiene un contrato vigente con tarifas: no se puede pedir personal todavía."

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Este hotel poncha con selfie: cambia el método antes."
msgstr "Este hotel poncha con selfie: cambia el método antes."

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Este hotel poncha con selfie: no tiene QR que imprimir."
msgstr "Este hotel poncha con selfie: no tiene QR que imprimir."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Este hotel todavía no tiene propuesta."
msgstr "Este hotel todavía no tiene propuesta."

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Este hotel todavía no tiene Schedule. En cuanto se programe una semana, aparece aquí."
msgstr "Este hotel todavía no tiene Schedule. En cuanto se programe una semana, aparece aquí."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Este hotel todavía no tiene un contrato activo con tarifas, así que no se le puede pedir personal. Cuando Ventas lo active, aquí aparecen sus posiciones."
msgstr "Este hotel todavía no tiene un contrato activo con tarifas, así que no se le puede pedir personal. Cuando Ventas lo active, aquí aparecen sus posiciones."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Este hotel todavía no tiene un contrato activo con tarifas."
msgstr "Este hotel todavía no tiene un contrato activo con tarifas."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Este hotel ya es cliente activo"
msgstr "Este hotel ya es cliente activo"

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
msgid "Este hotel ya no tiene slots libres en la Bolsa"
msgstr "Este hotel ya no tiene slots libres en la Bolsa"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Este hotel ya tiene el contrato {activeContractNumber} vigente. Cuando firmen los dos, este no se va a activar solo: primero cancela el vigente o espera a que venza."
msgstr "Este hotel ya tiene el contrato {activeContractNumber} vigente. Cuando firmen los dos, este no se va a activar solo: primero cancela el vigente o espera a que venza."

#. placeholder {0}: outgoingManager.fullName
#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Este hotel ya tiene gerente: {0}. Si dejó el hotel, dale de baja su cuenta desde «Personal de hoteles» — mientras siga activa puede entrar y aprobar horas."
msgstr "Este hotel ya tiene gerente: {0}. Si dejó el hotel, dale de baja su cuenta desde «Personal de hoteles» — mientras siga activa puede entrar y aprobar horas."

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Este hotel ya tiene operación y no se puede eliminar: archiva su ciclo."
msgstr "Este hotel ya tiene operación y no se puede eliminar: archiva su ciclo."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Este hotel ya tiene un ciclo comercial abierto: ciérralo o elige otro hotel."
msgstr "Este hotel ya tiene un ciclo comercial abierto: ciérralo o elige otro hotel."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Este hotel ya tiene un contrato vigente: primero hay que expirarlo."
msgstr "Este hotel ya tiene un contrato vigente: primero hay que expirarlo."

#: src/features/observability/lib/period.ts
msgid "Este mes"
msgstr "Este mes"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Este mes no tiene jornadas registradas. Navega con ‹ › a una semana con datos."
msgstr "Este mes no tiene jornadas registradas. Navega con ‹ › a una semana con datos."

#: src/features/worker/pages/PunchPage.tsx
msgid "Este navegador no da la ubicación: usa el navegador del teléfono."
msgstr "Este navegador no da la ubicación: usa el navegador del teléfono."

#: src/features/worker/components/CameraCapture.tsx
#: src/features/worker/components/QrScanner.tsx
msgid "Este navegador no puede abrir la cámara."
msgstr "Este navegador no puede abrir la cámara."

#. placeholder {0}: ONBOARDING_STATUS_LABEL[state]
#: src/features/conversion/pages/ConversionPage.tsx
msgid "Este prospecto está en <0>{0}</0> — la conversión sale de Rosa"
msgstr "Este prospecto está en <0>{0}</0> — la conversión sale de Rosa"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Este prospecto no existe o ya no está disponible. Vuelve al Pipeline y elige otro."
msgstr "Este prospecto no existe o ya no está disponible. Vuelve al Pipeline y elige otro."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Este prospecto ya no está en Rosa: alguien más lo movió."
msgstr "Este prospecto ya no está en Rosa: alguien más lo movió."

#: src/features/onboarding/types/proposalDraft.schema.ts
msgid "Este puesto ya tiene su tarifa más arriba"
msgstr "Este puesto ya tiene su tarifa más arriba"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Este reporte aún no se define"
msgstr "Este reporte aún no se define"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Este rol normalmente reporta a alguien: sin jefe no aparecerá en ningún «Mi Equipo»."
msgstr "Este rol normalmente reporta a alguien: sin jefe no aparecerá en ningún «Mi Equipo»."

#: src/features/contracts/components/clauses/ClausesEditWarningDialog.tsx
msgid "Este texto parte del <0>machote compartido</0> con todos los hoteles. Lo que cambies aquí queda solo para este documento, pero es un <1>documento legal</1>: edítalo con cuidado, porque es lo que el hotel firma."
msgstr "Este texto parte del <0>machote compartido</0> con todos los hoteles. Lo que cambies aquí queda solo para este documento, pero es un <1>documento legal</1>: edítalo con cuidado, porque es lo que el hotel firma."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Este usuario ya no existe."
msgstr "Este usuario ya no existe."

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Este veto es <0>manual</0>; los vetos por ausencias o disputa los genera el sistema. Al vetar, la persona pasa a <1>Negro</1> y sale del Pool de Colaboradores."
msgstr "Este veto es <0>manual</0>; los vetos por ausencias o disputa los genera el sistema. Al vetar, la persona pasa a <1>Negro</1> y sale del Pool de Colaboradores."

#. placeholder {0}: deleteTarget?.email ?? ''
#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Esto borra de verdad el buzón de {0} en cPanel — no se puede deshacer."
msgstr "Esto borra de verdad el buzón de {0} en cPanel — no se puede deshacer."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Esto es del Administrador"
msgstr "Esto es del Administrador"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Esto es lo que ves desde el Hotel"
msgstr "Esto es lo que ves desde el Hotel"

#: src/features/worker/pages/HomePage.tsx
msgid "Esto no cambia tu turno de hoy: es solo para que te consideren para más."
msgstr "Esto no cambia tu turno de hoy: es solo para que te consideren para más."

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "Esto no se deshace desde aquí. Si sigue trabajando en algún hotel, su asignación se libera al eliminarlo. El expediente y su historial se conservan por dentro, pero nadie vuelve a verlo en el Pool."
msgstr "Esto no se deshace desde aquí. Si sigue trabajando en algún hotel, su asignación se libera al eliminarlo. El expediente y su historial se conservan por dentro, pero nadie vuelve a verlo en el Pool."

#: src/features/messaging/components/ReportCharts.tsx
msgid "Etapa"
msgstr "Etapa"

#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Etiqueta"
msgstr "Etiqueta"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Etiqueta para todos los del archivo (opcional)"
msgstr "Etiqueta para todos los del archivo (opcional)"

#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/pages/MessagingPage.tsx
msgid "Etiquetas"
msgstr "Etiquetas"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Etiquetas aplicadas:"
msgstr "Etiquetas aplicadas:"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Etiquetas en el archivo:"
msgstr "Etiquetas en el archivo:"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Evidencia"
msgstr "Evidencia"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Evidencia <0>(obligatoria en un veto manual)</0>"
msgstr "Evidencia <0>(obligatoria en un veto manual)</0>"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "evidencia-turnos.pdf"
msgstr "evidencia-turnos.pdf"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Expandir cláusulas del documento"
msgstr "Expandir cláusulas del documento"

#: src/features/contracts/components/MissingContractsNotice.tsx
msgid "Expandir hoteles listos para su contrato"
msgstr "Expandir hoteles listos para su contrato"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Expandir texto de la propuesta"
msgstr "Expandir texto de la propuesta"

#: src/features/observability/lib/workerKpis.ts
msgid "Expedientes completos"
msgstr "Expedientes completos"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Experiencia"
msgstr "Experiencia"

#: src/shared/constants/contractStatus.ts
msgid "Expirado"
msgstr "Expirado"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "extra"
msgstr "extra"

#. placeholder {0}: String(index + 1)
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Factura {0}"
msgstr "Factura {0}"

#: src/features/accounting/pages/InvoicesPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Factura al Hotel"
msgstr "Factura al Hotel"

#. placeholder {0}: formatMoney(Number(payPreview.billSubtotal))
#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Factura al hotel {0}"
msgstr "Factura al hotel {0}"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Factura aprobada"
msgstr "Factura aprobada"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Factura por hora"
msgstr "Factura por hora"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Factura recalculada con las tarifas y horas de hoy"
msgstr "Factura recalculada con las tarifas y horas de hoy"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Falló"
msgstr "Falló"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Falta"
msgstr "Falta"

#. placeholder {0}: formatList(faltantes)
#: src/features/worker/pages/HomePage.tsx
msgid "Falta {0}. Con eso Reclutamiento puede validarte y empiezas a recibir turnos. Tu foto no hace falta para esto."
msgstr "Falta {0}. Con eso Reclutamiento puede validarte y empiezas a recibir turnos. Tu foto no hace falta para esto."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Falta aprobar antes de cerrar:"
msgstr "Falta aprobar antes de cerrar:"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Falta decir quién pagó el gasto."
msgstr "Falta decir quién pagó el gasto."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Falta el bill rate de un puesto"
msgstr "Falta el bill rate de un puesto"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta el departamento"
msgstr "Falta el departamento"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta el departamento del hotel"
msgstr "Falta el departamento del hotel"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Falta el día de inicio de semana"
msgstr "Falta el día de inicio de semana"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Falta el domicilio"
msgstr "Falta el domicilio"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta el hotel"
msgstr "Falta el hotel"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Falta el nombre"
msgstr "Falta el nombre"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Falta el nombre completo"
msgstr "Falta el nombre completo"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Falta el nombre del contacto de emergencia"
msgstr "Falta el nombre del contacto de emergencia"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Falta el nombre del hotel"
msgstr "Falta el nombre del hotel"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Falta el pay rate de un puesto"
msgstr "Falta el pay rate de un puesto"

#: src/features/conversion/api/conversionApi.ts
msgid "Falta el Usuario del Hotel: sin él no se puede aprobar"
msgstr "Falta el Usuario del Hotel: sin él no se puede aprobar"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Falta grave en el hotel"
msgstr "Falta grave en el hotel"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta la fecha de inicio"
msgstr "Falta la fecha de inicio"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Falta la fecha de nacimiento"
msgstr "Falta la fecha de nacimiento"

#: src/features/onboarding/types/registerContactAttempt.schema.ts
msgid "Falta la fecha y hora del intento"
msgstr "Falta la fecha y hora del intento"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta la hora"
msgstr "Falta la hora"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta la modalidad"
msgstr "Falta la modalidad"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Falta la posición"
msgstr "Falta la posición"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Falta la zona"
msgstr "Falta la zona"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Falta si paga horas extra (Sí o No)"
msgstr "Falta si paga horas extra (Sí o No)"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Falta su firma"
msgstr "Falta su firma"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Faltan datos de este hotel"
msgstr "Faltan datos de este hotel"

#: src/features/worker/pages/HomePage.tsx
msgid "Faltan datos tuyos"
msgstr "Faltan datos tuyos"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen las campañas."
msgstr "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen las campañas."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen las etiquetas."
msgstr "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen las etiquetas."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen las plantillas."
msgstr "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen las plantillas."

#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen los contactos, las plantillas y las campañas."
msgstr "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen los contactos, las plantillas y las campañas."

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen los contactos."
msgstr "Faltan las variables MESSAGING_API_* en el API. Cuando se configuren, aquí aparecen los contactos."

#: src/features/worker/components/NativePunchGate.tsx
msgid "Faltan permisos para ponchar"
msgstr "Faltan permisos para ponchar"

#: src/features/observability/lib/cohorts.ts
msgid "Faltó sin justificación"
msgstr "Faltó sin justificación"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Fase 1 · Entrevista"
msgstr "Fase 1 · Entrevista"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/timesheet/components/AttendanceView.tsx
msgid "Fecha"
msgstr "Fecha"

#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/admin/pages/UsersPage.tsx
msgid "Fecha de alta"
msgstr "Fecha de alta"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/shared/lib/contractClauses.ts
msgid "Fecha de fin"
msgstr "Fecha de fin"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/shared/lib/contractClauses.ts
msgid "Fecha de inicio"
msgstr "Fecha de inicio"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Fecha de la firma de Oranje"
msgstr "Fecha de la firma de Oranje"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Fecha de nacimiento"
msgstr "Fecha de nacimiento"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Fecha de preparación"
msgstr "Fecha de preparación"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Fecha y hora"
msgstr "Fecha y hora"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/shared/constants/workerEnums.ts
msgid "Femenino"
msgstr "Femenino"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/recruitment/types/selfPick.types.ts
#: src/shared/constants/workerStatus.ts
msgid "Fijo"
msgstr "Fijo"

#. placeholder {0}: String(row.rowNumber)
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "fila {0}"
msgstr "fila {0}"

#. placeholder {0}: item.rowNumber
#. placeholder {0}: row.rowNumber
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Fila {0}"
msgstr "Fila {0}"

#. placeholder {0}: row.rowNumber
#. placeholder {1}: row.errors.join(', ')
#. placeholder {1}: row.warnings.join(', ')
#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Fila {0}: {1}"
msgstr "Fila {0}: {1}"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Filas"
msgstr "Filas"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Fill rate"
msgstr "Fill rate"

#: src/features/messaging/components/tours.ts
msgid "Filtra por etiqueta"
msgstr "Filtra por etiqueta"

#: src/features/contracts/pages/ContractListPage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Filtrar"
msgstr "Filtrar"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Fin (obligatoria)"
msgstr "Fin (obligatoria)"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Fin (opcional)"
msgstr "Fin (opcional)"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Finalizar inspección"
msgstr "Finalizar inspección"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Firebase (respaldo)"
msgstr "Firebase (respaldo)"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Firebase no pudo mandar el correo. Inténtalo de nuevo."
msgstr "Firebase no pudo mandar el correo. Inténtalo de nuevo."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Firma de Oranje en el documento"
msgstr "Firma de Oranje en el documento"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firma electrónica"
msgstr "Firma electrónica"

#. placeholder {0}: signature.signer.name
#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Firma por Oranje {0}, el BDC que lleva el hotel"
msgstr "Firma por Oranje {0}, el BDC que lleva el hotel"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firmado por las dos partes, pero no se activó solo: el hotel ya tiene el contrato {activeContractNumber} vigente. Cancélalo o espera a que venza, y luego activa este."
msgstr "Firmado por las dos partes, pero no se activó solo: el hotel ya tiene el contrato {activeContractNumber} vigente. Cancélalo o espera a que venza, y luego activa este."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firmado por las dos partes, pero no se pudo activar solo: revisa «Activar contrato»."
msgstr "Firmado por las dos partes, pero no se pudo activar solo: revisa «Activar contrato»."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firmado por las dos partes. El contrato quedó activo."
msgstr "Firmado por las dos partes. El contrato quedó activo."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firmar ahora"
msgstr "Firmar ahora"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Firmar con DocuSign"
msgstr "Firmar con DocuSign"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Firmar en DocuSign"
msgstr "Firmar en DocuSign"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Firmar y enviar el contrato"
msgstr "Firmar y enviar el contrato"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Firmas en DocuSign y al hotel le llega por correo para firmar"
msgstr "Firmas en DocuSign y al hotel le llega por correo para firmar"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Firmas por Oranje en DocuSign. Al terminar, DocuSign le manda el contrato a quien firma por el hotel. Cuando firmen los dos, el contrato se activa solo."
msgstr "Firmas por Oranje en DocuSign. Al terminar, DocuSign le manda el contrato a quien firma por el hotel. Cuando firmen los dos, el contrato se activa solo."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Firmaste por Oranje. DocuSign ya le mandó el contrato a {email}."
msgstr "Firmaste por Oranje. DocuSign ya le mandó el contrato a {email}."

#. placeholder {0}: formatDateTime(signature.hotelSignedAt)
#. placeholder {0}: formatDateTime(signature.oranjeSignedAt)
#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Firmó el {0}"
msgstr "Firmó el {0}"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Folio"
msgstr "Folio"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Folio o hotel, p. ej. Xcaret…"
msgstr "Folio o hotel, p. ej. Xcaret…"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "Folio, p. ej. 202608…"
msgstr "Folio, p. ej. 202608…"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/worker/components/PhotoUploader.tsx
msgid "Foto"
msgstr "Foto"

#. placeholder {0}: prospect.hotelName
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Foto de {0} según Google"
msgstr "Foto de {0} según Google"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Foto de {hotelDisplayName} según Google"
msgstr "Foto de {hotelDisplayName} según Google"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Foto de la cuenta"
msgstr "Foto de la cuenta"

#: src/features/admin/components/AccountDeletionsSection.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Foto del colaborador"
msgstr "Foto del colaborador"

#: src/features/worker/components/PhotoUploader.tsx
msgid "Foto guardada"
msgstr "Foto guardada"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Foto subida"
msgstr "Foto subida"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Fuera de la geocerca"
msgstr "Fuera de la geocerca"

#: src/features/observability/components/KpiCard.tsx
msgid "Fuera de meta"
msgstr "Fuera de meta"

#: src/features/worker/pages/PunchPage.tsx
msgid "Fuera del hotel"
msgstr "Fuera del hotel"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Función que se le da"
msgstr "Función que se le da"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Funciones adicionales"
msgstr "Funciones adicionales"

#. placeholder {0}: item.fullName
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Funciones adicionales de {0}"
msgstr "Funciones adicionales de {0}"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Funciones que se dan por persona y no por rol. Solo quien esté en la lista las ve, y las puedes prender, apagar o quitar cuando quieras."
msgstr "Funciones que se dan por persona y no por rol. Solo quien esté en la lista las ve, y las puedes prender, apagar o quitar cuando quieras."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Gana la primera que confirma: si alguien se adelanta, el tablero se actualiza al momento."
msgstr "Gana la primera que confirma: si alguien se adelanta, el tablero se actualiza al momento."

#. placeholder {0}: formatMoney(Number(expenseRequested))
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Gasto de {0} pedido: pendiente de aprobación."
msgstr "Gasto de {0} pedido: pendiente de aprobación."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Gasto de la empresa: no se le descuenta ni se le suma nada al colaborador."
msgstr "Gasto de la empresa: no se le descuenta ni se le suma nada al colaborador."

#: src/shared/components/SettlementEffectBadge.tsx
msgid "Gasto de Oranje"
msgstr "Gasto de Oranje"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Gasto pedido: queda pendiente de que lo apruebe el Manager de QA"
msgstr "Gasto pedido: queda pendiente de que lo apruebe el Manager de QA"

#. placeholder {0}: adjustment.payConcept.name
#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "Gasto: {0}"
msgstr "Gasto: {0}"

#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Gastos/descuentos que Contabilidad ya decidió incluir en esta nómina — de toda la semana, no de un día en particular (el ajuste no tiene fecha propia). Ya están restados del Total de abajo."
msgstr "Gastos/descuentos que Contabilidad ya decidió incluir en esta nómina — de toda la semana, no de un día en particular (el ajuste no tiene fecha propia). Ya están restados del Total de abajo."

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Generando el código…"
msgstr "Generando el código…"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Generando…"
msgstr "Generando…"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Generar Consolidado es tu botón"
msgstr "Generar Consolidado es tu botón"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Generar una contraseña segura"
msgstr "Generar una contraseña segura"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Género"
msgstr "Género"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "geocerca"
msgstr "geocerca"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Geocerca"
msgstr "Geocerca"

#. placeholder {0}: client.geofenceRadiusM
#: src/features/clients/components/ClientCardGrid.tsx
msgid "geocerca {0} m"
msgstr "geocerca {0} m"

#. placeholder {0}: String(GEOFENCE_MIN_M)
#. placeholder {1}: String(GEOFENCE_MAX_M)
#. placeholder {2}: String(DEFAULT_GEOFENCE_M)
#: src/features/onboarding/import/mapImportRows.ts
msgid "Geocerca fuera de rango ({0}–{1} m): se usa {2} m"
msgstr "Geocerca fuera de rango ({0}–{1} m): se usa {2} m"

#: src/shared/components/SendDocumentModal.tsx
msgid "gerencia@hotel.com"
msgstr "gerencia@hotel.com"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Gestionar buzón"
msgstr "Gestionar buzón"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Google mandó un identificador del lugar que el servidor no aceptó. Vuelve a buscar el hotel en el paso 1 o marca la ubicación a mano en el mapa."
msgstr "Google mandó un identificador del lugar que el servidor no aceptó. Vuelve a buscar el hotel en el paso 1 o marca la ubicación a mano en el mapa."

#: src/shared/constants/onboardingStatus.ts
msgid "Gris"
msgstr "Gris"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Gris → Naranja"
msgstr "Gris → Naranja"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Grupo de {name}"
msgstr "Grupo de {name}"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Guardamos tu avance como borrador. Lo retomas en «Nuevo prospecto»."
msgstr "Guardamos tu avance como borrador. Lo retomas en «Nuevo prospecto»."

#: src/features/timesheet/components/HotelPaysLunchToggle.tsx
msgid "Guardando"
msgstr "Guardando"

#: src/features/worker/pages/PunchPage.tsx
msgid "Guardando tu ubicación"
msgstr "Guardando tu ubicación"

#: src/features/worker/pages/PunchPage.tsx
msgid "Guardando tu ubicación y tu foto"
msgstr "Guardando tu ubicación y tu foto"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/components/PayOverrideDialog.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/audits/components/AuditFormDialog.tsx
#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/components/RegisterAttemptDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/team/components/AssignTerritoryDialog.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/features/worker/pages/Phase3Page.tsx
msgid "Guardando…"
msgstr "Guardando…"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/messaging/components/ContactActions.tsx
#: src/features/worker/pages/Phase3Page.tsx
msgid "Guardar"
msgstr "Guardar"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Guardar borrador"
msgstr "Guardar borrador"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Guardar cambios"
msgstr "Guardar cambios"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Guardar contraseña"
msgstr "Guardar contraseña"

#: src/features/accounting/components/PayOverrideDialog.tsx
#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Guardar corrección"
msgstr "Guardar corrección"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Guardar límites"
msgstr "Guardar límites"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Guardar requisición"
msgstr "Guardar requisición"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Guardar tarifa"
msgstr "Guardar tarifa"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Guardar territorio"
msgstr "Guardar territorio"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Habilitados para requisiciones"
msgstr "Habilitados para requisiciones"

#. placeholder {0}: String(cycle.daysSinceAttempt)
#: src/features/team/pages/TeamPage.tsx
msgid "hace {0} d"
msgstr "hace {0} d"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "hace {days} días"
msgstr "hace {days} días"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Hasta"
msgstr "Hasta"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Hasta 60 caracteres"
msgstr "Hasta 60 caracteres"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Hasta 60 caracteres, sin variables."
msgstr "Hasta 60 caracteres, sin variables."

#. placeholder {0}: formatDate(value.to)
#: src/shared/components/DateRangeField.tsx
msgid "Hasta el {0}"
msgstr "Hasta el {0}"

#. placeholder {0}: matches.data.length
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Hay {total} coincidencias y aquí salen {0}: afina la búsqueda para ver a los demás."
msgstr "Hay {total} coincidencias y aquí salen {0}: afina la búsqueda para ver a los demás."

#. placeholder {0}: results.length
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Hay {total} coincidencias y aquí salen {0}: busca para encontrar a los demás."
msgstr "Hay {total} coincidencias y aquí salen {0}: busca para encontrar a los demás."

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Hay cuentas que tienen a esta persona como jefe. Cámbiales el jefe y vuelve a intentarlo."
msgstr "Hay cuentas que tienen a esta persona como jefe. Cámbiales el jefe y vuelve a intentarlo."

#: src/features/onboarding/import/mapImportRows.ts
msgid "Hay datos de contacto pero falta su nombre: no se crea el contacto"
msgstr "Hay datos de contacto pero falta su nombre: no se crea el contacto"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Hay dos renglones para el mismo puesto: deja uno solo."
msgstr "Hay dos renglones para el mismo puesto: deja uno solo."

#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "Hay entrada sin salida (o al revés), en un día que ya pasó. Así la semana no puede irse a aprobación."
msgstr "Hay entrada sin salida (o al revés), en un día que ya pasó. Así la semana no puede irse a aprobación."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Hay inspecciones con respuestas a este reactivo: no se puede eliminar."
msgstr "Hay inspecciones con respuestas a este reactivo: no se puede eliminar."

#: src/features/observability/components/TabParts.tsx
msgid "Hay más registros de los que esta pantalla puede traer: algunos números se calcularon sobre una parte."
msgstr "Hay más registros de los que esta pantalla puede traer: algunos números se calcularon sobre una parte."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Hay un puesto donde el bill rate queda por debajo del pay rate: se pierde en cada hora."
msgstr "Hay un puesto donde el bill rate queda por debajo del pay rate: se pierde en cada hora."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Hay una tarifa cotizada por debajo del costo: lo que se factura no puede ser menor a lo que se paga."
msgstr "Hay una tarifa cotizada por debajo del costo: lo que se factura no puede ser menor a lo que se paga."

#: src/app/RouteErrorPage.tsx
msgid "Hay una versión nueva de Oranje. Actualizando…"
msgstr "Hay una versión nueva de Oranje. Actualizando…"

#: src/shared/constants/workerEnums.ts
msgid "Hermano/a"
msgstr "Hermano/a"

#: src/shared/constants/workerEnums.ts
msgid "Hijo/a"
msgstr "Hijo/a"

#: src/features/requisitions/components/StatusHistoryCard.tsx
msgid "Historia de estado"
msgstr "Historia de estado"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Historial"
msgstr "Historial"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "historial completo"
msgstr "historial completo"

#: src/features/messaging/components/ContactImportsDialog.tsx
msgid "Historial de importaciones"
msgstr "Historial de importaciones"

#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Historial de versiones"
msgstr "Historial de versiones"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Historial del semáforo"
msgstr "Historial del semáforo"

#: src/features/dashboard/api/dashboardApi.ts
msgid "histórico"
msgstr "histórico"

#: src/features/observability/components/KpiCard.tsx
msgid "Histórico"
msgstr "Histórico"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Hojas esta semana"
msgstr "Hojas esta semana"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Hojas pendientes"
msgstr "Hojas pendientes"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Hojas sin aprobar"
msgstr "Hojas sin aprobar"

#: src/features/worker/pages/HomePage.tsx
msgid "Hola, {firstName}"
msgstr "Hola, {firstName}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Hora"
msgstr "Hora"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Hora {ordinal}"
msgstr "Hora {ordinal}"

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Hora de entrada"
msgstr "Hora de entrada"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Hora de la marca"
msgstr "Hora de la marca"

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Hora de salida"
msgstr "Hora de salida"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Hora real"
msgstr "Hora real"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Hora real de la marca"
msgstr "Hora real de la marca"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/timesheet/components/TimesheetViewControls.tsx
#: src/features/worker/pages/PunchPage.tsx
msgid "Horas"
msgstr "Horas"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Horas de semanas ya cerradas que el Manager de Área no ha aprobado. Lo que no se aprueba no entra al Consolidado ni se paga."
msgstr "Horas de semanas ya cerradas que el Manager de Área no ha aprobado. Lo que no se aprueba no entra al Consolidado ni se paga."

#: src/features/accounting/components/PayOverrideDialog.tsx
#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Horas extra"
msgstr "Horas extra"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Horas extra esta semana"
msgstr "Horas extra esta semana"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Horas netas"
msgstr "Horas netas"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Horas por semana"
msgstr "Horas por semana"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Horas regulares"
msgstr "Horas regulares"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/contracts/components/ContractSignatureCard.tsx
#: src/features/contracts/components/ContractTable.tsx
#: src/features/messaging/components/MessagingFilters.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/features/observability/components/CohortsView.tsx
#: src/features/observability/pages/ObservabilityPage.tsx
#: src/features/onboarding/components/JobTitleSelect.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Hotel"
msgstr "Hotel"

#: src/features/observability/lib/cohorts.ts
msgid "Hotel (gerente o supervisor)"
msgstr "Hotel (gerente o supervisor)"

#: src/features/observability/components/CohortSection.tsx
msgid "Hotel al ingresar"
msgstr "Hotel al ingresar"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Hotel cliente"
msgstr "Hotel cliente"

#: src/features/observability/lib/people.ts
msgid "Hotel convertido en cliente"
msgstr "Hotel convertido en cliente"

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Hotel eliminado: {hotelName}"
msgstr "Hotel eliminado: {hotelName}"

#: src/shared/constants/onboardingStatus.ts
msgid "Hotel identificado"
msgstr "Hotel identificado"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Hotel nuevo"
msgstr "Hotel nuevo"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Hotel o número de contrato, p. ej. Puerto Real…"
msgstr "Hotel o número de contrato, p. ej. Puerto Real…"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Hotel Puerto Real"
msgstr "Hotel Puerto Real"

#: src/features/onboarding/components/PlacesSearchField.tsx
msgid "Hotel Puerto Real, Cancún"
msgstr "Hotel Puerto Real, Cancún"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Hotel registrado"
msgstr "Hotel registrado"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Hotel sin nombre"
msgstr "Hotel sin nombre"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Hotel ya registrado"
msgstr "Hotel ya registrado"

#: src/layouts/GlobalSearch.tsx
msgid "Hotel, folio de requisición o colaborador, p. ej. Xcaret…"
msgstr "Hotel, folio de requisición o colaborador, p. ej. Xcaret…"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Hoteles"
msgstr "Hoteles"

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "Hoteles activados como clientes, listos para generar requisiciones"
msgstr "Hoteles activados como clientes, listos para generar requisiciones"

#: src/features/observability/lib/salesKpis.ts
msgid "Hoteles cliente sin ninguna requisición creada en los últimos {NO_REQUISITION_DAYS} días."
msgstr "Hoteles cliente sin ninguna requisición creada en los últimos {NO_REQUISITION_DAYS} días."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Hoteles del archivo"
msgstr "Hoteles del archivo"

#: src/features/contracts/components/MissingContractsNotice.tsx
msgid "Hoteles listos para su contrato"
msgstr "Hoteles listos para su contrato"

#: src/features/observability/lib/salesKpis.ts
msgid "Hoteles que pasaron a cliente sobre los ciclos que terminaron en el periodo."
msgstr "Hoteles que pasaron a cliente sobre los ciclos que terminaron en el periodo."

#: src/layouts/GlobalSearch.tsx
msgid "Hoteles y prospectos"
msgstr "Hoteles y prospectos"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "hoy"
msgstr "hoy"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Hoy descansas"
msgstr "Hoy descansas"

#: src/features/worker/pages/PunchPage.tsx
msgid "Hoy descansas. No tienes turno programado hoy."
msgstr "Hoy descansas. No tienes turno programado hoy."

#: src/features/observability/components/TabParts.tsx
msgid "Hoy en el sistema"
msgstr "Hoy en el sistema"

#: src/features/worker/pages/PunchPage.tsx
msgid "Hoy no ponchas."
msgstr "Hoy no ponchas."

#: src/features/worker/lib/noShiftMessage.ts
msgid "Hoy no tienes turno"
msgstr "Hoy no tienes turno"

#: src/features/worker/pages/PunchPage.tsx
msgid "Hoy no tienes turno: no hay nada que ponchar."
msgstr "Hoy no tienes turno: no hay nada que ponchar."

#: src/features/worker/pages/HomePage.tsx
msgid "Hoy no tienes turno. Cuando te asignen, aquí aparece el hotel y el horario."
msgstr "Hoy no tienes turno. Cuando te asignen, aquí aparece el hotel y el horario."

#. placeholder {0}: member.reportsTo.fullName
#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Hoy reporta a {0}."
msgstr "Hoy reporta a {0}."

#: src/features/worker/pages/PunchPage.tsx
msgid "Hoy tienes más de un turno: pídele al Supervisor que registre la marca."
msgstr "Hoy tienes más de un turno: pídele al Supervisor que registre la marca."

#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "Hoy, con entrada marcada y la jornada todavía sin terminar. No es un problema: solo falta que salga."
msgstr "Hoy, con entrada marcada y la jornada todavía sin terminar. No es un problema: solo falta que salga."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Identidad"
msgstr "Identidad"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Identificación oficial"
msgstr "Identificación oficial"

#: src/features/territory/components/TerritoryMapLegend.tsx
msgid "Identificado"
msgstr "Identificado"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Idioma"
msgstr "Idioma"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Imagen de referencia"
msgstr "Imagen de referencia"

#. placeholder {0}: prospect.hotelName
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Imagen de referencia: {0} todavía no tiene foto"
msgstr "Imagen de referencia: {0} todavía no tiene foto"

#: src/features/messaging/components/tours.ts
msgid "Importa un Excel"
msgstr "Importa un Excel"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Importación completada"
msgstr "Importación completada"

#: src/features/messaging/components/ContactImportsDialog.tsx
msgid "Importaciones"
msgstr "Importaciones"

#: src/features/messaging/components/ImportContactsDialog.tsx
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Importando…"
msgstr "Importando…"

#. placeholder {0}: row.hotelName || t`fila ${String(row.rowNumber)}`
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Importar {0}"
msgstr "Importar {0}"

#. placeholder {0}: preview.validCount
#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Importar {0} contactos"
msgstr "Importar {0} contactos"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Importar contactos"
msgstr "Importar contactos"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Importar hoteles"
msgstr "Importar hoteles"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Importar hoteles al Pipeline"
msgstr "Importar hoteles al Pipeline"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Importar hoteles no está en tu rol."
msgstr "Importar hoteles no está en tu rol."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Importar otro archivo"
msgstr "Importar otro archivo"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/onboarding/components/ContractPreviewDialog.tsx
msgid "Imprimir o guardar como PDF"
msgstr "Imprimir o guardar como PDF"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
#: src/features/admin/components/userListParts.tsx
msgid "Inactivo"
msgstr "Inactivo"

#: src/features/admin/components/userListParts.tsx
msgid "Inactivos"
msgstr "Inactivos"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Inasistencias"
msgstr "Inasistencias"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Incidencia (Rojo); Inspección la revisa"
msgstr "Incidencia (Rojo); Inspección la revisa"

#: src/layouts/Sidebar.tsx
msgid "Incidencias"
msgstr "Incidencias"

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "Incluido en la nómina"
msgstr "Incluido en la nómina"

#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "Incluir"
msgstr "Incluir"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Incluir en la nómina"
msgstr "Incluir en la nómina"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Incluyendo…"
msgstr "Incluyendo…"

#: src/features/recruitment/components/PoolTable.tsx
msgid "incompleto"
msgstr "incompleto"

#: src/features/contracts/utils/validity.ts
msgid "indefinido"
msgstr "indefinido"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Indefinido"
msgstr "Indefinido"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Indica cuándo ocurrió el intento"
msgstr "Indica cuándo ocurrió el intento"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "industria"
msgstr "industria"

#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Industria"
msgstr "Industria"

#. placeholder {0}: String(index + 1)
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Industria {0}"
msgstr "Industria {0}"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Industria de la posición"
msgstr "Industria de la posición"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Industria…"
msgstr "Industria…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Industrias"
msgstr "Industrias"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Información general"
msgstr "Información general"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Inglés"
msgstr "Inglés"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Inglés {ordinal}"
msgstr "Inglés {ordinal}"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Inglés y experiencia"
msgstr "Inglés y experiencia"

#: src/features/observability/components/CohortSection.tsx
msgid "Ingresaron"
msgstr "Ingresaron"

#: src/features/observability/components/CohortsView.tsx
msgid "Ingreso"
msgstr "Ingreso"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Ingreso al Pool"
msgstr "Ingreso al Pool"

#: src/features/observability/components/TabParts.tsx
msgid "Ingresos"
msgstr "Ingresos"

#: src/features/observability/components/CohortsView.tsx
msgid "Ingresos de las 12 semanas sombreadas"
msgstr "Ingresos de las 12 semanas sombreadas"

#: src/features/auth/pages/LoginPage.tsx
msgid "Inicia sesión"
msgstr "Inicia sesión"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Iniciando sesión…"
msgstr "Iniciando sesión…"

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Iniciar sesión"
msgstr "Iniciar sesión"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/components/MobileShell.tsx
msgid "Inicio"
msgstr "Inicio"

#. placeholder {0}: formatDayMonth(position.startDate)
#: src/features/requisitions/components/SlotList.tsx
msgid "Inicio {0}"
msgstr "Inicio {0}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Inicio {ordinal}"
msgstr "Inicio {ordinal}"

#: src/features/observability/components/CohortsView.tsx
msgid "Inicio del historial"
msgstr "Inicio del historial"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Inicio y fin definidos: la nómina toma lo que regía cada día."
msgstr "Inicio y fin definidos: la nómina toma lo que regía cada día."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/observability/lib/cohorts.ts
#: src/features/observability/pages/ObservabilityPage.tsx
msgid "Inspección"
msgstr "Inspección"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Inspección corregida"
msgstr "Inspección corregida"

#: src/features/audits/components/AuditHotelCard.tsx
#: src/features/audits/components/AuditWorkerList.tsx
msgid "Inspección de personal"
msgstr "Inspección de personal"

#: src/features/audits/components/PersonalPresentationAuditDialog.tsx
msgid "Inspección de Presentación Personal"
msgstr "Inspección de Presentación Personal"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Inspección guardada"
msgstr "Inspección guardada"

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Inspeccionado ayer"
msgstr "Inspeccionado ayer"

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Inspeccionado hace {days} días"
msgstr "Inspeccionado hace {days} días"

#: src/features/audits/components/AuditWorkerList.tsx
msgid "Inspeccionado hoy"
msgstr "Inspeccionado hoy"

#. placeholder {0}: worker.fullName
#: src/features/audits/components/AuditFormDialog.tsx
msgid "Inspeccionando a <0>{0}</0>"
msgstr "Inspeccionando a <0>{0}</0>"

#: src/features/audits/components/AuditHotelCard.tsx
msgid "Inspeccionar"
msgstr "Inspeccionar"

#: src/features/audits/components/AuditHotelCard.tsx
msgid "Inspeccionar por ambiente"
msgstr "Inspeccionar por ambiente"

#: src/features/audits/pages/AuditsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Inspecciones"
msgstr "Inspecciones"

#: src/features/requisitions/components/RequisitionTable.tsx
#: src/shared/constants/roles.ts
msgid "Inspector"
msgstr "Inspector"

#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "Inspector de zona"
msgstr "Inspector de zona"

#: src/features/audits/components/EnvironmentAuditDialog.tsx
msgid "Insumos, relaciones, carga laboral y entorno de {hotelName}."
msgstr "Insumos, relaciones, carga laboral y entorno de {hotelName}."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Intento corregido"
msgstr "Intento corregido"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Intento registrado"
msgstr "Intento registrado"

#: src/features/observability/lib/people.ts
msgid "Intentos"
msgstr "Intentos"

#: src/features/observability/lib/salesKpis.ts
msgid "Intentos de contacto con resultado «cita agendada». No existe una entidad de cita: es una aproximación."
msgstr "Intentos de contacto con resultado «cita agendada». No existe una entidad de cita: es una aproximación."

#: src/features/reports/pages/ReportsPage.tsx
msgid "Intentos por canal × resultado"
msgstr "Intentos por canal × resultado"

#: src/shared/constants/contactAttempt.ts
msgid "Interesado"
msgstr "Interesado"

#: src/shared/constants/catalogs.ts
msgid "Intermedio"
msgstr "Intermedio"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "interna"
msgstr "interna"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Inválidas"
msgstr "Inválidas"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Invitación"
msgstr "Invitación"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/components/userListParts.tsx
msgid "Invitación enviada"
msgstr "Invitación enviada"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Invitación enviada a:"
msgstr "Invitación enviada a:"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Invitación reenviada: la persona tiene un correo nuevo para establecer su contraseña."
msgstr "Invitación reenviada: la persona tiene un correo nuevo para establecer su contraseña."

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Invítalos desde tu Dashboard, en «¿Entró un Supervisor o un gerente nuevo?»."
msgstr "Invítalos desde tu Dashboard, en «¿Entró un Supervisor o un gerente nuevo?»."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ir a Catálogos"
msgstr "Ir a Catálogos"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Ir a Inicio"
msgstr "Ir a Inicio"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Ir a Inspecciones"
msgstr "Ir a Inspecciones"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Ir a la propuesta"
msgstr "Ir a la propuesta"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Ir a la semana actual"
msgstr "Ir a la semana actual"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "Ir a la semana de este día"
msgstr "Ir a la semana de este día"

#: src/features/worker/pages/PunchPage.tsx
msgid "Ir a Permisos"
msgstr "Ir a Permisos"

#: src/features/worker/pages/PunchPage.tsx
msgid "Ir a ponchar"
msgstr "Ir a ponchar"

#: src/features/onboarding/components/ContractUnlockedDialog.tsx
msgid "Ir al contrato"
msgstr "Ir al contrato"

#: src/features/recruitment/components/PoolTable.tsx
msgid "ITIN"
msgstr "ITIN"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "J"
msgstr "J"

#: src/features/worker/pages/PunchPage.tsx
msgid "Jornada completa"
msgstr "Jornada completa"

#: src/features/observability/lib/workerKpis.ts
#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "Jornadas completas"
msgstr "Jornadas completas"

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas completas de menos de {SHORT_SHIFT_HOURS} horas entre entrada y salida."
msgstr "Jornadas completas de menos de {SHORT_SHIFT_HOURS} horas entre entrada y salida."

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas con dos marcas seguidas en menos de un minuto."
msgstr "Jornadas con dos marcas seguidas en menos de un minuto."

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas con entrada, salida y regreso de cada comida, sin contar las de hoy."
msgstr "Jornadas con entrada, salida y regreso de cada comida, sin contar las de hoy."

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas cuya comida duró más de {LONG_LUNCH_MIN} minutos."
msgstr "Jornadas cuya comida duró más de {LONG_LUNCH_MIN} minutos."

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas cuya comida duró menos de {SHORT_LUNCH_MIN} minutos."
msgstr "Jornadas cuya comida duró menos de {SHORT_LUNCH_MIN} minutos."

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas de menos de {SHORT_SHIFT_HOURS} h"
msgstr "Jornadas de menos de {SHORT_SHIFT_HOURS} h"

#: src/features/observability/lib/workerKpis.ts
msgid "Jornadas en curso"
msgstr "Jornadas en curso"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Jue"
msgstr "Jue"

#: src/features/observability/components/TabParts.tsx
msgid "KPIs"
msgstr "KPIs"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "L"
msgstr "L"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "La app toma la foto en el momento de ponchar. Para cambiarlo, edita el hotel."
msgstr "La app toma la foto en el momento de ponchar. Para cambiarlo, edita el hotel."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "La app toma la foto en el momento. Es el método por defecto."
msgstr "La app toma la foto en el momento. Es el método por defecto."

#. placeholder {0}: credential.mailbox.reason
#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "La app ya tiene la contraseña nueva, pero el buzón de correo no cambió: {0}."
msgstr "La app ya tiene la contraseña nueva, pero el buzón de correo no cambió: {0}."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "La aprobación es del BDC"
msgstr "La aprobación es del BDC"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "La aprobación es del Manager"
msgstr "La aprobación es del Manager"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "La aprueba el Manager de Contabilidad, validando bill rate y horas autorizadas."
msgstr "La aprueba el Manager de Contabilidad, validando bill rate y horas autorizadas."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "La asignación quedó hecha, pero el ajuste/gasto no se pudo pedir. Vuelve a intentarlo."
msgstr "La asignación quedó hecha, pero el ajuste/gasto no se pudo pedir. Vuelve a intentarlo."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "La asignación se canceló: las horas registradas se conservan, pero ya no se capturan marcas"
msgstr "La asignación se canceló: las horas registradas se conservan, pero ya no se capturan marcas"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "La asignación terminó el {endsOn}: las horas se aprueban y pagan, pero ya no se capturan marcas"
msgstr "La asignación terminó el {endsOn}: las horas se aprueban y pagan, pero ya no se capturan marcas"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "La asignación terminó: las horas se aprueban y pagan, pero ya no se capturan marcas"
msgstr "La asignación terminó: las horas se aprueban y pagan, pero ya no se capturan marcas"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "La bitácora del prospecto vive de estos registros: quién buscó al hotel, cuándo y por qué canal."
msgstr "La bitácora del prospecto vive de estos registros: quién buscó al hotel, cuándo y por qué canal."

#. placeholder {0}: worker?.workerName ?? ''
#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "La contraseña con la que {0} entra a la app y a su correo."
msgstr "La contraseña con la que {0} entra a la app y a su correo."

#: src/features/admin/components/UserFormDialog.tsx
msgid "La contraseña necesita al menos 8 caracteres"
msgstr "La contraseña necesita al menos 8 caracteres"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "La contraseña no es correcta."
msgstr "La contraseña no es correcta."

#. placeholder {0}: worker?.workerName ?? ''
#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "La contraseña se muestra una sola vez. Dásela en mano a {0}."
msgstr "La contraseña se muestra una sola vez. Dásela en mano a {0}."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "La conversión a cliente es exclusiva del BDC y exige el Usuario del Hotel creado."
msgstr "La conversión a cliente es exclusiva del BDC y exige el Usuario del Hotel creado."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "la conversión a Naranja la aprueba el BDC desde Conversión."
msgstr "la conversión a Naranja la aprueba el BDC desde Conversión."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "La conversión Rosa → Naranja quedó aprobada: el hotel puede generar requisiciones y el BD queda como su referente comercial."
msgstr "La conversión Rosa → Naranja quedó aprobada: el hotel puede generar requisiciones y el BD queda como su referente comercial."

#. placeholder {0}: primaryContact.fullName
#. placeholder {1}: primaryContact.email
#: src/features/conversion/api/conversionApi.ts
msgid "La cuenta con la que el hotel opera Oranje: pedir requisiciones, administrar su Schedule y aprobar horas. Se crea para el contacto principal — {0} · {1} — y sin ella la conversión se bloquea"
msgstr "La cuenta con la que el hotel opera Oranje: pedir requisiciones, administrar su Schedule y aprobar horas. Se crea para el contacto principal — {0} · {1} — y sin ella la conversión se bloquea"

#. placeholder {0}: pending?.row.fullName ?? ''
#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "La cuenta de {0} vuelve a estar activa. Las asignaciones que ya se liberaron no se restauran."
msgstr "La cuenta de {0} vuelve a estar activa. Las asignaciones que ya se liberaron no se restauran."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "La cuenta de este colaborador está desactivada."
msgstr "La cuenta de este colaborador está desactivada."

#. placeholder {0}: credential.mailbox.reason
#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "La cuenta de Oranje ya existe, pero el buzón de correo no se pudo crear: {0}."
msgstr "La cuenta de Oranje ya existe, pero el buzón de correo no se pudo crear: {0}."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "La cuenta quedó guardada, pero el correo de invitación no salió: reenvíala desde su ficha."
msgstr "La cuenta quedó guardada, pero el correo de invitación no salió: reenvíala desde su ficha."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "La cuenta quedó guardada, pero el correo de invitación no salió. Reenvíala desde su ficha en unos minutos."
msgstr "La cuenta quedó guardada, pero el correo de invitación no salió. Reenvíala desde su ficha en unos minutos."

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "La cuenta se borra: el hotel tendría que proponerla de nuevo."
msgstr "La cuenta se borra: el hotel tendría que proponerla de nuevo."

#. placeholder {0}: extra.grantedBy
#. placeholder {1}: formatDate(extra.grantedAt)
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "La dio {0} el {1}"
msgstr "La dio {0} el {1}"

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "la dirección"
msgstr "la dirección"

#. placeholder {0}: String(PROSPECT_TEXT_MAX.address)
#: src/features/onboarding/import/mapImportRows.ts
msgid "La dirección pasa de {0} caracteres"
msgstr "La dirección pasa de {0} caracteres"

#: src/shared/constants/workerStatus.ts
msgid "La disputa se resolvió a favor del hotel: tiene el acceso bloqueado."
msgstr "La disputa se resolvió a favor del hotel: tiene el acceso bloqueado."

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "la eliges tú — Google no la conoce"
msgstr "la eliges tú — Google no la conoce"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "La eliminación quedó completada"
msgstr "La eliminación quedó completada"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "La entrevista es la Fase 1"
msgstr "La entrevista es la Fase 1"

#. placeholder {0}: tag.name
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "La etiqueta «{0}» se creó."
msgstr "La etiqueta «{0}» se creó."

#. placeholder {0}: tag.name
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "La etiqueta «{0}» se eliminó."
msgstr "La etiqueta «{0}» se eliminó."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "La fecha de fin es anterior al inicio: corrige el rango."
msgstr "La fecha de fin es anterior al inicio: corrige el rango."

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "La fecha de fin tiene que ser posterior al inicio."
msgstr "La fecha de fin tiene que ser posterior al inicio."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "La fecha de fin ya pasó: este contrato debe marcarse expirado."
msgstr "La fecha de fin ya pasó: este contrato debe marcarse expirado."

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "La fecha debe ser un día real (AAAA-MM-DD)"
msgstr "La fecha debe ser un día real (AAAA-MM-DD)"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "La fila no se borra: se marca levantada con tu motivo, y el pasado sigue consultable."
msgstr "La fila no se borra: se marca levantada con tu motivo, y el pasado sigue consultable."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "La firma electrónica todavía no está configurada."
msgstr "La firma electrónica todavía no está configurada."

#: src/features/worker/pages/HomePage.tsx
msgid "La foto confirma que eres tú; no se comparte con el hotel. Al continuar, tu teléfono te va a pedir permiso de cámara."
msgstr "La foto confirma que eres tú; no se comparte con el hotel. Al continuar, tu teléfono te va a pedir permiso de cámara."

#: src/features/admin/components/UserFormDialog.tsx
msgid "La foto pesa demasiado: el máximo es 15 MB."
msgstr "La foto pesa demasiado: el máximo es 15 MB."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "La geocerca rechazó la marca, se acabó la pila o no hubo señal: para eso existe la marca manual."
msgstr "La geocerca rechazó la marca, se acabó la pila o no hubo señal: para eso existe la marca manual."

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "La geocerca se mide en metros enteros"
msgstr "La geocerca se mide en metros enteros"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "La hora debe ser HH:MM (00:00–23:59)"
msgstr "La hora debe ser HH:MM (00:00–23:59)"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "La hora extra se paga 1.5 veces la hora normal."
msgstr "La hora extra se paga 1.5 veces la hora normal."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "La hora que pongas manda"
msgstr "La hora que pongas manda"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "La imagen no cargó o está dañada — ábrela en pestaña nueva para revisarla."
msgstr "La imagen no cargó o está dañada — ábrela en pestaña nueva para revisarla."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "La imagen pasa de 15 MB: toma la foto con menos resolución o comprímela."
msgstr "La imagen pasa de 15 MB: toma la foto con menos resolución o comprímela."

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "La lista reemplaza, no suma"
msgstr "La lista reemplaza, no suma"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "La marca carga tu motivo y se distingue de las normales en la revisión del día — nada se disfraza."
msgstr "La marca carga tu motivo y se distingue de las normales en la revisión del día — nada se disfraza."

#: src/features/worker/pages/PunchPage.tsx
msgid "La marca no quedó registrada"
msgstr "La marca no quedó registrada"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "la modalidad"
msgstr "la modalidad"

#: src/features/auth/pages/LoginPage.tsx
msgid "La operación de tu hotel, en un solo lugar."
msgstr "La operación de tu hotel, en un solo lugar."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "La persona a la que reporta no es de ese hotel o está de baja."
msgstr "La persona a la que reporta no es de ese hotel o está de baja."

#: src/features/admin/components/UserFormDialog.tsx
msgid "La persona a la que reporta no existe o está de baja."
msgstr "La persona a la que reporta no existe o está de baja."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "La persona del hotel con quien hablas: la gerente, el de compras, quien te atendió. No son tus datos: a esta persona le llegará la propuesta."
msgstr "La persona del hotel con quien hablas: la gerente, el de compras, quien te atendió. No son tus datos: a esta persona le llegará la propuesta."

#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "La persona marcó su entrada y su salida. Revisar el día es aparte: lo dice el chip."
msgstr "La persona marcó su entrada y su salida. Revisar el día es aparte: lo dice el chip."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "La persona recibirá un correo para establecer su contraseña. Hasta que entre por primera vez, su cuenta aparece como «Invitación enviada»."
msgstr "La persona recibirá un correo para establecer su contraseña. Hasta que entre por primera vez, su cuenta aparece como «Invitación enviada»."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "La plantilla de Firebase, que no se puede editar. Solo para salir del paso."
msgstr "La plantilla de Firebase, que no se puede editar. Solo para salir del paso."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "La plataforma deja fuera a quien se dio de baja, está inactivo o en lista negra."
msgstr "La plataforma deja fuera a quien se dio de baja, está inactivo o en lista negra."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "la posición"
msgstr "la posición"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "La posición y la requisición del turno se enseñan en la fila de Demanda: el contrato aún no liga el turno con una posición."
msgstr "La posición y la requisición del turno se enseñan en la fila de Demanda: el contrato aún no liga el turno con una posición."

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "La propuesta cambió después de este contrato"
msgstr "La propuesta cambió después de este contrato"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "La propuesta quedó enviada — el correo no salió, mándalo aparte."
msgstr "La propuesta quedó enviada — el correo no salió, mándalo aparte."

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "La propuesta se abre cuando un prospecto llega a Verde. Búscalo con «Ver propuesta» o ábrela desde la ficha del prospecto."
msgstr "La propuesta se abre cuando un prospecto llega a Verde. Búscalo con «Ver propuesta» o ábrela desde la ficha del prospecto."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "La propuesta se trabaja con el hotel en Verde o Café — este está en {statusLabel}."
msgstr "La propuesta se trabaja con el hotel en Verde o Café — este está en {statusLabel}."

#. placeholder {0}: ONBOARDING_STATUS_LABEL[workspace.prospectStatus]
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "La propuesta se trabaja con el hotel en Verde o Café: este está en {0}"
msgstr "La propuesta se trabaja con el hotel en Verde o Café: este está en {0}"

#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "La propuesta vive en Verde"
msgstr "La propuesta vive en Verde"

#. placeholder {0}: formatDate(password.dueAt)
#. placeholder {1}: password.day ?? 1
#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "La que te dieron es temporal. Tienes hasta el <0>{0}</0> (día {1} de 30); después tu acceso se bloquea hasta que la cambies."
msgstr "La que te dieron es temporal. Tienes hasta el <0>{0}</0> (día {1} de 30); después tu acceso se bloquea hasta que la cambies."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "La que tiene ahora deja de servir en cuanto la cambies."
msgstr "La que tiene ahora deja de servir en cuanto la cambies."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "La requisición es el pedido formal de colaboradores: qué posiciones necesitas y cuántas personas en cada una."
msgstr "La requisición es el pedido formal de colaboradores: qué posiciones necesitas y cuántas personas en cada una."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "La requisición ya está en la Bolsa del Self-Pick: las Reclutadoras van cubriendo los slots y aquí verás la cobertura al día."
msgstr "La requisición ya está en la Bolsa del Self-Pick: las Reclutadoras van cubriendo los slots y aquí verás la cobertura al día."

#: src/features/timesheet/components/AttendanceView.tsx
msgid "La salida no es después de la entrada"
msgstr "La salida no es después de la entrada"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "La semana de nómina la fija el contrato"
msgstr "La semana de nómina la fija el contrato"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "La semana del hotel empieza en"
msgstr "La semana del hotel empieza en"

#: src/features/onboarding/components/HotelDataCard.tsx
msgid "La semana empieza en"
msgstr "La semana empieza en"

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "La semana en cinco medidas"
msgstr "La semana en cinco medidas"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "La semana no puede empezar y terminar el mismo día"
msgstr "La semana no puede empezar y terminar el mismo día"

#: src/features/observability/components/CohortSection.tsx
msgid "La semana siguiente todavía no empieza."
msgstr "La semana siguiente todavía no empieza."

#: src/features/worker/pages/PunchPage.tsx
msgid "La semana ya se cerró: esta marca la captura el Supervisor."
msgstr "La semana ya se cerró: esta marca la captura el Supervisor."

#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "La semana ya se envió a aprobación: no admite más cambios. Si algo quedó mal, comunícate con Oranje."
msgstr "La semana ya se envió a aprobación: no admite más cambios. Si algo quedó mal, comunícate con Oranje."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "La sesión de firma caducó. «Firmar ahora» abre una nueva."
msgstr "La sesión de firma caducó. «Firmar ahora» abre una nueva."

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "La solicitud quedó cancelada"
msgstr "La solicitud quedó cancelada"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "La solicitud ya no está abierta, o su acceso ya se borró y no se puede cancelar."
msgstr "La solicitud ya no está abierta, o su acceso ya se borró y no se puede cancelar."

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "La solicitud ya no existe."
msgstr "La solicitud ya no existe."

#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "la ubicación en el mapa"
msgstr "la ubicación en el mapa"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "La ubicación importa"
msgstr "La ubicación importa"

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "La ven Reclutamiento y el Manager de QA, que son quienes sincronizan."
msgstr "La ven Reclutamiento y el Manager de QA, que son quienes sincronizan."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "La vigencia está bien definida"
msgstr "La vigencia está bien definida"

#: src/features/onboarding/import/mapImportRows.ts
msgid "La zona «{zoneText}» no existe en Oranje"
msgstr "La zona «{zoneText}» no existe en Oranje"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "La zona ya no existe en Oranje"
msgstr "La zona ya no existe en Oranje"

#. placeholder {0}: band.length
#: src/features/observability/components/CohortSection.tsx
msgid "Las {0} semanas alrededor"
msgstr "Las {0} semanas alrededor"

#. placeholder {0}: worker?.workerName ?? ''
#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Las contraseñas se muestran una sola vez. Dáselas en mano a {0}."
msgstr "Las contraseñas se muestran una sola vez. Dáselas en mano a {0}."

#: src/features/admin/pages/UsersPage.tsx
msgid "Las cuentas de cada hotel: Supervisores, Managers de Área y Managers Generales."
msgstr "Las cuentas de cada hotel: Supervisores, Managers de Área y Managers Generales."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Las defines tú en la entrevista; el candidato no las declara."
msgstr "Las defines tú en la entrevista; el candidato no las declara."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Las dos"
msgstr "Las dos"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Las dos contraseñas no coinciden"
msgstr "Las dos contraseñas no coinciden"

#: src/features/messaging/components/tours.ts
msgid "Las entregas y lecturas siguen llegando después del envío: actualiza para verlas."
msgstr "Las entregas y lecturas siguen llegando después del envío: actualiza para verlas."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Las enviadas no se editan: para renegociar se abre una versión nueva, que arranca con el título y las tarifas de la anterior."
msgstr "Las enviadas no se editan: para renegociar se abre una versión nueva, que arranca con el título y las tarifas de la anterior."

#: src/features/messaging/components/tours.ts
msgid "Las etiquetas agrupan contactos: con ellas eliges a quién va una campaña."
msgstr "Las etiquetas agrupan contactos: con ellas eliges a quién va una campaña."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Las fechas de vigencia que definas aquí mandan después en la nómina y en la factura. El corte semanal y el recargo de overtime ya los trae el hotel de sus datos contables."
msgstr "Las fechas de vigencia que definas aquí mandan después en la nómina y en la factura. El corte semanal y el recargo de overtime ya los trae el hotel de sus datos contables."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Las filas «para completar» se importan y lo que falta se termina en la ficha de cada prospecto. Las filas con error no se pueden elegir: corrígelas en el archivo y vuelve a subirlo."
msgstr "Las filas «para completar» se importan y lo que falta se termina en la ficha de cada prospecto. Las filas con error no se pueden elegir: corrígelas en el archivo y vuelve a subirlo."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Las horas que pasan de 40 a la semana no se le pagan al colaborador en este hotel."
msgstr "Las horas que pasan de 40 a la semana no se le pagan al colaborador en este hotel."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Las horas son de la zona horaria de cada hotel. Los días son fijos: el plazo y el corte son miércoles, el envío de emergencia es jueves y el correo de horas sale el sábado."
msgstr "Las horas son de la zona horaria de cada hotel. Los días son fijos: el plazo y el corte son miércoles, el envío de emergencia es jueves y el correo de horas sale el sábado."

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Las horas ya están aprobadas y no se modifican."
msgstr "Las horas ya están aprobadas y no se modifican."

#: src/features/audits/components/AuditHotelCard.tsx
msgid "Las inspecciones las hace el Supervisor del hotel; tú puedes ver el historial."
msgstr "Las inspecciones las hace el Supervisor del hotel; tú puedes ver el historial."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Las inspecciones las ve el equipo del hotel. Si crees que deberías tener acceso, pídeselo a tu Manager General."
msgstr "Las inspecciones las ve el equipo del hotel. Si crees que deberías tener acceso, pídeselo a tu Manager General."

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Las leyes laborales y fiscales de Estados Unidos nos obligan a guardar tu nombre, tu fecha de nacimiento, tu género, tu dirección, tu SSN o ITIN (cifrado), tus documentos, tus horas, tus ponches con sus fotos, tus pagos y deducciones, y los registros de accidentes de trabajo durante el plazo que marca la ley. También guardamos tu historial de estados y, si lo hay, el veto, para prevenir fraudes. Tu teléfono queda en una lista para no enviarte más mensajes."
msgstr "Las leyes laborales y fiscales de Estados Unidos nos obligan a guardar tu nombre, tu fecha de nacimiento, tu género, tu dirección, tu SSN o ITIN (cifrado), tus documentos, tus horas, tus ponches con sus fotos, tus pagos y deducciones, y los registros de accidentes de trabajo durante el plazo que marca la ley. También guardamos tu historial de estados y, si lo hay, el veto, para prevenir fraudes. Tu teléfono queda en una lista para no enviarte más mensajes."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Las Líderes y Reclutadoras se asignan en Usuarios: cuando alguien tenga «Reporta a» con tu nombre, aparecerá aquí."
msgstr "Las Líderes y Reclutadoras se asignan en Usuarios: cuando alguien tenga «Reporta a» con tu nombre, aparecerá aquí."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Las listas de las que bebe todo el sistema: requisiciones, altas y contratos."
msgstr "Las listas de las que bebe todo el sistema: requisiciones, altas y contratos."

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Las marcas del día"
msgstr "Las marcas del día"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Las más recientes, con su cobertura"
msgstr "Las más recientes, con su cobertura"

#: src/features/observability/pages/ObservabilityPage.tsx
msgid "Las metas son de ejemplo, tomadas del tablero maquetado: todavía nadie las aprobó."
msgstr "Las metas son de ejemplo, tomadas del tablero maquetado: todavía nadie las aprobó."

#: src/features/team/pages/TeamPage.tsx
msgid "Las notas al BD llegan pronto"
msgstr "Las notas al BD llegan pronto"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Las posiciones"
msgstr "Las posiciones"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Las propuestas las elabora el BD dueño de cada hotel: pídele que la abra."
msgstr "Las propuestas las elabora el BD dueño de cada hotel: pídele que la abra."

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "Las propuestas las elabora el BD dueño de cada prospecto: pídele que la abra."
msgstr "Las propuestas las elabora el BD dueño de cada prospecto: pídele que la abra."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Las ramas: salir y volver"
msgstr "Las ramas: salir y volver"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "las requisiciones de {hotelName}"
msgstr "las requisiciones de {hotelName}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Las requisiciones de otro departamento las crea su Manager de Área o el Manager General."
msgstr "Las requisiciones de otro departamento las crea su Manager de Área o el Manager General."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Las requisiciones las crea el hotel"
msgstr "Las requisiciones las crea el hotel"

#. placeholder {0}: data.range.tz
#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Las respuestas y bajas cuentan para una campaña si llegan en los 7 días siguientes al envío. Horarios en {0}."
msgstr "Las respuestas y bajas cuentan para una campaña si llegan en los 7 días siguientes al envío. Horarios en {0}."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Las semanas enviadas las aprueba el Manager de Área de su departamento o el Manager General. Hasta entonces las horas no se pagan ni se facturan."
msgstr "Las semanas enviadas las aprueba el Manager de Área de su departamento o el Manager General. Hasta entonces las horas no se pagan ni se facturan."

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Las semanas ya aprobadas <0>no se recalculan</0>: cada consolidado guarda lo que regía ese día."
msgstr "Las semanas ya aprobadas <0>no se recalculan</0>: cada consolidado guarda lo que regía ese día."

#. placeholder {0}: String(latestVersion)
#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Las tarifas del contrato se reemplazan por las de la v{0}. Los datos del documento, la vigencia y los multiplicadores no cambian."
msgstr "Las tarifas del contrato se reemplazan por las de la v{0}. Los datos del documento, la vigencia y los multiplicadores no cambian."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Las tarifas solo se editan en borrador"
msgstr "Las tarifas solo se editan en borrador"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Las tarifas ya están completas. Al activarlo, la nómina y la factura del hotel empiezan a usarlo y queda bloqueado — se desbloquea con un motivo si hace falta corregir algo."
msgstr "Las tarifas ya están completas. Al activarlo, la nómina y la factura del hotel empiezan a usarlo y queda bloqueado — se desbloquea con un motivo si hace falta corregir algo."

#: src/features/messaging/components/tours.ts
msgid "Las últimas campañas"
msgstr "Las últimas campañas"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Las vacaciones aún no tienen reglas ni registro en el sistema. Esta pantalla se llenará cuando existan."
msgstr "Las vacaciones aún no tienen reglas ni registro en el sistema. Esta pantalla se llenará cuando existan."

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Las zonas del BD las asigna su coordinador (o el Administrador): son donde abre y trabaja sus prospectos."
msgstr "Las zonas del BD las asigna su coordinador (o el Administrador): son donde abre y trabaja sus prospectos."

#. placeholder {0}: member.fullName
#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Las zonas donde {0} abre y trabaja sus prospectos."
msgstr "Las zonas donde {0} abre y trabaja sus prospectos."

#: src/features/team/pages/TeamPage.tsx
msgid "Las zonas donde este BD trabaja sus prospectos"
msgstr "Las zonas donde este BD trabaja sus prospectos"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Latitud o longitud no válidas: marca el pin en la ficha del prospecto"
msgstr "Latitud o longitud no válidas: marca el pin en la ficha del prospecto"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Laura Méndez"
msgstr "Laura Méndez"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Le faltan columnas obligatorias. Agrégalas con estos títulos o usa la plantilla:"
msgstr "Le faltan columnas obligatorias. Agrégalas con estos títulos o usa la plantilla:"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Le llega cuando firme Oranje"
msgstr "Le llega cuando firme Oranje"

#. placeholder {0}: preview.totalRecipients
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Le llegaría a <0>{0}</0> contactos"
msgstr "Le llegaría a <0>{0}</0> contactos"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/components/ReportParts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Leídos"
msgstr "Leídos"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Levantada"
msgstr "Levantada"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Levantando…"
msgstr "Levantando…"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Levantar de Blacklist"
msgstr "Levantar de Blacklist"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Levantar el veto"
msgstr "Levantar el veto"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Levantar un veto es del Administrador"
msgstr "Levantar un veto es del Administrador"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Levantar veto"
msgstr "Levantar veto"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Leyendo el archivo…"
msgstr "Leyendo el archivo…"

#. placeholder {0}: formatPercent(share(totals.read, totals.delivered))
#: src/features/messaging/components/ReportCharts.tsx
msgid "Leyeron el {0} de los que lo recibieron."
msgstr "Leyeron el {0} de los que lo recibieron."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Liberando…"
msgstr "Liberando…"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Liberar"
msgstr "Liberar"

#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
msgid "Liberar a {workerName}"
msgstr "Liberar a {workerName}"

#: src/features/recruitment/components/PoolRoster.tsx
msgid "Liberar asignación temporal"
msgstr "Liberar asignación temporal"

#: src/features/requisitions/components/SlotList.tsx
msgid "Libre"
msgstr "Libre"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "libre · elegir"
msgstr "libre · elegir"

#: src/shared/constants/roles.ts
msgid "Líder de Grupo de Reclutadoras"
msgstr "Líder de Grupo de Reclutadoras"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Límites guardados"
msgstr "Límites guardados"

#: src/shared/components/SearchField.tsx
msgid "Limpiar"
msgstr "Limpiar"

#: src/shared/components/SearchField.tsx
msgid "Limpiar la búsqueda"
msgstr "Limpiar la búsqueda"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Líneas facturadas"
msgstr "Líneas facturadas"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Líneas trabajadas"
msgstr "Líneas trabajadas"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Lista"
msgstr "Lista"

#. placeholder {0}: result.list.name
#. placeholder {1}: result.contacts
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Lista «{0}» lista con {1} contactos: elígela en una campaña nueva."
msgstr "Lista «{0}» lista con {1} contactos: elígela en una campaña nueva."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Lista de verificación"
msgstr "Lista de verificación"

#. placeholder {0}: result.deactivated
#. placeholder {1}: result.reactivated
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Lista negra: {0} dejan de recibir y {1} vuelven a recibir."
msgstr "Lista negra: {0} dejan de recibir y {1} vuelven a recibir."

#: src/features/messaging/components/ImportContactsDialog.tsx
#: src/features/onboarding/import/ImportProspectsDialog.tsx
#: src/features/recruitment/components/CreateAccessDialog.tsx
#: src/shared/components/GuidedTour.tsx
msgid "Listo"
msgstr "Listo"

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Listo para aprobar"
msgstr "Listo para aprobar"

#: src/features/recruitment/components/ProfileProgressAvatar.tsx
msgid "Listo para asignar"
msgstr "Listo para asignar"

#: src/features/observability/lib/people.ts
#: src/shared/constants/contactAttempt.ts
msgid "Llamada"
msgstr "Llamada"

#: src/features/observability/lib/people.ts
msgid "Llamadas"
msgstr "Llamadas"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Llenando"
msgstr "Llenando"

#. placeholder {0}: member.activeRequisitions
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Llenando {0}"
msgstr "Llenando {0}"

#. placeholder {0}: String(slot.ordinal)
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Llenar el slot {0} en vez de este"
msgstr "Llenar el slot {0} en vez de este"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Llenar un slot es de Reclutamiento: la Reclutadora, su Líder de Grupo o el Manager de Reclutamiento."
msgstr "Llenar un slot es de Reclutamiento: la Reclutadora, su Líder de Grupo o el Manager de Reclutamiento."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Llevas {typedLength} de {minLength} caracteres."
msgstr "Llevas {typedLength} de {minLength} caracteres."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Lo aprobado hasta aquí se paga ese día."
msgstr "Lo aprobado hasta aquí se paga ese día."

#: src/shared/constants/workerStatus.ts
msgid "lo asigna Reclutamiento (la Reclutadora, su Líder de Grupo o el Manager); el propio colaborador puede ponerse Disponible voluntario."
msgstr "lo asigna Reclutamiento (la Reclutadora, su Líder de Grupo o el Manager); el propio colaborador puede ponerse Disponible voluntario."

#: src/shared/constants/workerStatus.ts
msgid "lo asigna Reclutamiento temporalmente (la Reclutadora, su Líder de Grupo o el Manager)."
msgstr "lo asigna Reclutamiento temporalmente (la Reclutadora, su Líder de Grupo o el Manager)."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Lo autoriza el Manager de Contabilidad: segunda firma."
msgstr "Lo autoriza el Manager de Contabilidad: segunda firma."

#: src/shared/constants/workerStatus.ts
msgid "lo avanza el sistema con los ponches (el Inspector verifica su llegada)."
msgstr "lo avanza el sistema con los ponches (el Inspector verifica su llegada)."

#: src/shared/constants/workerStatus.ts
msgid "lo avanza el sistema con los ponches; al completar la semana queda Fijo."
msgstr "lo avanza el sistema con los ponches; al completar la semana queda Fijo."

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Lo bloqueaste antes: el navegador ya no vuelve a preguntar. Actívalo desde los Ajustes de tu teléfono, en los permisos de este sitio, y vuelve aquí a confirmar."
msgstr "Lo bloqueaste antes: el navegador ya no vuelve a preguntar. Actívalo desde los Ajustes de tu teléfono, en los permisos de este sitio, y vuelve aquí a confirmar."

#: src/shared/constants/workerStatus.ts
msgid "lo cierra el Inspector con el alta médica."
msgstr "lo cierra el Inspector con el alta médica."

#. placeholder {0}: missingPhase1Fields.join(', ')
#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Lo de Fase 1 ({0}) lo defines tú con «Editar»."
msgstr "Lo de Fase 1 ({0}) lo defines tú con «Editar»."

#. placeholder {0}: grant.grantedBy
#. placeholder {1}: formatDate(grant.grantedAt)
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Lo dio {0} el {1}"
msgstr "Lo dio {0} el {1}"

#. placeholder {0}: workspace.owner.name
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Lo elabora <0>{0}</0> — el BD dueño del ciclo — o el BDC."
msgstr "Lo elabora <0>{0}</0> — el BD dueño del ciclo — o el BDC."

#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Lo enviado no se edita"
msgstr "Lo enviado no se edita"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Lo haces tú, desde este mismo lugar (Ventas)."
msgstr "Lo haces tú, desde este mismo lugar (Ventas)."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Lo imprimes, lo firman a mano y después lo activas"
msgstr "Lo imprimes, lo firman a mano y después lo activas"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "lo mueve el BD o el BDC."
msgstr "lo mueve el BD o el BDC."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Lo pagó de su bolsillo: el monto se suma a lo que recibe esta semana, junto a sus horas."
msgstr "Lo pagó de su bolsillo: el monto se suma a lo que recibe esta semana, junto a sus horas."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Lo pagó el colaborador"
msgstr "Lo pagó el colaborador"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Lo pagó Oranje"
msgstr "Lo pagó Oranje"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Lo pagó Oranje directo: queda registrado, pero no cambia lo que recibe esta semana."
msgstr "Lo pagó Oranje directo: queda registrado, pero no cambia lo que recibe esta semana."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Lo pagó Oranje, descontárselo"
msgstr "Lo pagó Oranje, descontárselo"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Lo que cada hotel nos paga por semana, al precio que cobramos (bill rate)."
msgstr "Lo que cada hotel nos paga por semana, al precio que cobramos (bill rate)."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Lo que cada hotel nos paga y lo que le pagamos a su gente. Un contrato vigente por hotel."
msgstr "Lo que cada hotel nos paga y lo que le pagamos a su gente. Un contrato vigente por hotel."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Lo que corrijas, se paga"
msgstr "Lo que corrijas, se paga"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Lo que decide Oranje"
msgstr "Lo que decide Oranje"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Lo que dejes marcado ES el territorio completo del BD — desmarcar una zona se la quita en el mismo guardado."
msgstr "Lo que dejes marcado ES el territorio completo del BD — desmarcar una zona se la quita en el mismo guardado."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Lo que el hotel nos paga por semana, al precio que le cobramos — nunca el pago interno al colaborador."
msgstr "Lo que el hotel nos paga por semana, al precio que le cobramos — nunca el pago interno al colaborador."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Lo que el machote necesita y hoy no venía de ningún lado"
msgstr "Lo que el machote necesita y hoy no venía de ningún lado"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Lo que Google llenó por ti"
msgstr "Lo que Google llenó por ti"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Lo que guardamos y por qué"
msgstr "Lo que guardamos y por qué"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "lo que marca el contrato"
msgstr "lo que marca el contrato"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Lo que no llegue aprobado al cierre semanal queda en espera: sin pago y sin factura hasta que alguien apruebe."
msgstr "Lo que no llegue aprobado al cierre semanal queda en espera: sin pago y sin factura hasta que alguien apruebe."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Lo que no se aprueba, no se paga"
msgstr "Lo que no se aprueba, no se paga"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Lo que puedes hacer"
msgstr "Lo que puedes hacer"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Lo que puedes hacer con cada uno"
msgstr "Lo que puedes hacer con cada uno"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "lo que recibe"
msgstr "lo que recibe"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Lo que se borra"
msgstr "Lo que se borra"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Lo que se factura no puede ser menor a lo que se paga a la persona."
msgstr "Lo que se factura no puede ser menor a lo que se paga a la persona."

#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Lo que se factura no puede ser menor a lo que se paga."
msgstr "Lo que se factura no puede ser menor a lo que se paga."

#. placeholder {0}: formatMoney(Number(payPreview.billRate))
#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Lo que se le cobra al HOTEL por esta hoja, a {0} la hora (bill rate del contrato) — no lo que recibe el colaborador."
msgstr "Lo que se le cobra al HOTEL por esta hoja, a {0} la hora (bill rate del contrato) — no lo que recibe el colaborador."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Lo que se le paga a cada colaborador por semana. Se revisa, se autoriza y se paga en ese orden."
msgstr "Lo que se le paga a cada colaborador por semana. Se revisa, se autoriza y se paga en ese orden."

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Lo que tu teléfono le permite a Oranje para que puedas ponchar."
msgstr "Lo que tu teléfono le permite a Oranje para que puedas ponchar."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Lo que viste y que vale la pena dejar por escrito…"
msgstr "Lo que viste y que vale la pena dejar por escrito…"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Lo que ya inspeccionaste"
msgstr "Lo que ya inspeccionaste"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Lo registra Contabilidad al pagar."
msgstr "Lo registra Contabilidad al pagar."

#: src/shared/constants/workerStatus.ts
msgid "lo regresa el hotel (Supervisor, Manager de Área o Manager General); el propio colaborador puede ponerse Disponible voluntario."
msgstr "lo regresa el hotel (Supervisor, Manager de Área o Manager General); el propio colaborador puede ponerse Disponible voluntario."

#: src/shared/constants/workerStatus.ts
msgid "lo resuelve el Inspector: a Disponible o a Blacklist."
msgstr "lo resuelve el Inspector: a Disponible o a Blacklist."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Lo revisa la Contadora contra los Timesheets aprobados."
msgstr "Lo revisa la Contadora contra los Timesheets aprobados."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Lo usan Contabilidad y el hotel cada semana, sin que tengas que hacer nada."
msgstr "Lo usan Contabilidad y el hotel cada semana, sin que tengas que hacer nada."

#: src/shared/constants/workerStatus.ts
msgid "lo valida Reclutamiento (la Reclutadora, su Líder de Grupo o el Manager) cuando el expediente está completo."
msgstr "lo valida Reclutamiento (la Reclutadora, su Líder de Grupo o el Manager) cuando el expediente está completo."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Lo ven Reclutamiento, el Manager de QA, Contabilidad y los roles del hotel (solo su personal)."
msgstr "Lo ven Reclutamiento, el Manager de QA, Contabilidad y los roles del hotel (solo su personal)."

#. placeholder {0}: board.slots.length
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Los {0} slots están ocupados: la cobertura del renglón quedó completa."
msgstr "Los {0} slots están ocupados: la cobertura del renglón quedó completa."

#: src/features/worker/pages/HomePage.tsx
msgid "Los avisos importan"
msgstr "Los avisos importan"

#: src/features/team/pages/TeamPage.tsx
msgid "Los BDs de tu equipo se asignan en el alta de personal: cuando alguien tenga «Reporta a» con tu nombre, aparecerá aquí."
msgstr "Los BDs de tu equipo se asignan en el alta de personal: cuando alguien tenga «Reporta a» con tu nombre, aparecerá aquí."

#: src/features/team/pages/TeamPage.tsx
msgid "Los BDs que te reportan y cómo va su ciclo comercial"
msgstr "Los BDs que te reportan y cómo va su ciclo comercial"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Los catálogos alimentan toda la plataforma"
msgstr "Los catálogos alimentan toda la plataforma"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Los catálogos los administra el Administrador del sistema."
msgstr "Los catálogos los administra el Administrador del sistema."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Los colaboradores asignados a tus requisiciones, con su estado en el Semáforo. El Stand-by (Rosa) lo compartes con el Manager de Área."
msgstr "Los colaboradores asignados a tus requisiciones, con su estado en el Semáforo. El Stand-by (Rosa) lo compartes con el Manager de Área."

#: src/features/admin/pages/UsersPage.tsx
msgid "Los colaboradores con correo corporativo, y si su buzón real ya existe."
msgstr "Los colaboradores con correo corporativo, y si su buzón real ya existe."

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Los colaboradores que ya tienen correo @oranjepeople.com. El alta es de Reclutamiento."
msgstr "Los colaboradores que ya tienen correo @oranjepeople.com. El alta es de Reclutamiento."

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Los días de vacaciones de los colaboradores y cómo se pagan."
msgstr "Los días de vacaciones de los colaboradores y cómo se pagan."

#. placeholder {0}: session.hotel.name
#: src/features/team/pages/HotelTeamPage.tsx
msgid "Los gerentes y supervisores de {0}"
msgstr "Los gerentes y supervisores de {0}"

#. placeholder {0}: hotels && ` ${String(hotels.length)} con coordenada.`
#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "Los hoteles de tus zonas, del prospecto al cliente activo.{0} Cada pin abre Mi Territorio."
msgstr "Los hoteles de tus zonas, del prospecto al cliente activo.{0} Cada pin abre Mi Territorio."

#: src/features/observability/pages/ObservabilityPage.tsx
msgid "Los indicadores de cada departamento, calculados con lo que el sistema ya registra — todo de solo lectura."
msgstr "Los indicadores de cada departamento, calculados con lo que el sistema ya registra — todo de solo lectura."

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Los mensajes que aún no salieron ya no se envían. No se puede deshacer."
msgstr "Los mensajes que aún no salieron ya no se envían. No se puede deshacer."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Los que no tengan teléfono válido se saltan."
msgstr "Los que no tengan teléfono válido se saltan."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Los que ya existen se actualizan con los datos del archivo; no se duplican."
msgstr "Los que ya existen se actualizan con los datos del archivo; no se duplican."

#: src/features/messaging/components/tours.ts
msgid "Los reportes cuentan las campañas que salieron en esas fechas."
msgstr "Los reportes cuentan las campañas que salieron en esas fechas."

#: src/features/team/pages/TeamPage.tsx
msgid "Los reportes por BD llegan con la pantalla de Reportes"
msgstr "Los reportes por BD llegan con la pantalla de Reportes"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Los reportes que te envían tus Líderes llegarán con su pantalla «Mi Grupo», que todavía no existe."
msgstr "Los reportes que te envían tus Líderes llegarán con su pantalla «Mi Grupo», que todavía no existe."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Los títulos de la tabla"
msgstr "Los títulos de la tabla"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Los títulos pueden estar en español, inglés o portugués. Las marcadas como obligatorias tienen que existir; si una celda queda vacía, ese dato se completa después."
msgstr "Los títulos pueden estar en español, inglés o portugués. Las marcadas como obligatorias tienen que existir; si una celda queda vacía, ese dato se completa después."

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Lugares cubiertos"
msgstr "Lugares cubiertos"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Lugares cubiertos sobre lugares pedidos, de las requisiciones que empiezan en el periodo."
msgstr "Lugares cubiertos sobre lugares pedidos, de las requisiciones que empiezan en el periodo."

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Lugares pedidos"
msgstr "Lugares pedidos"

#: src/features/observability/lib/people.ts
msgid "Lugares por cubrir en las suyas"
msgstr "Lugares por cubrir en las suyas"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Lun"
msgstr "Lun"

#. placeholder {0}: timeOf(marks.LUNCH_OUT, shiftTimeZone)
#. placeholder {1}: marks.LUNCH_IN ? timeOf(marks.LUNCH_IN, shiftTimeZone) : '--:--'
#: src/features/worker/pages/PunchPage.tsx
msgid "Lunch {0} – {1}"
msgstr "Lunch {0} – {1}"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "M"
msgstr "M"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "MA"
msgstr "MA"

#: src/shared/constants/workerEnums.ts
msgid "Madre"
msgstr "Madre"

#: src/features/admin/types/admin.types.ts
#: src/shared/components/ApprovalTimelinessPanel.tsx
#: src/shared/constants/roles.ts
msgid "Manager de Área"
msgstr "Manager de Área"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Manager de Área (su departamento)"
msgstr "Manager de Área (su departamento)"

#: src/shared/constants/roles.ts
msgid "Manager de Contabilidad"
msgstr "Manager de Contabilidad"

#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
#: src/shared/constants/roles.ts
msgid "Manager de QA"
msgstr "Manager de QA"

#: src/shared/constants/roles.ts
msgid "Manager de Reclutamiento"
msgstr "Manager de Reclutamiento"

#: src/features/admin/types/admin.types.ts
#: src/shared/constants/roles.ts
msgid "Manager General"
msgstr "Manager General"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Manager General (cualquier departamento)"
msgstr "Manager General (cualquier departamento)"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Manda la invitación por correo y cada quien establece la suya. Si lo necesitas, también puedes definirla tú."
msgstr "Manda la invitación por correo y cada quien establece la suya. Si lo necesitas, también puedes definirla tú."

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "Manda primero la propuesta: el contrato se arma con las tarifas que el hotel aceptó."
msgstr "Manda primero la propuesta: el contrato se arma con las tarifas que el hotel aceptó."

#: src/features/personnel/components/StandByDialog.tsx
msgid "Mandando…"
msgstr "Mandando…"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Mandar a aprobación"
msgstr "Mandar a aprobación"

#: src/features/personnel/components/StandByDialog.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Mandar a Stand-by"
msgstr "Mandar a Stand-by"

#: src/features/personnel/components/StandByDialog.tsx
msgid "Mandar a Stand-by a {workerName}"
msgstr "Mandar a Stand-by a {workerName}"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Mandar la semana a aprobación del Manager"
msgstr "Mandar la semana a aprobación del Manager"

#: src/features/recruitment/types/blacklist.types.ts
msgid "Manual"
msgstr "Manual"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Manual · {manualReason}"
msgstr "Manual · {manualReason}"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Mar"
msgstr "Mar"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Marca / Administradora"
msgstr "Marca / Administradora"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Marca a quiénes enviarle:"
msgstr "Marca a quiénes enviarle:"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Marca a quiénes sincronizar:"
msgstr "Marca a quiénes sincronizar:"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Marca corregida"
msgstr "Marca corregida"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Marca el documento como revisado. No afecta la retención del 16% del SSN/ITIN."
msgstr "Marca el documento como revisado. No afecta la retención del 16% del SSN/ITIN."

#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Marca la ubicación en el mapa"
msgstr "Marca la ubicación en el mapa"

#: src/features/timesheet/components/DayStatusTour.tsx
msgid "Marca los días sin ponches"
msgstr "Marca los días sin ponches"

#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Marca manual"
msgstr "Marca manual"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Marca manual registrada"
msgstr "Marca manual registrada"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Marcando…"
msgstr "Marcando…"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Marcar como enviada"
msgstr "Marcar como enviada"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Marcar como enviado"
msgstr "Marcar como enviado"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Marcar como principal"
msgstr "Marcar como principal"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Marcar como revisado"
msgstr "Marcar como revisado"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Marcar el día"
msgstr "Marcar el día"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Marcar expirado"
msgstr "Marcar expirado"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Marcar revisado"
msgstr "Marcar revisado"

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Marcar todos"
msgstr "Marcar todos"

#: src/features/worker/pages/HomePage.tsx
msgid "Marcarme disponible"
msgstr "Marcarme disponible"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Marcas"
msgstr "Marcas"

#: src/features/observability/lib/workerKpis.ts
msgid "Marcas en el mismo minuto"
msgstr "Marcas en el mismo minuto"

#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/components/RateTable.tsx
msgid "Margen"
msgstr "Margen"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Margen bruto por hora"
msgstr "Margen bruto por hora"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "María Sandoval Ruiz"
msgstr "María Sandoval Ruiz"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Marketing"
msgstr "Marketing"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Marta Solís"
msgstr "Marta Solís"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "marta.solis@puertoreal.mx"
msgstr "marta.solis@puertoreal.mx"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Más acciones"
msgstr "Más acciones"

#: src/features/clients/types/client.types.ts
msgid "más antiguo"
msgstr "más antiguo"

#: src/shared/constants/workerEnums.ts
msgid "Más de 5 años"
msgstr "Más de 5 años"

#: src/features/clients/types/client.types.ts
msgid "más reciente"
msgstr "más reciente"

#: src/features/onboarding/components/ContractUnlockedDialog.tsx
#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "Más tarde"
msgstr "Más tarde"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/shared/constants/workerEnums.ts
msgid "Masculino"
msgstr "Masculino"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Máximo 160 caracteres"
msgstr "Máximo 160 caracteres"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Máximo 255 caracteres"
msgstr "Máximo 255 caracteres"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Máximo 999 personas por posición"
msgstr "Máximo 999 personas por posición"

#. placeholder {0}: formatDuration(report.latency.deliveredP90Seconds)
#. placeholder {0}: formatDuration(report.latency.readP90Seconds)
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "mediana · 90 % en {0}"
msgstr "mediana · 90 % en {0}"

#: src/shared/constants/requisitionStatus.ts
msgid "Medio"
msgstr "Medio"

#: src/shared/constants/catalogs.ts
msgid "Medio tiempo"
msgstr "Medio tiempo"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Mensaje"
msgstr "Mensaje"

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/features/messaging/pages/MessagingPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Mensajería"
msgstr "Mensajería"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Mensajes"
msgstr "Mensajes"

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Mensajes aprobados por Meta"
msgstr "Mensajes aprobados por Meta"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Mensajes aprobados por Meta, disponibles para usar en campañas."
msgstr "Mensajes aprobados por Meta, disponibles para usar en campañas."

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Mensajes por día"
msgstr "Mensajes por día"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Mensajes por día y resultado. Usa las flechas para recorrer los días; «Ver tabla» tiene todos los valores."
msgstr "Mensajes por día y resultado. Usa las flechas para recorrer los días; «Ver tabla» tiene todos los valores."

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Mensajes por WhatsApp a colaboradores, con plantillas y campañas."
msgstr "Mensajes por WhatsApp a colaboradores, con plantillas y campañas."

#: src/features/observability/components/CohortsView.tsx
msgid "Mensual"
msgstr "Mensual"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Mes"
msgstr "Mes"

#: src/features/observability/components/CohortsView.tsx
msgid "Mes {k}"
msgstr "Mes {k}"

#. placeholder {0}: formatNumber(report.billable)
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Meta cobra las plantillas entregadas ({0} en esta campaña); las no entregadas no se cobran. Respuestas y bajas: 7 días siguientes al envío."
msgstr "Meta cobra las plantillas entregadas ({0} en esta campaña); las no entregadas no se cobran. Respuestas y bajas: 7 días siguientes al envío."

#: src/features/observability/components/KpiCard.tsx
msgid "meta de ejemplo"
msgstr "meta de ejemplo"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Meta del ciclo: el hotel ya es cliente."
msgstr "Meta del ciclo: el hotel ya es cliente."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Meta la revisa antes de poder usarla en campañas; suele tardar minutos, a veces horas."
msgstr "Meta la revisa antes de poder usarla en campañas; suele tardar minutos, a veces horas."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Meta los usa para revisar la plantilla; no se envían a nadie."
msgstr "Meta los usa para revisar la plantilla; no se envían a nadie."

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Meta no entrega Marketing a números de EE. UU."
msgstr "Meta no entrega Marketing a números de EE. UU."

#: src/features/onboarding/import/mapImportRows.ts
msgid "Método de ponche no reconocido: se usa Selfie"
msgstr "Método de ponche no reconocido: se usa Selfie"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "MG"
msgstr "MG"

#: src/features/worker/components/MobileShell.tsx
msgid "Mi correo"
msgstr "Mi correo"

#: src/features/team/pages/HotelTeamPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
#: src/features/team/pages/TeamPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Mi Equipo"
msgstr "Mi Equipo"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Mi Equipo del Hotel es del Manager General"
msgstr "Mi Equipo del Hotel es del Manager General"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Mi Equipo es de la Manager de Reclutamiento"
msgstr "Mi Equipo es de la Manager de Reclutamiento"

#: src/features/team/pages/TeamPage.tsx
msgid "Mi Equipo solo la ve el BDC"
msgstr "Mi Equipo solo la ve el BDC"

#: src/features/worker/components/MobileShell.tsx
msgid "Mi Perfil"
msgstr "Mi Perfil"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Mi Personal"
msgstr "Mi Personal"

#: src/features/territory/components/TerritoryOwnerPicker.tsx
msgid "Mi territorio"
msgstr "Mi territorio"

#: src/features/territory/pages/TerritoryPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Mi Territorio"
msgstr "Mi Territorio"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Mié"
msgstr "Mié"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Mientras dure tu incapacidad no hay turnos que ponchar. Tu Inspector lleva el seguimiento."
msgstr "Mientras dure tu incapacidad no hay turnos que ponchar. Tu Inspector lleva el seguimiento."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Mínimo {MIN_LENGTH} caracteres"
msgstr "Mínimo {MIN_LENGTH} caracteres"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Mínimo {minLength} caracteres."
msgstr "Mínimo {minLength} caracteres."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Minúsculas y guion bajo, p. ej. aviso_turno"
msgstr "Minúsculas y guion bajo, p. ej. aviso_turno"

#: src/features/messaging/components/tours.ts
msgid "Mira el detalle"
msgstr "Mira el detalle"

#: src/features/worker/components/MobileShell.tsx
msgid "Mis datos"
msgstr "Mis datos"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "modalidad"
msgstr "modalidad"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Modalidad"
msgstr "Modalidad"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Modalidad {ordinal}"
msgstr "Modalidad {ordinal}"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Modalidades"
msgstr "Modalidades"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Montaña — Denver, Salt Lake City"
msgstr "Montaña — Denver, Salt Lake City"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Monto"
msgstr "Monto"

#. placeholder {0}: money(consolidation.grossAmount)
#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Monto (16% del bruto de {0})"
msgstr "Monto (16% del bruto de {0})"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Monto de comida por día laborado"
msgstr "Monto de comida por día laborado"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Monto de la deducción"
msgstr "Monto de la deducción"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Monto del gasto, en dólares"
msgstr "Monto del gasto, en dólares"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Monto por día laborado (USD)"
msgstr "Monto por día laborado (USD)"

#: src/features/observability/components/CohortSection.tsx
msgid "Mostrar"
msgstr "Mostrar"

#: src/features/auth/pages/LoginPage.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Mostrar contraseña"
msgstr "Mostrar contraseña"

#: src/layouts/Header.tsx
msgid "Mostrar u ocultar el menú"
msgstr "Mostrar u ocultar el menú"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "motivo"
msgstr "motivo"

#: src/features/contracts/components/ContractSignatureCard.tsx
#: src/features/contracts/components/UnlockContractDialog.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
#: src/features/recruitment/components/ChangeStateDialog.tsx
#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Motivo"
msgstr "Motivo"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Motivo (obligatorio)"
msgstr "Motivo (obligatorio)"

#: src/features/account/pages/DeleteAccountPage.tsx
#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Motivo (opcional)"
msgstr "Motivo (opcional)"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Motivo (queda en el journal, obligatorio)"
msgstr "Motivo (queda en el journal, obligatorio)"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Motivo <0>(obligatorio, mínimo 4 caracteres)</0>"
msgstr "Motivo <0>(obligatorio, mínimo 4 caracteres)</0>"

#. placeholder {0}: signature.closedReason
#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Motivo de la cancelación: «{0}»"
msgstr "Motivo de la cancelación: «{0}»"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Motivo de la corrección"
msgstr "Motivo de la corrección"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Motivo de la corrección (obligatorio)"
msgstr "Motivo de la corrección (obligatorio)"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Motivo de la marca manual"
msgstr "Motivo de la marca manual"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Motivo del ajuste de tarifa"
msgstr "Motivo del ajuste de tarifa"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Motivo del cierre"
msgstr "Motivo del cierre"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Motivo del gasto"
msgstr "Motivo del gasto"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Motivo del levantamiento <0>(obligatorio)</0>"
msgstr "Motivo del levantamiento <0>(obligatorio)</0>"

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Motivo del rechazo"
msgstr "Motivo del rechazo"

#. placeholder {0}: signature.closedReason
#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Motivo del rechazo: «{0}»"
msgstr "Motivo del rechazo: «{0}»"

#. placeholder {0}: template.rejectionReason
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Motivo del rechazo: {0}"
msgstr "Motivo del rechazo: {0}"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Motivo del regreso (obligatorio):"
msgstr "Motivo del regreso (obligatorio):"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Motivo del reporte"
msgstr "Motivo del reporte"

#: src/features/personnel/components/StandByDialog.tsx
msgid "Motivo del Stand-by"
msgstr "Motivo del Stand-by"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Motivo del veto <0>(obligatorio)</0>"
msgstr "Motivo del veto <0>(obligatorio)</0>"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "motivo obligatorio"
msgstr "motivo obligatorio"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Motivo para liberar el slot"
msgstr "Motivo para liberar el slot"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Motivo y evidencia, obligatorios"
msgstr "Motivo y evidencia, obligatorios"

#. placeholder {0}: filters.errorKey
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Motivo: {0}"
msgstr "Motivo: {0}"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Motivos"
msgstr "Motivos"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Motivos de salida a Rojo · Café · Negro"
msgstr "Motivos de salida a Rojo · Café · Negro"

#. placeholder {0}: target.label
#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Mover con {0}"
msgstr "Mover con {0}"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Multiplicador de festivo facturado"
msgstr "Multiplicador de festivo facturado"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Multiplicador de festivo pagado"
msgstr "Multiplicador de festivo pagado"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Multiplicador de overtime facturado"
msgstr "Multiplicador de overtime facturado"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Multiplicadores"
msgstr "Multiplicadores"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Multiplicadores actualizados"
msgstr "Multiplicadores actualizados"

#: src/features/messaging/pages/MessagingPage.tsx
#: src/shared/components/ModulePlaceholder.tsx
msgid "Muy pronto estará aquí"
msgstr "Muy pronto estará aquí"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "N/A"
msgstr "N/A"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Nace autorizada"
msgstr "Nace autorizada"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Nace autorizada: Reclutamiento la ve en cuanto la guardas, y la urgencia corre desde ese momento."
msgstr "Nace autorizada: Reclutamiento la ve en cuanto la guardas, y la urgencia corre desde ese momento."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Nace de la corrida de pago"
msgstr "Nace de la corrida de pago"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nace en Blanco al guardar"
msgstr "Nace en Blanco al guardar"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nace en Blanco: el colaborador termina las fases 2 y 3 en su app — si lo validas con algo pendiente, tiene 1 día para completarlo."
msgstr "Nace en Blanco: el colaborador termina las fases 2 y 3 en su app — si lo validas con algo pendiente, tiene 1 día para completarlo."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nace en Blanco: el expediente se completa por fases."
msgstr "Nace en Blanco: el expediente se completa por fases."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Nace en Borrador"
msgstr "Nace en Borrador"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Nace en Borrador con las tarifas del contrato vigente: ajusta lo que haya cambiado y actívalo cuando esté listo — el anterior sigue rigiendo hasta entonces."
msgstr "Nace en Borrador con las tarifas del contrato vigente: ajusta lo que haya cambiado y actívalo cuando esté listo — el anterior sigue rigiendo hasta entonces."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Nace en Borrador: las tarifas se afinan ahí y activarlo es el paso final."
msgstr "Nace en Borrador: las tarifas se afinan ahí y activarlo es el paso final."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Nacimiento"
msgstr "Nacimiento"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nacimiento y género"
msgstr "Nacimiento y género"

#. placeholder {0}: term.trim()
#: src/layouts/GlobalSearch.tsx
msgid "Nada coincide con «{0}». Prueba con el nombre del hotel, el folio de la requisición o el nombre del colaborador."
msgstr "Nada coincide con «{0}». Prueba con el nombre del hotel, el folio de la requisición o el nombre del colaborador."

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Nada por convertir"
msgstr "Nada por convertir"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Nada que cerrar: ya estaba pagado o aún no llega su corte."
msgstr "Nada que cerrar: ya estaba pagado o aún no llega su corte."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Nadie — la punta de la jerarquía"
msgstr "Nadie — la punta de la jerarquía"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Nadie — la punta de la jerarquía del hotel"
msgstr "Nadie — la punta de la jerarquía del hotel"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Nadie (sin jefe por ahora)"
msgstr "Nadie (sin jefe por ahora)"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Nadie coincide"
msgstr "Nadie coincide"

#: src/shared/components/SearchableSelect.tsx
msgid "Nadie coincide con «{query}»."
msgstr "Nadie coincide con «{query}»."

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Nadie coincide con «{search}»."
msgstr "Nadie coincide con «{search}»."

#: src/features/recruitment/components/PoolRoster.tsx
msgid "Nadie coincide con esa búsqueda o esos filtros. Cambia el nombre, la posición, la zona o el estado, o quítalos con «Quitar filtros»."
msgstr "Nadie coincide con esa búsqueda o esos filtros. Cambia el nombre, la posición, la zona o el estado, o quítalos con «Quitar filtros»."

#: src/features/admin/pages/UsersPage.tsx
msgid "Nadie coincide con esa búsqueda. Prueba otro nombre, correo o rol, o quita los filtros."
msgstr "Nadie coincide con esa búsqueda. Prueba otro nombre, correo o rol, o quita los filtros."

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Nadie coincide con esa búsqueda. Prueba otro nombre, correo, hotel o rol, o quita los filtros."
msgstr "Nadie coincide con esa búsqueda. Prueba otro nombre, correo, hotel o rol, o quita los filtros."

#: src/features/timesheet/components/TimesheetGrid.tsx
msgid "Nadie coincide con esos filtros esta semana. Cambia la requisición, el estado o el hotel."
msgstr "Nadie coincide con esos filtros esta semana. Cambia la requisición, el estado o el hotel."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Nadie coincide con esos filtros."
msgstr "Nadie coincide con esos filtros."

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Nadie coincide con esos filtros. Cambia el nombre, la requisición, el estado, el hotel o el periodo."
msgstr "Nadie coincide con esos filtros. Cambia el nombre, la requisición, el estado, el hotel o el periodo."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Nadie coincide."
msgstr "Nadie coincide."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Nadie con funciones adicionales coincide con la búsqueda."
msgstr "Nadie con funciones adicionales coincide con la búsqueda."

#: src/features/observability/components/PeopleView.tsx
msgid "Nadie de este departamento tiene actividad registrada que se pueda ver."
msgstr "Nadie de este departamento tiene actividad registrada que se pueda ver."

#. placeholder {0}: search.trim()
#: src/features/team/pages/HotelTeamPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Nadie de tu equipo se llama «{0}». Cambia la búsqueda o límpiala para ver a todos."
msgstr "Nadie de tu equipo se llama «{0}». Cambia la búsqueda o límpiala para ver a todos."

#: src/features/observability/components/CohortSection.tsx
msgid "Nadie empezó a trabajar esa semana."
msgstr "Nadie empezó a trabajar esa semana."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Nadie en la lista se llama «{search}»."
msgstr "Nadie en la lista se llama «{search}»."

#. placeholder {0}: search.trim()
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Nadie en tu plantel se llama «{0}». Cambia la búsqueda o límpiala para ver a todos."
msgstr "Nadie en tu plantel se llama «{0}». Cambia la búsqueda o límpiala para ver a todos."

#: src/features/admin/pages/UsersPage.tsx
msgid "Nadie está de baja. Las personas que des de baja aparecerán aquí."
msgstr "Nadie está de baja. Las personas que des de baja aparecerán aquí."

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Nadie falta"
msgstr "Nadie falta"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Nadie la está trabajando todavía."
msgstr "Nadie la está trabajando todavía."

#: src/features/schedule/components/ScheduleTimelineGrid.tsx
msgid "Nadie programado todavía: los turnos aparecen conforme se cubren los slots."
msgstr "Nadie programado todavía: los turnos aparecen conforme se cubren los slots."

#: src/features/team/pages/RecruitmentTeamPage.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "Nadie te reporta todavía"
msgstr "Nadie te reporta todavía"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Nadie te reporta todavía. Asigna tu equipo en Usuarios con «Reporta a»."
msgstr "Nadie te reporta todavía. Asigna tu equipo en Usuarios con «Reporta a»."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Nadie tiene asignación activa en la demanda de este hotel todavía"
msgstr "Nadie tiene asignación activa en la demanda de este hotel todavía"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Nadie tiene correo corporativo asignado todavía."
msgstr "Nadie tiene correo corporativo asignado todavía."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Nadie tiene este acceso: nadie ve la función. Dáselo a alguien abajo."
msgstr "Nadie tiene este acceso: nadie ve la función. Dáselo a alguien abajo."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Nadie tiene funciones adicionales: cada persona trabaja con el rol de su alta."
msgstr "Nadie tiene funciones adicionales: cada persona trabaja con el rol de su alta."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Nadie tiene que hacer nada con este documento."
msgstr "Nadie tiene que hacer nada con este documento."

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Nadie tiene Timesheet esta semana. Las filas aparecen cuando los Supervisores registran horas."
msgstr "Nadie tiene Timesheet esta semana. Las filas aparecen cuando los Supervisores registran horas."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Nadie tiene una asignación activa en una requisición autorizada de este hotel."
msgstr "Nadie tiene una asignación activa en una requisición autorizada de este hotel."

#: src/features/conversion/pages/ConversionPage.tsx
#: src/shared/constants/onboardingStatus.ts
msgid "Naranja"
msgstr "Naranja"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Naranja / ciclos cerrados"
msgstr "Naranja / ciclos cerrados"

#: src/shared/constants/onboardingStatus.ts
msgid "Negociación de términos"
msgstr "Negociación de términos"

#: src/shared/constants/onboardingStatus.ts
msgid "Negro"
msgstr "Negro"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Neto"
msgstr "Neto"

#. placeholder {0}: formatMoney(totalNet)
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Neto {0}"
msgstr "Neto {0}"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Neto a pagar"
msgstr "Neto a pagar"

#. placeholder {0}: search.trim()
#: src/features/team/pages/TeamPage.tsx
msgid "Ningún BD de tu equipo se llama «{0}». Cambia la búsqueda o límpiala para ver a todos."
msgstr "Ningún BD de tu equipo se llama «{0}». Cambia la búsqueda o límpiala para ver a todos."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Ningún colaborador coincide con «{search}»."
msgstr "Ningún colaborador coincide con «{search}»."

#: src/features/recruitment/components/PoolCardBoard.tsx
#: src/features/recruitment/components/PoolTable.tsx
msgid "Ningún colaborador coincide con estos filtros. Cambia o quita un filtro para ver más."
msgstr "Ningún colaborador coincide con estos filtros. Cambia o quita un filtro para ver más."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Ningún colaborador coincide: no se sincronizaría a nadie."
msgstr "Ningún colaborador coincide: no se sincronizaría a nadie."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Ningún colaborador está en ese estado."
msgstr "Ningún colaborador está en ese estado."

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Ningún colaborador sin teléfono válido coincide con esos filtros."
msgstr "Ningún colaborador sin teléfono válido coincide con esos filtros."

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Ningún contacto coincide con «{search}»."
msgstr "Ningún contacto coincide con «{search}»."

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Ningún contacto tiene esa etiqueta."
msgstr "Ningún contacto tiene esa etiqueta."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Ningún contacto tiene esta etiqueta."
msgstr "Ningún contacto tiene esta etiqueta."

#: src/features/contracts/components/ContractRowList.tsx
msgid "Ningún contrato coincide"
msgstr "Ningún contrato coincide"

#: src/features/contracts/components/ContractTable.tsx
msgid "Ningún contrato coincide con esos filtros. Cambia el estado, la zona o la búsqueda."
msgstr "Ningún contrato coincide con esos filtros. Cambia el estado, la zona o la búsqueda."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Ningún contrato con estos filtros. Prueba a quitar uno."
msgstr "Ningún contrato con estos filtros. Prueba a quitar uno."

#. placeholder {0}: search.trim()
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ningún departamento ni posición coincide con «{0}». Cambia la búsqueda o agrégala."
msgstr "Ningún departamento ni posición coincide con «{0}». Cambia la búsqueda o agrégala."

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "Ningún hotel coincide con estos filtros. Cambia la búsqueda o quita un filtro."
msgstr "Ningún hotel coincide con estos filtros. Cambia la búsqueda o quita un filtro."

#: src/features/contracts/components/MissingContractsNotice.tsx
msgid "Ningún hotel coincide con la búsqueda."
msgstr "Ningún hotel coincide con la búsqueda."

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Ningún hotel con ese nombre"
msgstr "Ningún hotel con ese nombre"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Ningún hotel con ese nombre. Prueba con otra parte del nombre."
msgstr "Ningún hotel con ese nombre. Prueba con otra parte del nombre."

#. placeholder {0}: search.trim()
#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Ningún hotel de la cola se llama «{0}»"
msgstr "Ningún hotel de la cola se llama «{0}»"

#: src/features/territory/pages/TerritoryPage.tsx
msgid "Ningún hotel de tu territorio coincide con estos filtros. Cambia la búsqueda o elige otra zona."
msgstr "Ningún hotel de tu territorio coincide con estos filtros. Cambia la búsqueda o elige otra zona."

#: src/features/messaging/components/ReportParts.tsx
msgid "Ningún mensaje falló."
msgstr "Ningún mensaje falló."

#. placeholder {0}: statusLight.name
#. placeholder {1}: search.trim()
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ningún motivo de {0} coincide con «{1}»."
msgstr "Ningún motivo de {0} coincide con «{1}»."

#: src/shared/components/PhoneInput.tsx
msgid "Ningún país se llama así"
msgstr "Ningún país se llama así"

#. placeholder {0}: activeFilterLabels.join(' · ')
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Ningún prospecto coincide con {0}"
msgstr "Ningún prospecto coincide con {0}"

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Ningún prospecto llegó a Rosa todavía. Un hotel entra aquí cuando su Documento de T&C se negocia y el BD lo mueve a Rosa en el Pipeline; entonces el BDC aprueba la conversión."
msgstr "Ningún prospecto llegó a Rosa todavía. Un hotel entra aquí cuando su Documento de T&C se negocia y el BD lo mueve a Rosa en el Pipeline; entonces el BDC aprueba la conversión."

#: src/features/dashboard/components/StaleProspectList.tsx
msgid "Ningún prospecto lleva más de 7 días sin un intento de contacto."
msgstr "Ningún prospecto lleva más de 7 días sin un intento de contacto."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Ningún reactivo coincide con lo que buscas. Cambia el filtro o la búsqueda."
msgstr "Ningún reactivo coincide con lo que buscas. Cambia el filtro o la búsqueda."

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
msgid "Ningún renglón de este hotel coincide con los filtros"
msgstr "Ningún renglón de este hotel coincide con los filtros"

#. placeholder {0}: search.trim()
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ningún semáforo ni motivo coincide con «{0}». Cambia la búsqueda o agrégalo."
msgstr "Ningún semáforo ni motivo coincide con «{0}». Cambia la búsqueda o agrégalo."

#. placeholder {0}: search.trim()
#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Ningún veto es de alguien llamado «{0}». Prueba otro nombre o quita la búsqueda."
msgstr "Ningún veto es de alguien llamado «{0}». Prueba otro nombre o quita la búsqueda."

#: src/features/worker/pages/Phase3Page.tsx
msgid "Ninguna"
msgstr "Ninguna"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Ninguna campaña está en ese estado."
msgstr "Ninguna campaña está en ese estado."

#. placeholder {0}: periodLabel[period].toLowerCase()
#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Ninguna campaña salió en {0}."
msgstr "Ninguna campaña salió en {0}."

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Ninguna cuenta de hotel está de baja. Las que des de baja aparecerán aquí."
msgstr "Ninguna cuenta de hotel está de baja. Las que des de baja aparecerán aquí."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Ninguna de sus altas sigue en Blanco."
msgstr "Ninguna de sus altas sigue en Blanco."

#. placeholder {0}: search.trim()
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Ninguna etiqueta coincide con «{0}»."
msgstr "Ninguna etiqueta coincide con «{0}»."

#. placeholder {0}: search.trim()
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ninguna fila coincide con «{0}». Cambia la búsqueda o agrégala."
msgstr "Ninguna fila coincide con «{0}». Cambia la búsqueda o agrégala."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Ninguna plantilla está en ese estado."
msgstr "Ninguna plantilla está en ese estado."

#. placeholder {0}: department.name
#. placeholder {1}: search.trim()
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ninguna posición de {0} coincide con «{1}»."
msgstr "Ninguna posición de {0} coincide con «{1}»."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Ninguna posición se factura por debajo de lo que se paga"
msgstr "Ninguna posición se factura por debajo de lo que se paga"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Ninguna requisición coincide con {activeFiltersText}"
msgstr "Ninguna requisición coincide con {activeFiltersText}"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Ninguna requisición lleva más de 24 h esperando."
msgstr "Ninguna requisición lleva más de 24 h esperando."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Ninguna semana espera aprobación"
msgstr "Ninguna semana espera aprobación"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Ninguno"
msgstr "Ninguno"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Ninguno — cubre todo el hotel"
msgstr "Ninguno — cubre todo el hotel"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ninguno — fuera de Hospitality"
msgstr "Ninguno — fuera de Hospitality"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Nivel"
msgstr "Nivel"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "nivel de inglés"
msgstr "nivel de inglés"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nivel de inglés"
msgstr "Nivel de inglés"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Niveles de inglés"
msgstr "Niveles de inglés"

#: src/features/recruitment/components/PoolTable.tsx
msgid "no"
msgstr "no"

#: src/features/audits/components/AuditFormDialog.tsx
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "No"
msgstr "No"

#: src/shared/constants/contactAttempt.ts
msgid "No contestó"
msgstr "No contestó"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "No dio de alta a nadie en los últimos 30 días."
msgstr "No dio de alta a nadie en los últimos 30 días."

#: src/features/recruitment/components/ProfileProgressAvatar.tsx
msgid "No disponible por su estado"
msgstr "No disponible por su estado"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No encontramos la tabla en el PDF: hace falta una fila con los títulos de las columnas. Si es un escaneo, usa Excel o CSV."
msgstr "No encontramos la tabla en el PDF: hace falta una fila con los títulos de las columnas. Si es un escaneo, usa Excel o CSV."

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/components/ReportParts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "No entregados"
msgstr "No entregados"

#. placeholder {0}: preview.usMarketing
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "No enviar a los {0} números de EE. UU. (no les llegaría y Meta lo cuenta como fallo)."
msgstr "No enviar a los {0} números de EE. UU. (no les llegaría y Meta lo cuenta como fallo)."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No está guardada porque se creó antes. Si la necesitas, ponle una nueva con «Poner contraseña»."
msgstr "No está guardada porque se creó antes. Si la necesitas, ponle una nueva con «Poner contraseña»."

#: src/features/conversion/api/conversionApi.ts
msgid "No existe, y el contacto principal no tiene correo: agrégaselo para poder crearlo"
msgstr "No existe, y el contacto principal no tiene correo: agrégaselo para poder crearlo"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "No firmó"
msgstr "No firmó"

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "No hay consolidados con esos filtros."
msgstr "No hay consolidados con esos filtros."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "No hay deducciones de ese tipo esta semana."
msgstr "No hay deducciones de ese tipo esta semana."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "No hay facturas con esos filtros."
msgstr "No hay facturas con esos filtros."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No hay hoteles debajo de los títulos."
msgstr "No hay hoteles debajo de los títulos."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "No hay hoteles libres: todos tienen ciclo abierto"
msgstr "No hay hoteles libres: todos tienen ciclo abierto"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "No hay más personas a quien dárselo."
msgstr "No hay más personas a quien dárselo."

#: src/features/observability/components/TabParts.tsx
msgid "No hay nada que contar."
msgstr "No hay nada que contar."

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "No hay otra Líder en tu equipo a la cual moverla. Cuando des de alta a una Líder y te reporte, aparecerá aquí."
msgstr "No hay otra Líder en tu equipo a la cual moverla. Cuando des de alta a una Líder y te reporte, aparecerá aquí."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "No hay plantillas aprobadas. Sincronízalas desde Meta en la sección Plantillas."
msgstr "No hay plantillas aprobadas. Sincronízalas desde Meta en la sección Plantillas."

#: src/features/schedule/pages/SchedulePage.tsx
msgid "No hay requisiciones autorizadas para esta semana. Cuando un Manager autorice una, sus posiciones aparecerán aquí."
msgstr "No hay requisiciones autorizadas para esta semana. Cuando un Manager autorice una, sus posiciones aparecerán aquí."

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "No hay requisiciones autorizadas por ahora."
msgstr "No hay requisiciones autorizadas por ahora."

#: src/features/timesheet/components/TimesheetViewControls.tsx
#: src/features/timesheet/components/WeekSlider.tsx
msgid "No hay semanas anteriores con datos"
msgstr "No hay semanas anteriores con datos"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "No hay semanas más recientes con datos"
msgstr "No hay semanas más recientes con datos"

#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "No hay slots libres con estos filtros. La Bolsa se llena cuando un hotel crea una requisición; prueba a quitar un filtro."
msgstr "No hay slots libres con estos filtros. La Bolsa se llena cuando un hotel crea una requisición; prueba a quitar un filtro."

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "No hay solicitudes en este estado."
msgstr "No hay solicitudes en este estado."

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "No hay vetos con estos filtros. Prueba con otro origen o con el historial completo."
msgstr "No hay vetos con estos filtros. Prueba con otro origen o con el historial completo."

#: src/features/admin/components/UserFormDialog.tsx
msgid "No hay zonas en el catálogo todavía."
msgstr "No hay zonas en el catálogo todavía."

#: src/shared/constants/contactAttempt.ts
msgid "No interesado"
msgstr "No interesado"

#: src/features/worker/pages/NotificationsPage.tsx
msgid "No leído"
msgstr "No leído"

#: src/features/audits/pages/AuditsPage.tsx
msgid "No mueve ningún semáforo. Inspecciona cuando quieras antes del corte semanal — el sistema te avisa conforme se acerca."
msgstr "No mueve ningún semáforo. Inspecciona cuando quieras antes del corte semanal — el sistema te avisa conforme se acerca."

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "No paga horas extra"
msgstr "No paga horas extra"

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "No pasó la revisión."
msgstr "No pasó la revisión."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "No pudimos conectar con Oranje. Revisa tu conexión e inténtalo en un momento."
msgstr "No pudimos conectar con Oranje. Revisa tu conexión e inténtalo en un momento."

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "No pudimos pedir la eliminación. Inténtalo de nuevo."
msgstr "No pudimos pedir la eliminación. Inténtalo de nuevo."

#: src/features/observability/components/PeopleView.tsx
msgid "No registró nada en el periodo."
msgstr "No registró nada en el periodo."

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "No registró ni una marca esta semana: no hay timesheet que enviar ni aprobar."
msgstr "No registró ni una marca esta semana: no hay timesheet que enviar ni aprobar."

#: src/features/observability/lib/cohorts.ts
#: src/shared/constants/workerStatus.ts
msgid "No regresó"
msgstr "No regresó"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "No reportan a ningún Manager de Área de tu hotel."
msgstr "No reportan a ningún Manager de Área de tu hotel."

#: src/features/recruitment/components/SelfPickPositionCard.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/shared/constants/catalogs.ts
msgid "No requerido"
msgstr "No requerido"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "No salió"
msgstr "No salió"

#: src/shared/constants/workerEnums.ts
msgid "No sé"
msgstr "No sé"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "No se archiva: si algo del sistema lo está usando, la propia base lo protege y te lo dice."
msgstr "No se archiva: si algo del sistema lo está usando, la propia base lo protege y te lo dice."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "No se cerró nada esta vez."
msgstr "No se cerró nada esta vez."

#: src/features/contracts/components/MultiplierTable.tsx
msgid "No se descuenta"
msgstr "No se descuenta"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se encontró al colaborador: puede que el enlace sea viejo o que ya no esté en el Pool."
msgstr "No se encontró al colaborador: puede que el enlace sea viejo o que ya no esté en el Pool."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "No se encontró esta posición: puede que ya se haya cubierto o eliminado."
msgstr "No se encontró esta posición: puede que ya se haya cubierto o eliminado."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "No se encontró la requisición: puede que se haya eliminado o que el enlace sea viejo."
msgstr "No se encontró la requisición: puede que se haya eliminado o que el enlace sea viejo."

#. placeholder {0}: result.withoutPhone
#. placeholder {1}: result.invalidPhone + result.rejected
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "No se enviaron {skipped}: {0} sin teléfono y {1} con teléfono inválido."
msgstr "No se enviaron {skipped}: {0} sin teléfono y {1} con teléfono inválido."

#: src/features/worker/pages/PunchPage.tsx
msgid "No se guardó"
msgstr "No se guardó"

#: src/features/worker/components/MobileShell.tsx
#: src/layouts/Sidebar.tsx
msgid "No se guardó tu idioma: al volver a entrar puede regresar a español."
msgstr "No se guardó tu idioma: al volver a entrar puede regresar a español."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No se importaron"
msgstr "No se importaron"

#: src/features/admin/components/UserFormDialog.tsx
msgid "No se podrá cambiar después del alta: es el correo con el que la persona entra."
msgstr "No se podrá cambiar después del alta: es el correo con el que la persona entra."

#: src/shared/constants/workerStatus.ts
msgid "No se presentó a trabajar por su cuenta."
msgstr "No se presentó a trabajar por su cuenta."

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "No se pudieron cargar las campañas."
msgstr "No se pudieron cargar las campañas."

#: src/features/admin/components/HotelUsersSection.tsx
msgid "No se pudieron cargar las cuentas de los hoteles. Reintenta en unos segundos."
msgstr "No se pudieron cargar las cuentas de los hoteles. Reintenta en unos segundos."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "No se pudieron cargar las deducciones. Reintenta en unos segundos."
msgstr "No se pudieron cargar las deducciones. Reintenta en unos segundos."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "No se pudieron cargar las etiquetas."
msgstr "No se pudieron cargar las etiquetas."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "No se pudieron cargar las facturas. Reintenta en unos segundos."
msgstr "No se pudieron cargar las facturas. Reintenta en unos segundos."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "No se pudieron cargar las funciones adicionales."
msgstr "No se pudieron cargar las funciones adicionales."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "No se pudieron cargar las plantillas."
msgstr "No se pudieron cargar las plantillas."

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "No se pudieron cargar las propuestas. Reintenta en unos segundos."
msgstr "No se pudieron cargar las propuestas. Reintenta en unos segundos."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "No se pudieron cargar las semanas sin aprobar. Reintenta en unos segundos."
msgstr "No se pudieron cargar las semanas sin aprobar. Reintenta en unos segundos."

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "No se pudieron cargar las solicitudes."
msgstr "No se pudieron cargar las solicitudes."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "No se pudieron cargar los accesos especiales."
msgstr "No se pudieron cargar los accesos especiales."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "No se pudieron cargar los ajustes del correo."
msgstr "No se pudieron cargar los ajustes del correo."

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "No se pudieron cargar los ajustes pendientes. Reintenta en unos segundos."
msgstr "No se pudieron cargar los ajustes pendientes. Reintenta en unos segundos."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "No se pudieron cargar los ajustes. Reintenta en unos segundos."
msgstr "No se pudieron cargar los ajustes. Reintenta en unos segundos."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "No se pudieron cargar los catálogos. Reintenta en unos segundos."
msgstr "No se pudieron cargar los catálogos. Reintenta en unos segundos."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "No se pudieron cargar los colaboradores."
msgstr "No se pudieron cargar los colaboradores."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "No se pudieron cargar los consolidados. Reintenta en unos segundos."
msgstr "No se pudieron cargar los consolidados. Reintenta en unos segundos."

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "No se pudieron cargar los contactos."
msgstr "No se pudieron cargar los contactos."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "No se pudieron cargar los contratos. Reintenta en unos segundos."
msgstr "No se pudieron cargar los contratos. Reintenta en unos segundos."

#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "No se pudieron cargar los hoteles del mapa. Recarga la página para reintentar."
msgstr "No se pudieron cargar los hoteles del mapa. Recarga la página para reintentar."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "No se pudieron cargar los hoteles. Reintenta en unos segundos."
msgstr "No se pudieron cargar los hoteles. Reintenta en unos segundos."

#: src/features/observability/components/TabParts.tsx
msgid "No se pudieron cargar los indicadores."
msgstr "No se pudieron cargar los indicadores."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "No se pudieron cargar los límites de pago."
msgstr "No se pudieron cargar los límites de pago."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "No se pudieron cargar los reactivos. Reintenta en unos segundos."
msgstr "No se pudieron cargar los reactivos. Reintenta en unos segundos."

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "No se pudieron cargar los reportes."
msgstr "No se pudieron cargar los reportes."

#: src/features/admin/pages/UsersPage.tsx
msgid "No se pudieron cargar los usuarios. Reintenta en unos segundos."
msgstr "No se pudieron cargar los usuarios. Reintenta en unos segundos."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "No se pudieron guardar los límites. Inténtalo de nuevo."
msgstr "No se pudieron guardar los límites. Inténtalo de nuevo."

#: src/features/worker/pages/Phase3Page.tsx
msgid "No se pudieron guardar tus datos. Inténtalo de nuevo."
msgstr "No se pudieron guardar tus datos. Inténtalo de nuevo."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "No se pudieron sincronizar las plantillas."
msgstr "No se pudieron sincronizar las plantillas."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "No se pudieron sincronizar los colaboradores."
msgstr "No se pudieron sincronizar los colaboradores."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "No se pudo abrir DocuSign. Inténtalo de nuevo."
msgstr "No se pudo abrir DocuSign. Inténtalo de nuevo."

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "No se pudo abrir el borrador. Ciérralo e inténtalo de nuevo desde la ficha del prospecto."
msgstr "No se pudo abrir el borrador. Ciérralo e inténtalo de nuevo desde la ficha del prospecto."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "No se pudo abrir el borrador. Reintenta en unos segundos."
msgstr "No se pudo abrir el borrador. Reintenta en unos segundos."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "No se pudo abrir el documento firmado."
msgstr "No se pudo abrir el documento firmado."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "No se pudo abrir esta factura. Puede que ya no exista."
msgstr "No se pudo abrir esta factura. Puede que ya no exista."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "No se pudo abrir este consolidado. Puede que ya no exista."
msgstr "No se pudo abrir este consolidado. Puede que ya no exista."

#: src/features/worker/components/CameraCapture.tsx
#: src/features/worker/components/QrScanner.tsx
msgid "No se pudo abrir la cámara. Cierra otras apps que la usen e inténtalo de nuevo."
msgstr "No se pudo abrir la cámara. Cierra otras apps que la usen e inténtalo de nuevo."

#: src/app/RouteErrorPage.tsx
msgid "No se pudo abrir la versión nueva de Oranje. Vuelve a cargar la página; si sigue igual, cierra la pestaña y ábrela de nuevo."
msgstr "No se pudo abrir la versión nueva de Oranje. Vuelve a cargar la página; si sigue igual, cierra la pestaña y ábrela de nuevo."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "No se pudo abrir la versión. Inténtalo de nuevo."
msgstr "No se pudo abrir la versión. Inténtalo de nuevo."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo aceptar la retención. Inténtalo de nuevo."
msgstr "No se pudo aceptar la retención. Inténtalo de nuevo."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "No se pudo actualizar. Inténtalo de nuevo."
msgstr "No se pudo actualizar. Inténtalo de nuevo."

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "No se pudo actualizar. Reintenta en unos segundos."
msgstr "No se pudo actualizar. Reintenta en unos segundos."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "No se pudo agregar el turno. Inténtalo de nuevo."
msgstr "No se pudo agregar el turno. Inténtalo de nuevo."

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "No se pudo agregar la deducción. Reintenta."
msgstr "No se pudo agregar la deducción. Reintenta."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "No se pudo aprobar la conversión. Inténtalo de nuevo."
msgstr "No se pudo aprobar la conversión. Inténtalo de nuevo."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "No se pudo aprobar la factura. Reintenta."
msgstr "No se pudo aprobar la factura. Reintenta."

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "No se pudo aprobar. Inténtalo de nuevo."
msgstr "No se pudo aprobar. Inténtalo de nuevo."

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "No se pudo archivar el ciclo. Inténtalo de nuevo."
msgstr "No se pudo archivar el ciclo. Inténtalo de nuevo."

#: src/features/reports/pages/ReportsPage.tsx
msgid "No se pudo armar el reporte. Reintenta en unos segundos."
msgstr "No se pudo armar el reporte. Reintenta en unos segundos."

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "No se pudo armar este reporte. Reintenta en unos segundos."
msgstr "No se pudo armar este reporte. Reintenta en unos segundos."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "No se pudo asignar al colaborador. Inténtalo de nuevo."
msgstr "No se pudo asignar al colaborador. Inténtalo de nuevo."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "No se pudo autorizar el pago. Reintenta."
msgstr "No se pudo autorizar el pago. Reintenta."

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "No se pudo borrar el acceso en Firebase; se reintentará automáticamente."
msgstr "No se pudo borrar el acceso en Firebase; se reintentará automáticamente."

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "No se pudo borrar el archivo. Inténtalo de nuevo."
msgstr "No se pudo borrar el archivo. Inténtalo de nuevo."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo borrar el documento. Inténtalo de nuevo."
msgstr "No se pudo borrar el documento. Inténtalo de nuevo."

#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/observability/pages/ObservabilityPage.tsx
msgid "No se pudo calcular la aprobación oportuna. Reintenta en unos segundos."
msgstr "No se pudo calcular la aprobación oportuna. Reintenta en unos segundos."

#: src/layouts/RoleSwitcher.tsx
msgid "No se pudo cambiar de función. Inténtalo de nuevo."
msgstr "No se pudo cambiar de función. Inténtalo de nuevo."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "No se pudo cambiar el acceso. Inténtalo de nuevo."
msgstr "No se pudo cambiar el acceso. Inténtalo de nuevo."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "No se pudo cambiar el ajuste. Inténtalo de nuevo."
msgstr "No se pudo cambiar el ajuste. Inténtalo de nuevo."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "No se pudo cambiar el estado del contrato. Inténtalo de nuevo."
msgstr "No se pudo cambiar el estado del contrato. Inténtalo de nuevo."

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "No se pudo cambiar el estado. Inténtalo de nuevo."
msgstr "No se pudo cambiar el estado. Inténtalo de nuevo."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "No se pudo cambiar el estado. Revisa el motivo e inténtalo de nuevo."
msgstr "No se pudo cambiar el estado. Revisa el motivo e inténtalo de nuevo."

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "No se pudo cambiar la contraseña. Inténtalo de nuevo."
msgstr "No se pudo cambiar la contraseña. Inténtalo de nuevo."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "No se pudo cambiar la semana. Inténtalo de nuevo."
msgstr "No se pudo cambiar la semana. Inténtalo de nuevo."

#: src/features/worker/pages/HomePage.tsx
msgid "No se pudo cambiar tu disponibilidad. Inténtalo de nuevo."
msgstr "No se pudo cambiar tu disponibilidad. Inténtalo de nuevo."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No se pudo cambiar. Inténtalo de nuevo."
msgstr "No se pudo cambiar. Inténtalo de nuevo."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "No se pudo cancelar el envío. Inténtalo de nuevo."
msgstr "No se pudo cancelar el envío. Inténtalo de nuevo."

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "No se pudo cancelar la solicitud. Inténtalo de nuevo."
msgstr "No se pudo cancelar la solicitud. Inténtalo de nuevo."

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "No se pudo cargar Clientes Activos. Reintenta en unos segundos."
msgstr "No se pudo cargar Clientes Activos. Reintenta en unos segundos."

#: src/features/dashboard/components/HotelDashboard.tsx
#: src/features/dashboard/components/RecruitmentDashboard.tsx
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/dashboard/components/SalesDashboard.tsx
msgid "No se pudo cargar el dashboard. Reintenta en unos segundos."
msgstr "No se pudo cargar el dashboard. Reintenta en unos segundos."

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "No se pudo cargar el detalle de la plantilla."
msgstr "No se pudo cargar el detalle de la plantilla."

#: src/features/audits/components/AuditHistoryList.tsx
msgid "No se pudo cargar el historial de inspecciones. Inténtalo de nuevo."
msgstr "No se pudo cargar el historial de inspecciones. Inténtalo de nuevo."

#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "No se pudo cargar el Panel de Mensajería."
msgstr "No se pudo cargar el Panel de Mensajería."

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "No se pudo cargar el Pipeline. Reintenta en unos segundos."
msgstr "No se pudo cargar el Pipeline. Reintenta en unos segundos."

#: src/features/audits/components/AuditWorkerList.tsx
msgid "No se pudo cargar el plantel del hotel. Inténtalo de nuevo."
msgstr "No se pudo cargar el plantel del hotel. Inténtalo de nuevo."

#: src/features/recruitment/pages/PoolPage.tsx
msgid "No se pudo cargar el Pool de Colaboradores. Revisa tu conexión e inténtalo de nuevo."
msgstr "No se pudo cargar el Pool de Colaboradores. Revisa tu conexión e inténtalo de nuevo."

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "No se pudo cargar el QR. Inténtalo de nuevo."
msgstr "No se pudo cargar el QR. Inténtalo de nuevo."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "No se pudo cargar el reporte."
msgstr "No se pudo cargar el reporte."

#: src/features/schedule/pages/SchedulePage.tsx
msgid "No se pudo cargar el Schedule. Revisa tu conexión e inténtalo de nuevo."
msgstr "No se pudo cargar el Schedule. Revisa tu conexión e inténtalo de nuevo."

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "No se pudo cargar el Tablero de Requisiciones. Revisa tu conexión e inténtalo de nuevo."
msgstr "No se pudo cargar el Tablero de Requisiciones. Revisa tu conexión e inténtalo de nuevo."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "No se pudo cargar el Timesheet. Reintenta en unos segundos."
msgstr "No se pudo cargar el Timesheet. Reintenta en unos segundos."

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "No se pudo cargar la bitácora. Inténtalo de nuevo."
msgstr "No se pudo cargar la bitácora. Inténtalo de nuevo."

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "No se pudo cargar la Blacklist. Revisa tu conexión e inténtalo de nuevo."
msgstr "No se pudo cargar la Blacklist. Revisa tu conexión e inténtalo de nuevo."

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "No se pudo cargar la Bolsa de Self-Pick. Revisa tu conexión e inténtalo de nuevo."
msgstr "No se pudo cargar la Bolsa de Self-Pick. Revisa tu conexión e inténtalo de nuevo."

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "No se pudo cargar la cola de Conversión. Reintenta en unos segundos."
msgstr "No se pudo cargar la cola de Conversión. Reintenta en unos segundos."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "No se pudo cargar la conversión de este hotel. Recarga la página para reintentar."
msgstr "No se pudo cargar la conversión de este hotel. Recarga la página para reintentar."

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "No se pudo cargar la lista de colaboradores."
msgstr "No se pudo cargar la lista de colaboradores."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "No se pudo cargar la lista de correos corporativos."
msgstr "No se pudo cargar la lista de correos corporativos."

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "No se pudo cargar la lista."
msgstr "No se pudo cargar la lista."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "No se pudo cargar la propuesta de este hotel."
msgstr "No se pudo cargar la propuesta de este hotel."

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "No se pudo cargar la semana del Timesheet Global. Reintenta en unos segundos."
msgstr "No se pudo cargar la semana del Timesheet Global. Reintenta en unos segundos."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "No se pudo cargar la semana del Timesheet. Reintenta en unos segundos."
msgstr "No se pudo cargar la semana del Timesheet. Reintenta en unos segundos."

#: src/features/team/pages/RecruitmentTeamPage.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "No se pudo cargar Mi Equipo. Reintenta en unos segundos."
msgstr "No se pudo cargar Mi Equipo. Reintenta en unos segundos."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "No se pudo cargar Mi Personal. Revisa tu conexión e inténtalo de nuevo."
msgstr "No se pudo cargar Mi Personal. Revisa tu conexión e inténtalo de nuevo."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No se pudo cargar su acceso."
msgstr "No se pudo cargar su acceso."

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/team/pages/HotelTeamPage.tsx
msgid "No se pudo cargar tu equipo. Reintenta en unos segundos."
msgstr "No se pudo cargar tu equipo. Reintenta en unos segundos."

#: src/features/territory/pages/TerritoryPage.tsx
msgid "No se pudo cargar tu territorio. Reintenta."
msgstr "No se pudo cargar tu territorio. Reintenta."

#: src/features/worker/pages/PunchPage.tsx
msgid "No se pudo cargar tu turno."
msgstr "No se pudo cargar tu turno."

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "No se pudo cerrar la semana. Reintenta."
msgstr "No se pudo cerrar la semana. Reintenta."

#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "No se pudo completar la acción."
msgstr "No se pudo completar la acción."

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "No se pudo completar la eliminación. Inténtalo de nuevo."
msgstr "No se pudo completar la eliminación. Inténtalo de nuevo."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "No se pudo completar la operación. Inténtalo de nuevo."
msgstr "No se pudo completar la operación. Inténtalo de nuevo."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "No se pudo copiar. Anótalo a mano."
msgstr "No se pudo copiar. Anótalo a mano."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "No se pudo corregir el intento. Solo su autor puede hacerlo."
msgstr "No se pudo corregir el intento. Solo su autor puede hacerlo."

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "No se pudo corregir la marca. Inténtalo de nuevo."
msgstr "No se pudo corregir la marca. Inténtalo de nuevo."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "No se pudo crear el acceso. Inténtalo de nuevo."
msgstr "No se pudo crear el acceso. Inténtalo de nuevo."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "No se pudo crear el contrato. Revisa los datos e inténtalo de nuevo."
msgstr "No se pudo crear el contrato. Revisa los datos e inténtalo de nuevo."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "No se pudo crear la campaña."
msgstr "No se pudo crear la campaña."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "No se pudo crear la cuenta del hotel. Inténtalo de nuevo."
msgstr "No se pudo crear la cuenta del hotel. Inténtalo de nuevo."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "No se pudo crear la cuenta. Inténtalo de nuevo."
msgstr "No se pudo crear la cuenta. Inténtalo de nuevo."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "No se pudo crear la etiqueta."
msgstr "No se pudo crear la etiqueta."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "No se pudo crear la lista."
msgstr "No se pudo crear la lista."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "No se pudo dar el acceso. Inténtalo de nuevo."
msgstr "No se pudo dar el acceso. Inténtalo de nuevo."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "No se pudo dar la función. Inténtalo de nuevo."
msgstr "No se pudo dar la función. Inténtalo de nuevo."

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "No se pudo desbloquear. Inténtalo de nuevo."
msgstr "No se pudo desbloquear. Inténtalo de nuevo."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "No se pudo descargar el CSV."
msgstr "No se pudo descargar el CSV."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "No se pudo descartar el borrador. Inténtalo de nuevo."
msgstr "No se pudo descartar el borrador. Inténtalo de nuevo."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "No se pudo devolver a Café. Inténtalo de nuevo."
msgstr "No se pudo devolver a Café. Inténtalo de nuevo."

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "No se pudo eliminar al colaborador. Inténtalo de nuevo."
msgstr "No se pudo eliminar al colaborador. Inténtalo de nuevo."

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "No se pudo eliminar el hotel. Reintenta."
msgstr "No se pudo eliminar el hotel. Reintenta."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "No se pudo eliminar la etiqueta."
msgstr "No se pudo eliminar la etiqueta."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "No se pudo eliminar la requisición. Inténtalo de nuevo."
msgstr "No se pudo eliminar la requisición. Inténtalo de nuevo."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
msgid "No se pudo eliminar. Inténtalo de nuevo."
msgstr "No se pudo eliminar. Inténtalo de nuevo."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "No se pudo enviar la campaña."
msgstr "No se pudo enviar la campaña."

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "No se pudo generar el PDF. Inténtalo de nuevo."
msgstr "No se pudo generar el PDF. Inténtalo de nuevo."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo generar la vista previa — el enlace firmado venció. Cierra y vuelve a abrir el expediente."
msgstr "No se pudo generar la vista previa — el enlace firmado venció. Cierra y vuelve a abrir el expediente."

#: src/mobile/nativeDownloads.ts
msgid "No se pudo guardar el archivo. Inténtalo de nuevo."
msgstr "No se pudo guardar el archivo. Inténtalo de nuevo."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "No se pudo guardar el colaborador. Revisa los datos e inténtalo de nuevo."
msgstr "No se pudo guardar el colaborador. Revisa los datos e inténtalo de nuevo."

#: src/features/messaging/components/ContactActions.tsx
msgid "No se pudo guardar el contacto."
msgstr "No se pudo guardar el contacto."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "No se pudo guardar el contacto. Revisa los datos e inténtalo de nuevo."
msgstr "No se pudo guardar el contacto. Revisa los datos e inténtalo de nuevo."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "No se pudo guardar el nuevo orden: vuelve a intentarlo."
msgstr "No se pudo guardar el nuevo orden: vuelve a intentarlo."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "No se pudo guardar el prospecto. Revisa los datos e inténtalo de nuevo."
msgstr "No se pudo guardar el prospecto. Revisa los datos e inténtalo de nuevo."

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "No se pudo guardar el territorio. Inténtalo de nuevo."
msgstr "No se pudo guardar el territorio. Inténtalo de nuevo."

#: src/features/worker/pages/Phase2Page.tsx
msgid "No se pudo guardar el transporte."
msgstr "No se pudo guardar el transporte."

#: src/features/admin/components/UserFormDialog.tsx
msgid "No se pudo guardar el usuario. Revisa los datos e inténtalo de nuevo."
msgstr "No se pudo guardar el usuario. Revisa los datos e inténtalo de nuevo."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "No se pudo guardar la corrección."
msgstr "No se pudo guardar la corrección."

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "No se pudo guardar la cuenta. Revisa los datos e inténtalo de nuevo."
msgstr "No se pudo guardar la cuenta. Revisa los datos e inténtalo de nuevo."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "No se pudo guardar la inspección. Inténtalo de nuevo."
msgstr "No se pudo guardar la inspección. Inténtalo de nuevo."

#: src/features/worker/pages/PunchPage.tsx
msgid "No se pudo guardar la marca. Inténtalo de nuevo."
msgstr "No se pudo guardar la marca. Inténtalo de nuevo."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "No se pudo guardar la propuesta. Revisa las tarifas e inténtalo de nuevo."
msgstr "No se pudo guardar la propuesta. Revisa las tarifas e inténtalo de nuevo."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "No se pudo guardar la requisición. Revisa las posiciones e inténtalo de nuevo."
msgstr "No se pudo guardar la requisición. Revisa las posiciones e inténtalo de nuevo."

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "No se pudo guardar la revisión. Inténtalo de nuevo."
msgstr "No se pudo guardar la revisión. Inténtalo de nuevo."

#: src/features/contracts/components/EditRateDialog.tsx
msgid "No se pudo guardar la tarifa. Inténtalo de nuevo."
msgstr "No se pudo guardar la tarifa. Inténtalo de nuevo."

#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "No se pudo guardar. Inténtalo de nuevo."
msgstr "No se pudo guardar. Inténtalo de nuevo."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "No se pudo guardar. Revisa el nombre e inténtalo de nuevo."
msgstr "No se pudo guardar. Revisa el nombre e inténtalo de nuevo."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "No se pudo guardar. Revisa los campos e inténtalo de nuevo."
msgstr "No se pudo guardar. Revisa los campos e inténtalo de nuevo."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "No se pudo importar el archivo."
msgstr "No se pudo importar el archivo."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No se pudo importar esta fila"
msgstr "No se pudo importar esta fila"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No se pudo importar. Inténtalo de nuevo."
msgstr "No se pudo importar. Inténtalo de nuevo."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
#: src/features/timesheet/components/PendingAdjustmentsChip.tsx
msgid "No se pudo incluir. Inténtalo de nuevo."
msgstr "No se pudo incluir. Inténtalo de nuevo."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "No se pudo leer el archivo."
msgstr "No se pudo leer el archivo."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "No se pudo leer el archivo. Revisa que no esté dañado ni protegido con contraseña."
msgstr "No se pudo leer el archivo. Revisa que no esté dañado ni protegido con contraseña."

#: src/features/worker/pages/PunchPage.tsx
msgid "No se pudo leer tu ubicación. Sal a cielo abierto e inténtalo de nuevo."
msgstr "No se pudo leer tu ubicación. Sal a cielo abierto e inténtalo de nuevo."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "No se pudo levantar el veto. Inténtalo de nuevo."
msgstr "No se pudo levantar el veto. Inténtalo de nuevo."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "No se pudo liberar el slot. Inténtalo de nuevo."
msgstr "No se pudo liberar el slot. Inténtalo de nuevo."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "No se pudo mandar a firma. Inténtalo de nuevo."
msgstr "No se pudo mandar a firma. Inténtalo de nuevo."

#: src/features/personnel/components/StandByDialog.tsx
msgid "No se pudo mandar a Stand-by. Inténtalo de nuevo."
msgstr "No se pudo mandar a Stand-by. Inténtalo de nuevo."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "No se pudo mandar el correo — inténtalo de nuevo o mándalo tú aparte."
msgstr "No se pudo mandar el correo — inténtalo de nuevo o mándalo tú aparte."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "No se pudo mandar el correo."
msgstr "No se pudo mandar el correo."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "No se pudo mandar la plantilla a Meta."
msgstr "No se pudo mandar la plantilla a Meta."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "No se pudo marcar como enviado. Reintenta en unos segundos."
msgstr "No se pudo marcar como enviado. Reintenta en unos segundos."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "No se pudo marcar como revisado. Reintenta."
msgstr "No se pudo marcar como revisado. Reintenta."

#: src/features/timesheet/components/AttendanceView.tsx
msgid "No se pudo marcar el día. Reintenta."
msgstr "No se pudo marcar el día. Reintenta."

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "No se pudo marcar el teléfono en la plataforma de mensajes; se reintentará automáticamente."
msgstr "No se pudo marcar el teléfono en la plataforma de mensajes; se reintentará automáticamente."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No se pudo mostrar. Inténtalo de nuevo."
msgstr "No se pudo mostrar. Inténtalo de nuevo."

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "No se pudo mover. Reintenta en unos segundos."
msgstr "No se pudo mover. Reintenta en unos segundos."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "No se pudo programar la campaña."
msgstr "No se pudo programar la campaña."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "No se pudo quitar el acceso. Inténtalo de nuevo."
msgstr "No se pudo quitar el acceso. Inténtalo de nuevo."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "No se pudo quitar la corrección."
msgstr "No se pudo quitar la corrección."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "No se pudo quitar la deducción. Reintenta."
msgstr "No se pudo quitar la deducción. Reintenta."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "No se pudo quitar la función. Inténtalo de nuevo."
msgstr "No se pudo quitar la función. Inténtalo de nuevo."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo quitar la retención. Inténtalo de nuevo."
msgstr "No se pudo quitar la retención. Inténtalo de nuevo."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "No se pudo recalcular la factura. Reintenta."
msgstr "No se pudo recalcular la factura. Reintenta."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo rechazar el documento. Inténtalo de nuevo."
msgstr "No se pudo rechazar el documento. Inténtalo de nuevo."

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "No se pudo rechazar. Inténtalo de nuevo."
msgstr "No se pudo rechazar. Inténtalo de nuevo."

#: src/features/admin/components/UserFormDialog.tsx
msgid "No se pudo reenviar la invitación. Inténtalo de nuevo."
msgstr "No se pudo reenviar la invitación. Inténtalo de nuevo."

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "No se pudo regenerar el QR. Inténtalo de nuevo."
msgstr "No se pudo regenerar el QR. Inténtalo de nuevo."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "No se pudo registrar el cobro. Reintenta."
msgstr "No se pudo registrar el cobro. Reintenta."

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "No se pudo registrar el envío. Reintenta."
msgstr "No se pudo registrar el envío. Reintenta."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "No se pudo registrar el intento. Revisa los datos e inténtalo de nuevo."
msgstr "No se pudo registrar el intento. Revisa los datos e inténtalo de nuevo."

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "No se pudo registrar el pago. Reintenta."
msgstr "No se pudo registrar el pago. Reintenta."

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "No se pudo registrar el veto. Revisa que la persona no esté en Gris ni tenga ya un veto vigente, e inténtalo de nuevo."
msgstr "No se pudo registrar el veto. Revisa que la persona no esté en Gris ni tenga ya un veto vigente, e inténtalo de nuevo."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "No se pudo registrar la marca. Inténtalo de nuevo."
msgstr "No se pudo registrar la marca. Inténtalo de nuevo."

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "No se pudo renombrar el archivo. Inténtalo de nuevo."
msgstr "No se pudo renombrar el archivo. Inténtalo de nuevo."

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "No se pudo reportar al colaborador. Inténtalo de nuevo."
msgstr "No se pudo reportar al colaborador. Inténtalo de nuevo."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "No se pudo revisar la campaña antes de enviarla."
msgstr "No se pudo revisar la campaña antes de enviarla."

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "No se pudo subir el archivo. Inténtalo de nuevo."
msgstr "No se pudo subir el archivo. Inténtalo de nuevo."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo subir el documento. Inténtalo de nuevo."
msgstr "No se pudo subir el documento. Inténtalo de nuevo."

#: src/features/admin/components/UserFormDialog.tsx
msgid "No se pudo subir la foto. Intenta con otra imagen."
msgstr "No se pudo subir la foto. Intenta con otra imagen."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "No se pudo subir la foto. Revisa tu conexión e inténtalo de nuevo."
msgstr "No se pudo subir la foto. Revisa tu conexión e inténtalo de nuevo."

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "No se pudo subir tu documento. Inténtalo de nuevo."
msgstr "No se pudo subir tu documento. Inténtalo de nuevo."

#: src/features/worker/components/PhotoUploader.tsx
msgid "No se pudo subir tu foto. Inténtalo de nuevo."
msgstr "No se pudo subir tu foto. Inténtalo de nuevo."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "No se pudo tomar la requisición. Inténtalo de nuevo."
msgstr "No se pudo tomar la requisición. Inténtalo de nuevo."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No se pudo verificar el documento. Inténtalo de nuevo."
msgstr "No se pudo verificar el documento. Inténtalo de nuevo."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "No se puede activar sin tarifas: agrega al menos una."
msgstr "No se puede activar sin tarifas: agrega al menos una."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "No se puede calificar una inspección donde todo quedó en N/A."
msgstr "No se puede calificar una inspección donde todo quedó en N/A."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No se puede leer la guardada. Ponle una nueva."
msgstr "No se puede leer la guardada. Ponle una nueva."

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "No se pueden sincronizar, así que no les llegan las campañas. Corrige su teléfono en su expediente y vuelve a sincronizar."
msgstr "No se pueden sincronizar, así que no les llegan las campañas. Corrige su teléfono en su expediente y vuelve a sincronizar."

#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "No se registró entrada ni salida. Puede ser que no tuviera turno ese día, o que el ponche no llegara a guardarse (por ejemplo, fuera de la geocerca). Revisa el Schedule para saber cuál de las dos fue."
msgstr "No se registró entrada ni salida. Puede ser que no tuviera turno ese día, o que el ponche no llegara a guardarse (por ejemplo, fuera de la geocerca). Revisa el Schedule para saber cuál de las dos fue."

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "No se sincronizan con Mensajería, así que ninguna campaña les llega. Corrige el teléfono en su expediente."
msgstr "No se sincronizan con Mensajería, así que ninguna campaña les llega. Corrige el teléfono en su expediente."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "No sirve (ilegible, incorrecto…): se le vuelve a pedir al colaborador."
msgstr "No sirve (ilegible, incorrecto…): se le vuelve a pedir al colaborador."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "No tiene correo @oranjepeople.com."
msgstr "No tiene correo @oranjepeople.com."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "No tiene fecha de fin: rige hasta que alguien lo marque expirado."
msgstr "No tiene fecha de fin: rige hasta que alguien lo marque expirado."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "No tiene servidor de correo configurado, así que todo sale por Firebase. El interruptor de abajo no cambia nada hasta que se configure."
msgstr "No tiene servidor de correo configurado, así que todo sale por Firebase. El interruptor de abajo no cambia nada hasta que se configure."

#: src/features/worker/pages/Phase2Page.tsx
msgid "No tienes nada pendiente aquí. Esto es lo que quedó registrado; si algo cambió, corrígelo."
msgstr "No tienes nada pendiente aquí. Esto es lo que quedó registrado; si algo cambió, corrígelo."

#: src/features/worker/lib/noShiftMessage.ts
msgid "No tienes turno programado hoy. Si sí te tocaba, avísale a tu Supervisor para que revise el Schedule."
msgstr "No tienes turno programado hoy. Si sí te tocaba, avísale a tu Supervisor para que revise el Schedule."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "no va con su otra función"
msgstr "no va con su otra función"

#: src/features/worker/components/useFaceGuide.ts
msgid "No vemos tu cara: mira a la cámara"
msgstr "No vemos tu cara: mira a la cámara"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "No-show del día 1"
msgstr "No-show del día 1"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "No, dejarlo"
msgstr "No, dejarlo"

#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/features/onboarding/components/PlacesAutofillSummary.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/worker/pages/Phase3Page.tsx
msgid "Nombre"
msgstr "Nombre"

#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Nombre *"
msgstr "Nombre *"

#: src/features/clients/types/client.types.ts
msgid "nombre A–Z"
msgstr "nombre A–Z"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/contracts/components/SignAndSendDialog.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Nombre completo"
msgstr "Nombre completo"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Nombre completo del contacto"
msgstr "Nombre completo del contacto"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre de la industria, p. ej. Retail…"
msgstr "Nombre de la industria, p. ej. Retail…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre de la modalidad, p. ej. Tiempo completo…"
msgstr "Nombre de la modalidad, p. ej. Tiempo completo…"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Nombre de la persona…"
msgstr "Nombre de la persona…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre de la posición, p. ej. Steward…"
msgstr "Nombre de la posición, p. ej. Steward…"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Nombre de la propiedad"
msgstr "Nombre de la propiedad"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre de la zona, p. ej. Riviera Maya…"
msgstr "Nombre de la zona, p. ej. Riviera Maya…"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Nombre del archivo"
msgstr "Nombre del archivo"

#: src/features/team/pages/TeamPage.tsx
msgid "Nombre del BD, p. ej. Rocío Lima…"
msgstr "Nombre del BD, p. ej. Rocío Lima…"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Nombre del colaborador"
msgstr "Nombre del colaborador"

#: src/features/admin/pages/CorporateEmailPage.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Nombre del colaborador, p. ej. Ana Rivera…"
msgstr "Nombre del colaborador, p. ej. Ana Rivera…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre del concepto, p. ej. Uber…"
msgstr "Nombre del concepto, p. ej. Uber…"

#: src/features/messaging/components/CreateCampaignDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Nombre del contacto"
msgstr "Nombre del contacto"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nombre del contacto de emergencia"
msgstr "Nombre del contacto de emergencia"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre del estado, p. ej. Descanso…"
msgstr "Nombre del estado, p. ej. Descanso…"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/shared/lib/contractClauses.ts
msgid "Nombre del hotel"
msgstr "Nombre del hotel"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Nombre del hotel en el documento"
msgstr "Nombre del hotel en el documento"

#: src/features/clients/components/ClientFilters.tsx
#: src/features/conversion/pages/ConversionQueuePage.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
#: src/features/territory/pages/TerritoryPage.tsx
msgid "Nombre del hotel, p. ej. Puerto Real…"
msgstr "Nombre del hotel, p. ej. Puerto Real…"

#: src/features/contracts/components/MissingContractsNotice.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Nombre del hotel…"
msgstr "Nombre del hotel…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre del motivo, p. ej. Se mudó…"
msgstr "Nombre del motivo, p. ej. Se mudó…"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Nombre del nivel, p. ej. Conversacional…"
msgstr "Nombre del nivel, p. ej. Conversacional…"

#: src/shared/lib/contractClauses.ts
msgid "Nombre del proveedor"
msgstr "Nombre del proveedor"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Nombre en la firma de Oranje"
msgstr "Nombre en la firma de Oranje"

#: src/features/admin/pages/UsersPage.tsx
msgid "Nombre o correo, p. ej. Ana López…"
msgstr "Nombre o correo, p. ej. Ana López…"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Nombre o correo, p. ej. Ana Rivera…"
msgstr "Nombre o correo, p. ej. Ana Rivera…"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Nombre o teléfono…"
msgstr "Nombre o teléfono…"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Nombre o zona, p. ej. Puerto Real…"
msgstr "Nombre o zona, p. ej. Puerto Real…"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Nombre o zona…"
msgstr "Nombre o zona…"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Nombre y puesto de quien envía"
msgstr "Nombre y puesto de quien envía"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Nombre, correo u hotel, p. ej. Xcaret…"
msgstr "Nombre, correo u hotel, p. ej. Xcaret…"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Nombre, p. ej. Alejandra Cohuo…"
msgstr "Nombre, p. ej. Alejandra Cohuo…"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Nombre, p. ej. Alma Torres…"
msgstr "Nombre, p. ej. Alma Torres…"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nombre, p. ej. Rubén Sandoval"
msgstr "Nombre, p. ej. Rubén Sandoval"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "nombre@hotel.mx"
msgstr "nombre@hotel.mx"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "nombre@oranjepeople.com"
msgstr "nombre@oranjepeople.com"

#: src/shared/constants/requisitionStatus.ts
msgid "Normal"
msgstr "Normal"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Nota"
msgstr "Nota"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/components/StandByDialog.tsx
msgid "Nota (opcional)"
msgstr "Nota (opcional)"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Nota <0>(opcional)</0>"
msgstr "Nota <0>(opcional)</0>"

#: src/features/team/pages/TeamPage.tsx
msgid "Nota al BD"
msgstr "Nota al BD"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Nota de la deducción"
msgstr "Nota de la deducción"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Nota de revisión"
msgstr "Nota de revisión"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Nota de revisión <0>(obligatoria)</0>"
msgstr "Nota de revisión <0>(obligatoria)</0>"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Nota del cierre"
msgstr "Nota del cierre"

#: src/shared/components/SendDocumentModal.tsx
msgid "Nota para el hotel"
msgstr "Nota para el hotel"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Notas"
msgstr "Notas"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "notas de crédito"
msgstr "notas de crédito"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Notas médicas"
msgstr "Notas médicas"

#: src/layouts/Header.tsx
msgid "Notificaciones"
msgstr "Notificaciones"

#. placeholder {0}: String(unread)
#: src/layouts/Header.tsx
msgid "Notificaciones: {0} sin leer"
msgstr "Notificaciones: {0} sin leer"

#: src/layouts/Header.tsx
msgid "Notificaciones: nada nuevo"
msgstr "Notificaciones: nada nuevo"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Nuestras plantillas, remitente @oranjepeople.com."
msgstr "Nuestras plantillas, remitente @oranjepeople.com."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Nuestro equipo de reclutamiento ya está buscando a {total, plural, one {la persona que pediste} other {las # personas que pediste}}."
msgstr "Nuestro equipo de reclutamiento ya está buscando a {total, plural, one {la persona que pediste} other {las # personas que pediste}}."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Nueva campaña"
msgstr "Nueva campaña"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Nueva cuenta del hotel"
msgstr "Nueva cuenta del hotel"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Nueva etiqueta"
msgstr "Nueva etiqueta"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Nueva plantilla"
msgstr "Nueva plantilla"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Nueva requisición"
msgstr "Nueva requisición"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Nueva versión (v{nextVersion})"
msgstr "Nueva versión (v{nextVersion})"

#: src/features/clients/components/ClientSpotlightCard.tsx
#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "Nuevo"
msgstr "Nuevo"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Nuevo colaborador"
msgstr "Nuevo colaborador"

#: src/features/messaging/components/ContactActions.tsx
msgid "Nuevo contacto"
msgstr "Nuevo contacto"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Nuevo contrato"
msgstr "Nuevo contrato"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Nuevo estado"
msgstr "Nuevo estado"

#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Nuevo prospecto"
msgstr "Nuevo prospecto"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Nuevo usuario"
msgstr "Nuevo usuario"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Nuevos"
msgstr "Nuevos"

#: src/features/contracts/components/ContractTable.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Número"
msgstr "Número"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "o"
msgstr "o"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "o acepta la retención del 16% y no lo pidas"
msgstr "o acepta la retención del 16% y no lo pidas"

#: src/features/messaging/components/tours.ts
msgid "O agrégalos uno por uno"
msgstr "O agrégalos uno por uno"

#: src/shared/constants/workerEnums.ts
msgid "O+"
msgstr "O+"

#: src/shared/constants/workerEnums.ts
msgid "O−"
msgstr "O−"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "obligatoria"
msgstr "obligatoria"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "obligatorio"
msgstr "obligatorio"

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Observaciones generales <0>(opcional)</0>"
msgstr "Observaciones generales <0>(opcional)</0>"

#: src/shared/constants/timesheetStatus.ts
msgid "Observado"
msgstr "Observado"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "observados"
msgstr "observados"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Ocho caracteres: seis letras y dos números. Si el correo la rechaza por débil, se pone una de 16."
msgstr "Ocho caracteres: seis letras y dos números. Si el correo la rechaza por débil, se pone una de 16."

#: src/features/auth/pages/LoginPage.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Ocultar contraseña"
msgstr "Ocultar contraseña"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "ocupado"
msgstr "ocupado"

#: src/features/requisitions/components/SlotList.tsx
msgid "Ocupado"
msgstr "Ocupado"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "OFF"
msgstr "OFF"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Ojo: el {activeContractNumber} sigue vigente para este hotel — solo puede haber uno activo, así que al activar este hay que expirar aquel."
msgstr "Ojo: el {activeContractNumber} sigue vigente para este hotel — solo puede haber uno activo, así que al activar este hay que expirar aquel."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Omitidos"
msgstr "Omitidos"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
#: src/features/worker/pages/Phase2Page.tsx
msgid "opcional"
msgstr "opcional"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Opcional — solo si el hotel pertenece a una cadena o lo administra otra empresa"
msgstr "Opcional — solo si el hotel pertenece a una cadena o lo administra otra empresa"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Opcional, y las dos pueden ir juntas: cada una la aprueba el Manager de QA por separado antes de que pese en el pago."
msgstr "Opcional, y las dos pueden ir juntas: cada una la aprueba el Manager de QA por separado antes de que pese en el pago."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Opcional: en una visita en frío puedes no encontrar a nadie"
msgstr "Opcional: en una visita en frío puedes no encontrar a nadie"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Opcional: lo completa el colaborador desde su app, pero si ya lo tienes, captúralo aquí y podrás validarlo sin esperar."
msgstr "Opcional: lo completa el colaborador desde su app, pero si ya lo tienes, captúralo aquí y podrás validarlo sin esperar."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Opcional: puedes agregarla después desde el Pool"
msgstr "Opcional: puedes agregarla después desde el Pool"

#: src/shared/constants/roles.ts
msgid "Operador de QA"
msgstr "Operador de QA"

#: src/features/contracts/components/ContractSignatureCard.tsx
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
msgid "Oranje"
msgstr "Oranje"

#: src/features/requisitions/components/SlotList.tsx
msgid "Oranje está buscando a alguien"
msgstr "Oranje está buscando a alguien"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Oranje la está cubriendo"
msgstr "Oranje la está cubriendo"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Oranje ya lo cubrió y el colaborador pidió que se le descontara: el monto se resta de lo que recibe esta semana, como una deducción más."
msgstr "Oranje ya lo cubrió y el colaborador pidió que se le descontara: el monto se resta de lo que recibe esta semana, como una deducción más."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Oranje ya recibió tu requisición"
msgstr "Oranje ya recibió tu requisición"

#: src/features/clients/components/ClientFilters.tsx
msgid "Ordenar"
msgstr "Ordenar"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Origen"
msgstr "Origen"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Otra deducción"
msgstr "Otra deducción"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Otra persona acaba de asignar a {nombreElegido}. Elige a alguien más."
msgstr "Otra persona acaba de asignar a {nombreElegido}. Elige a alguien más."

#. placeholder {0}: IS_DEV_UI ? ' (RR-15)' : ''
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Otra Reclutadora tomó este slot antes{0}: el tablero ya se actualizó, revisa el siguiente libre."
msgstr "Otra Reclutadora tomó este slot antes{0}: el tablero ya se actualizó, revisa el siguiente libre."

#: src/features/observability/lib/cohorts.ts
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/shared/constants/workerEnums.ts
msgid "Otro"
msgstr "Otro"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Otro clic lo borra definitivamente"
msgstr "Otro clic lo borra definitivamente"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "otro estado"
msgstr "otro estado"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "otro rol"
msgstr "otro rol"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Otros documentos"
msgstr "Otros documentos"

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Overtime"
msgstr "Overtime"

#: src/features/contracts/components/ContractTable.tsx
msgid "Overtime · Festivo"
msgstr "Overtime · Festivo"

#. placeholder {0}: overtime.pay.toFixed(2)
#. placeholder {1}: overtime.bill.toFixed(2)
#. placeholder {2}: holiday.pay.toFixed(2)
#. placeholder {3}: holiday.bill.toFixed(2)
#: src/features/contracts/components/ContractChecklist.tsx
msgid "Overtime {0}× / {1}× · Festivo {2}× / {3}× (pago / factura). El de factura nunca va por debajo del de pago."
msgstr "Overtime {0}× / {1}× · Festivo {2}× / {3}× (pago / factura). El de factura nunca va por debajo del de pago."

#: src/features/contracts/components/MultiplierTable.tsx
msgid "Overtime y día festivo según el contrato (mínimo 1.00×)"
msgstr "Overtime y día festivo según el contrato (mínimo 1.00×)"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Overtime y festivo no comen el margen"
msgstr "Overtime y festivo no comen el margen"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "P. ej. «Abandonó el turno sin aviso en dos ocasiones.»"
msgstr "P. ej. «Abandonó el turno sin aviso en dos ocasiones.»"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "P. ej. «Acuerdo con el hotel; reincorporación autorizada por el Manager de Reclutamiento.»"
msgstr "P. ej. «Acuerdo con el hotel; reincorporación autorizada por el Manager de Reclutamiento.»"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "P. ej. Steward"
msgstr "P. ej. Steward"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "P. ej. Uniforme completo, limpio y planchado"
msgstr "P. ej. Uniforme completo, limpio y planchado"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "P. ej. Uniformidad"
msgstr "P. ej. Uniformidad"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Pacífico — Los Ángeles, Las Vegas"
msgstr "Pacífico — Los Ángeles, Las Vegas"

#: src/shared/constants/workerEnums.ts
msgid "Padre"
msgstr "Padre"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Paga las horas aprobadas de este hotel esta semana"
msgstr "Paga las horas aprobadas de este hotel esta semana"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Paga las horas ya aprobadas de {hotelName} esta semana."
msgstr "Paga las horas ya aprobadas de {hotelName} esta semana."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Paga lo que se aprobó después del corte del miércoles."
msgstr "Paga lo que se aprobó después del corte del miércoles."

#: src/features/accounting/types/settlement.constants.ts
msgid "Pagada"
msgstr "Pagada"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Pagada la registra Contabilidad"
msgstr "Pagada la registra Contabilidad"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Pagada. Estado terminal."
msgstr "Pagada. Estado terminal."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/types/settlement.constants.ts
#: src/features/observability/lib/inspectionKpis.ts
msgid "Pagado"
msgstr "Pagado"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Pagado. Estado terminal."
msgstr "Pagado. Estado terminal."

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "Pagar"
msgstr "Pagar"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Pagar seleccionados"
msgstr "Pagar seleccionados"

#. placeholder {0}: data.meta.page
#. placeholder {0}: data.pagination.page
#. placeholder {1}: data.meta.totalPages
#. placeholder {1}: data.pagination.totalPages
#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/ContactImportsDialog.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Página {0} de {1}"
msgstr "Página {0} de {1}"

#: src/features/messaging/components/Pager.tsx
#: src/shared/components/CardPagination.tsx
msgid "Página {page} de {totalPages}"
msgstr "Página {page} de {totalPages}"

#: src/features/messaging/components/Pager.tsx
msgid "Página anterior"
msgstr "Página anterior"

#: src/features/messaging/components/Pager.tsx
msgid "Página siguiente"
msgstr "Página siguiente"

#: src/features/messaging/components/Pager.tsx
#: src/shared/components/CardPagination.tsx
msgid "Paginación"
msgstr "Paginación"

#. placeholder {0}: ONBOARDING_STATUS_LABEL[status]
#. placeholder {0}: department.name
#. placeholder {0}: items[0]?.category ?? ''
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/onboarding/components/PipelineColumn.tsx
msgid "Páginas de {0}"
msgstr "Páginas de {0}"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Páginas de correos corporativos"
msgstr "Páginas de correos corporativos"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Páginas de cuentas de colaboradores"
msgstr "Páginas de cuentas de colaboradores"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Páginas de cuentas de hotel"
msgstr "Páginas de cuentas de hotel"

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Páginas de cuentas por aprobar"
msgstr "Páginas de cuentas por aprobar"

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "Páginas de hoteles"
msgstr "Páginas de hoteles"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Páginas de los últimos correos"
msgstr "Páginas de los últimos correos"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Páginas de personas con acceso"
msgstr "Páginas de personas con acceso"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Páginas de personas con funciones adicionales"
msgstr "Páginas de personas con funciones adicionales"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Páginas de solicitudes de eliminación"
msgstr "Páginas de solicitudes de eliminación"

#: src/features/admin/pages/UsersPage.tsx
msgid "Páginas de usuarios"
msgstr "Páginas de usuarios"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Páginas del catálogo"
msgstr "Páginas del catálogo"

#. placeholder {0}: String(index + 1)
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Pago {0}"
msgstr "Pago {0}"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Pago autorizado"
msgstr "Pago autorizado"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Pago de horas extra"
msgstr "Pago de horas extra"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Pago del día"
msgstr "Pago del día"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Pago estimado"
msgstr "Pago estimado"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Pago por hora"
msgstr "Pago por hora"

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "Pago registrado"
msgstr "Pago registrado"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Pago y facturación de {hotelName} esta semana, listos para bajar — el mismo cuadro de \"Lo que el hotel nos paga\" en un archivo."
msgstr "Pago y facturación de {hotelName} esta semana, listos para bajar — el mismo cuadro de \"Lo que el hotel nos paga\" en un archivo."

#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/shared/components/PhoneInput.tsx
msgid "País"
msgstr "País"

#: src/shared/components/PhoneInput.tsx
msgid "País o lada: México, +52…"
msgstr "País o lada: México, +52…"

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Panel"
msgstr "Panel"

#: src/shared/components/SendDocumentModal.tsx
msgid "Para"
msgstr "Para"

#. placeholder {0}: row.workerName
#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Para {0} — la marca quedará señalada como manual, con tu motivo."
msgstr "Para {0} — la marca quedará señalada como manual, con tu motivo."

#. placeholder {0}: typeLabel ? i18n._(typeLabel) : target.punch.type
#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Para {workerName} — {0}. Queda registrado quién corrigió y por qué."
msgstr "Para {workerName} — {0}. Queda registrado quién corrigió y por qué."

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Para agrupar contactos"
msgstr "Para agrupar contactos"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Para asignar:"
msgstr "Para asignar:"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Para completar"
msgstr "Para completar"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Para completar en su ficha"
msgstr "Para completar en su ficha"

#. placeholder {0}: missingData.join(', ')
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Para completar: {0}."
msgstr "Para completar: {0}."

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Para confirmar que estás dentro del hotel al ponchar."
msgstr "Para confirmar que estás dentro del hotel al ponchar."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Para continuar:"
msgstr "Para continuar:"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Para convertir a Naranja primero debe existir el Usuario del Hotel: créalo desde aquí mismo."
msgstr "Para convertir a Naranja primero debe existir el Usuario del Hotel: créalo desde aquí mismo."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Para convertir a Naranja primero debe existir el Usuario del Hotel: créalo desde Conversión."
msgstr "Para convertir a Naranja primero debe existir el Usuario del Hotel: créalo desde Conversión."

#. placeholder {0}: missing.join(' · ')
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Para crear: {0}."
msgstr "Para crear: {0}."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Para encontrar una en segundos"
msgstr "Para encontrar una en segundos"

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Para la foto de Entrada y Salida — cuando el hotel usa selfie y no QR."
msgstr "Para la foto de Entrada y Salida — cuando el hotel usa selfie y no QR."

#. placeholder {0}: REQUISITION_STATUS_LABEL[detail.status]
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Para llenar un slot, la requisición tiene que estar autorizada y en proceso. Ahora está en {0}."
msgstr "Para llenar un slot, la requisición tiene que estar autorizada y en proceso. Ahora está en {0}."

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Para pedir personal:"
msgstr "Para pedir personal:"

#: src/features/recruitment/components/ProfileProgressAvatar.tsx
msgid "Para poder asignarlo falta capturar en la entrevista: {missingNames}"
msgstr "Para poder asignarlo falta capturar en la entrevista: {missingNames}"

#: src/features/worker/components/NativePunchGate.tsx
msgid "Para ponchar, la app necesita tu ubicación precisa, el GPS encendido y la cámara. Revisa qué falta y actívalo."
msgstr "Para ponchar, la app necesita tu ubicación precisa, el GPS encendido y la cámara. Revisa qué falta y actívalo."

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Para un hotel dado de alta por error o de prueba. Solo si nunca salió del Pipeline."
msgstr "Para un hotel dado de alta por error o de prueba. Solo si nunca salió del Pipeline."

#: src/features/messaging/components/tours.ts
msgid "Para ver solo a los de una etiqueta, por ejemplo los de una importación."
msgstr "Para ver solo a los de una etiqueta, por ejemplo los de una importación."

#: src/features/requisitions/utils/coverage.ts
msgid "parcial"
msgstr "parcial"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Parciales"
msgstr "Parciales"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase3Page.tsx
msgid "Parentesco"
msgstr "Parentesco"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Parentesco…"
msgstr "Parentesco…"

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Pasa a reportar a"
msgstr "Pasa a reportar a"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Pasa a Rojo: es una incidencia, no una pausa. Inspección la revisa."
msgstr "Pasa a Rojo: es una incidencia, no una pausa. Inspección la revisa."

#: src/features/personnel/components/StandByDialog.tsx
msgid "Pasa a Rosa: queda en pausa, sin turnos nuevos, hasta que el Hotel lo reactive."
msgstr "Pasa a Rosa: queda en pausa, sin turnos nuevos, hasta que el Hotel lo reactive."

#. placeholder {0}: money(consolidation.netAmount)
#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Pasa del neto de {0}: el pago quedaría en negativo."
msgstr "Pasa del neto de {0}: el pago quedaría en negativo."

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Pasaron los 30 días para cambiar la contraseña temporal que te dieron. Elige la tuya aquí y tu acceso vuelve al instante — tus datos y tu historial no se pierden."
msgstr "Pasaron los 30 días para cambiar la contraseña temporal que te dieron. Elige la tuya aquí y tu acceso vuelve al instante — tus datos y tu historial no se pierden."

#. placeholder {0}: index + 1
#. placeholder {1}: steps.length
#: src/features/messaging/components/Tour.tsx
msgid "Paso {0} de {1}"
msgstr "Paso {0} de {1}"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Paso {step} de {LAST_STEP}"
msgstr "Paso {step} de {LAST_STEP}"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Paso 2 de 2"
msgstr "Paso 2 de 2"

#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Pasó el día para completar tu expediente después de que Reclutamiento te validó. Llénalo aquí y tu acceso vuelve al instante — tus datos y tu historial no se pierden."
msgstr "Pasó el día para completar tu expediente después de que Reclutamiento te validó. Llénalo aquí y tu acceso vuelve al instante — tus datos y tu historial no se pierden."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Pasos de tu requisición"
msgstr "Pasos de tu requisición"

#. placeholder {0}: failed.join(', ')
#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Pasos que fallaron: {0}"
msgstr "Pasos que fallaron: {0}"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "pausa temporal (Rosa)"
msgstr "pausa temporal (Rosa)"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Pausa temporal (Rosa); lo compartes con el Manager de Área"
msgstr "Pausa temporal (Rosa); lo compartes con el Manager de Área"

#: src/features/personnel/components/StandByDialog.tsx
msgid "Pausa, no baja"
msgstr "Pausa, no baja"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Pausada"
msgstr "Pausada"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Pausado (Stand-by)"
msgstr "Pausado (Stand-by)"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Pausar"
msgstr "Pausar"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "pausarlo o reactivarlo es del BDC."
msgstr "pausarlo o reactivarlo es del BDC."

#. placeholder {0}: formatMoney(version.payRate)
#. placeholder {1}: formatMoney(version.billRate)
#: src/features/onboarding/lib/summarizeRates.ts
msgid "pay {0} · bill {1}"
msgstr "pay {0} · bill {1}"

#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Pay rate"
msgstr "Pay rate"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Pay rate por hora"
msgstr "Pay rate por hora"

#. placeholder {0}: formatInstantDate(row.requestedAt)
#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Pedida el {0}"
msgstr "Pedida el {0}"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Pedido por"
msgstr "Pedido por"

#. placeholder {0}: row.requestedBy.fullName
#. placeholder {1}: formatDateTime(row.requestedAt)
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Pedido por {0} · {1}"
msgstr "Pedido por {0} · {1}"

#: src/features/contracts/components/ContractChecklist.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Pendiente"
msgstr "Pendiente"

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Pendiente → Aprobada → Emitida"
msgstr "Pendiente → Aprobada → Emitida"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "pendiente de aprobación"
msgstr "pendiente de aprobación"

#: src/features/accounting/types/settlement.constants.ts
msgid "Pendiente de aprobación"
msgstr "Pendiente de aprobación"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Pendiente de definir"
msgstr "Pendiente de definir"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "pendiente de horas contractuales"
msgstr "pendiente de horas contractuales"

#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Pendiente de verificar"
msgstr "Pendiente de verificar"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "pendientes"
msgstr "pendientes"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Pendientes"
msgstr "Pendientes"

#: src/features/audits/components/EnvironmentAuditDialog.tsx
msgid "Percepción de Ambiente y Recursos"
msgstr "Percepción de Ambiente y Recursos"

#: src/features/observability/lib/salesKpis.ts
msgid "Pérdida"
msgstr "Pérdida"

#: src/features/worker/components/useFaceGuide.ts
msgid "Perfecto, toma la foto"
msgstr "Perfecto, toma la foto"

#: src/features/recruitment/components/PoolTable.tsx
#: src/features/worker/components/MobileShell.tsx
msgid "Perfil"
msgstr "Perfil"

#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "perfil completo"
msgstr "perfil completo"

#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "perfil incompleto"
msgstr "perfil incompleto"

#: src/features/recruitment/components/ProfilePendingLabel.tsx
msgid "Perfil incompleto"
msgstr "Perfil incompleto"

#: src/features/recruitment/components/ProfilePendingLabel.tsx
msgid "Perfil incompleto · se le venció, ya no entra a su app"
msgstr "Perfil incompleto · se le venció, ya no entra a su app"

#: src/features/recruitment/components/ProfilePendingLabel.tsx
msgid "Perfil incompleto · tiene hasta el {date}"
msgstr "Perfil incompleto · tiene hasta el {date}"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Perfil laboral y salud"
msgstr "Perfil laboral y salud"

#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/observability/components/TabParts.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Periodo"
msgstr "Periodo"

#: src/shared/components/DateRangeField.tsx
msgid "Periodo {label}"
msgstr "Periodo {label}"

#: src/features/worker/components/MobileShell.tsx
#: src/features/worker/pages/PermissionsPage.tsx
msgid "Permisos"
msgstr "Permisos"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/observability/components/PeopleView.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Persona"
msgstr "Persona"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Persona a quien dar el acceso"
msgstr "Persona a quien dar el acceso"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Persona a quien dar la función"
msgstr "Persona a quien dar la función"

#: src/features/admin/pages/UsersPage.tsx
msgid "Personal de hoteles"
msgstr "Personal de hoteles"

#: src/features/admin/pages/UsersPage.tsx
msgid "Personal Oranje"
msgstr "Personal Oranje"

#: src/features/observability/components/CohortsView.tsx
#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "Personas"
msgstr "Personas"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Personas asignadas que no ponchan su primer día, con el primer día en el periodo."
msgstr "Personas asignadas que no ponchan su primer día, con el primer día en el periodo."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Personas con acceso"
msgstr "Personas con acceso"

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Personas con funciones adicionales"
msgstr "Personas con funciones adicionales"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Personas en tu equipo"
msgstr "Personas en tu equipo"

#: src/features/observability/lib/workerKpis.ts
msgid "Personas que poncharon entrada hoy y todavía no su salida."
msgstr "Personas que poncharon entrada hoy y todavía no su salida."

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "personas que respondieron"
msgstr "personas que respondieron"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Peso"
msgstr "Peso"

#. placeholder {0}: item.weight
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Peso {0}"
msgstr "Peso {0}"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Peso en el promedio ponderado del score"
msgstr "Peso en el promedio ponderado del score"

#: src/features/requisitions/types/requisitionForm.schema.ts
msgid "Pide al menos 1 persona"
msgstr "Pide al menos 1 persona"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Pide personal desde aquí"
msgstr "Pide personal desde aquí"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Pide personal para tu hotel"
msgstr "Pide personal para tu hotel"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Pídele al Administrador que lo cree desde Correos corporativos."
msgstr "Pídele al Administrador que lo cree desde Correos corporativos."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Pidió que llamáramos la próxima semana"
msgstr "Pidió que llamáramos la próxima semana"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Pie (opcional)"
msgstr "Pie (opcional)"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Pin ajustado a mano"
msgstr "Pin ajustado a mano"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Pin en el punto exacto de Google"
msgstr "Pin en el punto exacto de Google"

#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/onboarding/pages/ProspectDetailPage.tsx
#: src/features/reports/pages/ReportsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Pipeline"
msgstr "Pipeline"

#: src/features/dashboard/components/StatusFunnel.tsx
msgid "Pipeline por estado"
msgstr "Pipeline por estado"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Plantilla"
msgstr "Plantilla"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Plantilla *"
msgstr "Plantilla *"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Plantilla en español"
msgstr "Plantilla en español"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Plantilla en inglés"
msgstr "Plantilla en inglés"

#: src/features/messaging/components/MessagingOverviewPanel.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/pages/MessagingPage.tsx
msgid "Plantillas"
msgstr "Plantillas"

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Plazo para aprobar las horas (miércoles)"
msgstr "Plazo para aprobar las horas (miércoles)"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "pon desde cuándo rige"
msgstr "pon desde cuándo rige"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Pon la fecha de fin: la asignación es temporal."
msgstr "Pon la fecha de fin: la asignación es temporal."

#: src/features/worker/components/MobileShell.tsx
#: src/features/worker/pages/HomePage.tsx
msgid "Ponchar"
msgstr "Ponchar"

#. placeholder {0}: i18n._(PUNCH_LABEL[next]).toLowerCase()
#: src/features/worker/pages/PunchPage.tsx
msgid "Ponchar {0}"
msgstr "Ponchar {0}"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Ponche"
msgstr "Ponche"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Ponches a tiempo"
msgstr "Ponches a tiempo"

#: src/features/observability/lib/workerKpis.ts
msgid "Ponches capturados a mano en lugar de con el teléfono."
msgstr "Ponches capturados a mano en lugar de con el teléfono."

#: src/features/timesheet/components/TimesheetDayCell.tsx
#: src/shared/constants/timesheetStatus.ts
msgid "Ponches completos"
msgstr "Ponches completos"

#: src/features/observability/lib/workerKpis.ts
msgid "Ponches fuera de geocerca"
msgstr "Ponches fuera de geocerca"

#: src/features/timesheet/components/TimesheetDayCell.tsx
#: src/shared/constants/timesheetStatus.ts
msgid "Ponches incompletos"
msgstr "Ponches incompletos"

#: src/features/observability/lib/workerKpis.ts
msgid "Ponches manuales"
msgstr "Ponches manuales"

#: src/features/observability/lib/workerKpis.ts
msgid "Ponches registrados fuera del radio del hotel."
msgstr "Ponches registrados fuera del radio del hotel."

#: src/shared/constants/workerStatus.ts
msgid "Ponchó en la propiedad al tercer día: ya tiene su uniforme."
msgstr "Ponchó en la propiedad al tercer día: ya tiene su uniforme."

#: src/features/observability/components/CohortSection.tsx
msgid "Ponchó esta semana o la pasada, después de su semana de ingreso."
msgstr "Ponchó esta semana o la pasada, después de su semana de ingreso."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Poner contraseña"
msgstr "Poner contraseña"

#: src/features/messaging/components/tours.ts
msgid "Ponle nombre y color. Luego asígnala a contactos o al importar un Excel."
msgstr "Ponle nombre y color. Luego asígnala a contactos o al importar un Excel."

#: src/features/recruitment/pages/PoolPage.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Pool de Colaboradores"
msgstr "Pool de Colaboradores"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Pool por estado"
msgstr "Pool por estado"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Por ahora la retención del 16% aplica a todos los colaboradores, suban o verifiquen o no su SSN/ITIN — es temporal, mientras se conecta ese proceso."
msgstr "Por ahora la retención del 16% aplica a todos los colaboradores, suban o verifiquen o no su SSN/ITIN — es temporal, mientras se conecta ese proceso."

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Por ahora, los reportes de Mensajería solo los ve Reclutamiento."
msgstr "Por ahora, los reportes de Mensajería solo los ve Reclutamiento."

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Por ahora, Mensajería es solo de Reclutamiento."
msgstr "Por ahora, Mensajería es solo de Reclutamiento."

#: src/features/recruitment/types/blacklist.types.ts
msgid "Por ausencias"
msgstr "Por ausencias"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Por categoría de plantilla"
msgstr "Por categoría de plantilla"

#: src/features/recruitment/types/blacklist.types.ts
msgid "Por disputa"
msgstr "Por disputa"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Por dónde buscaste al hotel"
msgstr "Por dónde buscaste al hotel"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Por dónde sale el correo"
msgstr "Por dónde sale el correo"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Por dónde salen los correos que manda el sistema, y qué ha pasado con ellos."
msgstr "Por dónde salen los correos que manda el sistema, y qué ha pasado con ellos."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Por el respaldo"
msgstr "Por el respaldo"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Por el servidor de Oranje"
msgstr "Por el servidor de Oranje"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Por etiquetas"
msgstr "Por etiquetas"

#: src/features/messaging/components/tours.ts
msgid "Por nombre, teléfono o email: son los contactos de la plataforma de mensajería."
msgstr "Por nombre, teléfono o email: son los contactos de la plataforma de mensajería."

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Por país"
msgstr "Por país"

#: src/features/observability/components/CohortSection.tsx
#: src/features/observability/components/TabParts.tsx
msgid "Por persona"
msgstr "Por persona"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Por persona · asignaciones y altas de los últimos 30 días"
msgstr "Por persona · asignaciones y altas de los últimos 30 días"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Por qué esta tarifa…"
msgstr "Por qué esta tarifa…"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Por qué este gasto…"
msgstr "Por qué este gasto…"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Por qué la hora registrada estaba mal"
msgstr "Por qué la hora registrada estaba mal"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Por qué no existe el ponche: rechazo de ubicación, teléfono sin batería…"
msgstr "Por qué no existe el ponche: rechazo de ubicación, teléfono sin batería…"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Por qué no llegaron"
msgstr "Por qué no llegaron"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Por qué no procede…"
msgstr "Por qué no procede…"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Por qué se corrige — p. ej. «El contrato traía la tarifa vieja.»"
msgstr "Por qué se corrige — p. ej. «El contrato traía la tarifa vieja.»"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Por qué se libera este slot…"
msgstr "Por qué se libera este slot…"

#: src/features/reports/pages/ReportsPage.tsx
msgid "por qué se van los ciclos, y que son reactivables"
msgstr "por qué se van los ciclos, y que son reactivables"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Por si algo pasa"
msgstr "Por si algo pasa"

#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "Por todo el territorio"
msgstr "Por todo el territorio"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Por validar"
msgstr "Por validar"

#. placeholder {0}: String(member.pendingValidation)
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Por validar · {0}"
msgstr "Por validar · {0}"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Porcentaje acumulado de destinatarios con el mensaje entregado y leído desde el inicio del envío. Usa las flechas para recorrer; «Ver tabla» tiene los valores."
msgstr "Porcentaje acumulado de destinatarios con el mensaje entregado y leído desde el inicio del envío. Usa las flechas para recorrer; «Ver tabla» tiene los valores."

#. placeholder {0}: data.thresholds.green
#. placeholder {1}: data.thresholds.yellow
#. placeholder {2}: data.weeks
#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Porcentaje de ponches de cada semana cerrada que el Manager de Área aprobó antes del cierre. Verde desde {0}%, amarillo desde {1}%, rojo por debajo. Últimas {2} semanas."
msgstr "Porcentaje de ponches de cada semana cerrada que el Manager de Área aprobó antes del cierre. Verde desde {0}%, amarillo desde {1}%, rojo por debajo. Últimas {2} semanas."

#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Pos."
msgstr "Pos."

#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "posición"
msgstr "posición"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/components/RateTable.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Posición"
msgstr "Posición"

#. placeholder {0}: String(index + 1)
#. placeholder {0}: index + 1
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Posición {0}"
msgstr "Posición {0}"

#. placeholder {0}: row.lineNumber
#. placeholder {1}: row.positionName
#: src/features/recruitment/components/SelfPickPositionCard.tsx
msgid "Posición {0} · {1}"
msgstr "Posición {0} · {1}"

#: src/features/requisitions/components/SlotList.tsx
msgid "Posición {index} · {name}"
msgstr "Posición {index} · {name}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Posición {ordinal}"
msgstr "Posición {ordinal}"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Posición y modalidad"
msgstr "Posición y modalidad"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Posición, modalidad, inglés y experiencia se deciden aquí: son decisiones de Oranje, no del colaborador."
msgstr "Posición, modalidad, inglés y experiencia se deciden aquí: son decisiones de Oranje, no del colaborador."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Posición…"
msgstr "Posición…"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "posiciones"
msgstr "posiciones"

#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/contracts/components/ContractTable.tsx
#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "Posiciones"
msgstr "Posiciones"

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Posiciones con urgencia roja y lugares vacíos, en requisiciones que se están llenando."
msgstr "Posiciones con urgencia roja y lugares vacíos, en requisiciones que se están llenando."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Posiciones solicitadas"
msgstr "Posiciones solicitadas"

#: src/features/observability/lib/people.ts
#: src/features/observability/lib/recruitmentKpis.ts
msgid "Posiciones urgentes sin cubrir"
msgstr "Posiciones urgentes sin cubrir"

#: src/shared/constants/workerStatus.ts
msgid "Pre-asignación"
msgstr "Pre-asignación"

#: src/features/accounting/pages/AccountingPendingPages.tsx
#: src/layouts/Sidebar.tsx
msgid "Pre-Payroll"
msgstr "Pre-Payroll"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Prendido"
msgstr "Prendido"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Preparando el documento…"
msgstr "Preparando el documento…"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Preparando el QR…"
msgstr "Preparando el QR…"

#: src/features/worker/components/useFaceGuide.ts
msgid "Preparando la cámara…"
msgstr "Preparando la cámara…"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/audits/components/AuditHistoryList.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Presentación Personal"
msgstr "Presentación Personal"

#: src/features/audits/pages/AuditsPage.tsx
msgid "Presentación Personal por colaborador y Percepción de Ambiente y Recursos de tu hotel — misma mecánica, categorías distintas."
msgstr "Presentación Personal por colaborador y Percepción de Ambiente y Recursos de tu hotel — misma mecánica, categorías distintas."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Presentación Personal por colaborador y Percepción de Ambiente y Recursos del hotel — un registro semanal que no toca ningún semáforo."
msgstr "Presentación Personal por colaborador y Percepción de Ambiente y Recursos del hotel — un registro semanal que no toca ningún semáforo."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Previsualizar"
msgstr "Previsualizar"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Primer contacto"
msgstr "Primer contacto"

#: src/shared/constants/workerStatus.ts
msgid "Primer o segundo día en el hotel. El Inspector confirma su llegada el día 1."
msgstr "Primer o segundo día en el hotel. El Inspector confirma su llegada el día 1."

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "Primero envía una propuesta al hotel"
msgstr "Primero envía una propuesta al hotel"

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Primero, sincroniza"
msgstr "Primero, sincroniza"

#: src/features/onboarding/components/HotelContactList.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Principal"
msgstr "Principal"

#. placeholder {0}: roleLabelOf(item.primaryRole.code).title
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Principal: {0}"
msgstr "Principal: {0}"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Problemas"
msgstr "Problemas"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Programada"
msgstr "Programada"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Programar"
msgstr "Programar"

#. placeholder {0}: campaign.name
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Programar «{0}»"
msgstr "Programar «{0}»"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/reports/pages/ReportsPage.tsx
msgid "Programar envío recurrente"
msgstr "Programar envío recurrente"

#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Progreso"
msgstr "Progreso"

#: src/features/clients/pages/ClientPortfolioPage.tsx
msgid "promedio como cliente"
msgstr "promedio como cliente"

#: src/features/observability/lib/hotelKpis.ts
msgid "Promedio de horas para aprobar una semana, de todo el histórico."
msgstr "Promedio de horas para aprobar una semana, de todo el histórico."

#: src/features/observability/lib/salesKpis.ts
msgid "Promedio de la apertura del ciclo a su cierre, de todo el histórico."
msgstr "Promedio de la apertura del ciclo a su cierre, de todo el histórico."

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Promedio en Autorizada más promedio en En proceso, de todo el histórico."
msgstr "Promedio en Autorizada más promedio en En proceso, de todo el histórico."

#: src/features/observability/lib/hotelKpis.ts
msgid "Promedio que un colaborador pasa en Stand-by, de todo el histórico."
msgstr "Promedio que un colaborador pasa en Stand-by, de todo el histórico."

#: src/shared/constants/workerEnums.ts
msgid "Propio"
msgstr "Propio"

#: src/features/territory/components/TerritoryMapLegend.tsx
msgid "Propuesta"
msgstr "Propuesta"

#. placeholder {0}: workspace.hotelName
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Propuesta · {0}"
msgstr "Propuesta · {0}"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Propuesta del hotel"
msgstr "Propuesta del hotel"

#: src/features/conversion/api/conversionApi.ts
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
msgid "Propuesta enviada"
msgstr "Propuesta enviada"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Propuesta enviada al hotel"
msgstr "Propuesta enviada al hotel"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Propuesta marcada como enviada"
msgstr "Propuesta marcada como enviada"

#. placeholder {0}: contract.proposal.version
#. placeholder {0}: selected.version
#. placeholder {0}: version.version
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/components/ProposalVersionHistory.tsx
#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Propuesta v{0}"
msgstr "Propuesta v{0}"

#. placeholder {0}: String(sentProposal.version)
#. placeholder {0}: selected.version
#. placeholder {1}: formatDayMonth(sentProposal.sentAt as string)
#. placeholder {1}: workspace.hotelName
#: src/features/conversion/api/conversionApi.ts
#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Propuesta v{0} · {1}"
msgstr "Propuesta v{0} · {1}"

#. placeholder {0}: prospect.latestProposalVersion
#: src/features/onboarding/utils/resolveActivityLabel.ts
msgid "Propuesta v{0} enviada"
msgstr "Propuesta v{0} enviada"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Propuestas"
msgstr "Propuestas"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Propuesto con la inicial y el apellido; cámbialo si ya existe."
msgstr "Propuesto con la inicial y el apellido; cámbialo si ya existe."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Prospecto actualizado"
msgstr "Prospecto actualizado"

#. placeholder {0}: form.hotelName
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Prospecto creado — {0}"
msgstr "Prospecto creado — {0}"

#: src/features/dashboard/components/StatusFunnel.tsx
msgid "Prospectos"
msgstr "Prospectos"

#: src/features/dashboard/components/ActivityCards.tsx
#: src/features/observability/lib/people.ts
#: src/features/team/pages/TeamPage.tsx
msgid "Prospectos abiertos"
msgstr "Prospectos abiertos"

#: src/features/observability/lib/salesKpis.ts
msgid "Prospectos abiertos con {STALE_DAYS} días o más sin un intento de contacto."
msgstr "Prospectos abiertos con {STALE_DAYS} días o más sin un intento de contacto."

#: src/features/team/pages/TeamPage.tsx
msgid "Prospectos abiertos del equipo"
msgstr "Prospectos abiertos del equipo"

#: src/features/observability/lib/salesKpis.ts
msgid "Prospectos estancados"
msgstr "Prospectos estancados"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "protegido (Gris)"
msgstr "protegido (Gris)"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Protegido (Gris)"
msgstr "Protegido (Gris)"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Próximamente"
msgstr "Próximamente"

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Prueba con otra parte del nombre, o quita la búsqueda."
msgstr "Prueba con otra parte del nombre, o quita la búsqueda."

#: src/shared/constants/workerEnums.ts
msgid "Público"
msgstr "Público"

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
msgid "Puede que otra Reclutadora ya los haya llenado. Vuelve a la Bolsa para ver los de todos los hoteles."
msgstr "Puede que otra Reclutadora ya los haya llenado. Vuelve a la Bolsa para ver los de todos los hoteles."

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
msgid "Puede que ya no tenga requisiciones o que no estén en tu zona. Vuelve al tablero para ver las de todos los hoteles."
msgstr "Puede que ya no tenga requisiciones o que no estén en tu zona. Vuelve al tablero para ver las de todos los hoteles."

#: src/shared/components/LanguagePrompt.tsx
msgid "Puedes cambiarlo después desde tu perfil · You can change this later"
msgstr "Puedes cambiarlo después desde tu perfil · You can change this later"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Puedes dejar al BD sin territorio: queda visible así en Mi Equipo hasta el siguiente reparto."
msgstr "Puedes dejar al BD sin territorio: queda visible así en Mi Equipo hasta el siguiente reparto."

#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/ProposalRateFields.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Puesto"
msgstr "Puesto"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Puesto «{jobTitleText}» no es un tipo de usuario del sistema: elígelo después"
msgstr "Puesto «{jobTitleText}» no es un tipo de usuario del sistema: elígelo después"

#: src/features/onboarding/components/JobTitleSelect.tsx
msgid "Puesto actual"
msgstr "Puesto actual"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Puesto del contacto"
msgstr "Puesto del contacto"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Puesto por puesto"
msgstr "Puesto por puesto"

#: src/features/contracts/components/ActivateContractDialog.tsx
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Puestos cotizados"
msgstr "Puestos cotizados"

#: src/features/observability/lib/workerKpis.ts
#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "Puntualidad"
msgstr "Puntualidad"

#. placeholder {0}: formatDate(access.changedByWorkerAt)
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Puso la suya el {0}. Esa no se guarda: si la olvida, ponle una nueva."
msgstr "Puso la suya el {0}. Esa no se guarda: si la olvida, ponle una nueva."

#. placeholder {0}: data.hotelName
#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "QR de ponche de {0}"
msgstr "QR de ponche de {0}"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "QR del hotel"
msgstr "QR del hotel"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "QR regenerado: versión {version}. Descarga la hoja nueva."
msgstr "QR regenerado: versión {version}. Descarga la hoja nueva."

#: src/features/reports/pages/ReportsPage.tsx
msgid "qué canal sí logra contacto"
msgstr "qué canal sí logra contacto"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Qué estás viendo"
msgstr "Qué estás viendo"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Que la genere el sistema"
msgstr "Que la genere el sistema"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Qué necesita"
msgstr "Qué necesita"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Qué pasa al aprobar"
msgstr "Qué pasa al aprobar"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Qué pasa después del alta"
msgstr "Qué pasa después del alta"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Qué pasó con este intento"
msgstr "Qué pasó con este intento"

#: src/features/observability/components/CohortSection.tsx
msgid "Qué pasó con quienes ya no trabajan"
msgstr "Qué pasó con quienes ya no trabajan"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Qué pasó y cuándo…"
msgstr "Qué pasó y cuándo…"

#: src/features/observability/components/CohortSection.tsx
msgid "Qué pasó y motivo"
msgstr "Qué pasó y motivo"

#: src/features/observability/components/CohortSection.tsx
msgid "Qué semanas ver"
msgstr "Qué semanas ver"

#. placeholder {0}: index + 1
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Qué va en la variable {0}"
msgstr "Qué va en la variable {0}"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Qué viste y cómo se resuelve — p. ej. «Salió por el acceso de servicio; el GPS tomó la calle.»"
msgstr "Qué viste y cómo se resuelve — p. ej. «Salió por el acceso de servicio; el GPS tomó la calle.»"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "queda como gasto de Oranje, sin tocar su pago"
msgstr "queda como gasto de Oranje, sin tocar su pago"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Queda lista para pago y factura, y deja de poder corregirse desde aquí. Si algo cambia después de aprobarla, contacta a Oranje."
msgstr "Queda lista para pago y factura, y deja de poder corregirse desde aquí. Si algo cambia después de aprobarla, contacta a Oranje."

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "Queda registrado en el journal, con este motivo."
msgstr "Queda registrado en el journal, con este motivo."

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Queda señalada como manual"
msgstr "Queda señalada como manual"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Quedan días con anomalía sin resolver: revísalos antes de enviar la semana."
msgstr "Quedan días con anomalía sin resolver: revísalos antes de enviar la semana."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Quedan días sin marca ni estado: marca Descanso, OFF… en cada uno antes de enviar la semana."
msgstr "Quedan días sin marca ni estado: marca Descanso, OFF… en cada uno antes de enviar la semana."

#: src/features/contracts/components/ContractNextStep.tsx
#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Quién"
msgstr "Quién"

#: src/features/reports/pages/ReportsPage.tsx
msgid "quién convierte y en cuánto tiempo"
msgstr "quién convierte y en cuánto tiempo"

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Quién firma por el hotel"
msgstr "Quién firma por el hotel"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Quién la está trabajando"
msgstr "Quién la está trabajando"

#: src/features/requisitions/components/SlotList.tsx
msgid "Quien lo cubrió ya terminó"
msgstr "Quien lo cubrió ya terminó"

#: src/features/observability/components/CohortSection.tsx
msgid "Quién lo originó"
msgstr "Quién lo originó"

#: src/features/observability/components/CohortSection.tsx
msgid "Quién originó la salida"
msgstr "Quién originó la salida"

#: src/features/admin/pages/UsersPage.tsx
msgid "Quien pidió eliminar su cuenta: se completa sola a los 14 días, o tú la concluyes o la cancelas antes."
msgstr "Quien pidió eliminar su cuenta: se completa sola a los 14 días, o tú la concluyes o la cancelas antes."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Quién trabaja el turno"
msgstr "Quién trabaja el turno"

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Quien trabaja en dos hoteles la misma semana tiene dos consolidados — cada uno con su propio cheque."
msgstr "Quien trabaja en dos hoteles la misma semana tiene dos consolidados — cada uno con su propio cheque."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Quienes la recibirían hoy: sin dados de baja, inactivos ni lista negra."
msgstr "Quienes la recibirían hoy: sin dados de baja, inactivos ni lista negra."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Quintana Roo — Cancún (sin horario de verano)"
msgstr "Quintana Roo — Cancún (sin horario de verano)"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Quita el filtro para reordenar"
msgstr "Quita el filtro para reordenar"

#: src/features/accounting/components/PayOverrideDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Quitando…"
msgstr "Quitando…"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Quitar"
msgstr "Quitar"

#. placeholder {0}: roleLabelOf(extra.code).title
#. placeholder {1}: item.fullName
#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Quitar {0} a {1}"
msgstr "Quitar {0} a {1}"

#. placeholder {0}: contactName(contact)
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Quitar a {0}"
msgstr "Quitar a {0}"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Quitar acceso"
msgstr "Quitar acceso"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Quitar botón"
msgstr "Quitar botón"

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Quitar búsqueda"
msgstr "Quitar búsqueda"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Quitar corrección"
msgstr "Quitar corrección"

#. placeholder {0}: String(index + 1)
#: src/features/onboarding/components/ProposalRateFields.tsx
msgid "Quitar el renglón {0}"
msgstr "Quitar el renglón {0}"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Quitar esta posición del contrato"
msgstr "Quitar esta posición del contrato"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Quitar esta posición del pedido"
msgstr "Quitar esta posición del pedido"

#: src/shared/components/FilterReset.tsx
msgid "Quitar filtros"
msgstr "Quitar filtros"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Quitar la deducción de {label}"
msgstr "Quitar la deducción de {label}"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Quitar la marca"
msgstr "Quitar la marca"

#. placeholder {0}: String(index + 1)
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Quitar posición {0}"
msgstr "Quitar posición {0}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Quitar posición {ordinal}"
msgstr "Quitar posición {ordinal}"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Quitar selección"
msgstr "Quitar selección"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Quitar, volver a pedirlo"
msgstr "Quitar, volver a pedirlo"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Radio de geocerca"
msgstr "Radio de geocerca"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Razón social de Oranje"
msgstr "Razón social de Oranje"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Reactiva hacia Azul claro: {reactivatedLabel}."
msgstr "Reactiva hacia Azul claro: {reactivatedLabel}."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Reactivar"
msgstr "Reactivar"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "reactivarlo es del BD o del BDC."
msgstr "reactivarlo es del BD o del BDC."

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "reactivarlo es del BDC."
msgstr "reactivarlo es del BDC."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Reactivo actualizado"
msgstr "Reactivo actualizado"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Reactivos de Inspección"
msgstr "Reactivos de Inspección"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Reactivos de Inspección es distinto"
msgstr "Reactivos de Inspección es distinto"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Reales"
msgstr "Reales"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Reanudar"
msgstr "Reanudar"

#: src/features/observability/lib/people.ts
msgid "Reasignadas"
msgstr "Reasignadas"

#: src/features/observability/lib/people.ts
msgid "Reasignó la requisición"
msgstr "Reasignó la requisición"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Recalculando…"
msgstr "Recalculando…"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Recalcular"
msgstr "Recalcular"

#: src/shared/components/ReloadButton.tsx
msgid "Recargar"
msgstr "Recargar"

#: src/features/onboarding/components/HotelLocationMap.tsx
msgid "Recentrar"
msgstr "Recentrar"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Rechazada"
msgstr "Rechazada"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Rechazando…"
msgstr "Rechazando…"

#: src/features/admin/components/PendingHotelUsers.tsx
#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Rechazar"
msgstr "Rechazar"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Rechazar ajuste"
msgstr "Rechazar ajuste"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Rechazaste firmar: el envío quedó cancelado."
msgstr "Rechazaste firmar: el envío quedó cancelado."

#: src/features/territory/components/TerritoryMapLegend.tsx
msgid "Rechazo"
msgstr "Rechazo"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Rechazó firmar"
msgstr "Rechazó firmar"

#: src/shared/constants/onboardingStatus.ts
msgid "Rechazo o no interés"
msgstr "Rechazo o no interés"

#: src/shared/constants/roles.ts
msgid "Reclutadora"
msgstr "Reclutadora"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Reclutadora salió"
msgstr "Reclutadora salió"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Reclutadora se unió"
msgstr "Reclutadora se unió"

#: src/features/observability/lib/cohorts.ts
#: src/features/observability/pages/ObservabilityPage.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/recruitment/pages/PoolPage.tsx
msgid "Reclutamiento"
msgstr "Reclutamiento"

#: src/features/conversion/api/conversionApi.ts
msgid "Reclutamiento e Inspección toman la operación"
msgstr "Reclutamiento e Inspección toman la operación"

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Reclutamiento pide, el Manager de QA aprueba"
msgstr "Reclutamiento pide, el Manager de QA aprueba"

#. placeholder {0}: formatDate(profile.dueAt)
#. placeholder {1}: profile.day ?? 1
#: src/features/worker/components/AccessDeadlineBanner.tsx
msgid "Reclutamiento ya te validó con tu expediente a medias. Tienes hasta el <0>{0}</0> (día {1} de 1); después tu acceso se bloquea hasta que lo completes."
msgstr "Reclutamiento ya te validó con tu expediente a medias. Tienes hasta el <0>{0}</0> (día {1} de 1); después tu acceso se bloquea hasta que lo completes."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Recupera tu contraseña"
msgstr "Recupera tu contraseña"

#: src/shared/components/SettlementEffectBadge.tsx
msgid "Reembolso: se le suma"
msgstr "Reembolso: se le suma"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Reemplazar"
msgstr "Reemplazar"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Reemplazar foto"
msgstr "Reemplazar foto"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Reenviar a Meta"
msgstr "Reenviar a Meta"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Reenviar contrato por correo"
msgstr "Reenviar contrato por correo"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Reenviar invitación"
msgstr "Reenviar invitación"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Reenviar por correo"
msgstr "Reenviar por correo"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Regenerando…"
msgstr "Regenerando…"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Regenerar QR"
msgstr "Regenerar QR"

#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/worker/pages/PunchPage.tsx
msgid "Registrando…"
msgstr "Registrando…"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Registrar cobro"
msgstr "Registrar cobro"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Registrar el intento"
msgstr "Registrar el intento"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Registrar envío al hotel"
msgstr "Registrar envío al hotel"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Registrar intento"
msgstr "Registrar intento"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Registrar intento de contacto"
msgstr "Registrar intento de contacto"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Registrar la marca"
msgstr "Registrar la marca"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Registrar marca"
msgstr "Registrar marca"

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "Registrar pago"
msgstr "Registrar pago"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Registras la hora real del hecho, no la de ahora: esa es la que cuenta horas para la nómina."
msgstr "Registras la hora real del hecho, no la de ahora: esa es la que cuenta horas para la nómina."

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Registró"
msgstr "Registró"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Registro de correos"
msgstr "Registro de correos"

#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Registro de entrada y salida"
msgstr "Registro de entrada y salida"

#: src/features/observability/components/CohortSection.tsx
msgid "Regresaron el lunes"
msgstr "Regresaron el lunes"

#: src/features/observability/components/CohortsView.tsx
msgid "Regresaron la semana siguiente"
msgstr "Regresaron la semana siguiente"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/worker/api/punchApi.ts
msgid "Regreso de lunch"
msgstr "Regreso de lunch"

#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Reintentar"
msgstr "Reintentar"

#: src/shared/constants/onboardingStatus.ts
msgid "Renegociación / desbloqueo"
msgstr "Renegociación / desbloqueo"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Renglón completo"
msgstr "Renglón completo"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Renombrar"
msgstr "Renombrar"

#. placeholder {0}: doc.displayName
#. placeholder {0}: i18n._(editor.noun)
#: src/features/admin/pages/CatalogsPage.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Renombrar {0}"
msgstr "Renombrar {0}"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Renovar contrato"
msgstr "Renovar contrato"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Repartir el territorio"
msgstr "Repartir el territorio"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Repetido en el archivo"
msgstr "Repetido en el archivo"

#. placeholder {0}: String(seen.get(nameKey(hotelName)))
#: src/features/onboarding/import/mapImportRows.ts
msgid "Repetido en el archivo (fila {0})"
msgstr "Repetido en el archivo (fila {0})"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
#: src/features/worker/components/ChangePasswordForm.tsx
msgid "Repítela"
msgstr "Repítela"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/UsersPage.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Reporta a"
msgstr "Reporta a"

#. placeholder {0}: member.reportsTo.fullName
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "reporta a {0}"
msgstr "reporta a {0}"

#: src/features/observability/lib/inspectionKpis.ts
#: src/shared/constants/workerStatus.ts
msgid "Reportado"
msgstr "Reportado"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Reportado (Rojo)"
msgstr "Reportado (Rojo)"

#: src/features/observability/lib/cohorts.ts
msgid "Reportado por el hotel"
msgstr "Reportado por el hotel"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Reportando…"
msgstr "Reportando…"

#: src/features/personnel/components/ReportWorkerDialog.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Reportar"
msgstr "Reportar"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Reportar a {workerName}"
msgstr "Reportar a {workerName}"

#: src/features/personnel/components/ReportWorkerDialog.tsx
msgid "Reportar es más serio que Stand-by"
msgstr "Reportar es más serio que Stand-by"

#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/reports/pages/ReportsPage.tsx
msgid "Reporte"
msgstr "Reporte"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/MessagingPage.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/reports/pages/ReportsPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Reportes"
msgstr "Reportes"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Reportes de Reclutamiento"
msgstr "Reportes de Reclutamiento"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Reprogramar"
msgstr "Reprogramar"

#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Requisición"
msgstr "Requisición"

#. placeholder {0}: board.requisitionState.name
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Requisición · {0}"
msgstr "Requisición · {0}"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Requisición {requisitionNumber} eliminada"
msgstr "Requisición {requisitionNumber} eliminada"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Requisición autorizada"
msgstr "Requisición autorizada"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Requisición creada"
msgstr "Requisición creada"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Requisición eliminada"
msgstr "Requisición eliminada"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
#: src/layouts/GlobalSearch.tsx
#: src/layouts/Sidebar.tsx
msgid "Requisiciones"
msgstr "Requisiciones"

#: src/features/observability/lib/people.ts
msgid "Requisiciones a su cargo"
msgstr "Requisiciones a su cargo"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Requisiciones abiertas"
msgstr "Requisiciones abiertas"

#: src/features/observability/lib/people.ts
msgid "Requisiciones abiertas en su zona"
msgstr "Requisiciones abiertas en su zona"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Requisiciones autorizadas, en proceso o cubiertas parcialmente"
msgstr "Requisiciones autorizadas, en proceso o cubiertas parcialmente"

#: src/features/observability/lib/hotelKpis.ts
msgid "Requisiciones creadas en el periodo que hoy están eliminadas. No incluye las modificadas."
msgstr "Requisiciones creadas en el periodo que hoy están eliminadas. No incluye las modificadas."

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Requisiciones críticas"
msgstr "Requisiciones críticas"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Requisiciones cubiertas"
msgstr "Requisiciones cubiertas"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Requisiciones del hotel"
msgstr "Requisiciones del hotel"

#: src/features/observability/lib/hotelKpis.ts
msgid "Requisiciones eliminadas"
msgstr "Requisiciones eliminadas"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Requisiciones en cola"
msgstr "Requisiciones en cola"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Requisiciones por estado y lugares cubiertos; sin las eliminadas"
msgstr "Requisiciones por estado y lugares cubiertos; sin las eliminadas"

#: src/features/observability/lib/people.ts
msgid "Requisiciones que creó"
msgstr "Requisiciones que creó"

#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Requisiciones que está llenando"
msgstr "Requisiciones que está llenando"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Requisiciones que están llenando"
msgstr "Requisiciones que están llenando"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Requisitos para habilitar la conversión"
msgstr "Requisitos para habilitar la conversión"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Resolver y marcar revisado"
msgstr "Resolver y marcar revisado"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Respaldo"
msgstr "Respaldo"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Responsable"
msgstr "Responsable"

#. placeholder {0}: item.label
#: src/features/audits/components/AuditFormDialog.tsx
msgid "Respuesta para {0}"
msgstr "Respuesta para {0}"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Respuestas"
msgstr "Respuestas"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/ReportCharts.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/onboarding/components/RegisterAttemptDialog.tsx
#: src/features/reports/pages/ReportsPage.tsx
msgid "Resultado"
msgstr "Resultado"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Resultado de los mensajes"
msgstr "Resultado de los mensajes"

#: src/layouts/GlobalSearch.tsx
msgid "Resultados"
msgstr "Resultados"

#: src/features/messaging/pages/MessagingPage.tsx
msgid "Resumen de la operación"
msgstr "Resumen de la operación"

#: src/features/accounting/types/settlement.constants.ts
msgid "Retención del 16%"
msgstr "Retención del 16%"

#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Retención del 16% aceptada"
msgstr "Retención del 16% aceptada"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Retención del 16% aceptada: ya no se pide el SSN/ITIN"
msgstr "Retención del 16% aceptada: ya no se pide el SSN/ITIN"

#: src/features/observability/components/CohortsView.tsx
msgid "Retención por cohorte"
msgstr "Retención por cohorte"

#. placeholder {0}: fields.join(', ')
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Revisa estos campos: {0}."
msgstr "Revisa estos campos: {0}."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/types/settlement.constants.ts
#: src/shared/constants/timesheetStatus.ts
msgid "Revisado"
msgstr "Revisado"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "revisados"
msgstr "revisados"

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Revisando a quién le llegaría…"
msgstr "Revisando a quién le llegaría…"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Revisando con las reglas de Meta…"
msgstr "Revisando con las reglas de Meta…"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Revisando el archivo…"
msgstr "Revisando el archivo…"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Revisando…"
msgstr "Revisando…"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Revisar"
msgstr "Revisar"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Revisar el día"
msgstr "Revisar el día"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Revisar no es aprobar"
msgstr "Revisar no es aprobar"

#: src/features/worker/components/NativePunchGate.tsx
msgid "Revisar permisos"
msgstr "Revisar permisos"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Revisas antes de importar"
msgstr "Revisas antes de importar"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Revisión"
msgstr "Revisión"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Revisión del día"
msgstr "Revisión del día"

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Rige desde"
msgstr "Rige desde"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Ritmo de entrega y lectura"
msgstr "Ritmo de entrega y lectura"

#: src/shared/components/ApprovalTimelinessPanel.tsx
#: src/shared/constants/onboardingStatus.ts
msgid "Rojo"
msgstr "Rojo"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Rojo · anomalía"
msgstr "Rojo · anomalía"

#: src/features/dashboard/components/PipelineFlowCard.tsx
msgid "Rojo, Café y Negro pueden reactivarse: vuelven a Azul claro."
msgstr "Rojo, Café y Negro pueden reactivarse: vuelven a Azul claro."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/UsersPage.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Rol"
msgstr "Rol"

#: src/shared/constants/onboardingStatus.ts
msgid "Rosa"
msgstr "Rosa"

#: src/features/conversion/components/ApproveConversionDialog.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "Rosa → Naranja"
msgstr "Rosa → Naranja"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Rosa → Naranja, por semana"
msgstr "Rosa → Naranja, por semana"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/recruitment/pages/PoolPage.tsx
#: src/features/recruitment/pages/SelfPickHotelPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ruta"
msgstr "Ruta"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "S"
msgstr "S"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Sáb"
msgstr "Sáb"

#. placeholder {0}: formatDateTime(campaign.scheduledAt)
#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Sale {0}"
msgstr "Sale {0}"

#: src/features/observability/tabs/RecruitmentTab.tsx
msgid "Sale de la bitácora de las requisiciones (quién las tomó, soltó o reasignó) y del historial de cada candidato nuevo (quién lo dio de alta). A quién asignó cada reclutador no se ve: eso se registra en otra bitácora que el Manager de QA no lee. Quien no movió ninguna requisición ni dio de alta a nadie no aparece."
msgstr "Sale de la bitácora de las requisiciones (quién las tomó, soltó o reasignó) y del historial de cada candidato nuevo (quién lo dio de alta). A quién asignó cada reclutador no se ve: eso se registra en otra bitácora que el Manager de QA no lee. Quien no movió ninguna requisición ni dio de alta a nadie no aparece."

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Sale del Pool mientras el veto viva; el historial completo queda y solo el Administrador lo levanta."
msgstr "Sale del Pool mientras el veto viva; el historial completo queda y solo el Administrador lo levanta."

#: src/features/admin/components/PaymentLimitsSection.tsx
msgid "Sale siempre, con o sin pendientes."
msgstr "Sale siempre, con o sin pendientes."

#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Sale sola a esa hora, con los contactos que cumplan el filtro en ese momento."
msgstr "Sale sola a esa hora, con los contactos que cumplan el filtro en ese momento."

#: src/features/schedule/components/AddShiftDialog.tsx
#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/worker/api/punchApi.ts
#: src/features/worker/pages/PunchPage.tsx
msgid "Salida"
msgstr "Salida"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/CorrectPunchDialog.tsx
#: src/features/timesheet/components/ManualPunchDialog.tsx
#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/worker/api/punchApi.ts
msgid "Salida a lunch"
msgstr "Salida a lunch"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Salida operativa"
msgstr "Salida operativa"

#: src/features/worker/components/MobileShell.tsx
msgid "Saliendo…"
msgstr "Saliendo…"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Salió"
msgstr "Salió"

#. placeholder {0}: formatDateTime(campaign.startedAt)
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Salió {0}"
msgstr "Salió {0}"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Salir de la requisición"
msgstr "Salir de la requisición"

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "Salir por una rama pide siempre el motivo, que queda en el historial del prospecto. Cerrar el ciclo (archivarlo) es un acto aparte: libera al hotel para un ciclo nuevo."
msgstr "Salir por una rama pide siempre el motivo, que queda en el historial del prospecto. Cerrar el ciclo (archivarlo) es un acto aparte: libera al hotel para un ciclo nuevo."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Saliste sin firmar. Cuando quieras, «Firmar ahora» te regresa al documento."
msgstr "Saliste sin firmar. Cuando quieras, «Firmar ahora» te regresa al documento."

#: src/features/messaging/components/Tour.tsx
#: src/shared/components/OnboardingIntro.tsx
msgid "Saltar"
msgstr "Saltar"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Salud"
msgstr "Salud"

#: src/layouts/Sidebar.tsx
msgid "Schedule"
msgstr "Schedule"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Schedule del hotel"
msgstr "Schedule del hotel"

#. placeholder {0}: label.trim()
#. placeholder {0}: name.trim()
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Se agregó «{0}»"
msgstr "Se agregó «{0}»"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "Se arma el PDF y se manda por correo al contacto del hotel."
msgstr "Se arma el PDF y se manda por correo al contacto del hotel."

#: src/shared/constants/onboardingStatus.ts
msgid "Se arma y se envía aquí, dentro de Verde. No se sale hacia otro estado sin haberla mandado."
msgstr "Se arma y se envía aquí, dentro de Verde. No se sale hacia otro estado sin haberla mandado."

#: src/features/messaging/components/ContactActions.tsx
msgid "Se borra de la plataforma de mensajería junto con su historial de mensajes. No se puede deshacer."
msgstr "Se borra de la plataforma de mensajería junto con su historial de mensajes. No se puede deshacer."

#. placeholder {0}: pending.row.fullName
#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Se borra el acceso y se anonimiza la cuenta de {0} ahora, sin esperar el plazo. No se puede deshacer."
msgstr "Se borra el acceso y se anonimiza la cuenta de {0} ahora, sin esperar el plazo. No se puede deshacer."

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Se borran el hotel, sus contactos, sus ciclos en el Pipeline y los intentos de contacto. No se puede deshacer; en el historial queda quién lo eliminó."
msgstr "Se borran el hotel, sus contactos, sus ciclos en el Pipeline y los intentos de contacto. No se puede deshacer; en el historial queda quién lo eliminó."

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Se canceló el envío. El contrato se puede editar y mandar otra vez."
msgstr "Se canceló el envío. El contrato se puede editar y mandar otra vez."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Se capturan en el consolidado"
msgstr "Se capturan en el consolidado"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Se capturan una sola vez, aquí: cuando el hotel firme su contrato, lo hereda de aquí y no se vuelve a preguntar."
msgstr "Se capturan una sola vez, aquí: cuando el hotel firme su contrato, lo hereda de aquí y no se vuelve a preguntar."

#. placeholder {0}: formatInstantDate(row.dueAt)
#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Se completa el {0}"
msgstr "Se completa el {0}"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Se conserva como historial y no admite cambios."
msgstr "Se conserva como historial y no admite cambios."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Se conserva como historial: las semanas que rigió se calcularon con él."
msgstr "Se conserva como historial: las semanas que rigió se calcularon con él."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Se cotiza por puesto"
msgstr "Se cotiza por puesto"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Se crea como borrador. Ajusta las tarifas por posición y actívalo cuando esté listo."
msgstr "Se crea como borrador. Ajusta las tarifas por posición y actívalo cuando esté listo."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Se crea si no existe. Con ella los encuentras en Etiquetas y les mandas una campaña."
msgstr "Se crea si no existe. Con ella los encuentras en Etiquetas y les mandas una campaña."

#. placeholder {0}: campaign.name
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Se creó «{0}», pero nadie cumple con esos destinatarios: revisa a quién va antes de enviarla."
msgstr "Se creó «{0}», pero nadie cumple con esos destinatarios: revisa a quién va antes de enviarla."

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Se descuenta del pago de esta semana. Se puede quitar mientras el consolidado siga en Borrador."
msgstr "Se descuenta del pago de esta semana. Se puede quitar mientras el consolidado siga en Borrador."

#. placeholder {0}: mealDeductionAmount.toFixed(2)
#: src/features/contracts/components/MultiplierTable.tsx
msgid "Se descuenta, {0} USD por día laborado"
msgstr "Se descuenta, {0} USD por día laborado"

#. placeholder {0}: money(removing.amount)
#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Se devuelven <0>{0}</0> al neto de esta semana. Queda en el historial quién la quitó."
msgstr "Se devuelven <0>{0}</0> al neto de esta semana. Queda en el historial quién la quitó."

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Se dio de baja"
msgstr "Se dio de baja"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Se elabora y se envía con el hotel en Verde — y de ahí no se avanza sin propuesta enviada."
msgstr "Se elabora y se envía con el hotel en Verde — y de ahí no se avanza sin propuesta enviada."

#. placeholder {0}: item.label
#. placeholder {0}: pending.item.name
#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Se eliminó «{0}»"
msgstr "Se eliminó «{0}»"

#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "Se factura {billRange} por hora"
msgstr "Se factura {billRange} por hora"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Se genera automáticamente a partir de los campos — no se edita aquí."
msgstr "Se genera automáticamente a partir de los campos — no se edita aquí."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Se genera automáticamente a partir de los campos de arriba — no se edita aquí."
msgstr "Se genera automáticamente a partir de los campos de arriba — no se edita aquí."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Se genera solo al correr el pago de la semana (miércoles o la emergencia del jueves) — nunca se crea uno a mano aquí."
msgstr "Se genera solo al correr el pago de la semana (miércoles o la emergencia del jueves) — nunca se crea uno a mano aquí."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Se guarda como borrador: enviarla es otro paso, desde el listado."
msgstr "Se guarda como borrador: enviarla es otro paso, desde el listado."

#. placeholder {0}: check.name
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Se guardará como {0}"
msgstr "Se guardará como {0}"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Se importan, con un aviso:"
msgstr "Se importan, con un aviso:"

#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/components/RateTable.tsx
msgid "Se le factura al hotel"
msgstr "Se le factura al hotel"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Se le paga a esta posición"
msgstr "Se le paga a esta posición"

#: src/features/contracts/components/EditRateDialog.tsx
#: src/features/contracts/components/MultiplierTable.tsx
#: src/features/contracts/components/RateTable.tsx
msgid "Se le paga al colaborador"
msgstr "Se le paga al colaborador"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Se le reembolsa: se suma a lo que Contabilidad le paga en su próxima nómina."
msgstr "Se le reembolsa: se suma a lo que Contabilidad le paga en su próxima nómina."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "se le resta al colaborador"
msgstr "se le resta al colaborador"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "se le suma al colaborador"
msgstr "se le suma al colaborador"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "se llena ahora"
msgstr "se llena ahora"

#: src/features/messaging/components/tours.ts
msgid "Se manda a Meta para revisión. Solo las aprobadas se pueden usar en campañas."
msgstr "Se manda a Meta para revisión. Solo las aprobadas se pueden usar en campañas."

#: src/shared/components/SendDocumentModal.tsx
msgid "Se manda desde notificaciones@oranjepeople.com — las respuestas del hotel llegan a tu correo."
msgstr "Se manda desde notificaciones@oranjepeople.com — las respuestas del hotel llegan a tu correo."

#. placeholder {0}: campaign.templateName ?? '—'
#: src/features/messaging/components/CampaignOpsDialogs.tsx
msgid "Se manda por WhatsApp con la plantilla {0}. Una vez enviado, el mensaje no se puede retirar."
msgstr "Se manda por WhatsApp con la plantilla {0}. Una vez enviado, el mensaje no se puede retirar."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Se manda y se aprueba en un solo paso: el hotel ya no podrá editar estos días. Si algo cambia después, contacta a Oranje."
msgstr "Se manda y se aprueba en un solo paso: el hotel ya no podrá editar estos días. Si algo cambia después, contacta a Oranje."

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Se muestra una sola vez: cPanel no la vuelve a enseñar. Cópiala antes de cerrar."
msgstr "Se muestra una sola vez: cPanel no la vuelve a enseñar. Cópiala antes de cerrar."

#: src/features/conversion/api/conversionApi.ts
msgid "Se negocia en Rosa — el sistema aún no lo registra (pendiente de modelar)"
msgstr "Se negocia en Rosa — el sistema aún no lo registra (pendiente de modelar)"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Se parte en 40 h regulares y lo que exceda, por requisición. Sin contrato ni tarifa interna que resolver, no se inventa un número — queda en «—»."
msgstr "Se parte en 40 h regulares y lo que exceda, por requisición. Sin contrato ni tarifa interna que resolver, no se inventa un número — queda en «—»."

#: src/shared/components/SendDocumentModal.tsx
msgid "Se propone el correo del contacto principal del hotel — puedes cambiarlo."
msgstr "Se propone el correo del contacto principal del hotel — puedes cambiarlo."

#: src/features/recruitment/components/PoolRoster.tsx
msgid "Se puso disponible por su cuenta: no cambia la asignación de arriba."
msgstr "Se puso disponible por su cuenta: no cambia la asignación de arriba."

#. placeholder {0}: grant.fullName
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Se quitó «{title}» a {0}"
msgstr "Se quitó «{title}» a {0}"

#. placeholder {0}: money(netAmount)
#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "Se registran <0>{0}</0> como pagados a {workerName}. No se puede deshacer ni editar desde aquí: si algo cambia después, el ajuste va en otra semana."
msgstr "Se registran <0>{0}</0> como pagados a {workerName}. No se puede deshacer ni editar desde aquí: si algo cambia después, el ajuste va en otra semana."

#. placeholder {0}: status.workers
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Se registran o actualizan {0} colaboradores como contactos en la plataforma, con sus etiquetas de hotel y estado. Los de la lista negra quedan inactivos."
msgstr "Se registran o actualizan {0} colaboradores como contactos en la plataforma, con sus etiquetas de hotel y estado. Los de la lista negra quedan inactivos."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Se registran o actualizan los colaboradores como contactos en la plataforma, con sus etiquetas de hotel y estado. Los de la lista negra quedan inactivos."
msgstr "Se registran o actualizan los colaboradores como contactos en la plataforma, con sus etiquetas de hotel y estado. Los de la lista negra quedan inactivos."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Se registran o actualizan solo los colaboradores que cumplan el filtro, con sus etiquetas de hotel y estado. A los demás contactos no les pasa nada."
msgstr "Se registran o actualizan solo los colaboradores que cumplan el filtro, con sus etiquetas de hotel y estado. A los demás contactos no les pasa nada."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Se vuelve a pedir el SSN/ITIN"
msgstr "Se vuelve a pedir el SSN/ITIN"

#: src/features/worker/components/MobileShell.tsx
msgid "Secciones"
msgstr "Secciones"

#: src/shared/constants/onboardingStatus.ts
msgid "Seguimiento"
msgstr "Seguimiento"

#: src/features/observability/lib/inspectionKpis.ts
msgid "Seguimiento médico"
msgstr "Seguimiento médico"

#. placeholder {0}: draft.version
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Seguir borrador v{0}"
msgstr "Seguir borrador v{0}"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Según el día de envío; cada columna muestra cómo terminaron esos mensajes."
msgstr "Según el día de envío; cada columna muestra cómo terminaron esos mensajes."

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Según el país del contacto."
msgstr "Según el país del contacto."

#: src/shared/constants/catalogs.ts
msgid "Según solicitud"
msgstr "Según solicitud"

#. placeholder {0}: entry.date
#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "Seleccionar {0}"
msgstr "Seleccionar {0}"

#: src/layouts/Sidebar.tsx
msgid "Self-Pick"
msgstr "Self-Pick"

#: src/features/onboarding/components/HotelPunchQrCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Selfie"
msgstr "Selfie"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Selfie es lo normal. QR es para los hoteles que no permiten tomar fotos: Oranje genera un código que el hotel imprime en el acceso."
msgstr "Selfie es lo normal. QR es para los hoteles que no permiten tomar fotos: Oranje genera un código que el hotel imprime en el acceso."

#: src/features/observability/components/CohortsView.tsx
msgid "Sem {k}"
msgstr "Sem {k}"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Semáforo"
msgstr "Semáforo"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Semáforo del Colaborador · hoy"
msgstr "Semáforo del Colaborador · hoy"

#. placeholder {0}: String(data.poolPendingValidation)
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Semáforo del Colaborador · hoy · {0} por validar"
msgstr "Semáforo del Colaborador · hoy · {0} por validar"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Semáforo del motivo"
msgstr "Semáforo del motivo"

#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Semana"
msgstr "Semana"

#. placeholder {0}: formatWeekRange( selectedWeek, new Date(new Date(`${selectedWeek}T00:00:00Z`).getTime() + 6 * 86_400_000) .toISOString() .slice(0, 10), )
#. placeholder {0}: formatWeekRange(selectedWeek, rows[0]?.weekEnd ?? selectedWeek)
#. placeholder {0}: formatWeekRange(selectedWeek, weekEnd)
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Semana {0}"
msgstr "Semana {0}"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Semana {rangeLabel}"
msgstr "Semana {rangeLabel}"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Semana anterior"
msgstr "Semana anterior"

#: src/features/timesheet/components/AttendanceView.tsx
#: src/features/timesheet/components/WeekActionBar.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Semana aprobada"
msgstr "Semana aprobada"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Semana cerrada"
msgstr "Semana cerrada"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Semana cerrada — estos valores no cambian aunque ajustes el lonche del hotel."
msgstr "Semana cerrada — estos valores no cambian aunque ajustes el lonche del hotel."

#: src/features/observability/components/CohortSection.tsx
msgid "Semana de ingreso"
msgstr "Semana de ingreso"

#. placeholder {0}: formatWeekRange(selectedWeek, addDaysIso(selectedWeek, 6))
#. placeholder {0}: weekRangeOf(selected)
#: src/features/observability/components/CohortSection.tsx
#: src/features/timesheet/components/AttendanceView.tsx
msgid "Semana del {0}"
msgstr "Semana del {0}"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Semana enviada a revisión"
msgstr "Semana enviada a revisión"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Semana enviada y aprobada"
msgstr "Semana enviada y aprobada"

#: src/features/observability/components/CohortsView.tsx
msgid "Semana pasada"
msgstr "Semana pasada"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Semana pendiente de aprobar"
msgstr "Semana pendiente de aprobar"

#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Semana siguiente"
msgstr "Semana siguiente"

#: src/features/schedule/pages/SchedulePage.tsx
msgid "Semana: <0>{coverage}% cubierto</0> · {holes, plural, one {# hueco} other {# huecos}} — se asignan desde la Bolsa de la Reclutadora"
msgstr "Semana: <0>{coverage}% cubierto</0> · {holes, plural, one {# hueco} other {# huecos}} — se asignan desde la Bolsa de la Reclutadora"

#: src/features/observability/components/CohortsView.tsx
msgid "Semanal"
msgstr "Semanal"

#: src/features/observability/components/CohortTimeline.tsx
msgid "Semanas de ingreso"
msgstr "Semanas de ingreso"

#: src/features/observability/lib/hotelKpis.ts
msgid "Semanas de timesheet que el hotel recibió y todavía no aprueba."
msgstr "Semanas de timesheet que el hotel recibió y todavía no aprueba."

#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "Semanas sin anomalías pendientes, listas para aprobar"
msgstr "Semanas sin anomalías pendientes, listas para aprobar"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/features/observability/lib/hotelKpis.ts
#: src/layouts/Sidebar.tsx
msgid "Semanas sin aprobar"
msgstr "Semanas sin aprobar"

#: src/features/observability/components/CohortSection.tsx
msgid "Semanas trabajadas"
msgstr "Semanas trabajadas"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Servicios ofrecidos"
msgstr "Servicios ofrecidos"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Servidor de Oranje"
msgstr "Servidor de Oranje"

#: src/features/recruitment/components/PoolTable.tsx
msgid "sí"
msgstr "sí"

#. placeholder {0}: contract.hotelName
#: src/features/contracts/components/ContractNextStep.tsx
msgid "Si {0} necesita contrato, crea uno nuevo desde «Agregar contrato»."
msgstr "Si {0} necesita contrato, crea uno nuevo desde «Agregar contrato»."

#. placeholder {0}: contract.hotelName
#: src/features/contracts/components/ContractNextStep.tsx
msgid "Si {0} sigue siendo cliente, lo que sigue es crear un contrato nuevo."
msgstr "Si {0} sigue siendo cliente, lo que sigue es crear un contrato nuevo."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Si <0>{resetSentTo}</0> está registrado en Oranje, el enlace ya va en camino. Revisa también la carpeta de spam."
msgstr "Si <0>{resetSentTo}</0> está registrado en Oranje, el enlace ya va en camino. Revisa también la carpeta de spam."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Si aparece, el nombre, la dirección, el teléfono, el pin del mapa y la foto llegan solos. Si no está en Google, escribe el nombre abajo y en el siguiente paso marcas el punto en el mapa."
msgstr "Si aparece, el nombre, la dirección, el teléfono, el pin del mapa y la foto llegan solos. Si no está en Google, escribe el nombre abajo y en el siguiente paso marcas el punto en el mapa."

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Si cambian las tarifas, se corrigen aquí mismo — primero hay que desbloquearlo. Las semanas ya pagadas no se recalculan: cada una usó la tarifa que regía ese día."
msgstr "Si cambian las tarifas, se corrigen aquí mismo — primero hay que desbloquearlo. Las semanas ya pagadas no se recalculan: cada una usó la tarifa que regía ese día."

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Si el hotel ya tiene propuestas, contratos, requisiciones o es cliente, no se elimina: archiva su ciclo."
msgstr "Si el hotel ya tiene propuestas, contratos, requisiciones o es cliente, no se elimina: archiva su ciclo."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Si el servidor de Oranje falla, el sistema se pasa a Firebase él solo. Cambia esto a mano solo cuando el correo parezca salir bien pero no llegue."
msgstr "Si el servidor de Oranje falla, el sistema se pasa a Firebase él solo. Cambia esto a mano solo cuando el correo parezca salir bien pero no llegue."

#: src/features/worker/pages/Phase2Page.tsx
msgid "Si tu Reclutadora no te la tomó en la entrevista, súbela tú. Se guarda al elegirla. No hace falta para que te validen."
msgstr "Si tu Reclutadora no te la tomó en la entrevista, súbela tú. Se guarda al elegirla. No hace falta para que te validen."

#: src/shared/components/MascotaPeek.tsx
msgid "Si tu sesión caduca, al volver a entrar retomas en la misma pantalla."
msgstr "Si tu sesión caduca, al volver a entrar retomas en la misma pantalla."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Si ya se lo hiciste llegar al hotel por fuera"
msgstr "Si ya se lo hiciste llegar al hotel por fuera"

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Sí, activar contrato"
msgstr "Sí, activar contrato"

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Sí, actualizar"
msgstr "Sí, actualizar"

#: src/features/timesheet/components/BulkApproveButton.tsx
msgid "Sí, aprobarlas"
msgstr "Sí, aprobarlas"

#: src/features/onboarding/components/ContactAttemptLog.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Sí, borrar"
msgstr "Sí, borrar"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Sí, cancelar borrador"
msgstr "Sí, cancelar borrador"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Sí, cancelar envío"
msgstr "Sí, cancelar envío"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Sí, cancelar solicitud"
msgstr "Sí, cancelar solicitud"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Sí, cerrar"
msgstr "Sí, cerrar"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Sí, completar ahora"
msgstr "Sí, completar ahora"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Sí, continuar"
msgstr "Sí, continuar"

#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "Sí, convertir en cliente"
msgstr "Sí, convertir en cliente"

#: src/features/onboarding/components/CreateProposalPromptDialog.tsx
msgid "Sí, crear propuesta"
msgstr "Sí, crear propuesta"

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Sí, dar de baja"
msgstr "Sí, dar de baja"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Sí, descartar borrador"
msgstr "Sí, descartar borrador"

#: src/features/contracts/components/clauses/ClausesEditWarningDialog.tsx
msgid "Sí, editar"
msgstr "Sí, editar"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
#: src/features/admin/pages/CatalogsPage.tsx
#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "Sí, eliminar"
msgstr "Sí, eliminar"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Sí, eliminar buzón"
msgstr "Sí, eliminar buzón"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Sí, eliminar contacto"
msgstr "Sí, eliminar contacto"

#: src/features/onboarding/components/DeleteHotelAction.tsx
msgid "Sí, eliminar hotel"
msgstr "Sí, eliminar hotel"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Sí, eliminar requisición"
msgstr "Sí, eliminar requisición"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "Sí, enviar propuesta"
msgstr "Sí, enviar propuesta"

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
msgid "Sí, inclúyelo"
msgstr "Sí, inclúyelo"

#: src/shared/components/ReleaseAssignmentWarningDialog.tsx
msgid "Sí, liberar"
msgstr "Sí, liberar"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Sí, liberar slot"
msgstr "Sí, liberar slot"

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "Sí, marcar como enviada"
msgstr "Sí, marcar como enviada"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Sí, marcar como enviado"
msgstr "Sí, marcar como enviado"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Sí, marcar expirado"
msgstr "Sí, marcar expirado"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/admin/components/RoleGrantsSection.tsx
#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Sí, quitar"
msgstr "Sí, quitar"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Sí, rechazar"
msgstr "Sí, rechazar"

#: src/features/accounting/components/PayConsolidationButton.tsx
msgid "Sí, registrar pago"
msgstr "Sí, registrar pago"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Sí, volver a correr"
msgstr "Sí, volver a correr"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Sí: está en Gris y protegido"
msgstr "Sí: está en Gris y protegido"

#: src/features/clients/components/ClientFilters.tsx
msgid "siempre"
msgstr "siempre"

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Sigue bloqueado. Actívalo desde los Ajustes de tu teléfono."
msgstr "Sigue bloqueado. Actívalo desde los Ajustes de tu teléfono."

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "Sigue el contrato"
msgstr "Sigue el contrato"

#: src/features/onboarding/components/ProspectPhotoCard.tsx
msgid "Sigue el contrato →"
msgstr "Sigue el contrato →"

#. placeholder {0}: values.hotelName
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Sigue siendo {0}. Arrastra el mapa para dejar el pin en la entrada por donde llegan los colaboradores: mover el pin no cambia el hotel, solo dónde se poncha."
msgstr "Sigue siendo {0}. Arrastra el mapa para dejar el pin en la entrada por donde llegan los colaboradores: mover el pin no cambia el hotel, solo dónde se poncha."

#: src/features/observability/lib/cohorts.ts
msgid "Sigue trabajando"
msgstr "Sigue trabajando"

#: src/features/observability/components/CohortsView.tsx
msgid "Siguen a las 12 semanas"
msgstr "Siguen a las 12 semanas"

#: src/features/observability/components/CohortsView.tsx
msgid "Siguen a las 4 semanas"
msgstr "Siguen a las 4 semanas"

#: src/features/observability/components/CohortSection.tsx
msgid "Siguen trabajando"
msgstr "Siguen trabajando"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Sigues en Blanco hasta que la Reclutadora valide el alta"
msgstr "Sigues en Blanco hasta que la Reclutadora valide el alta"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/ContactImportsDialog.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/components/Pager.tsx
#: src/features/messaging/components/Tour.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
#: src/shared/components/CardPagination.tsx
#: src/shared/components/GuidedTour.tsx
msgid "Siguiente"
msgstr "Siguiente"

#: src/features/contracts/components/ContractNextStep.tsx
msgid "Siguiente paso: activar el contrato"
msgstr "Siguiente paso: activar el contrato"

#: src/shared/components/SoundSwitch.tsx
msgid "Silencio"
msgstr "Silencio"

#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin acceso a la app"
msgstr "Sin acceso a la app"

#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "Sin actividad 7+ días"
msgstr "Sin actividad 7+ días"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Sin actividad en 7 días o más"
msgstr "Sin actividad en 7 días o más"

#: src/features/observability/components/PeopleView.tsx
msgid "Sin actividad en el periodo"
msgstr "Sin actividad en el periodo"

#: src/features/dashboard/components/StaleProspectList.tsx
msgid "Sin actividad reciente"
msgstr "Sin actividad reciente"

#: src/features/observability/pages/PayAdjustmentsQueuePage.tsx
msgid "Sin ajustes pendientes: nada que aprobar por ahora."
msgstr "Sin ajustes pendientes: nada que aprobar por ahora."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Sin ajustes por incluir: no hay nada aprobado pendiente de decisión."
msgstr "Sin ajustes por incluir: no hay nada aprobado pendiente de decisión."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Sin altas ni asignaciones todavía"
msgstr "Sin altas ni asignaciones todavía"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Sin aprobación no se paga"
msgstr "Sin aprobación no se paga"

#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Sin asignación"
msgstr "Sin asignación"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Sin asignación en esta requisición: no hay contra qué capturar marcas"
msgstr "Sin asignación en esta requisición: no hay contra qué capturar marcas"

#: src/features/observability/lib/cohorts.ts
msgid "Sin asignación: terminó o lo liberaron"
msgstr "Sin asignación: terminó o lo liberaron"

#: src/features/requisitions/components/SlotList.tsx
msgid "Sin asignar"
msgstr "Sin asignar"

#: src/features/worker/pages/NotificationsPage.tsx
#: src/layouts/Header.tsx
msgid "Sin avisos por ahora."
msgstr "Sin avisos por ahora."

#: src/features/timesheet/components/PayPreviewBadge.tsx
msgid "Sin bill rate"
msgstr "Sin bill rate"

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Sin campañas"
msgstr "Sin campañas"

#: src/features/onboarding/components/HotelGlobeCard.tsx
msgid "Sin ciclo abierto"
msgstr "Sin ciclo abierto"

#: src/features/team/pages/TeamPage.tsx
msgid "Sin ciclos abiertos ahora mismo: todo lo suyo está convertido o cerrado."
msgstr "Sin ciclos abiertos ahora mismo: todo lo suyo está convertido o cerrado."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Sin colaboradores"
msgstr "Sin colaboradores"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Sin conceptos en el catálogo: pídele al Administrador que agregue uno en Catálogos."
msgstr "Sin conceptos en el catálogo: pídele al Administrador que agregue uno en Catálogos."

#: src/features/worker/pages/PunchPage.tsx
msgid "Sin conexión: la marca no se puede guardar todavía. Vuelve a intentarlo cuando tengas señal."
msgstr "Sin conexión: la marca no se puede guardar todavía. Vuelve a intentarlo cuando tengas señal."

#: src/features/messaging/components/ReportCharts.tsx
msgid "Sin confirmar o en cola"
msgstr "Sin confirmar o en cola"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Sin contacto identificado"
msgstr "Sin contacto identificado"

#: src/features/conversion/api/conversionApi.ts
msgid "Sin contacto registrado — agrégalo en la ficha del prospecto"
msgstr "Sin contacto registrado — agrégalo en la ficha del prospecto"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Sin contacto: agrégalo después en la ficha"
msgstr "Sin contacto: agrégalo después en la ficha"

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Sin contactos"
msgstr "Sin contactos"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Sin contraseñas de por medio"
msgstr "Sin contraseñas de por medio"

#: src/features/clients/components/ClientCardGrid.tsx
#: src/features/clients/components/ClientMapCard.tsx
#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "sin contrato"
msgstr "sin contrato"

#: src/features/onboarding/components/HotelContactList.tsx
msgid "Sin correo"
msgstr "Sin correo"

#: src/features/admin/pages/CorporateEmailPage.tsx
msgid "Sin crear"
msgstr "Sin crear"

#: src/features/requisitions/utils/coverage.ts
#: src/features/schedule/pages/SchedulePage.tsx
msgid "sin cubrir"
msgstr "sin cubrir"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin cuenta todavía"
msgstr "Sin cuenta todavía"

#: src/features/observability/lib/cohorts.ts
#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
msgid "Sin dato"
msgstr "Sin dato"

#: src/features/observability/components/KpiCard.tsx
msgid "Sin datos"
msgstr "Sin datos"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Sin deducciones esta semana."
msgstr "Sin deducciones esta semana."

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Sin definir aún…"
msgstr "Sin definir aún…"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Sin departamento asignado"
msgstr "Sin departamento asignado"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Sin departamento, esta cuenta ve y pide personal de TODOS los departamentos del hotel — la jerarquía simple de un hotel chico, con un solo Supervisor."
msgstr "Sin departamento, esta cuenta ve y pide personal de TODOS los departamentos del hotel — la jerarquía simple de un hotel chico, con un solo Supervisor."

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Sin dirección todavía"
msgstr "Sin dirección todavía"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin documentos adicionales."
msgstr "Sin documentos adicionales."

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Sin encabezado"
msgstr "Sin encabezado"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin entrada registrada"
msgstr "Sin entrada registrada"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "sin enviar a revisión"
msgstr "sin enviar a revisión"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Sin envíos en el periodo"
msgstr "Sin envíos en el periodo"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin estos datos no hay Fase 1"
msgstr "Sin estos datos no hay Fase 1"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Sin etiquetas"
msgstr "Sin etiquetas"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Sin etiquetas: para mandarles una campaña, elígelos en Contactos específicos."
msgstr "Sin etiquetas: para mandarles una campaña, elígelos en Contactos específicos."

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
msgid "Sin eventos registrados todavía."
msgstr "Sin eventos registrados todavía."

#: src/shared/constants/workerEnums.ts
msgid "Sin experiencia"
msgstr "Sin experiencia"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Sin filtro se sincronizan todos."
msgstr "Sin filtro se sincronizan todos."

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
#: src/features/timesheet/components/TimesheetGrid.tsx
msgid "Sin folio"
msgstr "Sin folio"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Sin foto todavía. Al elegir el hotel en el buscador, la foto llega sola y se guarda con el prospecto."
msgstr "Sin foto todavía. Al elegir el hotel en el buscador, la foto llega sola y se guarda con el prospecto."

#: src/features/observability/components/KpiCard.tsx
msgid "Sin fuente"
msgstr "Sin fuente"

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "sin guardar"
msgstr "sin guardar"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Sin hoja esta semana"
msgstr "Sin hoja esta semana"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Sin industria"
msgstr "Sin industria"

#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "Sin inglés registrado"
msgstr "Sin inglés registrado"

#: src/features/audits/components/AuditWorkerList.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Sin inspeccionar"
msgstr "Sin inspeccionar"

#: src/features/dashboard/components/StaleProspectList.tsx
msgid "Sin intento de contacto en 7 días o más"
msgstr "Sin intento de contacto en 7 días o más"

#: src/features/onboarding/utils/resolveActivityLabel.ts
msgid "Sin intentos"
msgstr "Sin intentos"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Sin intentos registrados todavía. Se llenan desde la bitácora de cada prospecto."
msgstr "Sin intentos registrados todavía. Se llenan desde la bitácora de cada prospecto."

#: src/features/onboarding/components/ContactAttemptLog.tsx
msgid "Sin intentos registrados. Usa «Registrar intento» para anotar el primero."
msgstr "Sin intentos registrados. Usa «Registrar intento» para anotar el primero."

#. placeholder {0}: IS_DEV_UI ? ' (D-27)' : ''
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin ITIN: aplica retención del 16%{0}"
msgstr "Sin ITIN: aplica retención del 16%{0}"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Sin jornadas este día"
msgstr "Sin jornadas este día"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Sin líneas."
msgstr "Sin líneas."

#. placeholder {0}: campaign.audience.excludedCountries.join(', ')
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Sin los países: {0}"
msgstr "Sin los países: {0}"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Sin Manager de Área"
msgstr "Sin Manager de Área"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin marcas"
msgstr "Sin marcas"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin marcas · marcar"
msgstr "Sin marcas · marcar"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin marcas esta semana."
msgstr "Sin marcas esta semana."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Sin marcas hoy"
msgstr "Sin marcas hoy"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Sin marcas registradas todavía."
msgstr "Sin marcas registradas todavía."

#: src/features/observability/components/KpiCard.tsx
msgid "Sin meta"
msgstr "Sin meta"

#: src/features/recruitment/components/PoolCardBoard.tsx
msgid "Sin modalidad definida"
msgstr "Sin modalidad definida"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "sin motivo"
msgstr "sin motivo"

#: src/features/reports/api/reportsApi.ts
msgid "Sin motivo registrado"
msgstr "Sin motivo registrado"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Sin motivos: quien cierre o rechace en este semáforo no tendrá de dónde elegir."
msgstr "Sin motivos: quien cierre o rechace en este semáforo no tendrá de dónde elegir."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin notas registradas."
msgstr "Sin notas registradas."

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Sin país"
msgstr "Sin país"

#: src/features/worker/components/QrScanner.tsx
msgid "Sin permiso de cámara no se puede leer el QR. Permítelo para este sitio y vuelve a intentar."
msgstr "Sin permiso de cámara no se puede leer el QR. Permítelo para este sitio y vuelve a intentar."

#: src/features/worker/pages/PunchPage.tsx
msgid "Sin permiso de ubicación no se puede ponchar: actívalo en Permisos, en el menú de tu cuenta."
msgstr "Sin permiso de ubicación no se puede ponchar: actívalo en Permisos, en el menú de tu cuenta."

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Sin plantilla"
msgstr "Sin plantilla"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Sin plantillas"
msgstr "Sin plantillas"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Sin ponche hoy"
msgstr "Sin ponche hoy"

#: src/features/timesheet/components/TimesheetDayCell.tsx
msgid "Sin ponches"
msgstr "Sin ponches"

#: src/shared/constants/timesheetStatus.ts
msgid "Sin ponches ese día"
msgstr "Sin ponches ese día"

#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin posición"
msgstr "Sin posición"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Sin posición asignada"
msgstr "Sin posición asignada"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "sin posiciones contratadas"
msgstr "sin posiciones contratadas"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Sin posiciones para este departamento"
msgstr "Sin posiciones para este departamento"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Sin posiciones: mientras no tenga, nadie puede pedir personal de este departamento."
msgstr "Sin posiciones: mientras no tenga, nadie puede pedir personal de este departamento."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Sin problemas"
msgstr "Sin problemas"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Sin propuesta"
msgstr "Sin propuesta"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "sin propuesta de origen"
msgstr "sin propuesta de origen"

#: src/features/conversion/api/conversionApi.ts
msgid "Sin propuesta enviada — se elabora y envía en Verde"
msgstr "Sin propuesta enviada — se elabora y envía en Verde"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Sin propuesta que mostrar todavía."
msgstr "Sin propuesta que mostrar todavía."

#: src/features/dashboard/components/StatusFunnel.tsx
msgid "Sin prospectos abiertos en el periodo."
msgstr "Sin prospectos abiertos en el periodo."

#: src/features/onboarding/components/PipelineColumn.tsx
msgid "Sin prospectos en este estado"
msgstr "Sin prospectos en este estado"

#: src/features/timesheet/components/TimesheetGrid.tsx
msgid "Sin registro este día"
msgstr "Sin registro este día"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "sin requisición"
msgstr "sin requisición"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Sin requisitos pendientes."
msgstr "Sin requisitos pendientes."

#: src/shared/constants/timesheetStatus.ts
msgid "Sin revisar"
msgstr "Sin revisar"

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "sin salida"
msgstr "sin salida"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin salida registrada"
msgstr "Sin salida registrada"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Sin salidas registradas todavía. Ningún ciclo se ha ido a Rojo, Café o Negro."
msgstr "Sin salidas registradas todavía. Ningún ciclo se ha ido a Rojo, Café o Negro."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Sin salir"
msgstr "Sin salir"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Sin semanas cerradas en el periodo."
msgstr "Sin semanas cerradas en el periodo."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sin subir todavía"
msgstr "Sin subir todavía"

#: src/features/clients/components/ClientCardGrid.tsx
msgid "Sin tarifas"
msgstr "Sin tarifas"

#: src/features/contracts/components/ContractPdfButton.tsx
#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Sin tarifas no se puede enviar el contrato."
msgstr "Sin tarifas no se puede enviar el contrato."

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Sin tarifas no se puede enviar ni activar: este contrato no trae ninguna posición cotizada."
msgstr "Sin tarifas no se puede enviar ni activar: este contrato no trae ninguna posición cotizada."

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
#: src/features/messaging/components/SyncWorkersButton.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Sin teléfono"
msgstr "Sin teléfono"

#: src/features/team/pages/TeamPage.tsx
msgid "sin territorio asignado todavía"
msgstr "sin territorio asignado todavía"

#: src/shared/constants/timesheetStatus.ts
msgid "Sin Timesheet"
msgstr "Sin Timesheet"

#: src/features/timesheet/components/TimesheetGrid.tsx
msgid "Sin timesheet esta semana"
msgstr "Sin timesheet esta semana"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Sin Timesheet esta semana — no registró ni una marca"
msgstr "Sin Timesheet esta semana — no registró ni una marca"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Sin Timesheets esta semana."
msgstr "Sin Timesheets esta semana."

#: src/features/worker/lib/noShiftMessage.ts
msgid "Sin turnos por ahora"
msgstr "Sin turnos por ahora"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Sin ubicación: marca el pin en la ficha del prospecto"
msgstr "Sin ubicación: marca el pin en la ficha del prospecto"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "Sin urgentes"
msgstr "Sin urgentes"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Sin verificación pendiente"
msgstr "Sin verificación pendiente"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Sin versión abierta"
msgstr "Sin versión abierta"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Sin versión abierta · la última ya se envió"
msgstr "Sin versión abierta · la última ya se envió"

#: src/features/contracts/utils/validity.ts
msgid "sin vigencia"
msgstr "sin vigencia"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Sin zonas elegidas el BD queda sin territorio asignado."
msgstr "Sin zonas elegidas el BD queda sin territorio asignado."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Sin zonas elegidas el Inspector no ve ningún hotel para levantar requisiciones ni inspeccionar."
msgstr "Sin zonas elegidas el Inspector no ve ningún hotel para levantar requisiciones ni inspeccionar."

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Sin zonas también es válido"
msgstr "Sin zonas también es válido"

#: src/features/messaging/components/tours.ts
msgid "Sincroniza para ver las plantillas que Meta ya aprobó o rechazó."
msgstr "Sincroniza para ver las plantillas que Meta ya aprobó o rechazó."

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Sincronización"
msgstr "Sincronización"

#: src/features/messaging/components/TemplateDetailDialog.tsx
msgid "Sincronizada"
msgstr "Sincronizada"

#. placeholder {0}: formatDateTime(template.syncedAt)
#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Sincronizada {0}"
msgstr "Sincronizada {0}"

#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Sincronizando…"
msgstr "Sincronizando…"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Sincronizar"
msgstr "Sincronizar"

#. placeholder {0}: chosenIds.length
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Sincronizar a {0}"
msgstr "Sincronizar a {0}"

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Sincronizar colaboradores"
msgstr "Sincronizar colaboradores"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Sincronizar desde Meta"
msgstr "Sincronizar desde Meta"

#: src/features/requisitions/components/RequisitionJournalDialog.tsx
#: src/shared/constants/roles.ts
msgid "Sistema"
msgstr "Sistema"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/requisitions/components/SlotList.tsx
msgid "Slot liberado"
msgstr "Slot liberado"

#: src/features/requisitions/components/RequisitionSummaryStrip.tsx
msgid "Slots"
msgstr "Slots"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Slots del renglón"
msgstr "Slots del renglón"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "sobre 40 h por requisición"
msgstr "sobre 40 h por requisición"

#: src/features/team/pages/TeamPage.tsx
msgid "Solicitar reporte"
msgstr "Solicitar reporte"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Solo a quien tenga todas las etiquetas elegidas."
msgstr "Solo a quien tenga todas las etiquetas elegidas."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Solo aparece quien está en Verde fuerte: expediente completo, validado por Reclutamiento y sin otra asignación activa."
msgstr "Solo aparece quien está en Verde fuerte: expediente completo, validado por Reclutamiento y sin otra asignación activa."

#: src/features/team/pages/TeamPage.tsx
msgid "solo ciclos abiertos"
msgstr "solo ciclos abiertos"

#: src/features/dashboard/components/StatusFunnel.tsx
msgid "Solo ciclos abiertos"
msgstr "Solo ciclos abiertos"

#: src/features/timesheet/components/CorrectPunchDialog.tsx
msgid "Solo corriges las horas de tu departamento."
msgstr "Solo corriges las horas de tu departamento."

#: src/features/worker/pages/PunchPage.tsx
msgid "Solo dentro del hotel"
msgstr "Solo dentro del hotel"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Solo el Administrador levanta"
msgstr "Solo el Administrador levanta"

#: src/shared/constants/workerStatus.ts
msgid "solo el Administrador levanta un veto, desde Blacklist."
msgstr "solo el Administrador levanta un veto, desde Blacklist."

#. placeholder {0}: IS_DEV_UI ? ' (blacklist:lift)' : ''
#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Solo el Administrador puede levantar un veto{0}: pídeselo."
msgstr "Solo el Administrador puede levantar un veto{0}: pídeselo."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Solo el BD dueño del ciclo o el BDC abren y envían versiones. Desde tu rol puedes consultarla, no editarla."
msgstr "Solo el BD dueño del ciclo o el BDC abren y envían versiones. Desde tu rol puedes consultarla, no editarla."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Solo el BD dueño del ciclo o el BDC pueden elaborar la propuesta."
msgstr "Solo el BD dueño del ciclo o el BDC pueden elaborar la propuesta."

#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Solo el BD, el BDC o el hotel pueden regenerar su QR."
msgstr "Solo el BD, el BDC o el hotel pueden regenerar su QR."

#: src/features/onboarding/components/SemaforoHelpDialog.tsx
msgid "solo el BDC"
msgstr "solo el BDC"

#: src/features/conversion/api/conversionApi.ts
msgid "solo el BDC aprueba esta transición"
msgstr "solo el BDC aprueba esta transición"

#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Solo el BDC o el Administrador pueden asignar territorio."
msgstr "Solo el BDC o el Administrador pueden asignar territorio."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Solo el contrato define lo que se paga y se factura"
msgstr "Solo el contrato define lo que se paga y se factura"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Solo el Manager de Área o el Manager General pueden aprobar la semana."
msgstr "Solo el Manager de Área o el Manager General pueden aprobar la semana."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Solo el nombre es obligatorio. Puesto, teléfono y correo se registran con lo que se tenga y se completan después."
msgstr "Solo el nombre es obligatorio. Puesto, teléfono y correo se registran con lo que se tenga y se completan después."

#: src/features/observability/components/CohortSection.tsx
msgid "Solo esta semana"
msgstr "Solo esta semana"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Solo lectura: las horas se capturan y revisan en cada hotel. Aquí ves el semáforo de la semana de todos — filtra por Hotel para quedarte en uno solo."
msgstr "Solo lectura: las horas se capturan y revisan en cada hotel. Aquí ves el semáforo de la semana de todos — filtra por Hotel para quedarte en uno solo."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Solo lectura. Las horas se revisan en cada hotel; aquí solo se consultan."
msgstr "Solo lectura. Las horas se revisan en cada hotel; aquí solo se consultan."

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Solo letras, números, punto y guión"
msgstr "Solo letras, números, punto y guión"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Solo lo aprobado paga"
msgstr "Solo lo aprobado paga"

#: src/features/observability/tabs/InspectionTab.tsx
msgid "Solo lo que dicen las requisiciones: las de su zona y las que creó. Sus inspecciones, accidentes y visitas no se ven: el Manager de QA no tiene permiso para leerlos. Un inspector sin requisiciones asignadas no aparece."
msgstr "Solo lo que dicen las requisiciones: las de su zona y las que creó. Sus inspecciones, accidentes y visitas no se ven: el Manager de QA no tiene permiso para leerlos. Un inspector sin requisiciones asignadas no aparece."

#: src/features/observability/tabs/InspectionTab.tsx
msgid "Solo los consolidados de nómina por estado. Los KPIs de Contabilidad (consolidados a tiempo, días a invoice, cobro, fuga de horas) necesitan que el Manager de QA pueda leer nómina y facturación."
msgstr "Solo los consolidados de nómina por estado. Los KPIs de Contabilidad (consolidados a tiempo, días a invoice, cobro, fuga de horas) necesitan que el Manager de QA pueda leer nómina y facturación."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Solo los hoteles en Verde (o Café, para renegociar) pueden abrir propuesta — y de Verde no se avanza sin enviarla."
msgstr "Solo los hoteles en Verde (o Café, para renegociar) pueden abrir propuesta — y de Verde no se avanza sin enviarla."

#: src/features/observability/components/CohortSection.tsx
msgid "Solo para las dos semanas más recientes."
msgstr "Solo para las dos semanas más recientes."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Solo planeas turnos de tu departamento."
msgstr "Solo planeas turnos de tu departamento."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Solo puede haber un principal por hotel."
msgstr "Solo puede haber un principal por hotel."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Solo puedes crear requisiciones de tu hotel"
msgstr "Solo puedes crear requisiciones de tu hotel"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Solo puedes crear requisiciones de tu hotel."
msgstr "Solo puedes crear requisiciones de tu hotel."

#: src/features/team/components/MoveRecruiterDialog.tsx
msgid "Solo puedes moverla con una Líder de tu equipo o contigo."
msgstr "Solo puedes moverla con una Líder de tu equipo o contigo."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Solo puedes pedir posiciones de tu departamento"
msgstr "Solo puedes pedir posiciones de tu departamento"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Solo puedes pedir posiciones de tu departamento. Las de otro departamento las crea su Manager de Área o el Manager General."
msgstr "Solo puedes pedir posiciones de tu departamento. Las de otro departamento las crea su Manager de Área o el Manager General."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Solo roles internos (nunca Administrador, Sistema, Colaborador ni roles del hotel) y solo a personal interno."
msgstr "Solo roles internos (nunca Administrador, Sistema, Colaborador ni roles del hotel) y solo a personal interno."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Solo roles internos de Oranje — las cuentas de los hoteles van en «Personal de hoteles»."
msgstr "Solo roles internos de Oranje — las cuentas de los hoteles van en «Personal de hoteles»."

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Solo se aprueba una semana enviada a aprobación."
msgstr "Solo se aprueba una semana enviada a aprobación."

#: src/features/contracts/components/UnlockContractDialog.tsx
msgid "Solo se desbloquea un contrato enviado o vigente."
msgstr "Solo se desbloquea un contrato enviado o vigente."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Solo se ofrecen los superiores del rol elegido: el BD apunta a su BDC, la Reclutadora a su Líder o al Manager de Reclutamiento."
msgstr "Solo se ofrecen los superiores del rol elegido: el BD apunta a su BDC, la Reclutadora a su Líder o al Manager de Reclutamiento."

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Solo se puede dar a un BD o un BDC: quien ya tiene el Pipeline y puede dar de alta hoteles."
msgstr "Solo se puede dar a un BD o un BDC: quien ya tiene el Pipeline y puede dar de alta hoteles."

#: src/features/worker/pages/HomePage.tsx
msgid "Solo se usa al ponchar, para saber que estás dentro del hotel. Al continuar, tu teléfono te va a pedir permiso de ubicación."
msgstr "Solo se usa al ponchar, para saber que estás dentro del hotel. Al continuar, tu teléfono te va a pedir permiso de ubicación."

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Solo su autor corrige"
msgstr "Solo su autor corrige"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Solo tiene sentido dentro de Hospitality."
msgstr "Solo tiene sentido dentro de Hospitality."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Solo un borrador se cancela."
msgstr "Solo un borrador se cancela."

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Solo un contrato vigente se puede marcar expirado."
msgstr "Solo un contrato vigente se puede marcar expirado."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Solo verá los hoteles de estas zonas — nunca todos."
msgstr "Solo verá los hoteles de estas zonas — nunca todos."

#: src/features/observability/lib/people.ts
msgid "Soltadas"
msgstr "Soltadas"

#. placeholder {0}: formatWeekRange(target, addDaysIso(target, 6))
#: src/features/timesheet/components/WeekSlider.tsx
msgid "Soltar en: {0}"
msgstr "Soltar en: {0}"

#: src/features/observability/lib/people.ts
msgid "Soltó la requisición"
msgstr "Soltó la requisición"

#: src/shared/components/SoundSwitch.tsx
msgid "Sonido"
msgstr "Sonido"

#: src/features/worker/components/MobileShell.tsx
#: src/shared/components/SoundSwitch.tsx
msgid "Sonido apagado"
msgstr "Sonido apagado"

#: src/features/worker/components/MobileShell.tsx
#: src/shared/components/SoundSwitch.tsx
msgid "Sonido encendido"
msgstr "Sonido encendido"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "SSN / ITIN"
msgstr "SSN / ITIN"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "SSN o ITIN subido"
msgstr "SSN o ITIN subido"

#: src/features/recruitment/lib/profileFields.ts
msgid "SSN/ITIN"
msgstr "SSN/ITIN"

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "SSN/ITIN recibido"
msgstr "SSN/ITIN recibido"

#: src/shared/constants/workerStatus.ts
msgid "Stand-by"
msgstr "Stand-by"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Su conversión ya se aprobó: no hay nada que convertir."
msgstr "Su conversión ya se aprobó: no hay nada que convertir."

#: src/features/contracts/components/SignAndSendDialog.tsx
msgid "Su correo"
msgstr "Su correo"

#: src/features/recruitment/components/CreateAccessDialog.tsx
msgid "Su cuenta de Oranje y su correo corporativo, con contraseñas para entregar en mano."
msgstr "Su cuenta de Oranje y su correo corporativo, con contraseñas para entregar en mano."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Su cuenta todavía no está lista. Inténtalo en unos minutos."
msgstr "Su cuenta todavía no está lista. Inténtalo en unos minutos."

#: src/features/messaging/components/tours.ts
msgid "Su estado y cuántos mensajes van enviados. Para enviarlas o ver más, entra a Campañas."
msgstr "Su estado y cuántos mensajes van enviados. Para enviarlas o ver más, entra a Campañas."

#. placeholder {0}: missingProfileFields.join(', ')
#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Su expediente está a medias: falta {0}."
msgstr "Su expediente está a medias: falta {0}."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Su folio, en qué estado está y cuántos lugares llevas cubiertos de los que pediste."
msgstr "Su folio, en qué estado está y cuántos lugares llevas cubiertos de los que pediste."

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Su hotel los propuso. Al aprobar, la cuenta se activa y les llega la invitación; hasta entonces no pueden entrar."
msgstr "Su hotel los propuso. Al aprobar, la cuenta se activa y les llega la invitación; hasta entonces no pueden entrar."

#: src/features/observability/components/CohortSection.tsx
msgid "Su lunes todavía no llega."
msgstr "Su lunes todavía no llega."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Su propio peso por reactivo y arrastre para reordenar — por eso vive separado, con una línea divisoria antes de su pestaña."
msgstr "Su propio peso por reactivo y arrastre para reordenar — por eso vive separado, con una línea divisoria antes de su pestaña."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Su rol define su app"
msgstr "Su rol define su app"

#: src/features/admin/pages/FeatureAccessPage.tsx
msgid "Su rol ya no da de alta hoteles: el acceso no cuenta."
msgstr "Su rol ya no da de alta hoteles: el acceso no cuenta."

#: src/features/personnel/components/WorkerPerformanceRadar.tsx
msgid "Su semana aún no da para medir"
msgstr "Su semana aún no da para medir"

#: src/features/messaging/components/CampaignsTour.tsx
msgid "Sube a tus colaboradores a la plataforma de mensajería. Las campañas solo les llegan a sus contactos."
msgstr "Sube a tus colaboradores a la plataforma de mensajería. Las campañas solo les llegan a sus contactos."

#: src/features/messaging/components/tours.ts
msgid "Sube un archivo con nombre y teléfono, previsualízalo y luego impórtalo. Ponles una etiqueta para mandarles una campaña."
msgstr "Sube un archivo con nombre y teléfono, previsualízalo y luego impórtalo. Ponles una etiqueta para mandarles una campaña."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sube un archivo nuevo en lugar de este — queda pendiente de verificar otra vez."
msgstr "Sube un archivo nuevo en lugar de este — queda pendiente de verificar otra vez."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Sube un archivo nuevo en lugar de este."
msgstr "Sube un archivo nuevo en lugar de este."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Sube un Excel (.xlsx), un CSV o TXT, o un PDF con una tabla. Cada fila se vuelve un hotel con su ciclo en Gris, igual que «Nuevo prospecto»."
msgstr "Sube un Excel (.xlsx), un CSV o TXT, o un PDF con una tabla. Cada fila se vuelve un hotel con su ciclo en Gris, igual que «Nuevo prospecto»."

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/components/PhotoUploader.tsx
#: src/features/worker/components/TaxDocumentUploader.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Subiendo…"
msgstr "Subiendo…"

#: src/shared/constants/workerStatus.ts
msgid "Subió sus datos en la app y está pendiente de que Reclutamiento valide su expediente."
msgstr "Subió sus datos en la app y está pendiente de que Reclutamiento valide su expediente."

#. placeholder {0}: documentTypeLabel(type)
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Subir {0}"
msgstr "Subir {0}"

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Subir archivo"
msgstr "Subir archivo"

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "Subir de nuevo"
msgstr "Subir de nuevo"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Subir foto"
msgstr "Subir foto"

#: src/features/worker/components/PhotoUploader.tsx
msgid "Subir mi foto"
msgstr "Subir mi foto"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Subir mi SSN o ITIN"
msgstr "Subir mi SSN o ITIN"

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Subir otro archivo"
msgstr "Subir otro archivo"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "Subtotal"
msgstr "Subtotal"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "suma de los días con marcas"
msgstr "suma de los días con marcas"

#: src/features/admin/types/admin.types.ts
#: src/shared/constants/roles.ts
msgid "Supervisor"
msgstr "Supervisor"

#. placeholder {0}: manager.fullName
#: src/features/team/pages/HotelTeamPage.tsx
msgid "Supervisores de {0}"
msgstr "Supervisores de {0}"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Supervisores sin Manager de Área"
msgstr "Supervisores sin Manager de Área"

#. placeholder {0}: tag.contactCount
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Sus {0} contactos se quedan en la plataforma; solo pierden la etiqueta. Un borrador de campaña que la use se quedaría sin esos destinatarios."
msgstr "Sus {0} contactos se quedan en la plataforma; solo pierden la etiqueta. Un borrador de campaña que la use se quedaría sin esos destinatarios."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Sus altas"
msgstr "Sus altas"

#: src/features/team/pages/TeamPage.tsx
msgid "Sus ciclos abiertos"
msgstr "Sus ciclos abiertos"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Sus datos"
msgstr "Sus datos"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Tablero de Requisiciones"
msgstr "Tablero de Requisiciones"

#: src/shared/components/ApprovalTimelinessPanel.tsx
msgid "Tarde"
msgstr "Tarde"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Tarifa"
msgstr "Tarifa"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Tarifa acordada"
msgstr "Tarifa acordada"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Tarifa acordada, en dólares"
msgstr "Tarifa acordada, en dólares"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Tarifa de facturación"
msgstr "Tarifa de facturación"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Tarifa de pago"
msgstr "Tarifa de pago"

#: src/features/contracts/components/EditRateDialog.tsx
msgid "Tarifa guardada"
msgstr "Tarifa guardada"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Tarifa interna"
msgstr "Tarifa interna"

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Tarifa interna del colaborador — no es la del contrato de este hotel"
msgstr "Tarifa interna del colaborador — no es la del contrato de este hotel"

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Tarifa por hora"
msgstr "Tarifa por hora"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Tarifa y reparto de horas se pueden corregir aquí; el monto se recalcula solo. La corrida real del miércoles usa tu corrección, no lo calculado."
msgstr "Tarifa y reparto de horas se pueden corregir aquí; el monto se recalcula solo. La corrida real del miércoles usa tu corrección, no lo calculado."

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Tarifa/h"
msgstr "Tarifa/h"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Tarifas"
msgstr "Tarifas"

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Tarifas globales, por ahora"
msgstr "Tarifas globales, por ahora"

#: src/features/contracts/components/NewContractDialog.tsx
#: src/features/contracts/components/RateTable.tsx
msgid "Tarifas por posición"
msgstr "Tarifas por posición"

#: src/features/observability/lib/inspectionKpis.ts
msgid "Tarjetas de accidente abiertas"
msgstr "Tarjetas de accidente abiertas"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Tasa"
msgstr "Tasa"

#: src/features/dashboard/components/ActivityCards.tsx
#: src/features/team/pages/TeamPage.tsx
msgid "Tasa de conversión"
msgstr "Tasa de conversión"

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Te dice que esa semana ya está lista para el Consolidado — no es un botón, es el estado que dejó el Manager al aprobarla."
msgstr "Te dice que esa semana ya está lista para el Consolidado — no es un botón, es el estado que dejó el Manager al aprobarla."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Te mandamos un enlace al correo para crear una nueva."
msgstr "Te mandamos un enlace al correo para crear una nueva."

#: src/features/team/pages/TeamPage.tsx
msgid "te reportan directo"
msgstr "te reportan directo"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Te reportan directo"
msgstr "Te reportan directo"

#: src/features/messaging/components/MessagingContactsList.tsx
#: src/features/messaging/components/MessagingWorkersList.tsx
#: src/features/messaging/pages/CampaignReportPage.tsx
#: src/features/onboarding/components/HotelContactsDialog.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase3Page.tsx
#: src/features/worker/pages/ProfilePage.tsx
#: src/shared/components/PhoneInput.tsx
msgid "Teléfono"
msgstr "Teléfono"

#. placeholder {0}: punch.deviceTime
#. placeholder {1}: punch.serverTime
#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "teléfono {0} · <0>servidor {1}</0>"
msgstr "teléfono {0} · <0>servidor {1}</0>"

#: src/features/messaging/components/ContactActions.tsx
msgid "Teléfono *"
msgstr "Teléfono *"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Teléfono con código de país"
msgstr "Teléfono con código de país"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Teléfono copiado: márcalo desde tu celular"
msgstr "Teléfono copiado: márcalo desde tu celular"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Teléfono de emergencia"
msgstr "Teléfono de emergencia"

#: src/features/onboarding/components/ProposalVersionDetailDialog.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Teléfono de quien envía"
msgstr "Teléfono de quien envía"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Teléfono del contacto"
msgstr "Teléfono del contacto"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Teléfono del contacto de emergencia"
msgstr "Teléfono del contacto de emergencia"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Teléfono del contacto no válido: no se guarda"
msgstr "Teléfono del contacto no válido: no se guarda"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Teléfono del hotel no válido: no se guarda"
msgstr "Teléfono del hotel no válido: no se guarda"

#: src/features/admin/components/AccountDeletionsSection.tsx
msgid "Teléfono en la plataforma de mensajes"
msgstr "Teléfono en la plataforma de mensajes"

#: src/features/onboarding/components/HotelDataCard.tsx
msgid "Teléfono general"
msgstr "Teléfono general"

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Teléfono inválido"
msgstr "Teléfono inválido"

#. placeholder {0}: worker.phone
#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "Teléfono inválido: {0}"
msgstr "Teléfono inválido: {0}"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Teléfono y zona"
msgstr "Teléfono y zona"

#: src/features/personnel/components/StandByDialog.tsx
msgid "Temporada baja"
msgstr "Temporada baja"

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
#: src/features/recruitment/types/selfPick.types.ts
#: src/shared/constants/catalogs.ts
msgid "Temporal"
msgstr "Temporal"

#. placeholder {0}: weekdayName((values.weekStartDay + 6) % 7)
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Termina el {0}."
msgstr "Termina el {0}."

#: src/features/requisitions/components/SlotList.tsx
msgid "Terminado"
msgstr "Terminado"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Terminar"
msgstr "Terminar"

#. placeholder {0}: formatInstantDayMonth(slot.endedAt)
#: src/features/requisitions/components/SlotList.tsx
msgid "Terminó el {0}"
msgstr "Terminó el {0}"

#: src/features/observability/lib/cohorts.ts
msgid "Terminó su asignación"
msgstr "Terminó su asignación"

#. placeholder {0}: member.fullName
#: src/features/team/components/AssignTerritoryDialog.tsx
msgid "Territorio asignado a {0}"
msgstr "Territorio asignado a {0}"

#: src/features/territory/pages/TerritoryPage.tsx
msgid "Territorio de {ownerName}"
msgstr "Territorio de {ownerName}"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Texto"
msgstr "Texto"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Texto de la propuesta"
msgstr "Texto de la propuesta"

#. placeholder {0}: index + 1
#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Texto de la variable {0}"
msgstr "Texto de la variable {0}"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Texto del botón"
msgstr "Texto del botón"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Texto del encabezado"
msgstr "Texto del encabezado"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Texto del reactivo"
msgstr "Texto del reactivo"

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Texto del reactivo, p. ej. Uniforme…"
msgstr "Texto del reactivo, p. ej. Uniforme…"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Texto fijo"
msgstr "Texto fijo"

#: src/shared/constants/catalogs.ts
msgid "Tiempo completo"
msgstr "Tiempo completo"

#: src/features/observability/lib/hotelKpis.ts
msgid "Tiempo en Stand-by"
msgstr "Tiempo en Stand-by"

#: src/features/contracts/components/ActivateContractDialog.tsx
msgid "Tiempo extra"
msgstr "Tiempo extra"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Tiempo hasta entregar"
msgstr "Tiempo hasta entregar"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Tiempo hasta leer"
msgstr "Tiempo hasta leer"

#: src/features/observability/lib/hotelKpis.ts
msgid "Tiempo para aprobar el timesheet"
msgstr "Tiempo para aprobar el timesheet"

#: src/features/reports/pages/ReportsPage.tsx
msgid "Tiempo por color del semáforo"
msgstr "Tiempo por color del semáforo"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Tiempo promedio"
msgstr "Tiempo promedio"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Tiempo y medio"
msgstr "Tiempo y medio"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Tiene al menos una posición cotizada"
msgstr "Tiene al menos una posición cotizada"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Tiene colaboradores asignados: libera las asignaciones antes de eliminarla."
msgstr "Tiene colaboradores asignados: libera las asignaciones antes de eliminarla."

#. placeholder {0}: String(MAX_IMPORT_ROWS)
#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Tiene más de {0} hoteles: divídelo en varios archivos."
msgstr "Tiene más de {0} hoteles: divídelo en varios archivos."

#: src/features/recruitment/components/DeleteWorkerDialog.tsx
msgid "Tiene una asignación activa en un hotel: primero hay que terminarla o reasignarla."
msgstr "Tiene una asignación activa en un hotel: primero hay que terminarla o reasignarla."

#: src/features/observability/lib/recruitmentKpis.ts
msgid "Time-to-fill"
msgstr "Time-to-fill"

#: src/features/onboarding/components/StatusTimeline.tsx
#: src/features/territory/components/HotelMapCard.tsx
msgid "Timeline del semáforo"
msgstr "Timeline del semáforo"

#: src/features/timesheet/pages/TimesheetPage.tsx
#: src/layouts/Sidebar.tsx
msgid "Timesheet"
msgstr "Timesheet"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Timesheet · Todos los hoteles"
msgstr "Timesheet · Todos los hoteles"

#: src/layouts/Sidebar.tsx
msgid "Timesheet de todos los hoteles"
msgstr "Timesheet de todos los hoteles"

#: src/layouts/Sidebar.tsx
msgid "Timesheet Global"
msgstr "Timesheet Global"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Timesheet Global · Cumplimiento"
msgstr "Timesheet Global · Cumplimiento"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Timesheets sin aprobar"
msgstr "Timesheets sin aprobar"

#: src/features/accounting/components/AddDeductionDialog.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Tipo"
msgstr "Tipo"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Tipo de deducción"
msgstr "Tipo de deducción"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Tipo de intento"
msgstr "Tipo de intento"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Tipo de marca"
msgstr "Tipo de marca"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase3Page.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Tipo de sangre"
msgstr "Tipo de sangre"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Tipo y resultado salen de listas cerradas — así los reportes pueden agrupar sin adivinar."
msgstr "Tipo y resultado salen de listas cerradas — así los reportes pueden agrupar sin adivinar."

#: src/features/worker/pages/NotificationsPage.tsx
msgid "Tocar un aviso lo marca como leído; los leídos se limpian a los 30 días"
msgstr "Tocar un aviso lo marca como leído; los leídos se limpian a los 30 días"

#: src/features/clients/components/ClientFilters.tsx
#: src/features/contracts/components/ContractFilters.tsx
#: src/features/dashboard/api/dashboardApi.ts
#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
msgid "todas"
msgstr "todas"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/territory/components/TerritoryZoneChips.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Todas"
msgstr "Todas"

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Todas las etiquetas"
msgstr "Todas las etiquetas"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Todas las semanas, de un vistazo"
msgstr "Todas las semanas, de un vistazo"

#: src/features/admin/components/ColaboradorAccountsSection.tsx
msgid "Todavía nadie tiene correo corporativo asignado."
msgstr "Todavía nadie tiene correo corporativo asignado."

#: src/features/accounting/components/IncludeAdjustmentDialog.tsx
#: src/features/contracts/components/ActivateContractDialog.tsx
#: src/features/contracts/components/clauses/ClausesEditWarningDialog.tsx
#: src/features/conversion/components/ApproveConversionDialog.tsx
msgid "Todavía no"
msgstr "Todavía no"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Todavía no eliges a nadie: márcalos en la lista de abajo."
msgstr "Todavía no eliges a nadie: márcalos en la lista de abajo."

#: src/features/admin/components/HotelUserFormDialog.tsx
#: src/features/admin/components/UserFormDialog.tsx
msgid "Todavía no ha entrado por primera vez."
msgstr "Todavía no ha entrado por primera vez."

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Todavía no ha salido ningún correo desde este ambiente."
msgstr "Todavía no ha salido ningún correo desde este ambiente."

#: src/features/observability/tabs/InspectionTab.tsx
msgid "Todavía no hay actividad por persona en Contabilidad: quién consolidó, validó o pagó vive en nómina y facturación, que el Manager de QA no tiene permiso para leer."
msgstr "Todavía no hay actividad por persona en Contabilidad: quién consolidó, validó o pagó vive en nómina y facturación, que el Manager de QA no tiene permiso para leer."

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Todavía no hay archivos en el vault de este hotel. Sube el primero para empezar."
msgstr "Todavía no hay archivos en el vault de este hotel. Sube el primero para empezar."

#: src/features/messaging/components/MessagingCampaignsList.tsx
msgid "Todavía no hay campañas en la plataforma."
msgstr "Todavía no hay campañas en la plataforma."

#: src/features/messaging/components/MessagingOverviewPanel.tsx
msgid "Todavía no hay campañas."
msgstr "Todavía no hay campañas."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Todavía no hay colaboradores que puedas ver."
msgstr "Todavía no hay colaboradores que puedas ver."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Todavía no hay consolidados. Se generan al cerrar la semana con las horas ya aprobadas."
msgstr "Todavía no hay consolidados. Se generan al cerrar la semana con las horas ya aprobadas."

#: src/features/messaging/components/MessagingContactsList.tsx
msgid "Todavía no hay contactos en la plataforma de mensajería."
msgstr "Todavía no hay contactos en la plataforma de mensajería."

#: src/features/onboarding/components/HotelContactList.tsx
msgid "Todavía no hay contactos."
msgstr "Todavía no hay contactos."

#: src/features/onboarding/components/HotelContactList.tsx
msgid "Todavía no hay contactos. Usa «Editar» para agregar el primero."
msgstr "Todavía no hay contactos. Usa «Editar» para agregar el primero."

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Todavía no hay contratos. El contrato de un hotel nace en su propia ficha del Pipeline, cuando ya vio la propuesta."
msgstr "Todavía no hay contratos. El contrato de un hotel nace en su propia ficha del Pipeline, cuando ya vio la propuesta."

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Todavía no hay cuentas de hotel activas. Agrega la primera con el botón de arriba."
msgstr "Todavía no hay cuentas de hotel activas. Agrega la primera con el botón de arriba."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Todavía no hay deducciones. Se capturan en el detalle de cada consolidado mientras está en Borrador."
msgstr "Todavía no hay deducciones. Se capturan en el detalle de cada consolidado mientras está en Borrador."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Todavía no hay departamentos. Agrega el primero con el botón de arriba; las posiciones se cuelgan de cada uno."
msgstr "Todavía no hay departamentos. Agrega el primero con el botón de arriba; las posiciones se cuelgan de cada uno."

#: src/features/messaging/components/ContactActions.tsx
#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Todavía no hay etiquetas en la plataforma de mensajería."
msgstr "Todavía no hay etiquetas en la plataforma de mensajería."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Todavía no hay etiquetas en la plataforma."
msgstr "Todavía no hay etiquetas en la plataforma."

#: src/features/accounting/pages/InvoicesPage.tsx
msgid "Todavía no hay facturas. Se generan por hotel y semana con las horas autorizadas."
msgstr "Todavía no hay facturas. Se generan por hotel y semana con las horas autorizadas."

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Todavía no hay gerentes ni supervisores en tu hotel"
msgstr "Todavía no hay gerentes ni supervisores en tu hotel"

#: src/features/admin/components/HotelUserFormDialog.tsx
msgid "Todavía no hay hoteles dados de alta: los crea Ventas en el Pipeline."
msgstr "Todavía no hay hoteles dados de alta: los crea Ventas en el Pipeline."

#: src/features/observability/components/CohortsView.tsx
msgid "Todavía no hay ingresos que medir."
msgstr "Todavía no hay ingresos que medir."

#: src/features/audits/components/AuditHistoryList.tsx
msgid "Todavía no hay inspecciones"
msgstr "Todavía no hay inspecciones"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Todavía no hay motivos. Agrega el primero desde el semáforo al que pertenece."
msgstr "Todavía no hay motivos. Agrega el primero desde el semáforo al que pertenece."

#: src/features/admin/pages/UsersPage.tsx
msgid "Todavía no hay personal activo. Agrega al primer usuario con el botón de arriba."
msgstr "Todavía no hay personal activo. Agrega al primer usuario con el botón de arriba."

#: src/features/observability/components/CohortsView.tsx
msgid "Todavía no hay ponches para este hotel."
msgstr "Todavía no hay ponches para este hotel."

#: src/features/onboarding/components/ProposalVersionList.tsx
msgid "Todavía no hay propuesta para este hotel. Empieza con «Abrir propuesta»."
msgstr "Todavía no hay propuesta para este hotel. Empieza con «Abrir propuesta»."

#: src/features/onboarding/components/ProposalVersionList.tsx
msgid "Todavía no hay propuesta: se arma con el hotel en Verde."
msgstr "Todavía no hay propuesta: se arma con el hotel en Verde."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Todavía no hay reactivos para esta inspección. Pídele al Administrador que los agregue en Catálogos."
msgstr "Todavía no hay reactivos para esta inspección. Pídele al Administrador que los agregue en Catálogos."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Todavía no hay reactivos. Agrega el primero con el botón de arriba."
msgstr "Todavía no hay reactivos. Agrega el primero con el botón de arriba."

#: src/features/reports/pages/RecruitmentReportsPage.tsx
msgid "Todavía no hay requisiciones autorizadas en ningún hotel."
msgstr "Todavía no hay requisiciones autorizadas en ningún hotel."

#: src/features/accounting/components/AccountingTimesheetGrid.tsx
msgid "Todavía no hay timesheets."
msgstr "Todavía no hay timesheets."

#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Todavía no hay versiones de la propuesta."
msgstr "Todavía no hay versiones de la propuesta."

#: src/features/messaging/components/ContactImportsDialog.tsx
msgid "Todavía no se ha importado ningún archivo."
msgstr "Todavía no se ha importado ningún archivo."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Todavía no se puede crear: el hotel está en {statusLabel}. La propuesta se abre cuando llega a Verde (o regresa en Café)."
msgstr "Todavía no se puede crear: el hotel está en {statusLabel}. La propuesta se abre cuando llega a Verde (o regresa en Café)."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Todavía no se puede:"
msgstr "Todavía no se puede:"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Todavía no tiene acceso."
msgstr "Todavía no tiene acceso."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Todavía no tiene Reclutadoras en su grupo."
msgstr "Todavía no tiene Reclutadoras en su grupo."

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Todavía no tiene Supervisores a cargo."
msgstr "Todavía no tiene Supervisores a cargo."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Todavía no tienes ningún hotel cliente en tus zonas asignadas — pídele al Coordinador que revise tu zona."
msgstr "Todavía no tienes ningún hotel cliente en tus zonas asignadas — pídele al Coordinador que revise tu zona."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Todavía no toca convertir"
msgstr "Todavía no toca convertir"

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "Todavía se puede corregir y capturar marcas. El Supervisor la envía cuando esté lista."
msgstr "Todavía se puede corregir y capturar marcas. El Supervisor la envía cuando esté lista."

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Todavía sin construir"
msgstr "Todavía sin construir"

#: src/features/accounting/pages/AccountingPendingPages.tsx
msgid "Todavía sin datos conectados"
msgstr "Todavía sin datos conectados"

#: src/features/admin/components/HotelUsersSection.tsx
msgid "Todo el hotel"
msgstr "Todo el hotel"

#: src/shared/components/DateRangeField.tsx
msgid "Todo el periodo"
msgstr "Todo el periodo"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Todo tu equipo tuvo actividad en la última semana."
msgstr "Todo tu equipo tuvo actividad en la última semana."

#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/admin/pages/UsersPage.tsx
#: src/features/clients/components/ClientFilters.tsx
#: src/features/contracts/components/ContractFilters.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/pages/BlacklistPage.tsx
#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "todos"
msgstr "todos"

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
#: src/features/accounting/pages/ConsolidationsPage.tsx
#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/observability/components/CohortSection.tsx
msgid "Todos"
msgstr "Todos"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Todos los colaboradores tienen un teléfono válido."
msgstr "Todos los colaboradores tienen un teléfono válido."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Todos los contactos"
msgstr "Todos los contactos"

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Todos los contactos de la plataforma de mensajería, no solo los de Oranje: los importados, los creados a mano y los de otras áreas."
msgstr "Todos los contactos de la plataforma de mensajería, no solo los de Oranje: los importados, los creados a mano y los de otras áreas."

#: src/features/observability/components/CohortSection.tsx
msgid "Todos los de esta cohorte siguen trabajando: no hay salidas que desglosar."
msgstr "Todos los de esta cohorte siguen trabajando: no hay salidas que desglosar."

#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Todos los días de este grupo pertenecen a esta requisición"
msgstr "Todos los días de este grupo pertenecen a esta requisición"

#: src/features/messaging/components/MessagingFilters.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Todos los estados"
msgstr "Todos los estados"

#: src/features/clients/pages/ClientPortfolioPage.tsx
#: src/features/messaging/components/MessagingFilters.tsx
#: src/features/observability/components/CohortsView.tsx
#: src/features/timesheet/components/TimesheetToolbar.tsx
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Todos los hoteles"
msgstr "Todos los hoteles"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Todos los mensajes de las campañas del periodo."
msgstr "Todos los mensajes de las campañas del periodo."

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Todos los motivos"
msgstr "Todos los motivos"

#: src/features/messaging/pages/CampaignReportPage.tsx
msgid "Todos los resultados"
msgstr "Todos los resultados"

#: src/features/observability/lib/people.ts
msgid "Tomadas"
msgstr "Tomadas"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Tomadas por tu equipo"
msgstr "Tomadas por tu equipo"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Tomadas por tu equipo y sin cubrir del todo"
msgstr "Tomadas por tu equipo y sin cubrir del todo"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Tomadas por una Reclutadora"
msgstr "Tomadas por una Reclutadora"

#: src/features/worker/components/CameraCapture.tsx
msgid "Tomar foto"
msgstr "Tomar foto"

#: src/features/observability/lib/people.ts
msgid "Tomó la requisición"
msgstr "Tomó la requisición"

#: src/features/accounting/pages/DeductionsPage.tsx
#: src/features/accounting/pages/InvoiceDetailPage.tsx
#: src/features/accounting/pages/InvoicesPage.tsx
#: src/features/messaging/components/ReportCharts.tsx
msgid "Total"
msgstr "Total"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Total de la semana"
msgstr "Total de la semana"

#. placeholder {0}: report.teamTotals.open
#. placeholder {1}: report.teamTotals.converted
#. placeholder {2}: formatPercent(report.teamTotals.rate)
#. placeholder {3}: report.teamTotals.averageDays !== null ? ` · ${String(report.teamTotals.averageDays)} d` : ''
#: src/features/reports/pages/ReportsPage.tsx
msgid "Total del equipo: {0} abiertos · {1} convertidos · {2}{3}"
msgstr "Total del equipo: {0} abiertos · {1} convertidos · {2}{3}"

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Total: {positionCount, plural, one {# posición} other {# posiciones}} · {totalSlots, plural, one {# slot} other {# slots}}"
msgstr "Total: {positionCount, plural, one {# posición} other {# posiciones}} · {totalSlots, plural, one {# slot} other {# slots}}"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Trabajadas esta semana"
msgstr "Trabajadas esta semana"

#: src/features/timesheet/components/TimesheetDayCell.tsx
#: src/shared/constants/timesheetStatus.ts
msgid "Trabajando ahora"
msgstr "Trabajando ahora"

#: src/layouts/RoleSwitcher.tsx
msgid "Trabajar como"
msgstr "Trabajar como"

#: src/features/observability/components/CohortsView.tsx
msgid "Trabajaron en su semana 12 · ~90 días"
msgstr "Trabajaron en su semana 12 · ~90 días"

#: src/features/observability/components/CohortsView.tsx
msgid "Trabajaron en su semana 4 · ~30 días"
msgstr "Trabajaron en su semana 4 · ~30 días"

#: src/features/observability/components/CohortSection.tsx
msgid "Trabajaron la semana siguiente"
msgstr "Trabajaron la semana siguiente"

#: src/features/accounting/components/ConsolidationPayStatus.tsx
msgid "Trabajó en más de un hotel esta semana: cada Consolidado se paga por separado, desde su propia ficha."
msgstr "Trabajó en más de un hotel esta semana: cada Consolidado se paga por separado, desde su propia ficha."

#: src/features/messaging/components/tours.ts
msgid "Trae las de Meta"
msgstr "Trae las de Meta"

#: src/shared/components/ReloadButton.tsx
msgid "Traer lo más reciente"
msgstr "Traer lo más reciente"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/lib/profileFields.ts
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Transporte"
msgstr "Transporte"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Transporte guardado"
msgstr "Transporte guardado"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Transporte y salud"
msgstr "Transporte y salud"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Transporte y tipo de sangre"
msgstr "Transporte y tipo de sangre"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Transporte, emergencia y salud — opcional"
msgstr "Transporte, emergencia y salud — opcional"

#: src/features/observability/lib/cohorts.ts
msgid "Tres faltas: Blacklist automático"
msgstr "Tres faltas: Blacklist automático"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Tres reglas que el sistema hace cumplir siempre: un colaborador en <0>Gris</0> (accidentado) no se puede vetar; solo hay un veto vigente a la vez y el historial nunca se borra; y al levantarlo la persona vuelve a <1>Blanco</1>, reingresando por la validación de la Reclutadora."
msgstr "Tres reglas que el sistema hace cumplir siempre: un colaborador en <0>Gris</0> (accidentado) no se puede vetar; solo hay un veto vigente a la vez y el historial nunca se borra; y al levantarlo la persona vuelve a <1>Blanco</1>, reingresando por la validación de la Reclutadora."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "tú"
msgstr "tú"

#: src/features/worker/components/MobileShell.tsx
msgid "Tu acceso terminó"
msgstr "Tu acceso terminó"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Tu acceso y tus sesiones abiertas."
msgstr "Tu acceso y tus sesiones abiertas."

#. placeholder {0}: formatInstantDate(dueAt)
#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Tu acceso ya está cerrado. La eliminación de tu cuenta se completa el {0}."
msgstr "Tu acceso ya está cerrado. La eliminación de tu cuenta se completa el {0}."

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Tu actividad"
msgstr "Tu actividad"

#: src/features/worker/pages/HomePage.tsx
msgid "tu contacto de emergencia"
msgstr "tu contacto de emergencia"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Tu contraseña"
msgstr "Tu contraseña"

#. placeholder {0}: profile.legacyAccess.corporateEmail
#: src/features/worker/pages/PunchPage.tsx
msgid "Tu correo para entrar cambia a <0>{0}</0>: úsalo la próxima vez."
msgstr "Tu correo para entrar cambia a <0>{0}</0>: úsalo la próxima vez."

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Tu cuenta aún no tiene permiso para subir archivos: Oranje lo está habilitando."
msgstr "Tu cuenta aún no tiene permiso para subir archivos: Oranje lo está habilitando."

#: src/features/worker/pages/PunchPage.tsx
msgid "Tu cuenta aún no tiene permiso para subir la foto: Oranje lo está habilitando."
msgstr "Tu cuenta aún no tiene permiso para subir la foto: Oranje lo está habilitando."

#: src/features/auth/pages/LoginPage.tsx
#: src/mobile/AppLoginPage.tsx
msgid "Tu cuenta no está activa en Oranje. Pide al Administrador que la active."
msgstr "Tu cuenta no está activa en Oranje. Pide al Administrador que la active."

#: src/features/worker/pages/PunchPage.tsx
msgid "Tu cuenta no está ligada a un colaborador: avisa a Reclutamiento."
msgstr "Tu cuenta no está ligada a un colaborador: avisa a Reclutamiento."

#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Tu cuenta no tiene permiso para subir archivos a este vault."
msgstr "Tu cuenta no tiene permiso para subir archivos a este vault."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Tú decides si entra a la nómina"
msgstr "Tú decides si entra a la nómina"

#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Tu equipo"
msgstr "Tu equipo"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Tu equipo avanza contigo"
msgstr "Tu equipo avanza contigo"

#: src/features/worker/pages/ProfilePage.tsx
msgid "Tu estado hoy"
msgstr "Tu estado hoy"

#: src/features/worker/pages/Phase3Page.tsx
msgid "Tu expediente quedó completo. La Reclutadora lo validará"
msgstr "Tu expediente quedó completo. La Reclutadora lo validará"

#: src/features/worker/components/MobileShell.tsx
msgid "Tu expediente ya no está activo en Oranje, así que aquí no hay nada que mostrarte. Si crees que es un error, habla con tu Reclutadora."
msgstr "Tu expediente ya no está activo en Oranje, así que aquí no hay nada que mostrarte. Si crees que es un error, habla con tu Reclutadora."

#: src/features/worker/pages/Phase2Page.tsx
msgid "Tu foto"
msgstr "Tu foto"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Tu gente y su color"
msgstr "Tu gente y su color"

#: src/features/audits/components/AuditHotelCard.tsx
msgid "Tu hotel"
msgstr "Tu hotel"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Tu hotel todavía no tiene un contrato activo con Oranje: pídele a tu ejecutivo de Oranje que lo active."
msgstr "Tu hotel todavía no tiene un contrato activo con Oranje: pídele a tu ejecutivo de Oranje que lo active."

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Tu hotel usa selfie o el QR del acceso. Si usa QR, desde aquí imprimes la hoja que se pega en la entrada, y puedes regenerarla si se filtró."
msgstr "Tu hotel usa selfie o el QR del acceso. Si usa QR, desde aquí imprimes la hoja que se pega en la entrada, y puedes regenerarla si se filtró."

#: src/features/worker/pages/PunchPage.tsx
msgid "Tu marca quedó registrada"
msgstr "Tu marca quedó registrada"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Tu nombre, tu correo y tu foto en la cuenta, y tus avisos."
msgstr "Tu nombre, tu correo y tu foto en la cuenta, y tus avisos."

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "Tu plantel de un vistazo"
msgstr "Tu plantel de un vistazo"

#. placeholder {0}: profile.position.name
#. placeholder {1}: profile.hiringModality?.name ?? '—'
#. placeholder {2}: profile.englishLevel?.name ?? '—'
#: src/features/worker/pages/Phase2Page.tsx
msgid "Tu posición ({0}), modalidad ({1}) y nivel de inglés ({2}) los definió Oranje en tu entrevista. Si algo no cuadra, coméntalo con tu Reclutadora."
msgstr "Tu posición ({0}), modalidad ({1}) y nivel de inglés ({2}) los definió Oranje en tu entrevista. Si algo no cuadra, coméntalo con tu Reclutadora."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Tu requisición está cubierta"
msgstr "Tu requisición está cubierta"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Tu requisición se cerró"
msgstr "Tu requisición se cerró"

#: src/features/timesheet/components/ReviewDayDialog.tsx
msgid "Tú resuelves anomalías y dejas la nota; aprobar las horas es del Manager de Área o del General."
msgstr "Tú resuelves anomalías y dejas la nota; aprobar las horas es del Manager de Área o del General."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Tu rol no puede crear requisiciones: las crean el Supervisor, el Manager de Área, el Manager General del hotel o el Inspector de su zona."
msgstr "Tu rol no puede crear requisiciones: las crean el Supervisor, el Manager de Área, el Manager General del hotel o el Inspector de su zona."

#: src/features/messaging/components/MessagingWorkersList.tsx
msgid "Tu rol no puede ver el listado de colaboradores"
msgstr "Tu rol no puede ver el listado de colaboradores"

#: src/features/messaging/pages/ExcludedWorkersPage.tsx
msgid "Tu rol no puede ver esta lista"
msgstr "Tu rol no puede ver esta lista"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Tu rol no tiene acceso al Tablero de Requisiciones. Lo ven el hotel que las pide y Reclutamiento."
msgstr "Tu rol no tiene acceso al Tablero de Requisiciones. Lo ven el hotel que las pide y Reclutamiento."

#: src/features/team/pages/TeamPage.tsx
msgid "Tu rol no tiene BDs a cargo, así que aquí no hay nada que mostrar."
msgstr "Tu rol no tiene BDs a cargo, así que aquí no hay nada que mostrar."

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Tu rol no tiene gerentes ni supervisores a cargo, así que aquí no hay nada que mostrar."
msgstr "Tu rol no tiene gerentes ni supervisores a cargo, así que aquí no hay nada que mostrar."

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Tu rol no tiene Líderes ni Reclutadoras a cargo, así que aquí no hay nada que mostrar."
msgstr "Tu rol no tiene Líderes ni Reclutadoras a cargo, así que aquí no hay nada que mostrar."

#: src/features/accounting/pages/AccountingTimesheetPage.tsx
msgid "Tu rol todavía no tiene acceso a las horas de todos los hoteles."
msgstr "Tu rol todavía no tiene acceso a las horas de todos los hoteles."

#: src/features/worker/pages/ProfilePage.tsx
msgid "Tu semáforo"
msgstr "Tu semáforo"

#: src/features/worker/pages/HomePage.tsx
msgid "Tu semáforo no permite encender Amarillo desde aquí."
msgstr "Tu semáforo no permite encender Amarillo desde aquí."

#: src/features/worker/pages/HomePage.tsx
msgid "Tu semáforo, en palabras"
msgstr "Tu semáforo, en palabras"

#: src/features/worker/lib/noShiftMessage.ts
msgid "Tu situación está en revisión y no hay turnos que ponchar. Customer Service te puede orientar."
msgstr "Tu situación está en revisión y no hay turnos que ponchar. Customer Service te puede orientar."

#: src/features/worker/pages/HomePage.tsx
msgid "tu SSN o ITIN"
msgstr "tu SSN o ITIN"

#. placeholder {0}: deadline.isDocumentVerified ? t`verificado` : t`cargado, en verificación`
#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "Tu SSN/ITIN está {0}."
msgstr "Tu SSN/ITIN está {0}."

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "Tu SSN/ITIN fue rechazado"
msgstr "Tu SSN/ITIN fue rechazado"

#: src/features/worker/pages/PunchPage.tsx
msgid "Tu teléfono manda la ubicación y el sistema verifica que estés en el hotel. Si estás fuera, pídele al Supervisor un ponche manual."
msgstr "Tu teléfono manda la ubicación y el sistema verifica que estés en el hotel. Si estás fuera, pídele al Supervisor un ponche manual."

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Tu teléfono, tu contacto de emergencia, tu tipo de sangre, tus notas médicas, tu foto de perfil, tus avisos y tu correo de Oranje."
msgstr "Tu teléfono, tu contacto de emergencia, tu tipo de sangre, tus notas médicas, tu foto de perfil, tus avisos y tu correo de Oranje."

#: src/features/worker/pages/HomePage.tsx
msgid "tu tipo de sangre"
msgstr "tu tipo de sangre"

#: src/features/worker/pages/Phase2Page.tsx
msgid "Tu transporte quedó guardado."
msgstr "Tu transporte quedó guardado."

#: src/features/worker/pages/Phase2Page.tsx
msgid "Tu transporte y tu SSN o ITIN"
msgstr "Tu transporte y tu SSN o ITIN"

#: src/mobile/AppLoginPage.tsx
msgid "Tu turno o la operación de tu hotel, en tu celular."
msgstr "Tu turno o la operación de tu hotel, en tu celular."

#: src/features/auth/pages/LoginPage.tsx
msgid "Tu turno, tu ponche y tus datos, en tu celular."
msgstr "Tu turno, tu ponche y tus datos, en tu celular."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Tu usuario no tiene un hotel asignado todavía. Sin hotel no hay a quién inspeccionar — pídele al Administrador que revise tu alta."
msgstr "Tu usuario no tiene un hotel asignado todavía. Sin hotel no hay a quién inspeccionar — pídele al Administrador que revise tu alta."

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Turno agregado"
msgstr "Turno agregado"

#: src/features/schedule/pages/SchedulePage.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Turno elegido"
msgstr "Turno elegido"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Tus asignaciones se liberan hoy. Los pagos pendientes se pagan como siempre. Para volver a trabajar con Oranje tendrás que registrarte de nuevo."
msgstr "Tus asignaciones se liberan hoy. Los pagos pendientes se pagan como siempre. Para volver a trabajar con Oranje tendrás que registrarte de nuevo."

#: src/features/worker/pages/NotificationsPage.tsx
msgid "Tus avisos llegarán aquí en cuanto el servicio de notificaciones esté activo."
msgstr "Tus avisos llegarán aquí en cuanto el servicio de notificaciones esté activo."

#: src/features/worker/pages/ProfilePage.tsx
msgid "Tus datos"
msgstr "Tus datos"

#: src/features/team/pages/HotelTeamPage.tsx
msgid "Tus gerentes y supervisores"
msgstr "Tus gerentes y supervisores"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Tus Líderes y Reclutadoras, y cómo va el trabajo de cada una"
msgstr "Tus Líderes y Reclutadoras, y cómo va el trabajo de cada una"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Tus requisiciones recientes"
msgstr "Tus requisiciones recientes"

#: src/features/dashboard/components/HotelDashboard.tsx
msgid "Tus tres números"
msgstr "Tus tres números"

#: src/shared/constants/workerStatus.ts
msgid "Tuvo un accidente laboral y está en incapacidad médica. No se le puede vetar mientras esté aquí."
msgstr "Tuvo un accidente laboral y está en incapacidad médica. No se le puede vetar mientras esté aquí."

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/PlacesAutofillSummary.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/worker/pages/PermissionsPage.tsx
msgid "Ubicación"
msgstr "Ubicación"

#: src/features/observability/components/PeopleView.tsx
#: src/features/reports/pages/RecruitmentReportsPage.tsx
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Última actividad"
msgstr "Última actividad"

#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Última actividad hoy"
msgstr "Última actividad hoy"

#. placeholder {0}: lastSent.version
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Última enviada · v{0}"
msgstr "Última enviada · v{0}"

#: src/features/observability/components/CohortSection.tsx
msgid "Última semana"
msgstr "Última semana"

#. placeholder {0}: formatDateTime(data.updatedAt)
#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Última vez que se cambió: {0}"
msgstr "Última vez que se cambió: {0}"

#: src/features/dashboard/components/ActivityCards.tsx
msgid "Últimas 8 semanas"
msgstr "Últimas 8 semanas"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Últimos 30 días"
msgstr "Últimos 30 días"

#. placeholder {0}: String(member.workersCreatedLast30Days)
#: src/features/team/pages/RecruitmentTeamPage.tsx
msgid "Últimos 30 días · {0}"
msgstr "Últimos 30 días · {0}"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Últimos 7 días"
msgstr "Últimos 7 días"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/observability/lib/period.ts
msgid "Últimos 90 días"
msgstr "Últimos 90 días"

#: src/features/admin/pages/MailSettingsPage.tsx
msgid "Últimos correos"
msgstr "Últimos correos"

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Un consolidado es de un colaborador, un hotel y una semana: quien trabajó en dos hoteles aparece dos veces. El filtro por hotel llega después."
msgstr "Un consolidado es de un colaborador, un hotel y una semana: quien trabajó en dos hoteles aparece dos veces. El filtro por hotel llega después."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Un dato no es válido"
msgstr "Un dato no es válido"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Un dato no es válido ({fields})"
msgstr "Un dato no es válido ({fields})"

#: src/features/timesheet/components/DayStatusTour.tsx
msgid "Un día sin marcas no se puede enviar a aprobar hasta que elijas qué fue: Descanso, OFF… Tócalo aquí para marcarlo."
msgstr "Un día sin marcas no se puede enviar a aprobar hasta que elijas qué fue: Descanso, OFF… Tócalo aquí para marcarlo."

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Un documento por tipo — súbelo, verifícalo o reemplázalo"
msgstr "Un documento por tipo — súbelo, verifícalo o reemplázalo"

#: src/features/onboarding/components/ArchiveCycleDialog.tsx
msgid "Un hotel en Naranja es cliente activo: primero pásalo a Negro y luego archiva."
msgstr "Un hotel en Naranja es cliente activo: primero pásalo a Negro y luego archiva."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Un hotel puede pedir personal cuando llega a Naranja, es decir, cuando ya es cliente activo."
msgstr "Un hotel puede pedir personal cuando llega a Naranja, es decir, cuando ya es cliente activo."

#: src/features/onboarding/components/HotelContactsDialog.tsx
msgid "Un hotel puede tener los contactos que haga falta"
msgstr "Un hotel puede tener los contactos que haga falta"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Un hotel solo puede tener un contrato vigente a la vez: es lo que respalda cada asignación y cada factura."
msgstr "Un hotel solo puede tener un contrato vigente a la vez: es lo que respalda cada asignación y cada factura."

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Un hotel, un ciclo"
msgstr "Un hotel, un ciclo"

#: src/features/onboarding/components/RegisterAttemptDialog.tsx
msgid "Un intento puede corregirse o borrarse, pero únicamente por quien lo registró."
msgstr "Un intento puede corregirse o borrarse, pero únicamente por quien lo registró."

#: src/features/timesheet/components/WorkerWeekSummary.tsx
msgid "Un Manager ya la aprobó. Sigue el pago y la factura del hotel."
msgstr "Un Manager ya la aprobó. Sigue el pago y la factura del hotel."

#: src/shared/components/SendDocumentModal.tsx
msgid "Un mensaje breve antes del documento (opcional)…"
msgstr "Un mensaje breve antes del documento (opcional)…"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
#: src/features/worker/pages/HomePage.tsx
msgid "Un momento…"
msgstr "Un momento…"

#: src/features/accounting/components/AddDeductionDialog.tsx
msgid "Un monto mayor que 0, con hasta 2 decimales (p. ej. 15.00)."
msgstr "Un monto mayor que 0, con hasta 2 decimales (p. ej. 15.00)."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Un motivo pertenece a un semáforo: elige a cuál."
msgstr "Un motivo pertenece a un semáforo: elige a cuál."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Un número mayor a 0."
msgstr "Un número mayor a 0."

#: src/features/accounting/components/PayOverrideDialog.tsx
msgid "Un número válido, 0 o más."
msgstr "Un número válido, 0 o más."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Un pay rate y un bill rate para todo el hotel. Cotizar por posición llegará más adelante."
msgstr "Un pay rate y un bill rate para todo el hotel. Cotizar por posición llegará más adelante."

#: src/features/audits/pages/AuditsPage.tsx
msgid "Un registro sin consecuencia"
msgstr "Un registro sin consecuencia"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Un renglón por puesto con su pay y su bill: es el mismo cuadro que el hotel firma en el contrato."
msgstr "Un renglón por puesto con su pay y su bill: es el mismo cuadro que el hotel firma en el contrato."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Un slot por cada persona pedida en la posición"
msgstr "Un slot por cada persona pedida en la posición"

#: src/features/timesheet/components/WeekActionBar.tsx
msgid "Un solo clic: manda la semana y la deja aprobada"
msgstr "Un solo clic: manda la semana y la deja aprobada"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Un solo veto vigente"
msgstr "Un solo veto vigente"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Un solo veto vigente por colaborador; el historial nunca se borra"
msgstr "Un solo veto vigente por colaborador; el historial nunca se borra"

#: src/features/schedule/components/AddShiftDialog.tsx
msgid "Un turno no puede pasar de 16 horas."
msgstr "Un turno no puede pasar de 16 horas."

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Un veto vigente solo lo levanta el Administrador. Al levantarlo, el colaborador vuelve a Blanco y pasa otra vez por la validación de la Reclutadora antes de ser asignable."
msgstr "Un veto vigente solo lo levanta el Administrador. Al levantarlo, el colaborador vuelve a Blanco y pasa otra vez por la validación de la Reclutadora antes de ser asignable."

#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Una asignación temporal necesita fecha de fin: mientras dure, el colaborador está en Café y al vencer vuelve a su estado anterior."
msgstr "Una asignación temporal necesita fecha de fin: mientras dure, el colaborador está en Café y al vencer vuelve a su estado anterior."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Una de las posiciones no está en el contrato vigente del hotel: agrégala ahí primero."
msgstr "Una de las posiciones no está en el contrato vigente del hotel: agrégala ahí primero."

#: src/features/accounting/pages/PayAdjustmentsInclusionPage.tsx
msgid "Una eventual puede llevar un ajuste de tarifa o un gasto con concepto (Uber…). El Manager de QA los revisa, pero eso todavía no les hace nada a tus números."
msgstr "Una eventual puede llevar un ajuste de tarifa o un gasto con concepto (Uber…). El Manager de QA los revisa, pero eso todavía no les hace nada a tus números."

#: src/features/worker/components/TaxDocumentUploader.tsx
msgid "Una foto clara o un PDF. Oranje lo revisa y te avisa cuando quede verificado."
msgstr "Una foto clara o un PDF. Oranje lo revisa y te avisa cuando quede verificado."

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Una persona en accidente laboral no puede vetarse: primero se resuelve su caso, luego se decide."
msgstr "Una persona en accidente laboral no puede vetarse: primero se resuelve su caso, luego se decide."

#: src/features/admin/components/RoleGrantsSection.tsx
msgid "Una persona puede trabajar con más de un rol. Elige con cuál desde el pie del menú y nunca se suman: con cada función ve y hace solo lo de esa función. Las parejas que rompen una doble firma no se pueden dar."
msgstr "Una persona puede trabajar con más de un rol. Elige con cuál desde el pie del menú y nunca se suman: con cada función ve y hace solo lo de esa función. Las parejas que rompen una doble firma no se pueden dar."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Una posición pertenece a una industria: elige a cuál."
msgstr "Una posición pertenece a una industria: elige a cuál."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Una requisición en este estado no se elimina: las cubiertas se conservan como historia."
msgstr "Una requisición en este estado no se elimina: las cubiertas se conservan como historia."

#: src/features/observability/components/CohortTimeline.tsx
msgid "Una semana antes"
msgstr "Una semana antes"

#: src/features/accounting/pages/PendingApprovalsPage.tsx
msgid "Una semana cerrada sin aprobar no entra al Consolidado ni a la factura del hotel — queda en espera hasta que el Manager de Área la apruebe."
msgstr "Una semana cerrada sin aprobar no entra al Consolidado ni a la factura del hotel — queda en espera hasta que el Manager de Área la apruebe."

#: src/features/observability/components/CohortTimeline.tsx
msgid "Una semana después"
msgstr "Una semana después"

#: src/features/contracts/components/RateTable.tsx
msgid "Una tarifa por posición del catálogo"
msgstr "Una tarifa por posición del catálogo"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Una vez revisado el consolidado, sus deducciones quedan firmes. Un error se corrige en Borrador."
msgstr "Una vez revisado el consolidado, sus deducciones quedan firmes. Un error se corrige en Borrador."

#: src/features/accounting/types/settlement.constants.ts
msgid "Uniforme"
msgstr "Uniforme"

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "uniforme, comida y retención"
msgstr "uniforme, comida y retención"

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Uniforme, comida y retención del 16% no entran solos con la corrida de pago: se agregan en el consolidado de cada colaborador mientras está en Borrador."
msgstr "Uniforme, comida y retención del 16% no entran solos con la corrida de pago: se agregan en el consolidado de cada colaborador mientras está en Borrador."

#: src/features/accounting/pages/DeductionsPage.tsx
msgid "Uniforme, comida y retención del 16% que se descuentan del pago del colaborador."
msgstr "Uniforme, comida y retención del 16% que se descuentan del pago del colaborador."

#: src/features/accounting/pages/ConsolidationDetailPage.tsx
msgid "Uniforme, comida y retención no entran solos con la corrida de pago: captúralos antes de marcarlo como revisado."
msgstr "Uniforme, comida y retención no entran solos con la corrida de pago: captúralos antes de marcarlo como revisado."

#: src/features/audits/components/PersonalPresentationAuditDialog.tsx
msgid "Uniformidad, higiene, seguridad y actitud del colaborador, reactivo por reactivo."
msgstr "Uniformidad, higiene, seguridad y actitud del colaborador, reactivo por reactivo."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Unirme a la requisición"
msgstr "Unirme a la requisición"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Uno de los puestos ya no está en el catálogo. Recarga la página y vuelve a elegirlo."
msgstr "Uno de los puestos ya no está en el catálogo. Recarga la página y vuelve a elegirlo."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Uno de los reactivos ya no es parte de esta inspección. Recarga e inténtalo de nuevo."
msgstr "Uno de los reactivos ya no es parte de esta inspección. Recarga e inténtalo de nuevo."

#: src/features/audits/components/AuditFormDialog.tsx
msgid "Uno de los reactivos ya no existe. Recarga e inténtalo de nuevo."
msgstr "Uno de los reactivos ya no existe. Recarga e inténtalo de nuevo."

#: src/features/accounting/pages/ConsolidationsPage.tsx
msgid "Uno por colaborador, hotel y semana"
msgstr "Uno por colaborador, hotel y semana"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Uno vigente ahora mismo"
msgstr "Uno vigente ahora mismo"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Uno vigente por hotel"
msgstr "Uno vigente por hotel"

#: src/features/requisitions/components/RequisitionTable.tsx
msgid "Urgencia"
msgstr "Urgencia"

#: src/shared/components/UrgencyChip.tsx
msgid "Urgencia: {label}. Toca para ver el tiempo"
msgstr "Urgencia: {label}. Toca para ver el tiempo"

#: src/shared/constants/requisitionStatus.ts
msgid "Urgente"
msgstr "Urgente"

#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "Urgentes"
msgstr "Urgentes"

#: src/features/messaging/components/WorkersSyncNotice.tsx
msgid "Usa «Sincronizar colaboradores» antes de crear una campaña: si no, no les llegaría."
msgstr "Usa «Sincronizar colaboradores» antes de crear una campaña: si no, no les llegaría."

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Usa «Sincronizar desde Meta» para traer las plantillas aprobadas."
msgstr "Usa «Sincronizar desde Meta» para traer las plantillas aprobadas."

#. placeholder {0}: String(max)
#: src/features/onboarding/types/prospectForm.schema.ts
msgid "Usa como máximo {0} caracteres"
msgstr "Usa como máximo {0} caracteres"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Usa la plantilla (en español o inglés) o tus propios títulos en español, inglés o portugués. Obligatorias: Nombre del hotel, Zona, Inicio de semana, Paga horas extra y el contacto (nombre, teléfono y correo)."
msgstr "Usa la plantilla (en español o inglés) o tus propios títulos en español, inglés o portugués. Obligatorias: Nombre del hotel, Zona, Inicio de semana, Paga horas extra y el contacto (nombre, teléfono y correo)."

#: src/features/onboarding/components/ConfirmSendProposalDialog.tsx
msgid "Úsalo cuando ya se entregó por otro medio — impresa, en mano, por otro correo."
msgstr "Úsalo cuando ya se entregó por otro medio — impresa, en mano, por otro correo."

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Úsalo si ya se lo hiciste llegar al hotel por fuera. Igual que la propuesta, al enviarlo queda bloqueado: si hay que corregir algo, el BDC lo desbloquea."
msgstr "Úsalo si ya se lo hiciste llegar al hotel por fuera. Igual que la propuesta, al enviarlo queda bloqueado: si hay que corregir algo, el BDC lo desbloquea."

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Usuario (su correo)"
msgstr "Usuario (su correo)"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Usuario activado"
msgstr "Usuario activado"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Usuario actualizado"
msgstr "Usuario actualizado"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Usuario copiado"
msgstr "Usuario copiado"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Usuario creado"
msgstr "Usuario creado"

#. placeholder {0}: values.email
#: src/features/admin/components/UserFormDialog.tsx
msgid "Usuario creado — invitación enviada a {0}"
msgstr "Usuario creado — invitación enviada a {0}"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Usuario dado de baja"
msgstr "Usuario dado de baja"

#: src/features/conversion/api/conversionApi.ts
msgid "Usuario del Hotel creado"
msgstr "Usuario del Hotel creado"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Usuario del sistema"
msgstr "Usuario del sistema"

#: src/layouts/Sidebar.tsx
msgid "Usuarios"
msgstr "Usuarios"

#: src/features/admin/pages/UsersPage.tsx
msgid "Usuarios del sistema"
msgstr "Usuarios del sistema"

#: src/features/admin/pages/UsersPage.tsx
msgid "Usuarios del sistema es del Administrador"
msgstr "Usuarios del sistema es del Administrador"

#: src/features/messaging/components/MessagingReportsList.tsx
#: src/features/messaging/components/MessagingTemplatesList.tsx
#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Utilidad"
msgstr "Utilidad"

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "V"
msgstr "V"

#. placeholder {0}: candidate.latestVersion
#. placeholder {1}: candidate.latestSentAt ? t`Enviada ${formatDate(candidate.latestSentAt)}` : t`Borrador sin enviar`
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "v{0} · {1}"
msgstr "v{0} · {1}"

#. placeholder {0}: last.version
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "v{0} enviada"
msgstr "v{0} enviada"

#: src/features/accounting/pages/AccountingPendingPages.tsx
#: src/features/personnel/components/StandByDialog.tsx
#: src/layouts/Sidebar.tsx
msgid "Vacaciones"
msgstr "Vacaciones"

#: src/features/messaging/components/TemplateFormDialog.tsx
msgid "Vacantes y promociones. Meta no la entrega a números de EE. UU."
msgstr "Vacantes y promociones. Meta no la entrega a números de EE. UU."

#: src/features/observability/lib/inspectionKpis.ts
msgid "Validado"
msgstr "Validado"

#: src/features/recruitment/components/CreateWorkerDialog.tsx
msgid "Validar lo hace entrar al Pool"
msgstr "Validar lo hace entrar al Pool"

#: src/features/recruitment/components/ChangeStateDialog.tsx
msgid "Validarlo de todas formas"
msgstr "Validarlo de todas formas"

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Válidas"
msgstr "Válidas"

#: src/shared/constants/onboardingStatus.ts
msgid "Vamos a crear la propuesta"
msgstr "Vamos a crear la propuesta"

#. placeholder {0}: status.workers
#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Van los {0} colaboradores. Para elegir solo a algunos, busca por nombre o usa Hotel y Estado."
msgstr "Van los {0} colaboradores. Para elegir solo a algunos, busca por nombre o usa Hotel y Estado."

#: src/features/messaging/components/SyncWorkersButton.tsx
msgid "Van todos los colaboradores. Para elegir solo a algunos, busca por nombre o usa Hotel y Estado."
msgstr "Van todos los colaboradores. Para elegir solo a algunos, busca por nombre o usa Hotel y Estado."

#: src/features/messaging/components/CreateCampaignDialog.tsx
msgid "Variables"
msgstr "Variables"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Varias Reclutadoras pueden trabajar la misma requisición a la vez."
msgstr "Varias Reclutadoras pueden trabajar la misma requisición a la vez."

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Varios hoteles de una vez"
msgstr "Varios hoteles de una vez"

#: src/features/contracts/components/clauses/ClausesEditWarningDialog.tsx
msgid "Vas a editar el machote"
msgstr "Vas a editar el machote"

#: src/features/timesheet/components/ManualPunchDialog.tsx
msgid "Vas a marcar:"
msgstr "Vas a marcar:"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalVersionPage.tsx
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Vault de documentos"
msgstr "Vault de documentos"

#: src/features/messaging/components/tours.ts
msgid "Ve quiénes la tienen"
msgstr "Ve quiénes la tienen"

#. placeholder {0}: formatDate(contract.validTo)
#: src/features/contracts/components/ContractNextStep.tsx
msgid "Vence el {0}. Para renovar, crea un contrato nuevo antes de esa fecha y marca este como expirado."
msgstr "Vence el {0}. Para renovar, crea un contrato nuevo antes de esa fecha y marca este como expirado."

#. placeholder {0}: String(row.daysRemaining)
#: src/features/contracts/utils/validity.ts
msgid "vence en {0} días"
msgstr "vence en {0} días"

#: src/features/contracts/utils/validity.ts
msgid "vence en 1 día"
msgstr "vence en 1 día"

#: src/features/contracts/utils/validity.ts
msgid "vencido"
msgstr "vencido"

#: src/features/contracts/components/ContractFilters.tsx
msgid "Vencimiento"
msgstr "Vencimiento"

#: src/features/observability/pages/ObservabilityPage.tsx
#: src/features/reports/pages/ReportsPage.tsx
msgid "Ventas"
msgstr "Ventas"

#: src/features/messaging/components/SyncWorkersButton.tsx
#: src/shared/components/ListItemViewHint.tsx
msgid "Ver"
msgstr "Ver"

#. placeholder {0}: doc.displayName
#: src/shared/components/HotelDocumentVaultDialog.tsx
msgid "Ver {0}"
msgstr "Ver {0}"

#: src/features/messaging/components/ReportParts.tsx
msgid "Ver a quiénes"
msgstr "Ver a quiénes"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ver bitácora"
msgstr "Ver bitácora"

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Ver Clientes Activos"
msgstr "Ver Clientes Activos"

#: src/features/messaging/components/MessagingTagsList.tsx
msgid "Ver contactos"
msgstr "Ver contactos"

#: src/features/onboarding/components/ContractStepCard.tsx
msgid "Ver contrato"
msgstr "Ver contrato"

#: src/features/onboarding/components/ProspectPhotoCard.tsx
msgid "Ver contrato →"
msgstr "Ver contrato →"

#: src/features/messaging/components/MessagingTemplatesList.tsx
msgid "Ver detalle"
msgstr "Ver detalle"

#. placeholder {0}: version.version
#: src/features/onboarding/components/ProposalVersionHistory.tsx
msgid "Ver el detalle de la Propuesta v{0}, enviada"
msgstr "Ver el detalle de la Propuesta v{0}, enviada"

#. placeholder {0}: slot.assigneeName
#: src/features/requisitions/components/SlotList.tsx
msgid "Ver el perfil de {0}"
msgstr "Ver el perfil de {0}"

#: src/features/audits/pages/AuditsPage.tsx
#: src/features/dashboard/components/HotelDashboard.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ver el recorrido"
msgstr "Ver el recorrido"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Ver en Clientes Activos"
msgstr "Ver en Clientes Activos"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Ver gráfica"
msgstr "Ver gráfica"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Ver lista de contratos"
msgstr "Ver lista de contratos"

#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Ver lista de propuestas"
msgstr "Ver lista de propuestas"

#: src/features/contracts/pages/ContractListPage.tsx
msgid "Ver los contratos"
msgstr "Ver los contratos"

#: src/features/dashboard/components/ActivityCards.tsx
#: src/features/dashboard/components/RecruitmentManagerDashboard.tsx
msgid "Ver Mi Equipo"
msgstr "Ver Mi Equipo"

#: src/features/contracts/components/ContractPdfButton.tsx
msgid "Ver PDF"
msgstr "Ver PDF"

#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/PoolRoster.tsx
msgid "Ver perfil"
msgstr "Ver perfil"

#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
#: src/features/onboarding/pages/ProposalListPage.tsx
msgid "Ver propuesta"
msgstr "Ver propuesta"

#: src/features/onboarding/components/ProspectPhotoCard.tsx
msgid "Ver propuesta enviada →"
msgstr "Ver propuesta enviada →"

#: src/features/onboarding/components/ProposalVersionList.tsx
msgid "Ver propuestas"
msgstr "Ver propuestas"

#: src/features/recruitment/pages/PoolPage.tsx
msgid "Ver quién tiene un documento (SSN/ITIN) pendiente de verificar"
msgstr "Ver quién tiene un documento (SSN/ITIN) pendiente de verificar"

#: src/features/messaging/components/Tour.tsx
msgid "Ver recorrido"
msgstr "Ver recorrido"

#: src/features/messaging/components/MessagingReportsList.tsx
msgid "Ver reporte"
msgstr "Ver reporte"

#: src/features/timesheet/components/ReviewDayDialog.tsx
#: src/features/timesheet/components/TimesheetHoursView.tsx
msgid "Ver revisión"
msgstr "Ver revisión"

#: src/features/recruitment/components/SelfPickHotelCardList.tsx
msgid "Ver slots"
msgstr "Ver slots"

#: src/features/messaging/components/ReportCharts.tsx
msgid "Ver tabla"
msgstr "Ver tabla"

#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "Ver toda la Bolsa"
msgstr "Ver toda la Bolsa"

#: src/features/requisitions/components/HotelRequisitionCardList.tsx
msgid "Ver todas"
msgstr "Ver todas"

#: src/shared/components/DateRangeField.tsx
msgid "Ver todo el periodo"
msgstr "Ver todo el periodo"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "Ver todos ({total})"
msgstr "Ver todos ({total})"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "Ver todos y corregirlos"
msgstr "Ver todos y corregirlos"

#: src/shared/components/ApprovalTimelinessPanel.tsx
#: src/shared/constants/onboardingStatus.ts
msgid "Verde"
msgstr "Verde"

#: src/features/timesheet/pages/TimesheetGlobalPage.tsx
msgid "Verde · cumplimiento"
msgstr "Verde · cumplimiento"

#: src/features/dashboard/components/RecruitmentDashboard.tsx
msgid "Verde fuerte, sin veto vigente"
msgstr "Verde fuerte, sin veto vigente"

#: src/features/onboarding/components/ChangeStatusDialog.tsx
msgid "Verde no se abandona sin enviar la Propuesta Personalizada: abre la propuesta, envíala y vuelve a intentar."
msgstr "Verde no se abandona sin enviar la Propuesta Personalizada: abre la propuesta, envíala y vuelve a intentar."

#: src/features/worker/components/TaxDeadlineBanner.tsx
msgid "verificado"
msgstr "verificado"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/Phase2Page.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Verificado"
msgstr "Verificado"

#. placeholder {0}: previewDoc.verifiedBy?.fullName ?? '—'
#. placeholder {1}: previewDoc.verifiedAt === null ? '—' : formatDate(previewDoc.verifiedAt)
#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Verificado por {0} · {1}"
msgstr "Verificado por {0} · {1}"

#: src/features/worker/pages/PunchPage.tsx
msgid "Verificando…"
msgstr "Verificando…"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Verificar documento"
msgstr "Verificar documento"

#. placeholder {0}: draft.version
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Versión {0} · borrador sin enviar"
msgstr "Versión {0} · borrador sin enviar"

#. placeholder {0}: String(punchQr.version)
#. placeholder {1}: formatDateTime(punchQr.generatedAt)
#: src/features/onboarding/components/HotelPunchQrCard.tsx
msgid "Versión {0} · generado el {1}"
msgstr "Versión {0} · generado el {1}"

#. placeholder {0}: data.version
#: src/features/onboarding/pages/HotelPunchQrPrintPage.tsx
msgid "Versión {0} · generado el {generatedOn}. Si el hotel regenera su QR, esta hoja deja de servir."
msgstr "Versión {0} · generado el {generatedOn}. Si el hotel regenera su QR, esta hoja deja de servir."

#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Versión nueva abierta"
msgstr "Versión nueva abierta"

#: src/features/onboarding/components/ProposalVersionList.tsx
#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Versiones de la propuesta"
msgstr "Versiones de la propuesta"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Ves cada fila: lista, para completar o con error. Eliges cuáles entran: una o todas. Lo que falte (el pin, el contacto) se completa después en la ficha del prospecto."
msgstr "Ves cada fila: lista, para completar o con error. Eliges cuáles entran: una o todas. Lo que falte (el pin, el contacto) se completa después en la ficha del prospecto."

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Vetando…"
msgstr "Vetando…"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Vetar colaborador"
msgstr "Vetar colaborador"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Veto levantado — vuelve a Blanco"
msgstr "Veto levantado — vuelve a Blanco"

#. placeholder {0}: worker.fullName
#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Veto registrado — {0}"
msgstr "Veto registrado — {0}"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Vetos anteriores"
msgstr "Vetos anteriores"

#: src/features/timesheet/components/TimesheetMonthView.tsx
msgid "Vie"
msgstr "Vie"

#. placeholder {0}: filters.hotelName
#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Viendo {0} · solo lectura"
msgstr "Viendo {0} · solo lectura"

#: src/features/recruitment/pages/SelfPickPage.tsx
msgid "Viendo solo esta requisición, cubierto incluido."
msgstr "Viendo solo esta requisición, cubierto incluido."

#: src/features/timesheet/pages/TimesheetPage.tsx
msgid "Viendo todos los hoteles · solo lectura"
msgstr "Viendo todos los hoteles · solo lectura"

#. placeholder {0}: formatWeekRange(visibleWeek, addDaysIso(visibleWeek, 6))
#: src/features/timesheet/components/WeekSlider.tsx
msgid "Viendo: {0}"
msgstr "Viendo: {0}"

#: src/features/timesheet/components/AttendanceView.tsx
msgid "Viene del día anterior"
msgstr "Viene del día anterior"

#: src/features/contracts/components/ContractTable.tsx
#: src/features/contracts/components/NewContractDialog.tsx
msgid "Vigencia"
msgstr "Vigencia"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Vigencia actualizada"
msgstr "Vigencia actualizada"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Vigencia y semana de nómina"
msgstr "Vigencia y semana de nómina"

#: src/features/contracts/components/ValidityCell.tsx
msgid "Vigencia: {note}"
msgstr "Vigencia: {note}"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "Vigente"
msgstr "Vigente"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Vigente desde"
msgstr "Vigente desde"

#: src/features/contracts/components/ContractChecklist.tsx
msgid "Vigente desde el inicio, sin fecha de fin: aplica hasta que se expire a mano."
msgstr "Vigente desde el inicio, sin fecha de fin: aplica hasta que se expire a mano."

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Vigente hasta"
msgstr "Vigente hasta"

#: src/features/contracts/components/NewContractDialog.tsx
msgid "Vigente hasta (opcional)"
msgstr "Vigente hasta (opcional)"

#: src/features/recruitment/pages/BlacklistPage.tsx
msgid "vigentes"
msgstr "vigentes"

#: src/features/requisitions/api/requisitionsApi.ts
msgid "Visible en la Bolsa · Self-Pick"
msgstr "Visible en la Bolsa · Self-Pick"

#: src/features/observability/lib/people.ts
#: src/shared/constants/contactAttempt.ts
msgid "Visita en frío"
msgstr "Visita en frío"

#: src/features/observability/lib/people.ts
#: src/features/observability/lib/salesKpis.ts
msgid "Visitas en frío"
msgstr "Visitas en frío"

#: src/features/observability/lib/salesKpis.ts
msgid "Visitas en frío registradas en el periodo, de todos los BD."
msgstr "Visitas en frío registradas en el periodo, de todos los BD."

#: src/features/observability/components/TabParts.tsx
#: src/features/timesheet/components/TimesheetViewControls.tsx
msgid "Vista"
msgstr "Vista"

#: src/features/onboarding/components/ContractPreviewDialog.tsx
msgid "Vista previa del contrato"
msgstr "Vista previa del contrato"

#. placeholder {0}: version.version
#: src/features/onboarding/components/ContractPreviewButton.tsx
msgid "Vista previa del contrato de la Propuesta v{0}"
msgstr "Vista previa del contrato de la Propuesta v{0}"

#: src/features/contracts/pages/ContractDetailPage.tsx
#: src/features/onboarding/pages/ProposalEditorPage.tsx
msgid "Vista previa del documento"
msgstr "Vista previa del documento"

#: src/features/messaging/components/ExcludedWorkersDialog.tsx
msgid "Vista rápida"
msgstr "Vista rápida"

#: src/features/account/pages/DeleteAccountPage.tsx
#: src/features/admin/components/AccountDeletionsSection.tsx
#: src/features/messaging/components/CampaignOpsDialogs.tsx
#: src/features/messaging/components/MessagingCampaignsList.tsx
#: src/features/messaging/components/SyncWorkersButton.tsx
#: src/layouts/AppShell.tsx
#: src/mobile/layouts.tsx
msgid "Volver"
msgstr "Volver"

#: src/shared/components/LoadError.tsx
msgid "Volver a cargar"
msgstr "Volver a cargar"

#: src/features/contracts/pages/ContractDetailPage.tsx
msgid "Volver a Contratos"
msgstr "Volver a Contratos"

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Volver a Conversión"
msgstr "Volver a Conversión"

#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Volver a correrla solo agrega lo que {hotelName} aprobó después de la última vez — no duplica nada de lo que ya está cerrado."
msgstr "Volver a correrla solo agrega lo que {hotelName} aprobó después de la última vez — no duplica nada de lo que ya está cerrado."

#: src/features/recruitment/pages/SelfPickHotelPage.tsx
#: src/features/recruitment/pages/SlotAssignmentPage.tsx
msgid "Volver a la Bolsa"
msgstr "Volver a la Bolsa"

#: src/shared/components/BackToListButton.tsx
msgid "Volver a la lista"
msgstr "Volver a la lista"

#: src/layouts/AppShell.tsx
msgid "Volver a la página anterior"
msgstr "Volver a la página anterior"

#: src/features/onboarding/pages/ProposalVersionPage.tsx
msgid "Volver a Propuestas"
msgstr "Volver a Propuestas"

#: src/features/onboarding/pages/ProposalEditorPage.tsx
#: src/features/onboarding/pages/ProspectDetailPage.tsx
msgid "Volver al Pipeline"
msgstr "Volver al Pipeline"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Volver al Pool de Colaboradores"
msgstr "Volver al Pool de Colaboradores"

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Volver al Tablero de Requisiciones"
msgstr "Volver al Tablero de Requisiciones"

#: src/features/recruitment/components/LiftBlacklistDialog.tsx
msgid "Vuelve a Blanco, no al Pool"
msgstr "Vuelve a Blanco, no al Pool"

#: src/shared/constants/workerStatus.ts
msgid "vuelve solo al vencer los días asignados; Reclutamiento puede cancelarlo liberando la asignación."
msgstr "vuelve solo al vencer los días asignados; Reclutamiento puede cancelarlo liberando la asignación."

#: src/shared/constants/workerStatus.ts
msgid "vuelve solo cuando el colaborador poncha de nuevo; a la tercera falta el sistema lo manda a Blacklist."
msgstr "vuelve solo cuando el colaborador poncha de nuevo; a la tercera falta el sistema lo manda a Blacklist."

#: src/features/schedule/components/ScheduleMiniCalendar.tsx
msgid "X"
msgstr "X"

#: src/features/requisitions/pages/HotelRequisitionsPage.tsx
#: src/features/requisitions/pages/RequisitionBoardPage.tsx
msgid "y"
msgstr "y"

#: src/features/worker/pages/HomePage.tsx
msgid "Y tu ubicación, para confirmar dónde estás"
msgstr "Y tu ubicación, para confirmar dónde estás"

#: src/features/accounting/pages/InvoiceDetailPage.tsx
msgid "ya aprobada"
msgstr "ya aprobada"

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Ya cubrimos {covered} de {total, plural, one {# lugar} other {# lugares}}. Abajo ves quién llega a cada uno."
msgstr "Ya cubrimos {covered} de {total, plural, one {# lugar} other {# lugares}}. Abajo ves quién llega a cada uno."

#: src/features/admin/components/userListParts.tsx
msgid "Ya entró"
msgstr "Ya entró"

#: src/features/admin/components/HotelUsersSection.tsx
#: src/features/admin/pages/UsersPage.tsx
msgid "Ya entró al sistema"
msgstr "Ya entró al sistema"

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ya entró por primera vez: no hace falta reenviar la invitación."
msgstr "Ya entró por primera vez: no hace falta reenviar la invitación."

#: src/features/onboarding/components/ViewProposalDialog.tsx
msgid "Ya es cliente con contrato vigente: la propuesta no se reabre. Si cambian las tarifas, se edita el contrato."
msgstr "Ya es cliente con contrato vigente: la propuesta no se reabre. Si cambian las tarifas, se edita el contrato."

#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Ya está autorizada: Reclutamiento la ve desde ahora y empieza a cubrirla."
msgstr "Ya está autorizada: Reclutamiento la ve desde ahora y empieza a cubrirla."

#: src/features/worker/pages/Phase2Page.tsx
msgid "Ya está todo"
msgstr "Ya está todo"

#: src/features/recruitment/pages/WorkerDetailPage.tsx
msgid "Ya está verificado: no se puede borrar, deja rastro de quién lo revisó."
msgstr "Ya está verificado: no se puede borrar, deja rastro de quién lo revisó."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ya estabas trabajando esta requisición."
msgstr "Ya estabas trabajando esta requisición."

#: src/features/worker/pages/HomePage.tsx
msgid "Ya estás disponible"
msgstr "Ya estás disponible"

#: src/features/timesheet/components/WeekSlider.tsx
msgid "Ya estás en la semana más reciente"
msgstr "Ya estás en la semana más reciente"

#: src/features/onboarding/import/ImportProspectsDialog.tsx
msgid "Ya existe en Oranje"
msgstr "Ya existe en Oranje"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Ya existe en Oranje: para abrirle un ciclo usa «Hotel ya registrado»"
msgstr "Ya existe en Oranje: para abrirle un ciclo usa «Hotel ya registrado»"

#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Ya existe un hotel con ese nombre: elige «Hotel ya registrado» o cambia el nombre."
msgstr "Ya existe un hotel con ese nombre: elige «Hotel ya registrado» o cambia el nombre."

#: src/features/admin/components/AuditChecklistItemsPanel.tsx
msgid "Ya existe un reactivo con ese texto en esta inspección."
msgstr "Ya existe un reactivo con ese texto en esta inspección."

#: src/features/conversion/pages/ConversionPage.tsx
msgid "Ya existe un usuario con ese correo."
msgstr "Ya existe un usuario con ese correo."

#: src/features/admin/pages/CatalogsPage.tsx
msgid "Ya existe una fila con ese nombre en este catálogo."
msgstr "Ya existe una fila con ese nombre en este catálogo."

#: src/features/messaging/components/ImportContactsDialog.tsx
msgid "Ya existen"
msgstr "Ya existen"

#: src/features/recruitment/components/CreateBlacklistDialog.tsx
msgid "Ya hay un veto vigente para esta persona: levántalo antes de registrar otro."
msgstr "Ya hay un veto vigente para esta persona: levántalo antes de registrar otro."

#. placeholder {0}: formatHours(overtime.hours)
#. placeholder {1}: overtime.multiplier
#: src/features/timesheet/components/AttendanceView.tsx
msgid "Ya incluye {0} de extra, pagadas a {1}×"
msgstr "Ya incluye {0} de extra, pagadas a {1}×"

#: src/features/admin/components/ChangeWorkerPasswordDialog.tsx
msgid "Ya la anoté"
msgstr "Ya la anoté"

#: src/features/contracts/components/ContractSignatureCard.tsx
msgid "Ya le llegó el correo de DocuSign: esperando su firma"
msgstr "Ya le llegó el correo de DocuSign: esperando su firma"

#: src/features/worker/pages/PermissionsPage.tsx
msgid "Ya lo cambié: comprobar de nuevo"
msgstr "Ya lo cambié: comprobar de nuevo"

#: src/features/personnel/pages/PersonnelPage.tsx
msgid "ya marcaron hoy"
msgstr "ya marcaron hoy"

#: src/shared/components/UrgencyChip.tsx
msgid "Ya no aplica"
msgstr "Ya no aplica"

#: src/features/recruitment/components/WorkerAccessDialog.tsx
msgid "Ya no está guardada. Si la necesitas, ponle una nueva."
msgstr "Ya no está guardada. Si la necesitas, ponle una nueva."

#: src/features/requisitions/pages/RequisitionDetailPage.tsx
msgid "Ya no estabas trabajando esta requisición."
msgstr "Ya no estabas trabajando esta requisición."

#: src/features/messaging/components/ContactActions.tsx
msgid "Ya no recibirá mensajes de ninguna campaña. Es la baja que pide la ley: no se deshace desde aquí."
msgstr "Ya no recibirá mensajes de ninguna campaña. Es la baja que pide la ley: no se deshace desde aquí."

#: src/features/requisitions/components/RequisitionProgressCard.tsx
msgid "Ya no se va a cubrir. Si todavía necesitas personal, crea una requisición nueva."
msgstr "Ya no se va a cubrir. Si todavía necesitas personal, crea una requisición nueva."

#: src/features/observability/components/CohortSection.tsx
msgid "Ya no trabajan"
msgstr "Ya no trabajan"

#: src/features/contracts/components/MissingContractsNotice.tsx
msgid "Ya pasaron Amarillo y todavía no tienen contrato, ni en Borrador"
msgstr "Ya pasaron Amarillo y todavía no tienen contrato, ni en Borrador"

#: src/features/account/pages/DeleteAccountPage.tsx
msgid "Ya pediste eliminar tu cuenta."
msgstr "Ya pediste eliminar tu cuenta."

#: src/features/admin/components/UserFormDialog.tsx
msgid "Ya puede entrar con la contraseña que definiste. Compártesela por un canal seguro — no viaja por correo."
msgstr "Ya puede entrar con la contraseña que definiste. Compártesela por un canal seguro — no viaja por correo."

#: src/features/onboarding/components/ContractUnlockedDialog.tsx
msgid "Ya puedes armar el contrato"
msgstr "Ya puedes armar el contrato"

#: src/features/admin/components/PendingHotelUsers.tsx
msgid "Ya se aprobó: un rechazo no deshace una aprobación."
msgstr "Ya se aprobó: un rechazo no deshace una aprobación."

#. placeholder {0}: rows.length
#. placeholder {1}: formatMoney(totalNet)
#: src/features/accounting/components/GeneratePaymentRunButton.tsx
msgid "Ya se cerraron {0} hojas esta semana, por {1} neto."
msgstr "Ya se cerraron {0} hojas esta semana, por {1} neto."

#: src/features/contracts/components/ProposalSyncNotice.tsx
msgid "Ya se le envió al hotel y está bloqueado: desbloquéalo primero."
msgstr "Ya se le envió al hotel y está bloqueado: desbloquéalo primero."

#: src/features/conversion/pages/ConversionQueuePage.tsx
msgid "Ya son clientes: su ficha completa vive en Clientes Activos"
msgstr "Ya son clientes: su ficha completa vive en Clientes Activos"

#: src/features/requisitions/components/SlotList.tsx
msgid "Ya terminó"
msgstr "Ya terminó"

#: src/features/recruitment/components/ProfileProgressAvatar.tsx
msgid "Ya tiene todo lo de la entrevista. Para asignarlo, cámbialo a {readyLabel}."
msgstr "Ya tiene todo lo de la entrevista. Para asignarlo, cámbialo a {readyLabel}."

#: src/features/recruitment/components/PoolRoster.tsx
msgid "Ya tiene una asignación fija: pasa a Día 1-2 en cuanto ponche por primera vez."
msgstr "Ya tiene una asignación fija: pasa a Día 1-2 en cuanto ponche por primera vez."

#: src/features/onboarding/pages/PipelinePage.tsx
msgid "yo"
msgstr "yo"

#: src/features/admin/pages/CatalogsPage.tsx
msgid "zona"
msgstr "zona"

#: src/features/clients/components/ClientFilters.tsx
#: src/features/contracts/components/ContractFilters.tsx
#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
#: src/features/onboarding/pages/PipelinePage.tsx
#: src/features/personnel/pages/PersonnelPage.tsx
#: src/features/recruitment/components/CreateWorkerDialog.tsx
#: src/features/recruitment/components/PoolFilters.tsx
#: src/features/recruitment/components/PoolRoster.tsx
#: src/features/recruitment/components/PoolTable.tsx
#: src/features/recruitment/components/SelfPickFilterBar.tsx
#: src/features/recruitment/pages/WorkerDetailPage.tsx
#: src/features/worker/pages/ProfilePage.tsx
msgid "Zona"
msgstr "Zona"

#. placeholder {0}: client.zoneName
#. placeholder {1}: client.timezone
#: src/features/clients/components/ClientSpotlightCard.tsx
msgid "Zona {0} · {1}"
msgstr "Zona {0} · {1}"

#. placeholder {0}: client.zoneName
#. placeholder {1}: formatDate(client.activatedAt)
#: src/features/clients/components/ClientCardGrid.tsx
msgid "Zona {0} · cliente desde {1}"
msgstr "Zona {0} · cliente desde {1}"

#. placeholder {0}: hotel.zoneName
#: src/features/requisitions/components/NewRequisitionDialog.tsx
msgid "Zona {0} · el Inspector se congela al guardar"
msgstr "Zona {0} · el Inspector se congela al guardar"

#: src/features/onboarding/components/PlacesAutofillSummary.tsx
msgid "Zona comercial"
msgstr "Zona comercial"

#: src/features/onboarding/components/HotelDataCard.tsx
#: src/features/onboarding/components/PlacesAutofillSummary.tsx
#: src/features/onboarding/components/ProspectFormDialog.tsx
msgid "Zona horaria"
msgstr "Zona horaria"

#: src/features/onboarding/import/mapImportRows.ts
msgid "Zona horaria no reconocida: «{timeZoneText}»"
msgstr "Zona horaria no reconocida: «{timeZoneText}»"

#. placeholder {0}: zoneOptions.find((zone) => zone.value === filters.zone)?.label ?? filters.zone
#: src/features/onboarding/pages/PipelinePage.tsx
msgid "Zona: {0}"
msgstr "Zona: {0}"

#: src/features/recruitment/components/SelfPickFilterBar.tsx
msgid "Zona: próximamente"
msgstr "Zona: próximamente"

#: src/features/admin/components/UserFormDialog.tsx
#: src/features/admin/pages/CatalogsPage.tsx
msgid "Zonas"
msgstr "Zonas"

#. placeholder {0}: formatList(member.zoneNames)
#: src/features/team/pages/TeamPage.tsx
msgid "Zonas {0}"
msgstr "Zonas {0}"

#: src/features/timesheet/components/TimesheetToolbar.tsx
msgid "Zoom · ancho de columna"
msgstr "Zoom · ancho de columna"
